// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"jJLhA":[function(require,module,exports,__globalThis) {
require("aab8d88262aa064c").register(require("f7ea9a0e9654d00e").getBundleURL('5pDNv'), JSON.parse("[\"5pDNv\",\"app.js\",\"eMrMa\",\"browser.a5c4a1dc.js\",\"s5Dtw\",\"inspirationsListing.015b4cdc.js\",\"1bg04\",\"inspirationsListing.e8078601.js\",\"a2Mxw\",\"component.39fe6bf2.js\",\"fddn7\",\"login.425f37b6.js\",\"8JkDf\",\"signUp.6a8712fe.js\",\"4o371\",\"verify.689976b8.js\",\"jhr1I\",\"inspiration.a3511f1a.js\",\"lmMa7\",\"preview.300d79b3.js\",\"1808G\",\"favorites.4244ebc9.js\"]"));

},{"aab8d88262aa064c":"gSiLw","f7ea9a0e9654d00e":"a2ypy"}],"gSiLw":[function(require,module,exports,__globalThis) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"a2ypy":[function(require,module,exports,__globalThis) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return '/';
}
function getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"83hJF":[function(require,module,exports,__globalThis) {
var _core = require("@xatom/core");
var _routes = require("./routes");
var _supbase = require("./modules/supbase");
var _navbar = require("./modules/auth/navbar");
var _posthog = require("./utils/posthog");
window.WFDebug = true;
(0, _core.onReady)(()=>{
    (0, _posthog.initPostHog)(); // Initialize PostHog
    (0, _supbase.initSupabase)(()=>{
        (0, _routes.app)();
        (0, _navbar.initNavbar)(); // Initialize navbar with logout functionality
    });
});

},{"@xatom/core":"5eqAK","./routes":"2uPfR","./modules/supbase":"54PYi","./modules/auth/navbar":"kUH5i","./utils/posthog":"gxEu2"}],"5eqAK":[function(require,module,exports,__globalThis) {
var $iEn1Z$uuid = require("116fc168c31b637d");
function $parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $90b1e0f272b5544a$exports = {};
$parcel$export($90b1e0f272b5544a$exports, "WFAuth", ()=>$90b1e0f272b5544a$export$cb2138cd710ea58a);
class $90b1e0f272b5544a$export$cb2138cd710ea58a {
    constructor(config = {}){
        this.config = config;
    }
    isLoggedIn() {
        return !!this.user;
    }
    getRole() {
        return this.role;
    }
    getUser() {
        return this.user;
    }
    getConfig() {
        return this.config;
    }
    logout() {
        this.user = null;
        this.role = null;
        this.config = null;
    }
    setUser(user) {
        this.user = user;
    }
    setRole(role) {
        this.role = role;
    }
    setConfig(config) {
        this.config = config;
    }
}
var $336c7a32b438dc35$exports = {};
$parcel$export($336c7a32b438dc35$exports, "WFAuthMiddleware", ()=>$336c7a32b438dc35$export$42f600804a30f397);
class $336c7a32b438dc35$export$42f600804a30f397 {
    constructor(auth){
        this.auth = auth;
    }
    allowTo(role) {
        return this.auth.getRole() === role;
    }
    disallowedTo(role) {
        return this.auth.getRole() !== role;
    }
    getAuth() {
        return this.auth;
    }
}
var $5ce0995b4e579efe$exports = {};
$parcel$export($5ce0995b4e579efe$exports, "WFComponent", ()=>$5ce0995b4e579efe$export$b8941e06d24ae728);
var $30d957643bf2e67a$exports = {};
var $62881ab850a57a38$exports = {};
$parcel$export($62881ab850a57a38$exports, "debug", ()=>$62881ab850a57a38$export$1c9f709888824e05);
const $62881ab850a57a38$export$1c9f709888824e05 = (...args)=>{
    if (window.WFDebug) console.log(...args);
};
var $9e73fdbf37a9aa00$exports = {};
$parcel$export($9e73fdbf37a9aa00$exports, "getElementByXPath", ()=>$9e73fdbf37a9aa00$export$7ffef3582c93037b);
function $9e73fdbf37a9aa00$export$7ffef3582c93037b(xpath, parent) {
    const result = document.evaluate(xpath, parent, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
    return result.singleNodeValue;
}
var $100caf27c28c32c0$exports = {};
$parcel$export($100caf27c28c32c0$exports, "getRouteQueryParams", ()=>$100caf27c28c32c0$export$1346b4a9ff9b6881);
const $100caf27c28c32c0$export$1346b4a9ff9b6881 = ()=>{
    const _data = {};
    new URLSearchParams(location.search).forEach((val, key)=>{
        _data[key] = val;
    });
    return _data;
};
var $e533c87ae7d96e3e$exports = {};
$parcel$export($e533c87ae7d96e3e$exports, "getXPathForChangedChild", ()=>$e533c87ae7d96e3e$export$5fe4b019801f5ef1);
function $e533c87ae7d96e3e$export$5fe4b019801f5ef1(node, parent) {
    const xpathParts = [];
    // Traverse up the DOM tree from the node and generate an XPath expression for each parent element
    while(node && node !== parent && node.nodeType === Node.ELEMENT_NODE){
        let xpath = node.nodeName.toLowerCase();
        // If the element has an ID attribute, add it to the XPath expression
        if (node.hasAttribute("id")) xpath += '[@id="' + node.getAttribute("id") + '"]';
        else if (node.hasAttribute("class")) xpath += '[@class="' + node.getAttribute("class") + '"]';
        // Add the XPath expression for this element to the list
        xpathParts.unshift(xpath);
        // Move up to the parent element
        node = node.parentNode;
    }
    // Combine the XPath parts into a single XPath expression
    return xpathParts.join("/");
}
var $4117225480b0cc44$exports = {};
$parcel$export($4117225480b0cc44$exports, "navigate", ()=>$4117225480b0cc44$export$ff7962acd6052c28);
const $4117225480b0cc44$export$ff7962acd6052c28 = (arg)=>{
    if (typeof arg === "string") window.location.assign(arg);
    else if (typeof arg === "object" && arg.type === "replace") window.location.replace(arg.to);
    else if (typeof arg === "object" && arg.type === "reload") window.location.reload();
};
var $0b3f70b8f06eedca$exports = {};
$parcel$export($0b3f70b8f06eedca$exports, "parse", ()=>$0b3f70b8f06eedca$export$98e6a39c04603d36);
$parcel$export($0b3f70b8f06eedca$exports, "compile", ()=>$0b3f70b8f06eedca$export$ef7acd7185315e22);
$parcel$export($0b3f70b8f06eedca$exports, "tokensToFunction", ()=>$0b3f70b8f06eedca$export$5b9bad9e403cf3d9);
$parcel$export($0b3f70b8f06eedca$exports, "match", ()=>$0b3f70b8f06eedca$export$4659b591c19bdf3d);
$parcel$export($0b3f70b8f06eedca$exports, "pathToRegexp", ()=>$0b3f70b8f06eedca$export$71304158c7e35877);
$parcel$export($0b3f70b8f06eedca$exports, "regexpToFunction", ()=>$0b3f70b8f06eedca$export$968e97c88708237a);
$parcel$export($0b3f70b8f06eedca$exports, "tokensToRegexp", ()=>$0b3f70b8f06eedca$export$9a9303716def6456);
$parcel$export($0b3f70b8f06eedca$exports, "routeMatch", ()=>$0b3f70b8f06eedca$export$6c50148cf1d992bd);
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $0b3f70b8f06eedca$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            let name = "";
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            let count = 1;
            let pattern = "";
            let j = i + 1;
            if (str[j] === "?") throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $0b3f70b8f06eedca$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $0b3f70b8f06eedca$var$lexer(str);
    const { prefixes: prefixes = "./" } = options;
    const defaultPattern = `[^${$0b3f70b8f06eedca$var$escapeString(options.delimiter || "/#?")}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = "";
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        let result = "";
        let value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume("CHAR");
        const name = tryConsume("NAME");
        const pattern = tryConsume("PATTERN");
        if (name || pattern) {
            let prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || defaultPattern,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        const value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        const open = tryConsume("OPEN");
        if (open) {
            const prefix = consumeText();
            const name = tryConsume("NAME") || "";
            const pattern = tryConsume("PATTERN") || "";
            const suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name || (pattern ? key++ : ""),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $0b3f70b8f06eedca$export$ef7acd7185315e22(str, options) {
    return $0b3f70b8f06eedca$export$5b9bad9e403cf3d9($0b3f70b8f06eedca$export$98e6a39c04603d36(str, options), options);
}
function $0b3f70b8f06eedca$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $0b3f70b8f06eedca$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    const matches = tokens.map((token)=>{
        if (typeof token === "object") return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = "";
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === "?" || token.modifier === "*";
            const repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            const typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $0b3f70b8f06eedca$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $0b3f70b8f06eedca$export$71304158c7e35877(str, keys, options);
    return $0b3f70b8f06eedca$export$968e97c88708237a(re, keys, options);
}
function $0b3f70b8f06eedca$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>{
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $0b3f70b8f06eedca$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $0b3f70b8f06eedca$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $0b3f70b8f06eedca$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $0b3f70b8f06eedca$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$0b3f70b8f06eedca$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join("|")})`, $0b3f70b8f06eedca$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $0b3f70b8f06eedca$var$stringToRegexp(path, keys, options) {
    return $0b3f70b8f06eedca$export$9a9303716def6456($0b3f70b8f06eedca$export$98e6a39c04603d36(path, options), keys, options);
}
function $0b3f70b8f06eedca$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = "/#?", endsWith: endsWith = "" } = options;
    const endsWithRe = `[${$0b3f70b8f06eedca$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$0b3f70b8f06eedca$var$escapeString(delimiter)}]`;
    let route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === "string") route += $0b3f70b8f06eedca$var$escapeString(encode(token));
    else {
        const prefix = $0b3f70b8f06eedca$var$escapeString(encode(token.prefix));
        const suffix = $0b3f70b8f06eedca$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === "+" || token.modifier === "*") {
                    const mod = token.modifier === "*" ? "?" : "";
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === "+" || token.modifier === "*") route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? "$" : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $0b3f70b8f06eedca$var$flags(options));
}
function $0b3f70b8f06eedca$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $0b3f70b8f06eedca$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $0b3f70b8f06eedca$var$arrayToRegexp(path, keys, options);
    return $0b3f70b8f06eedca$var$stringToRegexp(path, keys, options);
}
function $0b3f70b8f06eedca$var$pathMatch(options = {}) {
    return function(path) {
        var keys = [];
        var re = $0b3f70b8f06eedca$export$71304158c7e35877(path, keys, options);
        return function(pathname, params) {
            var m = re.exec(pathname);
            if (!m) return false;
            params = params || {};
            var key, param;
            for(var i = 0; i < keys.length; i++){
                key = keys[i];
                param = m[i + 1];
                if (!param) continue;
                params[key.name] = $0b3f70b8f06eedca$var$decodeParam(param);
                if (key.repeat) params[key.name] = params[key.name].split(key.delimiter);
            }
            return params;
        };
    };
}
const $0b3f70b8f06eedca$export$6c50148cf1d992bd = (routeToMatch, route, defaultParams = {}, options = {})=>{
    return $0b3f70b8f06eedca$var$pathMatch(options)(routeToMatch)(route, defaultParams);
};
function $0b3f70b8f06eedca$var$decodeParam(param) {
    try {
        return decodeURIComponent(param);
    } catch (_) {
        throw new Error('failed to decode param "' + param + '"');
    }
}
var $36bdd128d4111a37$exports = {};
$parcel$export($36bdd128d4111a37$exports, "createComponent", ()=>$36bdd128d4111a37$export$60e54eaca7e7fb38);
const $36bdd128d4111a37$export$60e54eaca7e7fb38 = (type)=>{
    return new $5ce0995b4e579efe$export$b8941e06d24ae728(document.createElement(type));
};
$parcel$exportWildcard($30d957643bf2e67a$exports, $62881ab850a57a38$exports);
$parcel$exportWildcard($30d957643bf2e67a$exports, $9e73fdbf37a9aa00$exports);
$parcel$exportWildcard($30d957643bf2e67a$exports, $100caf27c28c32c0$exports);
$parcel$exportWildcard($30d957643bf2e67a$exports, $e533c87ae7d96e3e$exports);
$parcel$exportWildcard($30d957643bf2e67a$exports, $4117225480b0cc44$exports);
$parcel$exportWildcard($30d957643bf2e67a$exports, $0b3f70b8f06eedca$exports);
$parcel$exportWildcard($30d957643bf2e67a$exports, $36bdd128d4111a37$exports);
class $5ce0995b4e579efe$export$b8941e06d24ae728 {
    constructor(query){
        if (typeof query === "string") {
            const el = document.querySelector(query);
            if (el) {
                this.element = el;
                this.updateClone();
            } else throw new Error(`Could not find ${query}`);
        } else if (typeof query === "object" && query instanceof HTMLElement) {
            this.element = query;
            this.updateClone();
        } else if (typeof query === "object" && query instanceof SVGSVGElement) {
            this.element = query;
            this.updateClone();
        } else if (query instanceof $5ce0995b4e579efe$export$b8941e06d24ae728) {
            this.element = query.getElement();
            this.updateClone();
        } else throw new Error(`Could not find ${query}`);
    }
    updateClone() {
        this.cloneEl = this.element.cloneNode(true);
    }
    getElement() {
        return this.element;
    }
    updateTextViaAttrVar(keyPair) {
        const fields = {};
        const addEl = (key, val)=>{
            if (!(key in fields)) fields[key] = [];
            fields[key].push(val);
        };
        if (this.hasAttribute("xa-var")) addEl(this.getAttribute("xa-var"), this.getElement());
        const _els = this.getChildAsComponents(`[xa-var]`);
        _els.forEach((el)=>{
            addEl(el.getAttribute("xa-var"), el.getElement());
        });
        Object.keys(keyPair).forEach((key)=>{
            if (key in fields) fields[key].forEach((d)=>{
                d.textContent = keyPair[key].toString();
            });
        });
    }
    updateTextVariable(keyPair) {
        if (this.cloneEl.childNodes.length === 1 && this.cloneEl.firstChild instanceof Text) Object.keys(keyPair).forEach((key)=>{
            if (this.cloneEl.textContent.includes(`{{${key}}}`)) this.element.textContent = this.cloneEl.textContent.replace(`{{${key}}}`, keyPair[key].toString());
        });
        else {
            const els = Array.from(this.cloneEl.querySelectorAll("*")).map((el)=>Array.from(el.childNodes).filter((node)=>node instanceof Text && node.textContent.trim().length > 0)).flat();
            // console.log(els, this.cloneEl);
            Object.keys(keyPair).forEach((key)=>{
                els.filter((el)=>el.textContent.includes(`{{${key}}}`)).forEach((el)=>{
                    const path = $e533c87ae7d96e3e$export$5fe4b019801f5ef1(el.parentElement, this.cloneEl);
                    const _el = $9e73fdbf37a9aa00$export$7ffef3582c93037b(path, this.element);
                    // console.log(
                    //   el,
                    //   _el,
                    //   " found",
                    //   path,
                    //   el.parentElement,
                    //   this
                    // );
                    if (_el) _el.textContent = el.textContent.replace(`{{${key}}}`, keyPair[key].toString());
                    else console.log(el, _el, "not found", path, el.parentElement, this);
                });
            });
        }
    }
    setAttribute(key, value) {
        this.element.setAttribute(key, value);
    }
    removeAttribute(key) {
        this.element.removeAttribute(key);
    }
    getAttribute(key) {
        return this.element.getAttribute(key);
    }
    hasAttribute(key) {
        return this.element.hasAttribute(key);
    }
    getChildAsComponents(selector) {
        return Array.from(this.element.querySelectorAll(selector)).map((el)=>new $5ce0995b4e579efe$export$b8941e06d24ae728(el));
    }
    getChildAsComponent(selector) {
        return new $5ce0995b4e579efe$export$b8941e06d24ae728(this.element.querySelector(selector));
    }
    getManyChildAsComponents(selectors) {
        let _els = {};
        Object.keys(selectors).forEach((key)=>{
            _els[key] = new $5ce0995b4e579efe$export$b8941e06d24ae728(this.element.querySelector(selectors[key]));
        });
        return _els;
    }
    getCssClass() {
        return Array.from(this.element.classList);
    }
    addCssClass(className) {
        this.element.classList.add(className);
        this.cloneEl.classList.add(className);
    }
    removeCssClass(className) {
        this.element.classList.remove(className);
        this.cloneEl.classList.remove(className);
    }
    replaceCssClass(className, newClassName) {
        this.element.classList.replace(className, newClassName);
        this.cloneEl.classList.replace(className, newClassName);
    }
    toggleCssClass(className) {
        this.element.classList.toggle(className);
        this.cloneEl.classList.toggle(className);
    }
    on(type, listener, options) {
        this.element.addEventListener(type, listener, options);
    }
    off(type, listener, options) {
        this.element.removeEventListener(type, listener, options);
    }
    setText(text) {
        this.getElement().innerText = text.toString();
    }
    getText() {
        return this.getElement().innerText;
    }
    setTextContent(text) {
        this.getElement().textContent = text;
    }
    getTextContent() {
        return this.getElement().textContent;
    }
    setHTML(htmlText) {
        this.getElement().innerHTML = htmlText;
    }
    getHTML() {
        return this.getElement().innerHTML;
    }
    getCloneAsComponent() {
        return new $5ce0995b4e579efe$export$b8941e06d24ae728(this.cloneEl.cloneNode(true));
    }
    setStyle(style = {}) {
        Object.keys(style).forEach((key)=>{
            this.element.style[key] = style[key];
        });
    }
    getStyle() {
        return window.getComputedStyle(this.element);
    }
    appendChild(child) {
        this.element.appendChild(new $5ce0995b4e579efe$export$b8941e06d24ae728(child).getElement());
    }
    remove() {
        this.element.remove();
    }
    removeAllChildren() {
        this.element.replaceChildren();
    }
}
var $0105599dd5ebe189$exports = {};
$parcel$export($0105599dd5ebe189$exports, "WFDynamicList", ()=>$0105599dd5ebe189$export$688e73055717bd51);
class $0105599dd5ebe189$export$688e73055717bd51 extends $5ce0995b4e579efe$export$b8941e06d24ae728 {
    showLoadingState = false;
    constructor(query, config){
        super(query);
        if (typeof config.rowSelector === "string") this.rowComponent = this.getChildAsComponent(config.rowSelector);
        else this.rowComponent = new $5ce0995b4e579efe$export$b8941e06d24ae728(config.rowSelector);
        this.rowComponent.remove();
        if (config.loaderSelector) {
            if (typeof config.loaderSelector === "string") this.loaderComponent = this.getChildAsComponent(config.loaderSelector);
            else this.loaderComponent = new $5ce0995b4e579efe$export$b8941e06d24ae728(config.loaderSelector);
            this.loaderComponent.remove();
        }
        if (config.emptySelector) {
            if (typeof config.emptySelector === "string") this.emptyComponent = this.getChildAsComponent(config.emptySelector);
            else this.emptyComponent = new $5ce0995b4e579efe$export$b8941e06d24ae728(config.emptySelector);
            this.emptyComponent.remove();
        }
    }
    rowRenderer(cb) {
        this.rowRendererCB = cb;
    }
    emptyRenderer(cb) {
        this.emptyRendererCB = cb;
    }
    loaderRenderer(cb) {
        this.loaderRendererCB = cb;
    }
    setData(data) {
        this.data = data;
        this.render();
    }
    render() {
        if (!this.rowRendererCB) throw new Error("Unable to find renderer");
        this.hideLoading();
        this.removeAllChildren();
        if (this.data.length === 0 && this.emptyComponent) this.showEmpty();
        this.data.map((rowData, index, data)=>this.rowRendererCB({
                index: index,
                rowData: rowData,
                rowElement: this.rowComponent.getCloneAsComponent(),
                data: data
            })).filter((d)=>d).forEach((d)=>{
            this.appendChild(d);
        });
        if (this.showLoadingState) this.showLoading();
    }
    changeLoadingStatus(state) {
        this.showLoadingState = state;
        if (state) this.showLoading();
        else this.hideLoading();
    }
    showLoading() {
        this.hideLoading();
        if (!this.loaderComponent) return;
        if (this.loaderRendererCB) {
            this.lastLoadingComponent = this.loaderRendererCB(this.loaderComponent.getCloneAsComponent());
            this.appendChild(this.lastLoadingComponent);
        } else {
            this.lastLoadingComponent = this.loaderComponent.getCloneAsComponent();
            this.appendChild(this.lastLoadingComponent);
        }
    }
    showEmpty() {
        this.hideEmpty();
        if (this.emptyRendererCB) {
            this.lastEmptyComponent = this.emptyRendererCB(this.emptyComponent.getCloneAsComponent());
            this.appendChild(this.lastEmptyComponent);
        } else {
            this.lastEmptyComponent = this.emptyComponent.getCloneAsComponent();
            this.appendChild(this.lastEmptyComponent);
        }
    }
    hideLoading() {
        if (this.lastLoadingComponent) this.lastLoadingComponent.remove();
    }
    hideEmpty() {
        if (this.lastEmptyComponent) this.lastEmptyComponent.remove();
    }
    forceRender() {
        this.render();
    }
}
var $ce18c18667e54846$exports = {};
$parcel$export($ce18c18667e54846$exports, "WFFormComponent", ()=>$ce18c18667e54846$export$e7173e584c7cbeff);
class $ce18c18667e54846$export$e7173e584c7cbeff extends $5ce0995b4e579efe$export$b8941e06d24ae728 {
    defaultFormDisplayStyle = "";
    constructor(query){
        super(query);
        this.formComponent = this.getChildAsComponents("form")[0];
        this.defaultFormDisplayStyle = window.getComputedStyle(this.formComponent.getElement()).display;
    }
    getFormData() {
        const _data = {};
        new FormData(this.formComponent.getElement()).forEach((val, key)=>{
            if (_data[key]) _data[key] = [
                _data[key],
                val
            ].flat();
            else _data[key] = val;
        });
        return _data;
    }
    setFromData(data) {
        Object.keys(data).forEach((key)=>{
            this.getFormComponent().getElement().querySelector(`[name="${key}"]`).value = data[key];
        });
    }
    onFormSubmit(cb) {
        this.formComponent.getElement().onsubmit = (ev)=>{
            ev.preventDefault();
            ev.stopPropagation();
            ev.stopImmediatePropagation();
            cb(this.getFormData(), ev);
        };
    }
    submitWebflowForm() {
        const wfForm = Object.keys(this.formComponent.getElement()).filter((d)=>d.includes("jQuery")).map((d)=>this.formComponent.getElement()[d]).filter((d)=>typeof d === "object" && ".wForm" in d).map((d)=>d[".wForm"]).reduce((d)=>d);
        if (wfForm && wfForm.handler) wfForm.handler(wfForm);
        else if (wfForm && wfForm.action) this.formComponent.getElement().submit();
    }
    getFormComponent() {
        return this.formComponent;
    }
    getSuccessComponent() {
        return this.getChildAsComponents(".w-form-done")[0];
    }
    getErrorComponent() {
        return this.getChildAsComponents(".w-form-fail")[0];
    }
    showSuccessState() {
        this.formComponent.getElement().style.display = "none";
        this.getErrorComponent().getElement().style.display = "none";
        this.getSuccessComponent().getElement().style.display = "block";
    }
    showErrorState() {
        this.getSuccessComponent().getElement().style.display = "none";
        this.getErrorComponent().getElement().style.display = "block";
        this.formComponent.getElement().style.display = this.defaultFormDisplayStyle;
    }
    showForm() {
        this.getErrorComponent().getElement().style.display = "none";
        this.getSuccessComponent().getElement().style.display = "none";
        this.formComponent.getElement().style.display = this.defaultFormDisplayStyle;
    }
    disableForm() {
        const _els = this.formComponent.getElement().querySelectorAll("input, select, option, textarea, button");
        Array.from(_els).forEach((el)=>{
            el.setAttribute("disabled", "disabled");
        });
    }
    enableForm() {
        const _els = this.formComponent.getElement().querySelectorAll("input, select, option, textarea, button");
        Array.from(_els).forEach((el)=>{
            el.removeAttribute("disabled");
        });
    }
    getSubmitButton() {
        return this.formComponent.getChildAsComponents(`[type="submit"]`)[0];
    }
    resetForm() {
        this.formComponent.getElement().reset();
    }
    updateSubmitButtonText(text) {
        this.getSubmitButton().setAttribute("value", text);
    }
}
var $b73002af79232c1a$exports = {};
$parcel$export($b73002af79232c1a$exports, "WFRoute", ()=>$b73002af79232c1a$export$4e1b92c1162557be);
class $b73002af79232c1a$export$4e1b92c1162557be {
    middlewareAllowExecutionOnFail = false;
    constructor(route){
        this.route = route;
    }
    withMiddleware(middleware, role, type = "allow", options = {}) {
        this.middleware = middleware;
        this.middlewareRole = role;
        this.middlewareType = type;
        if ("allowExecutionOnFail" in options) this.middlewareAllowExecutionOnFail = options.allowExecutionOnFail === true;
        if ("onError" in options) this.middlewareErrorFn = options.onError;
        return this;
    }
    validateRole() {
        return this.middlewareType === "allow" ? this.middleware.allowTo(this.middlewareRole) : this.middleware.disallowedTo(this.middlewareRole);
    }
    execute(fn) {
        const _match = $0b3f70b8f06eedca$export$6c50148cf1d992bd(this.route, location.pathname);
        if (_match) {
            $62881ab850a57a38$export$1c9f709888824e05("matched fn start", this.route, location.pathname);
            if (this.middleware) {
                const canAccess = this.validateRole();
                $62881ab850a57a38$export$1c9f709888824e05("checking access role", this.route, this.middlewareRole, this.middlewareType, "canAccess", canAccess, this.middlewareAllowExecutionOnFail);
                if (canAccess || this.middlewareAllowExecutionOnFail) fn({
                    ..._match,
                    ...$100caf27c28c32c0$export$1346b4a9ff9b6881()
                }, canAccess, this.middleware.getAuth());
                else this.middlewareErrorFn && this.middlewareErrorFn();
            } else fn({
                ..._match,
                ...$100caf27c28c32c0$export$1346b4a9ff9b6881()
            }, true);
            $62881ab850a57a38$export$1c9f709888824e05("matched fn end", this.route, location.pathname);
        } else $62881ab850a57a38$export$1c9f709888824e05("did not match", this.route, location.pathname);
        return this;
    }
}
var $16d2504bbe4bb459$exports = {};
$parcel$export($16d2504bbe4bb459$exports, "onReady", ()=>$16d2504bbe4bb459$export$ef1639a4b889352d);
/**
 * @description execute code when the page is loaded
 * @param cb callback function
 */ const $16d2504bbe4bb459$export$ef1639a4b889352d = (cb)=>{
    window.Webflow ||= [];
    window.Webflow.push(()=>{
        cb();
    });
};
var $78395a99ad91c494$exports = {};
$parcel$export($78395a99ad91c494$exports, "WFInvisibleForm", ()=>$78395a99ad91c494$export$bc36999d76b95c72);
class $78395a99ad91c494$export$bc36999d76b95c72 {
    loading = false;
    loadingListener = new Map();
    successListener = new Map();
    errorListener = new Map();
    constructor(formName = ""){
        this.fromName = formName;
        this.siteId = document.querySelector("html").getAttribute("data-wf-site") || "";
    }
    setFormName(formName) {
        this.fromName = formName;
    }
    getFormName() {
        return this.fromName;
    }
    setFormData(data) {
        this.data = data;
    }
    getFormData() {
        return this.data;
    }
    isLoading() {
        return this.loading;
    }
    onLoadingChange(fn) {
        const _id = (0, $iEn1Z$uuid.v4)();
        this.loadingListener.set(_id, fn);
        return ()=>{
            this.loadingListener.delete(_id);
        };
    }
    onSuccess(fn) {
        const _id = (0, $iEn1Z$uuid.v4)();
        this.successListener.set(_id, fn);
        return ()=>{
            this.successListener.delete(_id);
        };
    }
    onError(fn) {
        const _id = (0, $iEn1Z$uuid.v4)();
        this.errorListener.set(_id, fn);
        return ()=>{
            this.errorListener.delete(_id);
        };
    }
    updateLoadingState(state) {
        this.loading = state;
        this.loadingListener.forEach((fn)=>{
            fn(this.loading);
        });
    }
    formSubmitted() {
        this.successListener.forEach((fn)=>{
            fn();
        });
    }
    formFailed() {
        this.errorListener.forEach((fn)=>{
            fn();
        });
    }
    submitForm() {
        const _updateStatus = (state)=>{
            this.updateLoadingState(state);
        };
        const onFailed = ()=>{
            this.formFailed();
        };
        const onDone = ()=>{
            this.formSubmitted();
        };
        _updateStatus(true);
        window["jQuery"].ajax({
            url: `https://webflow.com/api/v1/form/${this.siteId}`,
            type: "POST",
            data: {
                name: this.fromName || "Untitled Form",
                source: location.href,
                test: false,
                fields: this.data,
                dolphin: false
            },
            dataType: "json",
            crossDomain: true
        }).done(function(response) {
            _updateStatus(false);
            if (response && response.code === 200) onDone();
            else onFailed();
        }).fail(function() {
            _updateStatus(false);
            onFailed();
        });
    }
}
$parcel$exportWildcard(module.exports, $90b1e0f272b5544a$exports);
$parcel$exportWildcard(module.exports, $336c7a32b438dc35$exports);
$parcel$exportWildcard(module.exports, $5ce0995b4e579efe$exports);
$parcel$exportWildcard(module.exports, $0105599dd5ebe189$exports);
$parcel$exportWildcard(module.exports, $ce18c18667e54846$exports);
$parcel$exportWildcard(module.exports, $b73002af79232c1a$exports);
$parcel$exportWildcard(module.exports, $30d957643bf2e67a$exports);
$parcel$exportWildcard(module.exports, $16d2504bbe4bb459$exports);
$parcel$exportWildcard(module.exports, $78395a99ad91c494$exports);

},{"116fc168c31b637d":"hIyym"}],"hIyym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", ()=>(0, _v1JsDefault.default));
parcelHelpers.export(exports, "v3", ()=>(0, _v3JsDefault.default));
parcelHelpers.export(exports, "v4", ()=>(0, _v4JsDefault.default));
parcelHelpers.export(exports, "v5", ()=>(0, _v5JsDefault.default));
parcelHelpers.export(exports, "NIL", ()=>(0, _nilJsDefault.default));
parcelHelpers.export(exports, "version", ()=>(0, _versionJsDefault.default));
parcelHelpers.export(exports, "validate", ()=>(0, _validateJsDefault.default));
parcelHelpers.export(exports, "stringify", ()=>(0, _stringifyJsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseJsDefault.default));
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":"iQ6UN","./v3.js":"fW2F8","./v4.js":"h4z53","./v5.js":"jMNKD","./nil.js":"5Bod7","./version.js":"dnsqZ","./validate.js":"eG5s0","./stringify.js":"doA1n","./parse.js":"j2gue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"iQ6UN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js"); // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
let _nodeId;
let _clockseq; // Previous uuid creation time
let _lastMSecs = 0;
let _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    let i = buf && offset || 0;
    const b = buf || new Array(16);
    options = options || {};
    let node = options.node || _nodeId;
    let clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        const seedBytes = options.random || (options.rng || (0, _rngJsDefault.default))();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    let msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    let nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
    const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
     // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000; // `time_low`
    const tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff; // `time_mid`
    const tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff; // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
    b[i++] = clockseq & 0xff; // `node`
    for(let n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf || (0, _stringifyJs.unsafeStringify)(b);
}
exports.default = v1;

},{"./rng.js":"fo5Bv","./stringify.js":"doA1n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fo5Bv":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rng);
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jiucr":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"doA1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", ()=>unsafeStringify);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const byteToHex = [];
for(let i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr, offset = 0) {
    const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"eG5s0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"eG5s0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"2jBiL","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2jBiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fW2F8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _md5Js = require("./md5.js");
var _md5JsDefault = parcelHelpers.interopDefault(_md5Js);
const v3 = (0, _v35JsDefault.default)('v3', 0x30, (0, _md5JsDefault.default));
exports.default = v3;

},{"./v35.js":"6feLd","./md5.js":"gsSTl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6feLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DNS", ()=>DNS);
parcelHelpers.export(exports, "URL", ()=>URL);
parcelHelpers.export(exports, "default", ()=>v35);
var _stringifyJs = require("./stringify.js");
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    const bytes = [];
    for(let i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
    return bytes;
}
const DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
const URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
        var _namespace;
        if (typeof value === 'string') value = stringToBytes(value);
        if (typeof namespace === 'string') namespace = (0, _parseJsDefault.default)(namespace);
        if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
         // Compute hash of namespace and value, Per 4.3
        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
        // hashfunc([...namespace, ... value])`
        let bytes = new Uint8Array(16 + value.length);
        bytes.set(namespace);
        bytes.set(value, namespace.length);
        bytes = hashfunc(bytes);
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) {
            offset = offset || 0;
            for(let i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
            return buf;
        }
        return (0, _stringifyJs.unsafeStringify)(bytes);
    } // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name; // eslint-disable-next-line no-empty
    } catch (err) {} // For CommonJS default export support
    generateUUID.DNS = DNS;
    generateUUID.URL = URL;
    return generateUUID;
}

},{"./stringify.js":"doA1n","./parse.js":"j2gue","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"j2gue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function parse(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    let v;
    const arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
exports.default = parse;

},{"./validate.js":"eG5s0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gsSTl":[function(require,module,exports,__globalThis) {
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function md5(bytes) {
    if (typeof bytes === 'string') {
        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = new Uint8Array(msg.length);
        for(let i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
    }
    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
    const output = [];
    const length32 = input.length * 32;
    const hexTab = '0123456789abcdef';
    for(let i = 0; i < length32; i += 8){
        const x = input[i >> 5] >>> i % 32 & 0xff;
        const hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
        output.push(hex);
    }
    return output;
}
/**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[getOutputLength(len) - 1] = len;
    let a = 1732584193;
    let b = -271733879;
    let c = -1732584194;
    let d = 271733878;
    for(let i = 0; i < x.length; i += 16){
        const olda = a;
        const oldb = b;
        const oldc = c;
        const oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
    if (input.length === 0) return [];
    const length8 = input.length * 8;
    const output = new Uint32Array(getOutputLength(length8));
    for(let i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
    return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
    const lsw = (x & 0xffff) + (y & 0xffff);
    const msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
exports.default = md5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"h4z53":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"agPy7","./rng.js":"fo5Bv","./stringify.js":"doA1n","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"agPy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jMNKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _sha1Js = require("./sha1.js");
var _sha1JsDefault = parcelHelpers.interopDefault(_sha1Js);
const v5 = (0, _v35JsDefault.default)('v5', 0x50, (0, _sha1JsDefault.default));
exports.default = v5;

},{"./v35.js":"6feLd","./sha1.js":"bDFTF","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bDFTF":[function(require,module,exports,__globalThis) {
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function sha1(bytes) {
    const K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    const H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes === 'string') {
        const msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = [];
        for(let i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
    bytes.push(0x80);
    const l = bytes.length / 4 + 2;
    const N = Math.ceil(l / 16);
    const M = new Array(N);
    for(let i = 0; i < N; ++i){
        const arr = new Uint32Array(16);
        for(let j = 0; j < 16; ++j)arr[j] = bytes[i * 64 + j * 4] << 24 | bytes[i * 64 + j * 4 + 1] << 16 | bytes[i * 64 + j * 4 + 2] << 8 | bytes[i * 64 + j * 4 + 3];
        M[i] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(let i = 0; i < N; ++i){
        const W = new Uint32Array(80);
        for(let t = 0; t < 16; ++t)W[t] = M[i][t];
        for(let t = 16; t < 80; ++t)W[t] = ROTL(W[t - 3] ^ W[t - 8] ^ W[t - 14] ^ W[t - 16], 1);
        let a = H[0];
        let b = H[1];
        let c = H[2];
        let d = H[3];
        let e = H[4];
        for(let t = 0; t < 80; ++t){
            const s = Math.floor(t / 20);
            const T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t] >>> 0;
            e = d;
            d = c;
            c = ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
exports.default = sha1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5Bod7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '00000000-0000-0000-0000-000000000000';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dnsqZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function version(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    return parseInt(uuid.slice(14, 15), 16);
}
exports.default = version;

},{"./validate.js":"eG5s0","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2uPfR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "app", ()=>app);
var _core = require("@xatom/core");
var _auth = require("../modules/auth");
var _posthogJs = require("posthog-js");
var _posthogJsDefault = parcelHelpers.interopDefault(_posthogJs);
var _config = require("../config");
const app = ()=>{
    // Track page views
    const trackPageView = (path)=>{
        (0, _posthogJsDefault.default).capture("$pageview", {
            path
        });
    };
    new (0, _core.WFRoute)("/(.*)").execute(()=>{
        const urlPath = window.location.pathname;
        trackPageView(urlPath);
    });
    new (0, _core.WFRoute)((0, _config.websiteRoutes).mainDashboard).execute(()=>{
        require("431cef64251fde3b").then(({ initInspirationHandlerPage })=>initInspirationHandlerPage()).catch(console.error);
        require("32037615a3f8fbd1").then(({ initComponentsPage })=>initComponentsPage()).catch(console.error);
    });
    //will trigger route matches /auth/*
    new (0, _core.WFRoute)("/app/(.*)").withMiddleware((0, _auth.userMiddleware), "GUEST", "allow", {
        onError () {
            (0, _core.navigate)("/components/");
        }
    }).execute(()=>{
        //will trigger route matches /auth/sign-up
        new (0, _core.WFRoute)("/app/login").execute(()=>{
            //lazy loading route
            require("124a5e4ffe80a2c8").then(({ login })=>login()).catch(console.error);
        });
        //will trigger route matches /auth/sign-in
        new (0, _core.WFRoute)("/app/signup").execute(()=>{
            //lazy loading route
            require("8dff4a7369311fc").then(({ signUp })=>signUp()).catch(console.error);
        });
        //will trigger route matches /auth/verify
        new (0, _core.WFRoute)("/app/verify").execute(()=>{
            //lazy loading route
            require("d2ff0736bf12c1b5").then(({ verify })=>verify()).catch(console.error);
        });
    });
    new (0, _core.WFRoute)("/inspirations").execute(()=>{
        require("431cef64251fde3b").then(({ initInspirationHandlerPage })=>initInspirationHandlerPage()).catch(console.error);
    });
    new (0, _core.WFRoute)("/inspiration/(.*)").execute(()=>{
        //will trigger route matches /app/task-list
        require("429a653045d559e1").then(({ initInspirationPage })=>initInspirationPage()).catch(console.error);
    });
    new (0, _core.WFRoute)("/preview").execute((params)=>{
        require("c3b0c4086fc45adf").then(({ Preview })=>{
            new Preview(params.comp_id).init();
        }).catch(console.error);
    });
    new (0, _core.WFRoute)("/components").execute(()=>{
        require("32037615a3f8fbd1").then(({ initComponentsPage })=>initComponentsPage()).catch(console.error);
    });
    new (0, _core.WFRoute)("/components/(.*)").execute(()=>{
        require("32037615a3f8fbd1").then(({ initComponentsPage })=>initComponentsPage()).catch(console.error);
    });
    new (0, _core.WFRoute)("/component/(.*)").execute(()=>{
        require("32037615a3f8fbd1").then(({ initComponentsPage })=>initComponentsPage()).catch(console.error);
    });
    new (0, _core.WFRoute)("/favorites").withMiddleware((0, _auth.userMiddleware), "USER", "allow", {
        onError () {
            (0, _core.navigate)((0, _config.websiteRoutes).login);
        }
    }).execute(()=>{
        require("d6738d715985c5e2").then(({ Favorites })=>new Favorites()).catch(console.error);
    });
};

},{"@xatom/core":"5eqAK","../modules/auth":"apxUl","posthog-js":"2NARa","../config":"dwh13","431cef64251fde3b":"9Y0pX","32037615a3f8fbd1":"d9yXj","124a5e4ffe80a2c8":"iLyIO","8dff4a7369311fc":"26IT8","d2ff0736bf12c1b5":"hveJJ","429a653045d559e1":"fcuxK","c3b0c4086fc45adf":"lAq9d","d6738d715985c5e2":"d0q55","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"apxUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "userAuth", ()=>userAuth);
parcelHelpers.export(exports, "setUser", ()=>setUser);
parcelHelpers.export(exports, "logout", ()=>logout);
parcelHelpers.export(exports, "userMiddleware", ()=>userMiddleware);
var _core = require("@xatom/core");
var _supbase = require("../supbase");
var _supbaseDefault = parcelHelpers.interopDefault(_supbase);
const userAuth = new (0, _core.WFAuth)();
//setting default role
userAuth.setRole("GUEST");
const setUser = (fullName, email)=>{
    userAuth.setUser({
        email,
        fullName
    });
    userAuth.setRole("USER");
};
const logout = ()=>{
    return (0, _supbaseDefault.default).auth.signOut().then(()=>{
        userAuth.logout();
        (0, _core.navigate)("/");
    }).catch((error)=>{
        console.error("Logout failed:", error);
    });
};
const userMiddleware = new (0, _core.WFAuthMiddleware)(userAuth);

},{"@xatom/core":"5eqAK","../supbase":"54PYi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"54PYi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initSupabase", ()=>initSupabase);
var _supabaseJs = require("@supabase/supabase-js");
var _auth = require("../auth");
var _userState = require("../../utils/auth/userState");
var _posthogUser = require("../../utils/posthogUser");
const options = {
    db: {
        schema: "public"
    },
    auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true
    }
};
const supabaseUrl = "https://ezjssbrfuibaueodcuob.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV6anNzYnJmdWliYXVlb2RjdW9iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzAyMDU2MzMsImV4cCI6MjA0NTc4MTYzM30.91GDgZKUEVgMkmRGijW99kdKYotkJreA4-xvJly6DLs";
const supabase = (0, _supabaseJs.createClient)(supabaseUrl, supabaseKey, options);
const handleUserSession = (session)=>{
    if (session?.user?.user_metadata) {
        const user = session.user;
        (0, _auth.setUser)(user.user_metadata.fullName, user.email);
        (0, _posthogUser.identifyUser)(user.id, {
            email: user.email,
            name: user.user_metadata.fullName
        });
        (0, _userState.userStateManager).updateLoginState(true);
    } else (0, _userState.userStateManager).updateLoginState(false);
};
const initSupabase = (cb)=>{
    supabase.auth.getSession().then((data)=>{
        if (!data.error && data.data && data.data.session) handleUserSession(data.data.session);
        else (0, _userState.userStateManager).updateLoginState(false);
    }).catch((err)=>{
        console.log({
            err
        });
        (0, _userState.userStateManager).updateLoginState(false);
    }).finally(cb);
};
supabase.auth.onAuthStateChange((event, session)=>{
    switch(event){
        case "SIGNED_IN":
        case "USER_UPDATED":
        case "INITIAL_SESSION":
            handleUserSession(session);
            break;
        case "SIGNED_OUT":
            (0, _userState.userStateManager).updateLoginState(false);
            break;
    }
});
exports.default = supabase;

},{"@supabase/supabase-js":"7aWuS","../auth":"apxUl","../../utils/auth/userState":"kAY9V","../../utils/posthogUser":"2pVOg","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7aWuS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostgrestError", ()=>(0, _postgrestJs.PostgrestError));
parcelHelpers.export(exports, "FunctionsHttpError", ()=>(0, _functionsJs.FunctionsHttpError));
parcelHelpers.export(exports, "FunctionsFetchError", ()=>(0, _functionsJs.FunctionsFetchError));
parcelHelpers.export(exports, "FunctionsRelayError", ()=>(0, _functionsJs.FunctionsRelayError));
parcelHelpers.export(exports, "FunctionsError", ()=>(0, _functionsJs.FunctionsError));
parcelHelpers.export(exports, "FunctionRegion", ()=>(0, _functionsJs.FunctionRegion));
parcelHelpers.export(exports, "SupabaseClient", ()=>(0, _supabaseClientDefault.default));
parcelHelpers.export(exports, "createClient", ()=>createClient);
var _supabaseClient = require("./SupabaseClient");
var _supabaseClientDefault = parcelHelpers.interopDefault(_supabaseClient);
var _authJs = require("@supabase/auth-js");
parcelHelpers.exportAll(_authJs, exports);
var _postgrestJs = require("@supabase/postgrest-js");
var _functionsJs = require("@supabase/functions-js");
var _realtimeJs = require("@supabase/realtime-js");
parcelHelpers.exportAll(_realtimeJs, exports);
const createClient = (supabaseUrl, supabaseKey, options)=>{
    return new (0, _supabaseClientDefault.default)(supabaseUrl, supabaseKey, options);
};

},{"./SupabaseClient":"3zLHT","@supabase/auth-js":"8VjzZ","@supabase/postgrest-js":"7SSSP","@supabase/functions-js":false,"@supabase/realtime-js":"dSbb2","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3zLHT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _functionsJs = require("@supabase/functions-js");
var _postgrestJs = require("@supabase/postgrest-js");
var _realtimeJs = require("@supabase/realtime-js");
var _storageJs = require("@supabase/storage-js");
var _constants = require("./lib/constants");
var _fetch = require("./lib/fetch");
var _helpers = require("./lib/helpers");
var _supabaseAuthClient = require("./lib/SupabaseAuthClient");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class SupabaseClient {
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error('supabaseUrl is required.');
        if (!supabaseKey) throw new Error('supabaseKey is required.');
        const _supabaseUrl = (0, _helpers.stripTrailingSlash)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, 'ws');
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split('.')[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, _constants.DEFAULT_DB_OPTIONS),
            realtime: (0, _constants.DEFAULT_REALTIME_OPTIONS),
            auth: Object.assign(Object.assign({}, (0, _constants.DEFAULT_AUTH_OPTIONS)), {
                storageKey: defaultStorageKey
            }),
            global: (0, _constants.DEFAULT_GLOBAL_OPTIONS)
        };
        const settings = (0, _helpers.applySettingDefaults)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_a = settings.auth.storageKey) !== null && _a !== void 0 ? _a : '';
        this.headers = (_b = settings.global.headers) !== null && _b !== void 0 ? _b : {};
        if (!settings.accessToken) this.auth = this._initSupabaseAuthClient((_c = settings.auth) !== null && _c !== void 0 ? _c : {}, this.headers, settings.global.fetch);
        else {
            this.accessToken = settings.accessToken;
            this.auth = new Proxy({}, {
                get: (_, prop)=>{
                    throw new Error(`@supabase/supabase-js: Supabase Client is configured with the accessToken option, accessing supabase.auth.${String(prop)} is not possible`);
                }
            });
        }
        this.fetch = (0, _fetch.fetchWithAuth)(supabaseKey, this._getAccessToken.bind(this), settings.global.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers,
            accessToken: this._getAccessToken.bind(this)
        }, settings.realtime));
        this.rest = new (0, _postgrestJs.PostgrestClient)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: settings.db.schema,
            fetch: this.fetch
        });
        if (!settings.accessToken) this._listenForAuthEvents();
    }
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, _functionsJs.FunctionsClient)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, _storageJs.StorageClient)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function*() {
            if (this.accessToken) return yield this.accessToken();
            const { data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken, persistSession, detectSessionInUrl, storage, storageKey, flowType, lock, debug }, headers, fetch) {
        var _a;
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, _supabaseAuthClient.SupabaseAuthClient)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken,
            persistSession,
            detectSessionInUrl,
            storage,
            flowType,
            lock,
            debug,
            fetch,
            // auth checks if there is a custom authorizaiton header using this flag
            // so it knows whether to return an error when getUser is called with no session
            hasCustomAuthorizationHeader: (_a = 'Authorization' in this.headers, _a !== void 0) ? _a : false
        });
    }
    _initRealtimeClient(options) {
        return new (0, _realtimeJs.RealtimeClient)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, 'CLIENT', session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === 'TOKEN_REFRESHED' || event === 'SIGNED_IN') && this.changedAccessToken !== token) this.changedAccessToken = token;
        else if (event === 'SIGNED_OUT') {
            this.realtime.setAuth();
            if (source == 'STORAGE') this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
}
exports.default = SupabaseClient;

},{"@supabase/functions-js":"bltAo","@supabase/postgrest-js":"7SSSP","@supabase/realtime-js":"dSbb2","@supabase/storage-js":"dLDMJ","./lib/constants":"1uIhb","./lib/fetch":"jU4vw","./lib/helpers":"3zuQC","./lib/SupabaseAuthClient":"7YJ7Q","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bltAo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionsClient", ()=>(0, _functionsClient.FunctionsClient));
parcelHelpers.export(exports, "FunctionsError", ()=>(0, _types.FunctionsError));
parcelHelpers.export(exports, "FunctionsFetchError", ()=>(0, _types.FunctionsFetchError));
parcelHelpers.export(exports, "FunctionsHttpError", ()=>(0, _types.FunctionsHttpError));
parcelHelpers.export(exports, "FunctionsRelayError", ()=>(0, _types.FunctionsRelayError));
parcelHelpers.export(exports, "FunctionRegion", ()=>(0, _types.FunctionRegion));
var _functionsClient = require("./FunctionsClient");
var _types = require("./types");

},{"./FunctionsClient":"34eZ1","./types":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"34eZ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionsClient", ()=>FunctionsClient);
var _helper = require("./helper");
var _types = require("./types");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class FunctionsClient {
    constructor(url, { headers = {}, customFetch, region = (0, _types.FunctionRegion).Any } = {}){
        this.url = url;
        this.headers = headers;
        this.region = region;
        this.fetch = (0, _helper.resolveFetch)(customFetch);
    }
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const { headers, method, body: functionArgs } = options;
                let _headers = {};
                let { region } = options;
                if (!region) region = this.region;
                if (region && region !== 'any') _headers['x-region'] = region;
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, 'Content-Type') || !headers)) {
                    if (typeof Blob !== 'undefined' && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers['Content-Type'] = 'application/octet-stream';
                        body = functionArgs;
                    } else if (typeof functionArgs === 'string') {
                        // plain string
                        _headers['Content-Type'] = 'text/plain';
                        body = functionArgs;
                    } else if (typeof FormData !== 'undefined' && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers['Content-Type'] = 'application/json';
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || 'POST',
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body
                }).catch((fetchError)=>{
                    throw new (0, _types.FunctionsFetchError)(fetchError);
                });
                const isRelayError = response.headers.get('x-relay-error');
                if (isRelayError && isRelayError === 'true') throw new (0, _types.FunctionsRelayError)(response);
                if (!response.ok) throw new (0, _types.FunctionsHttpError)(response);
                let responseType = ((_a = response.headers.get('Content-Type')) !== null && _a !== void 0 ? _a : 'text/plain').split(';')[0].trim();
                let data;
                if (responseType === 'application/json') data = yield response.json();
                else if (responseType === 'application/octet-stream') data = yield response.blob();
                else if (responseType === 'text/event-stream') data = response;
                else if (responseType === 'multipart/form-data') data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error
                };
            }
        });
    }
}

},{"./helper":"6UEpC","./types":"f4Ykd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"6UEpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveFetch", ()=>resolveFetch);
const resolveFetch = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>require("db8a7a5aa4509164").then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

},{"db8a7a5aa4509164":"a8HCk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"a8HCk":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("4Q5V1"));

},{}],"f4Ykd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionsError", ()=>FunctionsError);
parcelHelpers.export(exports, "FunctionsFetchError", ()=>FunctionsFetchError);
parcelHelpers.export(exports, "FunctionsRelayError", ()=>FunctionsRelayError);
parcelHelpers.export(exports, "FunctionsHttpError", ()=>FunctionsHttpError);
parcelHelpers.export(exports, "FunctionRegion", ()=>FunctionRegion);
class FunctionsError extends Error {
    constructor(message, name = 'FunctionsError', context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class FunctionsFetchError extends FunctionsError {
    constructor(context){
        super('Failed to send a request to the Edge Function', 'FunctionsFetchError', context);
    }
}
class FunctionsRelayError extends FunctionsError {
    constructor(context){
        super('Relay Error invoking the Edge Function', 'FunctionsRelayError', context);
    }
}
class FunctionsHttpError extends FunctionsError {
    constructor(context){
        super('Edge Function returned a non-2xx status code', 'FunctionsHttpError', context);
    }
}
var FunctionRegion;
(function(FunctionRegion) {
    FunctionRegion["Any"] = "any";
    FunctionRegion["ApNortheast1"] = "ap-northeast-1";
    FunctionRegion["ApNortheast2"] = "ap-northeast-2";
    FunctionRegion["ApSouth1"] = "ap-south-1";
    FunctionRegion["ApSoutheast1"] = "ap-southeast-1";
    FunctionRegion["ApSoutheast2"] = "ap-southeast-2";
    FunctionRegion["CaCentral1"] = "ca-central-1";
    FunctionRegion["EuCentral1"] = "eu-central-1";
    FunctionRegion["EuWest1"] = "eu-west-1";
    FunctionRegion["EuWest2"] = "eu-west-2";
    FunctionRegion["EuWest3"] = "eu-west-3";
    FunctionRegion["SaEast1"] = "sa-east-1";
    FunctionRegion["UsEast1"] = "us-east-1";
    FunctionRegion["UsWest1"] = "us-west-1";
    FunctionRegion["UsWest2"] = "us-west-2";
})(FunctionRegion || (FunctionRegion = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7SSSP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostgrestBuilder", ()=>PostgrestBuilder);
parcelHelpers.export(exports, "PostgrestClient", ()=>PostgrestClient);
parcelHelpers.export(exports, "PostgrestFilterBuilder", ()=>PostgrestFilterBuilder);
parcelHelpers.export(exports, "PostgrestQueryBuilder", ()=>PostgrestQueryBuilder);
parcelHelpers.export(exports, "PostgrestTransformBuilder", ()=>PostgrestTransformBuilder);
parcelHelpers.export(exports, "PostgrestError", ()=>PostgrestError);
var _indexJs = require("../cjs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
const { PostgrestClient, PostgrestQueryBuilder, PostgrestFilterBuilder, PostgrestTransformBuilder, PostgrestBuilder, PostgrestError } = (0, _indexJsDefault.default);
// compatibility with CJS output
exports.default = {
    PostgrestClient,
    PostgrestQueryBuilder,
    PostgrestFilterBuilder,
    PostgrestTransformBuilder,
    PostgrestBuilder,
    PostgrestError
};

},{"../cjs/index.js":"jITuT","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jITuT":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PostgrestError = exports.PostgrestBuilder = exports.PostgrestTransformBuilder = exports.PostgrestFilterBuilder = exports.PostgrestQueryBuilder = exports.PostgrestClient = void 0;
// Always update wrapper.mjs when updating this file.
const PostgrestClient_1 = __importDefault(require("f5e06a51982719bd"));
exports.PostgrestClient = PostgrestClient_1.default;
const PostgrestQueryBuilder_1 = __importDefault(require("df90e8e15649ad51"));
exports.PostgrestQueryBuilder = PostgrestQueryBuilder_1.default;
const PostgrestFilterBuilder_1 = __importDefault(require("599489c94cb82979"));
exports.PostgrestFilterBuilder = PostgrestFilterBuilder_1.default;
const PostgrestTransformBuilder_1 = __importDefault(require("f49dd89b70eda0a2"));
exports.PostgrestTransformBuilder = PostgrestTransformBuilder_1.default;
const PostgrestBuilder_1 = __importDefault(require("aab5557e345022fe"));
exports.PostgrestBuilder = PostgrestBuilder_1.default;
const PostgrestError_1 = __importDefault(require("79848042fc731b87"));
exports.PostgrestError = PostgrestError_1.default;
exports.default = {
    PostgrestClient: PostgrestClient_1.default,
    PostgrestQueryBuilder: PostgrestQueryBuilder_1.default,
    PostgrestFilterBuilder: PostgrestFilterBuilder_1.default,
    PostgrestTransformBuilder: PostgrestTransformBuilder_1.default,
    PostgrestBuilder: PostgrestBuilder_1.default,
    PostgrestError: PostgrestError_1.default
};

},{"f5e06a51982719bd":"1Ot24","df90e8e15649ad51":"i7fD9","599489c94cb82979":"6JEn9","f49dd89b70eda0a2":"jx0WB","aab5557e345022fe":"5u3Bg","79848042fc731b87":"ieSnf"}],"1Ot24":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const PostgrestQueryBuilder_1 = __importDefault(require("46c45ba978d8f946"));
const PostgrestFilterBuilder_1 = __importDefault(require("a418b29a37404612"));
const constants_1 = require("56170df5c50b72a8");
/**
 * PostgREST client.
 *
 * @typeParam Database - Types for the schema from the [type
 * generator](https://supabase.com/docs/reference/javascript/next/typescript-support)
 *
 * @typeParam SchemaName - Postgres schema to switch to. Must be a string
 * literal, the same one passed to the constructor. If the schema is not
 * `"public"`, this must be supplied manually.
 */ class PostgrestClient {
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers = {}, schema, fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, constants_1.DEFAULT_HEADERS), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new PostgrestQueryBuilder_1.default(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new PostgrestClient(this.url, {
            headers: this.headers,
            schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.get - When set to `true`, the function will be called with
     * read-only access mode.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head = false, get = false, count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head || get) {
            method = head ? 'HEAD' : 'GET';
            Object.entries(args)// params with undefined value needs to be filtered out, otherwise it'll
            // show up as `?param=undefined`
            .filter(([_, value])=>value !== undefined)// array values need special syntax
            .map(([name, value])=>[
                    name,
                    Array.isArray(value) ? `{${value.join(',')}}` : `${value}`
                ]).forEach(([name, value])=>{
                url.searchParams.append(name, value);
            });
        } else {
            method = 'POST';
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers['Prefer'] = `count=${count}`;
        return new PostgrestFilterBuilder_1.default({
            method,
            url,
            headers,
            schema: this.schemaName,
            body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
exports.default = PostgrestClient;

},{"46c45ba978d8f946":"i7fD9","a418b29a37404612":"6JEn9","56170df5c50b72a8":"82nQd"}],"i7fD9":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const PostgrestFilterBuilder_1 = __importDefault(require("d92f25ea3845826e"));
class PostgrestQueryBuilder {
    constructor(url, { headers = {}, schema, fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head = false, count } = {}) {
        const method = head ? 'HEAD' : 'GET';
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (count) this.headers['Prefer'] = `count=${count}`;
        return new PostgrestFilterBuilder_1.default({
            method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count, defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new PostgrestFilterBuilder_1.default({
            method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict, ignoreDuplicates = false, count, defaultToNull = true } = {}) {
        const method = 'POST';
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? 'ignore' : 'merge'}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set('on_conflict', onConflict);
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push('missing=default');
        this.headers['Prefer'] = prefersHeaders.join(',');
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set('columns', uniqueColumns.join(','));
            }
        }
        return new PostgrestFilterBuilder_1.default({
            method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count } = {}) {
        const method = 'PATCH';
        const prefersHeaders = [];
        if (this.headers['Prefer']) prefersHeaders.push(this.headers['Prefer']);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new PostgrestFilterBuilder_1.default({
            method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count } = {}) {
        const method = 'DELETE';
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers['Prefer']) prefersHeaders.unshift(this.headers['Prefer']);
        this.headers['Prefer'] = prefersHeaders.join(',');
        return new PostgrestFilterBuilder_1.default({
            method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
}
exports.default = PostgrestQueryBuilder;

},{"d92f25ea3845826e":"6JEn9"}],"6JEn9":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const PostgrestTransformBuilder_1 = __importDefault(require("f4f4faf3c6f1b259"));
class PostgrestFilterBuilder extends PostgrestTransformBuilder_1.default {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(',')}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = Array.from(new Set(values)).map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === 'string' && new RegExp('[,()]').test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(',');
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === 'string') // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(',')}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === 'string') // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(',')}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config, type } = {}) {
        let typePart = '';
        if (type === 'plain') typePart = 'pl';
        else if (type === 'phrase') typePart = 'ph';
        else if (type === 'websearch') typePart = 'w';
        const configPart = config === undefined ? '' : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable, referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : 'or';
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}
exports.default = PostgrestFilterBuilder;

},{"f4f4faf3c6f1b259":"jx0WB"}],"jx0WB":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
const PostgrestBuilder_1 = __importDefault(require("389721aef4055205"));
class PostgrestTransformBuilder extends PostgrestBuilder_1.default {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : '*').split('').map((c)=>{
            if (/\s/.test(c) && !quoted) return '';
            if (c === '"') quoted = !quoted;
            return c;
        }).join('');
        this.url.searchParams.set('select', cleanedColumns);
        if (this.headers['Prefer']) this.headers['Prefer'] += ',';
        this.headers['Prefer'] += 'return=representation';
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending = true, nullsFirst, foreignTable, referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : 'order';
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ''}${column}.${ascending ? 'asc' : 'desc'}${nullsFirst === undefined ? '' : nullsFirst ? '.nullsfirst' : '.nullslast'}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable, referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset `from` and ending at the offset `to`.
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable, referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === 'undefined' ? 'offset' : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === 'undefined' ? 'limit' : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === 'GET') this.headers['Accept'] = 'application/json';
        else this.headers['Accept'] = 'application/vnd.pgrst.object+json';
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers['Accept'] = 'text/csv';
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers['Accept'] = 'application/geo+json';
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze = false, verbose = false, settings = false, buffers = false, wal = false, format = 'text' } = {}) {
        var _a;
        const options = [
            analyze ? 'analyze' : null,
            verbose ? 'verbose' : null,
            settings ? 'settings' : null,
            buffers ? 'buffers' : null,
            wal ? 'wal' : null
        ].filter(Boolean).join('|');
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers['Accept']) !== null && _a !== void 0 ? _a : 'application/json';
        this.headers['Accept'] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === 'json') return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers['Prefer']) !== null && _a !== void 0 ? _a : '').trim().length > 0) this.headers['Prefer'] += ',tx=rollback';
        else this.headers['Prefer'] = 'tx=rollback';
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */ returns() {
        return this;
    }
}
exports.default = PostgrestTransformBuilder;

},{"389721aef4055205":"5u3Bg"}],"5u3Bg":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
// @ts-ignore
const node_fetch_1 = __importDefault(require("a07474f6bfb42ff0"));
const PostgrestError_1 = __importDefault(require("d8f4708fc301a50"));
class PostgrestBuilder {
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === 'undefined') this.fetch = node_fetch_1.default;
        else this.fetch = fetch;
    }
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    /**
     * Set an HTTP header for the request.
     */ setHeader(name, value) {
        this.headers = Object.assign({}, this.headers);
        this.headers[name] = value;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            'GET',
            'HEAD'
        ].includes(this.method)) this.headers['Accept-Profile'] = this.schema;
        else this.headers['Content-Profile'] = this.schema;
        if (this.method !== 'GET' && this.method !== 'HEAD') this.headers['Content-Type'] = 'application/json';
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== 'HEAD') {
                    const body = await res.text();
                    if (body === '') ;
                    else if (this.headers['Accept'] === 'text/csv') data = body;
                    else if (this.headers['Accept'] && this.headers['Accept'].includes('application/vnd.pgrst.plan+text')) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers['Prefer']) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get('content-range')) === null || _b === void 0 ? void 0 : _b.split('/');
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === 'GET' && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: 'PGRST116',
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: 'JSON object requested, multiple (or no) rows returned'
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = 'Not Acceptable';
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = 'OK';
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === '') {
                        status = 204;
                        statusText = 'No Content';
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes('0 rows'))) {
                    error = null;
                    status = 200;
                    statusText = 'OK';
                }
                if (error && this.shouldThrowOnError) throw new PostgrestError_1.default(error);
            }
            const postgrestResponse = {
                error,
                data,
                count,
                status,
                statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : 'FetchError'}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ''}`,
                    hint: '',
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ''}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ''
            };
        });
        return res.then(onfulfilled, onrejected);
    }
}
exports.default = PostgrestBuilder;

},{"a07474f6bfb42ff0":"4Q5V1","d8f4708fc301a50":"ieSnf"}],"4Q5V1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetch", ()=>fetch);
parcelHelpers.export(exports, "Headers", ()=>Headers);
parcelHelpers.export(exports, "Request", ()=>Request);
parcelHelpers.export(exports, "Response", ()=>Response);
var global = arguments[3];
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    throw new Error('unable to locate global object');
};
var globalObject = getGlobal();
const fetch = globalObject.fetch;
exports.default = globalObject.fetch.bind(globalObject);
const Headers = globalObject.Headers;
const Request = globalObject.Request;
const Response = globalObject.Response;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ieSnf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Error format
 *
 * {@link https://postgrest.org/en/stable/api.html?highlight=options#errors-and-http-status-codes}
 */ class PostgrestError extends Error {
    constructor(context){
        super(context.message);
        this.name = 'PostgrestError';
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}
exports.default = PostgrestError;

},{}],"82nQd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_HEADERS = void 0;
const version_1 = require("f6ef08da709cffa4");
exports.DEFAULT_HEADERS = {
    'X-Client-Info': `postgrest-js/${version_1.version}`
};

},{"f6ef08da709cffa4":"2psnM"}],"2psnM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.version = void 0;
exports.version = '0.0.0-automated';

},{}],"dSbb2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RealtimePresence", ()=>(0, _realtimePresenceDefault.default));
parcelHelpers.export(exports, "RealtimeChannel", ()=>(0, _realtimeChannelDefault.default));
parcelHelpers.export(exports, "RealtimeClient", ()=>(0, _realtimeClientDefault.default));
parcelHelpers.export(exports, "REALTIME_LISTEN_TYPES", ()=>(0, _realtimeChannel.REALTIME_LISTEN_TYPES));
parcelHelpers.export(exports, "REALTIME_POSTGRES_CHANGES_LISTEN_EVENT", ()=>(0, _realtimeChannel.REALTIME_POSTGRES_CHANGES_LISTEN_EVENT));
parcelHelpers.export(exports, "REALTIME_PRESENCE_LISTEN_EVENTS", ()=>(0, _realtimePresence.REALTIME_PRESENCE_LISTEN_EVENTS));
parcelHelpers.export(exports, "REALTIME_SUBSCRIBE_STATES", ()=>(0, _realtimeChannel.REALTIME_SUBSCRIBE_STATES));
parcelHelpers.export(exports, "REALTIME_CHANNEL_STATES", ()=>(0, _realtimeChannel.REALTIME_CHANNEL_STATES));
var _realtimeClient = require("./RealtimeClient");
var _realtimeClientDefault = parcelHelpers.interopDefault(_realtimeClient);
var _realtimeChannel = require("./RealtimeChannel");
var _realtimeChannelDefault = parcelHelpers.interopDefault(_realtimeChannel);
var _realtimePresence = require("./RealtimePresence");
var _realtimePresenceDefault = parcelHelpers.interopDefault(_realtimePresence);

},{"./RealtimeClient":"bwAzk","./RealtimeChannel":"kPfVs","./RealtimePresence":"1SbUv","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bwAzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("./lib/constants");
var _serializer = require("./lib/serializer");
var _serializerDefault = parcelHelpers.interopDefault(_serializer);
var _timer = require("./lib/timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
var _transformers = require("./lib/transformers");
var _realtimeChannel = require("./RealtimeChannel");
var _realtimeChannelDefault = parcelHelpers.interopDefault(_realtimeChannel);
const noop = ()=>{};
const NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== 'undefined';
const WORKER_SCRIPT = `
  addEventListener("message", (e) => {
    if (e.data.event === "start") {
      setInterval(() => postMessage({ event: "keepAlive" }), e.data.interval);
    }
  });`;
class RealtimeClient {
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param httpEndpoint The string HTTP endpoint, ie, "https://example.com", "/" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     * @param options.worker Use Web Worker to set a side flow. Defaults to false.
     * @param options.workerUrl The URL of the worker script. Defaults to https://realtime.supabase.com/worker.js that includes a heartbeat event call to keep the connection alive.
     */ constructor(endPoint, options){
        var _a;
        this.accessTokenValue = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = '';
        this.httpEndpoint = '';
        this.headers = (0, _constants.DEFAULT_HEADERS);
        this.params = {};
        this.timeout = (0, _constants.DEFAULT_TIMEOUT);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, _serializerDefault.default)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        this.accessToken = null;
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === 'undefined') _fetch = (...args)=>require("3ea8640035012c43").then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, _constants.TRANSPORTS).websocket}`;
        this.httpEndpoint = (0, _transformers.httpEndpointURL)(endPoint);
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessTokenValue = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessTokenValue) {
            this.accessTokenValue = accessTokenValue;
            this.apiKey = accessTokenValue;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, _timerDefault.default)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
        if (options === null || options === void 0 ? void 0 : options.worker) {
            if (typeof window !== 'undefined' && !window.Worker) throw new Error('Web Worker is not supported');
            this.worker = (options === null || options === void 0 ? void 0 : options.worker) || false;
            this.workerUrl = options === null || options === void 0 ? void 0 : options.workerUrl;
        }
        this.accessToken = (options === null || options === void 0 ? void 0 : options.accessToken) || null;
    }
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (this.transport) {
            this.conn = new this.transport(this.endpointURL(), undefined, {
                headers: this.headers
            });
            return;
        }
        if (NATIVE_WEBSOCKET_AVAILABLE) {
            this.conn = new WebSocket(this.endpointURL());
            this.setupConnection();
            return;
        }
        this.conn = new WSWebSocketDummy(this.endpointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
        require("c4dfe9bfdd39a2b7").then(({ default: WS })=>{
            this.conn = new WS(this.endpointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
        });
    }
    /**
     * Returns the URL of the websocket.
     * @returns string The URL of the websocket.
     */ endpointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, _constants.VSN)
        }));
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : '');
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, _constants.SOCKET_STATES).connecting:
                return (0, _constants.CONNECTION_STATE).Connecting;
            case (0, _constants.SOCKET_STATES).open:
                return (0, _constants.CONNECTION_STATE).Open;
            case (0, _constants.SOCKET_STATES).closing:
                return (0, _constants.CONNECTION_STATE).Closing;
            default:
                return (0, _constants.CONNECTION_STATE).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, _constants.CONNECTION_STATE).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const chan = new (0, _realtimeChannelDefault.default)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic, event, payload, ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log('push', `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * If param is null it will use the `accessToken` callback function or the token set on the client.
     *
     * On callback used, it will set the value of the token internal to the client.
     *
     * @param token A JWT string to override the token set on the client.
     */ async setAuth(token = null) {
        let tokenToSend = token || this.accessToken && await this.accessToken() || this.accessTokenValue;
        if (tokenToSend) {
            let parsed = null;
            try {
                parsed = JSON.parse(atob(tokenToSend.split('.')[1]));
            } catch (_error) {}
            if (parsed && parsed.exp) {
                let now = Math.floor(Date.now() / 1000);
                let valid = now - parsed.exp < 0;
                if (!valid) {
                    this.log('auth', `InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                    return Promise.reject(`InvalidJWTToken: Invalid value for JWT claim "exp" with value ${parsed.exp}`);
                }
            }
            this.accessTokenValue = tokenToSend;
            this.channels.forEach((channel)=>{
                tokenToSend && channel.updateJoinPayload({
                    access_token: tokenToSend
                });
                if (channel.joinedOnce && channel._isJoined()) channel._push((0, _constants.CHANNEL_EVENTS).access_token, {
                    access_token: tokenToSend
                });
            });
        }
    }
    /**
     * Sends a heartbeat message if the socket is connected.
     */ async sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log('transport', 'heartbeat timeout. Attempting to re-establish connection');
            (_a = this.conn) === null || _a === void 0 || _a.close((0, _constants.WS_CLOSE_NORMAL), 'hearbeat timeout');
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: 'phoenix',
            event: 'heartbeat',
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth();
    }
    /**
     * Flushes send buffer
     */ flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log('transport', `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = 'arraybuffer';
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic, event, payload, ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef) this.pendingHeartbeatRef = null;
            this.log('receive', `${payload.status || ''} ${topic} ${event} ${ref && '(' + ref + ')' || ''}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ async _onConnOpen() {
        this.log('transport', `connected to ${this.endpointURL()}`);
        this.flushSendBuffer();
        this.reconnectTimer.reset();
        if (!this.worker) {
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = setInterval(()=>this.sendHeartbeat(), this.heartbeatIntervalMs);
        } else {
            if (this.workerUrl) this.log('worker', `starting worker for from ${this.workerUrl}`);
            else this.log('worker', `starting default worker`);
            const objectUrl = this._workerObjectUrl(this.workerUrl);
            this.workerRef = new Worker(objectUrl);
            this.workerRef.onerror = (error)=>{
                this.log('worker', 'worker error', error.message);
                this.workerRef.terminate();
            };
            this.workerRef.onmessage = (event)=>{
                if (event.data.event === 'keepAlive') this.sendHeartbeat();
            };
            this.workerRef.postMessage({
                event: 'start',
                interval: this.heartbeatIntervalMs
            });
        }
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log('transport', 'close', event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log('transport', error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, _constants.CHANNEL_EVENTS).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? '&' : '?';
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    _workerObjectUrl(url) {
        let result_url;
        if (url) result_url = url;
        else {
            const blob = new Blob([
                WORKER_SCRIPT
            ], {
                type: 'application/javascript'
            });
            result_url = URL.createObjectURL(blob);
        }
        return result_url;
    }
}
exports.default = RealtimeClient;
class WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = 'arraybuffer';
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, _constants.SOCKET_STATES).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}

},{"./lib/constants":"b7Tfz","./lib/serializer":"bHUs4","./lib/timer":"4kZpX","./lib/transformers":"fMnzi","./RealtimeChannel":"kPfVs","3ea8640035012c43":"a8HCk","c4dfe9bfdd39a2b7":"7PeRN","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"b7Tfz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_HEADERS", ()=>DEFAULT_HEADERS);
parcelHelpers.export(exports, "VSN", ()=>VSN);
parcelHelpers.export(exports, "DEFAULT_TIMEOUT", ()=>DEFAULT_TIMEOUT);
parcelHelpers.export(exports, "WS_CLOSE_NORMAL", ()=>WS_CLOSE_NORMAL);
parcelHelpers.export(exports, "SOCKET_STATES", ()=>SOCKET_STATES);
parcelHelpers.export(exports, "CHANNEL_STATES", ()=>CHANNEL_STATES);
parcelHelpers.export(exports, "CHANNEL_EVENTS", ()=>CHANNEL_EVENTS);
parcelHelpers.export(exports, "TRANSPORTS", ()=>TRANSPORTS);
parcelHelpers.export(exports, "CONNECTION_STATE", ()=>CONNECTION_STATE);
var _version = require("./version");
const DEFAULT_HEADERS = {
    'X-Client-Info': `realtime-js/${(0, _version.version)}`
};
const VSN = '1.0.0';
const DEFAULT_TIMEOUT = 10000;
const WS_CLOSE_NORMAL = 1000;
var SOCKET_STATES;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})(SOCKET_STATES || (SOCKET_STATES = {}));
var CHANNEL_STATES;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})(CHANNEL_STATES || (CHANNEL_STATES = {}));
var CHANNEL_EVENTS;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})(CHANNEL_EVENTS || (CHANNEL_EVENTS = {}));
var TRANSPORTS;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})(TRANSPORTS || (TRANSPORTS = {}));
var CONNECTION_STATE;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})(CONNECTION_STATE || (CONNECTION_STATE = {}));

},{"./version":"cD5jd","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"cD5jd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = '2.11.2';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bHUs4":[function(require,module,exports,__globalThis) {
// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Serializer {
    constructor(){
        this.HEADER_LENGTH = 1;
    }
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === 'string') return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
}
exports.default = Serializer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4kZpX":[function(require,module,exports,__globalThis) {
/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Timer {
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
}
exports.default = Timer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"fMnzi":[function(require,module,exports,__globalThis) {
/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PostgresTypes", ()=>PostgresTypes);
parcelHelpers.export(exports, "convertChangeData", ()=>convertChangeData);
parcelHelpers.export(exports, "convertColumn", ()=>convertColumn);
parcelHelpers.export(exports, "convertCell", ()=>convertCell);
parcelHelpers.export(exports, "toBoolean", ()=>toBoolean);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toJson", ()=>toJson);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "toTimestampString", ()=>toTimestampString);
parcelHelpers.export(exports, "httpEndpointURL", ()=>httpEndpointURL);
var PostgresTypes;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})(PostgresTypes || (PostgresTypes = {}));
const convertChangeData = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = convertColumn(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const convertColumn = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return convertCell(colType, value);
    return noop(value);
};
const convertCell = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === '_') {
        const dataType = type.slice(1, type.length);
        return toArray(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case PostgresTypes.bool:
            return toBoolean(value);
        case PostgresTypes.float4:
        case PostgresTypes.float8:
        case PostgresTypes.int2:
        case PostgresTypes.int4:
        case PostgresTypes.int8:
        case PostgresTypes.numeric:
        case PostgresTypes.oid:
            return toNumber(value);
        case PostgresTypes.json:
        case PostgresTypes.jsonb:
            return toJson(value);
        case PostgresTypes.timestamp:
            return toTimestampString(value); // Format to be consistent with PostgREST
        case PostgresTypes.abstime:
        case PostgresTypes.date:
        case PostgresTypes.daterange:
        case PostgresTypes.int4range:
        case PostgresTypes.int8range:
        case PostgresTypes.money:
        case PostgresTypes.reltime:
        case PostgresTypes.text:
        case PostgresTypes.time:
        case PostgresTypes.timestamptz:
        case PostgresTypes.timetz:
        case PostgresTypes.tsrange:
        case PostgresTypes.tstzrange:
            return noop(value);
        default:
            // Return the value for remaining types
            return noop(value);
    }
};
const noop = (value)=>{
    return value;
};
const toBoolean = (value)=>{
    switch(value){
        case 't':
            return true;
        case 'f':
            return false;
        default:
            return value;
    }
};
const toNumber = (value)=>{
    if (typeof value === 'string') {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const toJson = (value)=>{
    if (typeof value === 'string') try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const toArray = (value, type)=>{
    if (typeof value !== 'string') return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === '{' && closeBrace === '}') {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse('[' + valTrim + ']');
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(',') : [];
        }
        return arr.map((val)=>convertCell(type, val));
    }
    return value;
};
const toTimestampString = (value)=>{
    if (typeof value === 'string') return value.replace(' ', 'T');
    return value;
};
const httpEndpointURL = (socketUrl)=>{
    let url = socketUrl;
    url = url.replace(/^ws/i, 'http');
    url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, '');
    return url.replace(/\/+$/, '');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kPfVs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REALTIME_POSTGRES_CHANGES_LISTEN_EVENT", ()=>REALTIME_POSTGRES_CHANGES_LISTEN_EVENT);
parcelHelpers.export(exports, "REALTIME_LISTEN_TYPES", ()=>REALTIME_LISTEN_TYPES);
parcelHelpers.export(exports, "REALTIME_SUBSCRIBE_STATES", ()=>REALTIME_SUBSCRIBE_STATES);
parcelHelpers.export(exports, "REALTIME_CHANNEL_STATES", ()=>REALTIME_CHANNEL_STATES);
var _constants = require("./lib/constants");
var _push = require("./lib/push");
var _pushDefault = parcelHelpers.interopDefault(_push);
var _timer = require("./lib/timer");
var _timerDefault = parcelHelpers.interopDefault(_timer);
var _realtimePresence = require("./RealtimePresence");
var _realtimePresenceDefault = parcelHelpers.interopDefault(_realtimePresence);
var _transformers = require("./lib/transformers");
var REALTIME_POSTGRES_CHANGES_LISTEN_EVENT;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT || (REALTIME_POSTGRES_CHANGES_LISTEN_EVENT = {}));
var REALTIME_LISTEN_TYPES;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
    REALTIME_LISTEN_TYPES["SYSTEM"] = "system";
})(REALTIME_LISTEN_TYPES || (REALTIME_LISTEN_TYPES = {}));
var REALTIME_SUBSCRIBE_STATES;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})(REALTIME_SUBSCRIBE_STATES || (REALTIME_SUBSCRIBE_STATES = {}));
const REALTIME_CHANNEL_STATES = (0, _constants.CHANNEL_STATES);
class RealtimeChannel {
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, _constants.CHANNEL_STATES).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, '');
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ''
            },
            private: false
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, _pushDefault.default)(this, (0, _constants.CHANNEL_EVENTS).join, this.params, this.timeout);
        this.rejoinTimer = new (0, _timerDefault.default)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive('ok', ()=>{
            this.state = (0, _constants.CHANNEL_STATES).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log('channel', `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, _constants.CHANNEL_STATES).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log('channel', `error ${this.topic}`, reason);
            this.state = (0, _constants.CHANNEL_STATES).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive('timeout', ()=>{
            if (!this._isJoining()) return;
            this.socket.log('channel', `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, _constants.CHANNEL_STATES).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, _constants.CHANNEL_EVENTS).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, _realtimePresenceDefault.default)(this);
        this.broadcastEndpointURL = (0, _transformers.httpEndpointURL)(this.socket.endPoint) + '/api/broadcast';
        this.private = this.params.config.private || false;
    }
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast, presence, private: isPrivate } } = this.params;
            this._onError((e)=>callback === null || callback === void 0 ? void 0 : callback(REALTIME_SUBSCRIBE_STATES.CHANNEL_ERROR, e));
            this._onClose(()=>callback === null || callback === void 0 ? void 0 : callback(REALTIME_SUBSCRIBE_STATES.CLOSED));
            const accessTokenPayload = {};
            const config = {
                broadcast,
                presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : [],
                private: isPrivate
            };
            if (this.socket.accessTokenValue) accessTokenPayload.access_token = this.socket.accessTokenValue;
            this.updateJoinPayload(Object.assign({
                config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive('ok', async ({ postgres_changes })=>{
                var _a;
                this.socket.setAuth();
                if (postgres_changes === undefined) {
                    callback === null || callback === void 0 || callback(REALTIME_SUBSCRIBE_STATES.SUBSCRIBED);
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event, schema, table, filter } } = clientPostgresBinding;
                        const serverPostgresFilter = postgres_changes && postgres_changes[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback === null || callback === void 0 || callback(REALTIME_SUBSCRIBE_STATES.CHANNEL_ERROR, new Error('mismatch between server and client bindings for postgres changes'));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback(REALTIME_SUBSCRIBE_STATES.SUBSCRIBED);
                    return;
                }
            }).receive('error', (error)=>{
                callback === null || callback === void 0 || callback(REALTIME_SUBSCRIBE_STATES.CHANNEL_ERROR, new Error(JSON.stringify(Object.values(error).join(', ') || 'error')));
                return;
            }).receive('timeout', ()=>{
                callback === null || callback === void 0 || callback(REALTIME_SUBSCRIBE_STATES.TIMED_OUT);
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'track',
            payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: 'presence',
            event: 'untrack'
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === 'broadcast') {
            const { event, payload: endpoint_payload } = args;
            const authorization = this.socket.accessTokenValue ? `Bearer ${this.socket.accessTokenValue}` : '';
            const options = {
                method: 'POST',
                headers: {
                    Authorization: authorization,
                    apikey: this.socket.apiKey ? this.socket.apiKey : '',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event,
                            payload: endpoint_payload,
                            private: this.private
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_a = opts.timeout) !== null && _a !== void 0 ? _a : this.timeout);
                await ((_b = response.body) === null || _b === void 0 ? void 0 : _b.cancel());
                return response.ok ? 'ok' : 'error';
            } catch (error) {
                if (error.name === 'AbortError') return 'timed out';
                else return 'error';
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === 'broadcast' && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve('ok');
            push.receive('ok', ()=>resolve('ok'));
            push.receive('error', ()=>resolve('error'));
            push.receive('timeout', ()=>resolve('timed out'));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, _constants.CHANNEL_STATES).leaving;
        const onClose = ()=>{
            this.socket.log('channel', `leave ${this.topic}`);
            this._trigger((0, _constants.CHANNEL_EVENTS).close, 'leave', this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, _pushDefault.default)(this, (0, _constants.CHANNEL_EVENTS).leave, {}, timeout);
            leavePush.receive('ok', ()=>{
                onClose();
                resolve('ok');
            }).receive('timeout', ()=>{
                onClose();
                resolve('timed out');
            }).receive('error', ()=>{
                resolve('error');
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger('ok', {});
        });
    }
    /** @internal */ async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, _pushDefault.default)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close, error, leave, join } = (0, _constants.CHANNEL_EVENTS);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw 'channel onMessage callbacks must return the payload, modified or unmodified';
        if ([
            'insert',
            'update',
            'delete'
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === '*' || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                'broadcast',
                'presence',
                'postgres_changes'
            ].includes(typeLower)) {
                if ('id' in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === '*' || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === '*' || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === 'object' && 'ids' in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema, table, commit_timestamp, type, errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, _constants.CHANNEL_STATES).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, _constants.CHANNEL_STATES).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, _constants.CHANNEL_STATES).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, _constants.CHANNEL_STATES).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && RealtimeChannel.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, _constants.CHANNEL_EVENTS).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, _constants.CHANNEL_EVENTS).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, _constants.CHANNEL_STATES).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === 'INSERT' || payload.type === 'UPDATE') records.new = _transformers.convertChangeData(payload.columns, payload.record);
        if (payload.type === 'UPDATE' || payload.type === 'DELETE') records.old = _transformers.convertChangeData(payload.columns, payload.old_record);
        return records;
    }
}
exports.default = RealtimeChannel;

},{"./lib/constants":"b7Tfz","./lib/push":"04M5X","./lib/timer":"4kZpX","./RealtimePresence":"1SbUv","./lib/transformers":"fMnzi","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"04M5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("../lib/constants");
class Push {
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, _constants.DEFAULT_TIMEOUT)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = '';
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = '';
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived('timeout')) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status,
            callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger('timeout', {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status,
            response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status, response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
}
exports.default = Push;

},{"../lib/constants":"b7Tfz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1SbUv":[function(require,module,exports,__globalThis) {
/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REALTIME_PRESENCE_LISTEN_EVENTS", ()=>REALTIME_PRESENCE_LISTEN_EVENTS);
var REALTIME_PRESENCE_LISTEN_EVENTS;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})(REALTIME_PRESENCE_LISTEN_EVENTS || (REALTIME_PRESENCE_LISTEN_EVENTS = {}));
class RealtimePresence {
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: 'presence_state',
            diff: 'presence_diff'
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin, onLeave, onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = RealtimePresence.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = RealtimePresence.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin, onLeave, onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = RealtimePresence.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger('presence', {
                event: 'join',
                key,
                currentPresences,
                newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger('presence', {
                event: 'leave',
                key,
                currentPresences,
                leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger('presence', {
                event: 'sync'
            });
        });
    }
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins,
            leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins, leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ('metas' in presences) newState[key] = presences.metas.map((presence)=>{
                presence['presence_ref'] = presence['phx_ref'];
                delete presence['phx_ref'];
                delete presence['phx_ref_prev'];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
}
exports.default = RealtimePresence;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7PeRN":[function(require,module,exports,__globalThis) {
module.exports = require("b963ea68b91a2759")(require("deb0d39d16aa6672").resolve("eMrMa")).then(()=>module.bundle.root('kNPZK'));

},{"b963ea68b91a2759":"9wKyf","deb0d39d16aa6672":"gSiLw"}],"9wKyf":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"e8xyU"}],"e8xyU":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"dLDMJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageClient", ()=>(0, _storageClient.StorageClient));
var _storageClient = require("./StorageClient");
var _types = require("./lib/types");
parcelHelpers.exportAll(_types, exports);
var _errors = require("./lib/errors");
parcelHelpers.exportAll(_errors, exports);

},{"./StorageClient":"lznxO","./lib/types":false,"./lib/errors":false,"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lznxO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageClient", ()=>StorageClient);
var _storageFileApi = require("./packages/StorageFileApi");
var _storageFileApiDefault = parcelHelpers.interopDefault(_storageFileApi);
var _storageBucketApi = require("./packages/StorageBucketApi");
var _storageBucketApiDefault = parcelHelpers.interopDefault(_storageBucketApi);
class StorageClient extends (0, _storageBucketApiDefault.default) {
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, _storageFileApiDefault.default)(this.url, this.headers, id, this.fetch);
    }
}

},{"./packages/StorageFileApi":"7RmCB","./packages/StorageBucketApi":"d3OVP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7RmCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errors = require("../lib/errors");
var _fetch = require("../lib/fetch");
var _helpers = require("../lib/helpers");
var Buffer = require("ebcf743ac8dd004a").Buffer;
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: 'name',
        order: 'asc'
    }
};
const DEFAULT_FILE_OPTIONS = {
    cacheControl: '3600',
    contentType: 'text/plain;charset=UTF-8',
    upsert: false
};
class StorageFileApi {
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, _helpers.resolveFetch)(fetch);
    }
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, DEFAULT_FILE_OPTIONS), fileOptions);
                let headers = Object.assign(Object.assign({}, this.headers), method === 'POST' && {
                    'x-upsert': String(options.upsert)
                });
                const metadata = options.metadata;
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                    if (metadata) body.append('metadata', this.encodeMetadata(metadata));
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                    if (metadata) headers['x-metadata'] = this.toBase64(this.encodeMetadata(metadata));
                }
                if (fileOptions === null || fileOptions === void 0 ? void 0 : fileOptions.headers) headers = Object.assign(Object.assign({}, headers), fileOptions.headers);
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method,
                    body: body,
                    headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error
                    };
                }
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('POST', path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set('token', token);
            try {
                let body;
                const options = Object.assign({
                    upsert: DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    'x-upsert': String(options.upsert)
                });
                if (typeof Blob !== 'undefined' && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append('cacheControl', options.cacheControl);
                    body.append('', fileBody);
                } else if (typeof FormData !== 'undefined' && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append('cacheControl', options.cacheControl);
                } else {
                    body = fileBody;
                    headers['cache-control'] = `max-age=${options.cacheControl}`;
                    headers['content-type'] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: 'PUT',
                    body: body,
                    headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error
                    };
                }
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param options.upsert If set to true, allows the file to be overwritten if it already exists.
     */ createSignedUploadUrl(path, options) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const headers = Object.assign({}, this.headers);
                if (options === null || options === void 0 ? void 0 : options.upsert) headers['x-upsert'] = 'true';
                const data = yield (0, _fetch.post)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get('token');
                if (!token) throw new (0, _errors.StorageError)('No token returned by API');
                return {
                    data: {
                        signedUrl: url.toString(),
                        path,
                        token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return __awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate('PUT', path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     * @param options The destination options.
     */ move(fromPath, toPath, options) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.post)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     * @param options The destination options.
     */ copy(fromPath, toPath, options) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.post)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath,
                    destinationBucket: options === null || options === void 0 ? void 0 : options.destinationBucket
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, _fetch.post)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl
                };
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.post)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn,
                    paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? '' : options.download}` : '';
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return __awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
            const renderPath = wantsTransformation ? 'render/image/authenticated' : 'object';
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : '';
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, _fetch.get)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing file.
     * @param path
     */ info(path) {
        return __awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                const data = yield (0, _fetch.get)(this.fetch, `${this.url}/object/info/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: (0, _helpers.recursiveToCamel)(data),
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Checks the existence of a file.
     * @param path
     */ exists(path) {
        return __awaiter(this, void 0, void 0, function*() {
            const _path = this._getFinalPath(path);
            try {
                yield (0, _fetch.head)(this.fetch, `${this.url}/object/${_path}`, {
                    headers: this.headers
                });
                return {
                    data: true,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error) && error instanceof (0, _errors.StorageUnknownError)) {
                    const originalError = error.originalError;
                    if ([
                        400,
                        404
                    ].includes(originalError === null || originalError === void 0 ? void 0 : originalError.status)) return {
                        data: false,
                        error
                    };
                }
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? '' : options.download}` : '';
        if (downloadQueryParam !== '') _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== 'undefined';
        const renderPath = wantsTransformation ? 'render/image' : 'object';
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== '') _queryString.push(transformationQuery);
        let queryString = _queryString.join('&');
        if (queryString !== '') queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.remove)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ''
                });
                const data = yield (0, _fetch.post)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    encodeMetadata(metadata) {
        return JSON.stringify(metadata);
    }
    toBase64(data) {
        if (typeof Buffer !== 'undefined') return Buffer.from(data).toString('base64');
        return btoa(data);
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, '').replace(/\/+/g, '/');
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join('&');
    }
}
exports.default = StorageFileApi;

},{"ebcf743ac8dd004a":"dB11O","../lib/errors":"pVJlf","../lib/fetch":"7gpc7","../lib/helpers":"glFBz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dB11O":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"ettWx","aceacb6a4531a9d2":"6DXND"}],"ettWx":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"6DXND":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"pVJlf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageError", ()=>StorageError);
parcelHelpers.export(exports, "isStorageError", ()=>isStorageError);
parcelHelpers.export(exports, "StorageApiError", ()=>StorageApiError);
parcelHelpers.export(exports, "StorageUnknownError", ()=>StorageUnknownError);
class StorageError extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = 'StorageError';
    }
}
function isStorageError(error) {
    return typeof error === 'object' && error !== null && '__isStorageError' in error;
}
class StorageApiError extends StorageError {
    constructor(message, status){
        super(message);
        this.name = 'StorageApiError';
        this.status = status;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
}
class StorageUnknownError extends StorageError {
    constructor(message, originalError){
        super(message);
        this.name = 'StorageUnknownError';
        this.originalError = originalError;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7gpc7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", ()=>get);
parcelHelpers.export(exports, "post", ()=>post);
parcelHelpers.export(exports, "put", ()=>put);
parcelHelpers.export(exports, "head", ()=>head);
parcelHelpers.export(exports, "remove", ()=>remove);
var _errors = require("./errors");
var _helpers = require("./helpers");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const _getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const handleError = (error, reject, options)=>__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, _helpers.resolveResponse)();
        if (error instanceof Res && !(options === null || options === void 0 ? void 0 : options.noResolveJson)) error.json().then((err)=>{
            reject(new (0, _errors.StorageApiError)(_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, _errors.StorageUnknownError)(_getErrorMessage(err), err));
        });
        else reject(new (0, _errors.StorageUnknownError)(_getErrorMessage(error), error));
    });
const _getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json'
    }, options === null || options === void 0 ? void 0 : options.headers);
    if (body) params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function _handleRequest(fetcher, method, url, options, parameters, body) {
    return __awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, _getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>handleError(error, reject, options));
        });
    });
}
function get(fetcher, url, options, parameters) {
    return __awaiter(this, void 0, void 0, function*() {
        return _handleRequest(fetcher, 'GET', url, options, parameters);
    });
}
function post(fetcher, url, body, options, parameters) {
    return __awaiter(this, void 0, void 0, function*() {
        return _handleRequest(fetcher, 'POST', url, options, parameters, body);
    });
}
function put(fetcher, url, body, options, parameters) {
    return __awaiter(this, void 0, void 0, function*() {
        return _handleRequest(fetcher, 'PUT', url, options, parameters, body);
    });
}
function head(fetcher, url, options, parameters) {
    return __awaiter(this, void 0, void 0, function*() {
        return _handleRequest(fetcher, 'HEAD', url, Object.assign(Object.assign({}, options), {
            noResolveJson: true
        }), parameters);
    });
}
function remove(fetcher, url, body, options, parameters) {
    return __awaiter(this, void 0, void 0, function*() {
        return _handleRequest(fetcher, 'DELETE', url, options, parameters, body);
    });
}

},{"./errors":"pVJlf","./helpers":"glFBz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"glFBz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveFetch", ()=>resolveFetch);
parcelHelpers.export(exports, "resolveResponse", ()=>resolveResponse);
parcelHelpers.export(exports, "recursiveToCamel", ()=>recursiveToCamel);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const resolveFetch = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>require("d0262cf6b6e3064e").then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const resolveResponse = ()=>__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === 'undefined') // @ts-ignore
        return (yield require("d0262cf6b6e3064e")).Response;
        return Response;
    });
const recursiveToCamel = (item)=>{
    if (Array.isArray(item)) return item.map((el)=>recursiveToCamel(el));
    else if (typeof item === 'function' || item !== Object(item)) return item;
    const result = {};
    Object.entries(item).forEach(([key, value])=>{
        const newKey = key.replace(/([-_][a-z])/gi, (c)=>c.toUpperCase().replace(/[-_]/g, ''));
        result[newKey] = recursiveToCamel(value);
    });
    return result;
};

},{"d0262cf6b6e3064e":"a8HCk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"d3OVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _constants = require("../lib/constants");
var _errors = require("../lib/errors");
var _fetch = require("../lib/fetch");
var _helpers = require("../lib/helpers");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class StorageBucketApi {
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, _constants.DEFAULT_HEADERS)), headers);
        this.fetch = (0, _helpers.resolveFetch)(fetch);
    }
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.get)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.get)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.post)(this.fetch, `${this.url}/bucket`, {
                    id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.put)(this.fetch, `${this.url}/bucket/${id}`, {
                    id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.post)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return __awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, _fetch.remove)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data,
                    error: null
                };
            } catch (error) {
                if ((0, _errors.isStorageError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
}
exports.default = StorageBucketApi;

},{"../lib/constants":"bnkrr","../lib/errors":"pVJlf","../lib/fetch":"7gpc7","../lib/helpers":"glFBz","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"bnkrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_HEADERS", ()=>DEFAULT_HEADERS);
var _version = require("./version");
const DEFAULT_HEADERS = {
    'X-Client-Info': `storage-js/${(0, _version.version)}`
};

},{"./version":"7HfjH","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7HfjH":[function(require,module,exports,__globalThis) {
// generated by genversion
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = '2.7.1';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"1uIhb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_HEADERS", ()=>DEFAULT_HEADERS);
parcelHelpers.export(exports, "DEFAULT_GLOBAL_OPTIONS", ()=>DEFAULT_GLOBAL_OPTIONS);
parcelHelpers.export(exports, "DEFAULT_DB_OPTIONS", ()=>DEFAULT_DB_OPTIONS);
parcelHelpers.export(exports, "DEFAULT_AUTH_OPTIONS", ()=>DEFAULT_AUTH_OPTIONS);
parcelHelpers.export(exports, "DEFAULT_REALTIME_OPTIONS", ()=>DEFAULT_REALTIME_OPTIONS);
var _version = require("./version");
let JS_ENV = '';
// @ts-ignore
if (typeof Deno !== 'undefined') JS_ENV = 'deno';
else if (typeof document !== 'undefined') JS_ENV = 'web';
else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') JS_ENV = 'react-native';
else JS_ENV = 'node';
const DEFAULT_HEADERS = {
    'X-Client-Info': `supabase-js-${JS_ENV}/${(0, _version.version)}`
};
const DEFAULT_GLOBAL_OPTIONS = {
    headers: DEFAULT_HEADERS
};
const DEFAULT_DB_OPTIONS = {
    schema: 'public'
};
const DEFAULT_AUTH_OPTIONS = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit'
};
const DEFAULT_REALTIME_OPTIONS = {};

},{"./version":"lmgeJ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lmgeJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = '2.47.14';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"jU4vw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveFetch", ()=>resolveFetch);
parcelHelpers.export(exports, "resolveHeadersConstructor", ()=>resolveHeadersConstructor);
parcelHelpers.export(exports, "fetchWithAuth", ()=>fetchWithAuth);
// @ts-ignore
var _nodeFetch = require("@supabase/node-fetch");
var _nodeFetchDefault = parcelHelpers.interopDefault(_nodeFetch);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const resolveFetch = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (0, _nodeFetchDefault.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const resolveHeadersConstructor = ()=>{
    if (typeof Headers === 'undefined') return 0, _nodeFetch.Headers;
    return Headers;
};
const fetchWithAuth = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = resolveFetch(customFetch);
    const HeadersConstructor = resolveHeadersConstructor();
    return (input, init)=>__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has('apikey')) headers.set('apikey', supabaseKey);
            if (!headers.has('Authorization')) headers.set('Authorization', `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers
            }));
        });
};

},{"@supabase/node-fetch":"4Q5V1","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"3zuQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "stripTrailingSlash", ()=>stripTrailingSlash);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "applySettingDefaults", ()=>applySettingDefaults);
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function stripTrailingSlash(url) {
    return url.replace(/\/$/, '');
}
const isBrowser = ()=>typeof window !== 'undefined';
function applySettingDefaults(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    const result = {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions),
        accessToken: ()=>__awaiter(this, void 0, void 0, function*() {
                return '';
            })
    };
    if (options.accessToken) result.accessToken = options.accessToken;
    else // hack around Required<>
    delete result.accessToken;
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"7YJ7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SupabaseAuthClient", ()=>SupabaseAuthClient);
var _authJs = require("@supabase/auth-js");
class SupabaseAuthClient extends (0, _authJs.AuthClient) {
    constructor(options){
        super(options);
    }
}

},{"@supabase/auth-js":"8VjzZ","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8VjzZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "navigatorLock", ()=>(0, _locks.navigatorLock));
parcelHelpers.export(exports, "NavigatorLockAcquireTimeoutError", ()=>(0, _locks.NavigatorLockAcquireTimeoutError));
parcelHelpers.export(exports, "lockInternals", ()=>(0, _locks.internals));
parcelHelpers.export(exports, "GoTrueAdminApi", ()=>(0, _goTrueAdminApiDefault.default));
parcelHelpers.export(exports, "GoTrueClient", ()=>(0, _goTrueClientDefault.default));
parcelHelpers.export(exports, "AuthAdminApi", ()=>(0, _authAdminApiDefault.default));
parcelHelpers.export(exports, "AuthClient", ()=>(0, _authClientDefault.default));
var _goTrueAdminApi = require("./GoTrueAdminApi");
var _goTrueAdminApiDefault = parcelHelpers.interopDefault(_goTrueAdminApi);
var _goTrueClient = require("./GoTrueClient");
var _goTrueClientDefault = parcelHelpers.interopDefault(_goTrueClient);
var _authAdminApi = require("./AuthAdminApi");
var _authAdminApiDefault = parcelHelpers.interopDefault(_authAdminApi);
var _authClient = require("./AuthClient");
var _authClientDefault = parcelHelpers.interopDefault(_authClient);
var _types = require("./lib/types");
parcelHelpers.exportAll(_types, exports);
var _errors = require("./lib/errors");
parcelHelpers.exportAll(_errors, exports);
var _locks = require("./lib/locks");

},{"./GoTrueAdminApi":"5bmQV","./GoTrueClient":"8QbFP","./AuthAdminApi":"dTWKm","./AuthClient":"itpDP","./lib/types":"aKMd1","./lib/errors":"8RHqO","./lib/locks":"4RjEn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5bmQV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fetch = require("./lib/fetch");
var _helpers = require("./lib/helpers");
var _errors = require("./lib/errors");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class GoTrueAdminApi {
    constructor({ url = '', headers = {}, fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, _helpers.resolveFetch)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = 'global') {
        try {
            await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/invite`, {
                body: {
                    email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, _fetch._userResponse)
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options } = params, rest = __rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ('newEmail' in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body['newEmail'];
            }
            return await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, _fetch._generateLinkResponse),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, _fetch._userResponse)
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, _fetch._request)(this.fetch, 'GET', `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '',
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ''
                },
                xform: (0, _fetch._noResolveJsonResponse)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get('x-total-count')) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get('link')) === null || _f === void 0 ? void 0 : _f.split(',')) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(';')[0].split('=')[1].substring(0, 1));
                    const rel = JSON.parse(link.split(';')[1].split('=')[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    users: []
                },
                error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, _fetch._request)(this.fetch, 'GET', `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, _fetch._userResponse)
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, _fetch._request)(this.fetch, 'PUT', `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, _fetch._userResponse)
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted from the auth schema. Soft deletion allows user identification from the hashed user ID but is not reversible.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, _fetch._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, _fetch._userResponse)
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data, error } = await (0, _fetch._request)(this.fetch, 'GET', `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors
                        },
                        error: null
                    };
                }
            });
            return {
                data,
                error
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, _fetch._request)(this.fetch, 'DELETE', `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data,
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
}
exports.default = GoTrueAdminApi;

},{"./lib/fetch":"dOWmM","./lib/helpers":"lQJ1C","./lib/errors":"8RHqO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dOWmM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleError", ()=>handleError);
parcelHelpers.export(exports, "_request", ()=>_request);
parcelHelpers.export(exports, "_sessionResponse", ()=>_sessionResponse);
parcelHelpers.export(exports, "_sessionResponsePassword", ()=>_sessionResponsePassword);
parcelHelpers.export(exports, "_userResponse", ()=>_userResponse);
parcelHelpers.export(exports, "_ssoResponse", ()=>_ssoResponse);
parcelHelpers.export(exports, "_generateLinkResponse", ()=>_generateLinkResponse);
parcelHelpers.export(exports, "_noResolveJsonResponse", ()=>_noResolveJsonResponse);
var _constants = require("./constants");
var _helpers = require("./helpers");
var _errors = require("./errors");
var __rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const _getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function handleError(error) {
    var _a;
    if (!(0, _helpers.looksLikeFetchResponse)(error)) throw new (0, _errors.AuthRetryableFetchError)(_getErrorMessage(error), 0);
    if (NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, _errors.AuthRetryableFetchError)(_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, _errors.AuthUnknownError)(_getErrorMessage(e), e);
    }
    let errorCode = undefined;
    const responseAPIVersion = (0, _helpers.parseResponseAPIVersion)(error);
    if (responseAPIVersion && responseAPIVersion.getTime() >= (0, _constants.API_VERSIONS)['2024-01-01'].timestamp && typeof data === 'object' && data && typeof data.code === 'string') errorCode = data.code;
    else if (typeof data === 'object' && data && typeof data.error_code === 'string') errorCode = data.error_code;
    if (!errorCode) {
        // Legacy support for weak password errors, when there were no error codes
        if (typeof data === 'object' && data && typeof data.weak_password === 'object' && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) throw new (0, _errors.AuthWeakPasswordError)(_getErrorMessage(data), error.status, data.weak_password.reasons);
    } else if (errorCode === 'weak_password') throw new (0, _errors.AuthWeakPasswordError)(_getErrorMessage(data), error.status, ((_a = data.weak_password) === null || _a === void 0 ? void 0 : _a.reasons) || []);
    else if (errorCode === 'session_not_found') // The `session_id` inside the JWT does not correspond to a row in the
    // `sessions` table. This usually means the user has signed out, has been
    // deleted, or their session has somehow been terminated.
    throw new (0, _errors.AuthSessionMissingError)();
    throw new (0, _errors.AuthApiError)(_getErrorMessage(data), error.status || 500, errorCode);
}
const _getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === 'GET') return params;
    params.headers = Object.assign({
        'Content-Type': 'application/json;charset=UTF-8'
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function _request(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (!headers[0, _constants.API_VERSION_HEADER_NAME]) headers[0, _constants.API_VERSION_HEADER_NAME] = (0, _constants.API_VERSIONS)['2024-01-01'].name;
    if (options === null || options === void 0 ? void 0 : options.jwt) headers['Authorization'] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs['redirect_to'] = options.redirectTo;
    const queryString = Object.keys(qs).length ? '?' + new URLSearchParams(qs).toString() : '';
    const data = await _handleRequest(fetcher, method, url + queryString, {
        headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function _handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = _getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, Object.assign({}, requestParams));
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, _errors.AuthRetryableFetchError)(_getErrorMessage(e), 0);
    }
    if (!result.ok) await handleError(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await handleError(e);
    }
}
function _sessionResponse(data) {
    var _a;
    let session = null;
    if (hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, _helpers.expiresAt)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session,
            user
        },
        error: null
    };
}
function _sessionResponsePassword(data) {
    const response = _sessionResponse(data);
    if (!response.error && data.weak_password && typeof data.weak_password === 'object' && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === 'string' && data.weak_password.reasons.reduce((a, i)=>a && typeof i === 'string', true)) response.data.weak_password = data.weak_password;
    return response;
}
function _userResponse(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user
        },
        error: null
    };
}
function _ssoResponse(data) {
    return {
        data,
        error: null
    };
}
function _generateLinkResponse(data) {
    const { action_link, email_otp, hashed_token, redirect_to, verification_type } = data, rest = __rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link,
        email_otp,
        hashed_token,
        redirect_to,
        verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties,
            user
        },
        error: null
    };
}
function _noResolveJsonResponse(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}

},{"./constants":"5kgHI","./helpers":"lQJ1C","./errors":"8RHqO","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"5kgHI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GOTRUE_URL", ()=>GOTRUE_URL);
parcelHelpers.export(exports, "STORAGE_KEY", ()=>STORAGE_KEY);
parcelHelpers.export(exports, "AUDIENCE", ()=>AUDIENCE);
parcelHelpers.export(exports, "DEFAULT_HEADERS", ()=>DEFAULT_HEADERS);
parcelHelpers.export(exports, "EXPIRY_MARGIN", ()=>EXPIRY_MARGIN);
parcelHelpers.export(exports, "NETWORK_FAILURE", ()=>NETWORK_FAILURE);
parcelHelpers.export(exports, "API_VERSION_HEADER_NAME", ()=>API_VERSION_HEADER_NAME);
parcelHelpers.export(exports, "API_VERSIONS", ()=>API_VERSIONS);
var _version = require("./version");
const GOTRUE_URL = 'http://localhost:9999';
const STORAGE_KEY = 'supabase.auth.token';
const AUDIENCE = '';
const DEFAULT_HEADERS = {
    'X-Client-Info': `gotrue-js/${(0, _version.version)}`
};
const EXPIRY_MARGIN = 10; // in seconds
const NETWORK_FAILURE = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};
const API_VERSION_HEADER_NAME = 'X-Supabase-Api-Version';
const API_VERSIONS = {
    '2024-01-01': {
        timestamp: Date.parse('2024-01-01T00:00:00.0Z'),
        name: '2024-01-01'
    }
};

},{"./version":"gfN29","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gfN29":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
const version = '2.67.3';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"lQJ1C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expiresAt", ()=>expiresAt);
parcelHelpers.export(exports, "uuid", ()=>uuid);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "supportsLocalStorage", ()=>supportsLocalStorage);
/**
 * Extracts parameters encoded in the URL both in the query and fragment.
 */ parcelHelpers.export(exports, "parseParametersFromURL", ()=>parseParametersFromURL);
parcelHelpers.export(exports, "resolveFetch", ()=>resolveFetch);
parcelHelpers.export(exports, "looksLikeFetchResponse", ()=>looksLikeFetchResponse);
parcelHelpers.export(exports, "setItemAsync", ()=>setItemAsync);
parcelHelpers.export(exports, "getItemAsync", ()=>getItemAsync);
parcelHelpers.export(exports, "removeItemAsync", ()=>removeItemAsync);
parcelHelpers.export(exports, "decodeBase64URL", ()=>decodeBase64URL);
/**
 * A deferred represents some asynchronous work that is not yet finished, which
 * may or may not culminate in a value.
 * Taken from: https://github.com/mike-north/types/blob/master/src/async.ts
 */ parcelHelpers.export(exports, "Deferred", ()=>Deferred);
// Taken from: https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
parcelHelpers.export(exports, "decodeJWTPayload", ()=>decodeJWTPayload);
/**
 * Creates a promise that resolves to null after some time.
 */ parcelHelpers.export(exports, "sleep", ()=>sleep);
/**
 * Converts the provided async function into a retryable function. Each result
 * or thrown error is sent to the isRetryable function which should return true
 * if the function should run again.
 */ parcelHelpers.export(exports, "retryable", ()=>retryable);
// Functions below taken from: https://stackoverflow.com/questions/63309409/creating-a-code-verifier-and-challenge-for-pkce-auth-on-spotify-api-in-reactjs
parcelHelpers.export(exports, "generatePKCEVerifier", ()=>generatePKCEVerifier);
parcelHelpers.export(exports, "generatePKCEChallenge", ()=>generatePKCEChallenge);
parcelHelpers.export(exports, "getCodeChallengeAndMethod", ()=>getCodeChallengeAndMethod);
parcelHelpers.export(exports, "parseResponseAPIVersion", ()=>parseResponseAPIVersion);
var _constants = require("./constants");
function expiresAt(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const isBrowser = ()=>typeof window !== 'undefined' && typeof document !== 'undefined';
const localStorageWriteTests = {
    tested: false,
    writable: false
};
const supportsLocalStorage = ()=>{
    if (!isBrowser()) return false;
    try {
        if (typeof globalThis.localStorage !== 'object') return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if (localStorageWriteTests.tested) return localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        localStorageWriteTests.tested = true;
        localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        localStorageWriteTests.tested = true;
        localStorageWriteTests.writable = false;
    }
    return localStorageWriteTests.writable;
};
function parseParametersFromURL(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === '#') try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
const resolveFetch = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === 'undefined') _fetch = (...args)=>require("b14de0e012a619af").then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const looksLikeFetchResponse = (maybeResponse)=>{
    return typeof maybeResponse === 'object' && maybeResponse !== null && 'status' in maybeResponse && 'ok' in maybeResponse && 'json' in maybeResponse && typeof maybeResponse.json === 'function';
};
const setItemAsync = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const getItemAsync = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const removeItemAsync = async (storage, key)=>{
    await storage.removeItem(key);
};
function decodeBase64URL(value) {
    const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let base64 = '';
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    value = value.replace('-', '+').replace('_', '/');
    while(i < value.length){
        enc1 = key.indexOf(value.charAt(i++));
        enc2 = key.indexOf(value.charAt(i++));
        enc3 = key.indexOf(value.charAt(i++));
        enc4 = key.indexOf(value.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        base64 = base64 + String.fromCharCode(chr1);
        if (enc3 != 64 && chr2 != 0) base64 = base64 + String.fromCharCode(chr2);
        if (enc4 != 64 && chr3 != 0) base64 = base64 + String.fromCharCode(chr3);
    }
    return base64;
}
class Deferred {
    constructor(){
        this.promise = new Deferred.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
Deferred.promiseConstructor = Promise;
function decodeJWTPayload(token) {
    // Regex checks for base64url format
    const base64UrlRegex = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i;
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error('JWT is not valid: not a JWT structure');
    if (!base64UrlRegex.test(parts[1])) throw new Error('JWT is not valid: payload is not in base64url format');
    const base64Url = parts[1];
    return JSON.parse(decodeBase64URL(base64Url));
}
async function sleep(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function retryable(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function generatePKCEVerifier() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === 'undefined') {
        const charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        const charSetLen = charSet.length;
        let verifier = '';
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, dec2hex).join('');
}
async function sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest('SHA-256', encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join('');
}
function base64urlencode(str) {
    return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
async function generatePKCEChallenge(verifier) {
    const hasCryptoSupport = typeof crypto !== 'undefined' && typeof crypto.subtle !== 'undefined' && typeof TextEncoder !== 'undefined';
    if (!hasCryptoSupport) {
        console.warn('WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.');
        return verifier;
    }
    const hashed = await sha256(verifier);
    return base64urlencode(hashed);
}
async function getCodeChallengeAndMethod(storage, storageKey, isPasswordRecovery = false) {
    const codeVerifier = generatePKCEVerifier();
    let storedCodeVerifier = codeVerifier;
    if (isPasswordRecovery) storedCodeVerifier += '/PASSWORD_RECOVERY';
    await setItemAsync(storage, `${storageKey}-code-verifier`, storedCodeVerifier);
    const codeChallenge = await generatePKCEChallenge(codeVerifier);
    const codeChallengeMethod = codeVerifier === codeChallenge ? 'plain' : 's256';
    return [
        codeChallenge,
        codeChallengeMethod
    ];
}
/** Parses the API version which is 2YYY-MM-DD. */ const API_VERSION_REGEX = /^2[0-9]{3}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])$/i;
function parseResponseAPIVersion(response) {
    const apiVersion = response.headers.get((0, _constants.API_VERSION_HEADER_NAME));
    if (!apiVersion) return null;
    if (!apiVersion.match(API_VERSION_REGEX)) return null;
    try {
        const date = new Date(`${apiVersion}T00:00:00.0Z`);
        return date;
    } catch (e) {
        return null;
    }
}

},{"./constants":"5kgHI","b14de0e012a619af":"a8HCk","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8RHqO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthError", ()=>AuthError);
parcelHelpers.export(exports, "isAuthError", ()=>isAuthError);
parcelHelpers.export(exports, "AuthApiError", ()=>AuthApiError);
parcelHelpers.export(exports, "isAuthApiError", ()=>isAuthApiError);
parcelHelpers.export(exports, "AuthUnknownError", ()=>AuthUnknownError);
parcelHelpers.export(exports, "CustomAuthError", ()=>CustomAuthError);
parcelHelpers.export(exports, "AuthSessionMissingError", ()=>AuthSessionMissingError);
parcelHelpers.export(exports, "isAuthSessionMissingError", ()=>isAuthSessionMissingError);
parcelHelpers.export(exports, "AuthInvalidTokenResponseError", ()=>AuthInvalidTokenResponseError);
parcelHelpers.export(exports, "AuthInvalidCredentialsError", ()=>AuthInvalidCredentialsError);
parcelHelpers.export(exports, "AuthImplicitGrantRedirectError", ()=>AuthImplicitGrantRedirectError);
parcelHelpers.export(exports, "isAuthImplicitGrantRedirectError", ()=>isAuthImplicitGrantRedirectError);
parcelHelpers.export(exports, "AuthPKCEGrantCodeExchangeError", ()=>AuthPKCEGrantCodeExchangeError);
parcelHelpers.export(exports, "AuthRetryableFetchError", ()=>AuthRetryableFetchError);
parcelHelpers.export(exports, "isAuthRetryableFetchError", ()=>isAuthRetryableFetchError);
/**
 * This error is thrown on certain methods when the password used is deemed
 * weak. Inspect the reasons to identify what password strength rules are
 * inadequate.
 */ parcelHelpers.export(exports, "AuthWeakPasswordError", ()=>AuthWeakPasswordError);
parcelHelpers.export(exports, "isAuthWeakPasswordError", ()=>isAuthWeakPasswordError);
class AuthError extends Error {
    constructor(message, status, code){
        super(message);
        this.__isAuthError = true;
        this.name = 'AuthError';
        this.status = status;
        this.code = code;
    }
}
function isAuthError(error) {
    return typeof error === 'object' && error !== null && '__isAuthError' in error;
}
class AuthApiError extends AuthError {
    constructor(message, status, code){
        super(message, status, code);
        this.name = 'AuthApiError';
        this.status = status;
        this.code = code;
    }
}
function isAuthApiError(error) {
    return isAuthError(error) && error.name === 'AuthApiError';
}
class AuthUnknownError extends AuthError {
    constructor(message, originalError){
        super(message);
        this.name = 'AuthUnknownError';
        this.originalError = originalError;
    }
}
class CustomAuthError extends AuthError {
    constructor(message, name, status, code){
        super(message, status, code);
        this.name = name;
        this.status = status;
    }
}
class AuthSessionMissingError extends CustomAuthError {
    constructor(){
        super('Auth session missing!', 'AuthSessionMissingError', 400, undefined);
    }
}
function isAuthSessionMissingError(error) {
    return isAuthError(error) && error.name === 'AuthSessionMissingError';
}
class AuthInvalidTokenResponseError extends CustomAuthError {
    constructor(){
        super('Auth session or user missing', 'AuthInvalidTokenResponseError', 500, undefined);
    }
}
class AuthInvalidCredentialsError extends CustomAuthError {
    constructor(message){
        super(message, 'AuthInvalidCredentialsError', 400, undefined);
    }
}
class AuthImplicitGrantRedirectError extends CustomAuthError {
    constructor(message, details = null){
        super(message, 'AuthImplicitGrantRedirectError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
function isAuthImplicitGrantRedirectError(error) {
    return isAuthError(error) && error.name === 'AuthImplicitGrantRedirectError';
}
class AuthPKCEGrantCodeExchangeError extends CustomAuthError {
    constructor(message, details = null){
        super(message, 'AuthPKCEGrantCodeExchangeError', 500, undefined);
        this.details = null;
        this.details = details;
    }
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
}
class AuthRetryableFetchError extends CustomAuthError {
    constructor(message, status){
        super(message, 'AuthRetryableFetchError', status, undefined);
    }
}
function isAuthRetryableFetchError(error) {
    return isAuthError(error) && error.name === 'AuthRetryableFetchError';
}
class AuthWeakPasswordError extends CustomAuthError {
    constructor(message, status, reasons){
        super(message, 'AuthWeakPasswordError', status, 'weak_password');
        this.reasons = reasons;
    }
}
function isAuthWeakPasswordError(error) {
    return isAuthError(error) && error.name === 'AuthWeakPasswordError';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"8QbFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _goTrueAdminApi = require("./GoTrueAdminApi");
var _goTrueAdminApiDefault = parcelHelpers.interopDefault(_goTrueAdminApi);
var _constants = require("./lib/constants");
var _errors = require("./lib/errors");
var _fetch = require("./lib/fetch");
var _helpers = require("./lib/helpers");
var _localStorage = require("./lib/local-storage");
var _polyfills = require("./lib/polyfills");
var _version = require("./lib/version");
var _locks = require("./lib/locks");
(0, _polyfills.polyfillGlobalThis)(); // Make "globalThis" available
const DEFAULT_OPTIONS = {
    url: (0, _constants.GOTRUE_URL),
    storageKey: (0, _constants.STORAGE_KEY),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, _constants.DEFAULT_HEADERS),
    flowType: 'implicit',
    debug: false,
    hasCustomAuthorizationHeader: false
};
/** Current session will be checked for refresh at this interval. */ const AUTO_REFRESH_TICK_DURATION = 30000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */ const AUTO_REFRESH_TICK_THRESHOLD = 3;
async function lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class GoTrueClient {
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.hasCustomAuthorizationHeader = false;
        this.suppressGetSessionWarning = false;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = GoTrueClient.nextInstanceID;
        GoTrueClient.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, _helpers.isBrowser)()) console.warn('Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.');
        const settings = Object.assign(Object.assign({}, DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === 'function') this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, _goTrueAdminApiDefault.default)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, _helpers.resolveFetch)(settings.fetch);
        this.lock = settings.lock || lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        this.hasCustomAuthorizationHeader = settings.hasCustomAuthorizationHeader;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, _helpers.isBrowser)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, _locks.navigatorLock);
        else this.lock = lockNoOp;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, _helpers.supportsLocalStorage)()) this.storage = (0, _localStorage.localStorageAdapter);
            else {
                this.memoryStorage = {};
                this.storage = (0, _localStorage.memoryLocalStorageAdapter)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, _localStorage.memoryLocalStorageAdapter)(this.memoryStorage);
        }
        if ((0, _helpers.isBrowser)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error('Failed to create a new BroadcastChannel, multi-tab state changes will not be available', e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener('message', async (event)=>{
                this._debug('received broadcast notification from other tab or client', event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, _version.version)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        var _a;
        try {
            const params = (0, _helpers.parseParametersFromURL)(window.location.href);
            let callbackUrlType = 'none';
            if (this._isImplicitGrantCallback(params)) callbackUrlType = 'implicit';
            else if (await this._isPKCECallback(params)) callbackUrlType = 'pkce';
            /**
             * Attempt to get the session from the URL only if these conditions are fulfilled
             *
             * Note: If the URL isn't one of the callback url types (implicit or pkce),
             * then there could be an existing session so we don't want to prematurely remove it
             */ if ((0, _helpers.isBrowser)() && this.detectSessionInUrl && callbackUrlType !== 'none') {
                const { data, error } = await this._getSessionFromURL(params, callbackUrlType);
                if (error) {
                    this._debug('#_initialize()', 'error detecting session from URL', error);
                    if ((0, _errors.isAuthImplicitGrantRedirectError)(error)) {
                        const errorCode = (_a = error.details) === null || _a === void 0 ? void 0 : _a.code;
                        if (errorCode === 'identity_already_exists' || errorCode === 'identity_not_found' || errorCode === 'single_identity_not_deletable') return {
                            error
                        };
                    }
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error
                    };
                }
                const { session, redirectType } = data;
                this._debug('#_initialize()', 'detected session in URL', session, 'redirect type', redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === 'recovery') await this._notifyAllSubscribers('PASSWORD_RECOVERY', session);
                    else await this._notifyAllSubscribers('SIGNED_IN', session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                error
            };
            return {
                error: new (0, _errors.AuthUnknownError)('Unexpected error during initialization', error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug('#_initialize()', 'end');
        }
    }
    /**
     * Creates a new anonymous user.
     *
     * @returns A session where the is_anonymous claim in the access token JWT set to true
     */ async signInAnonymously(credentials) {
        var _a, _b, _c;
        try {
            const res = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/signup`, {
                headers: this.headers,
                body: {
                    data: (_b = (_a = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : {},
                    gotrue_meta_security: {
                        captcha_token: (_c = credentials === null || credentials === void 0 ? void 0 : credentials.options) === null || _c === void 0 ? void 0 : _c.captchaToken
                    }
                },
                xform: (0, _fetch._sessionResponse)
            });
            const { data, error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user,
                    session
                },
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            let res;
            if ('email' in credentials) {
                const { email, password, options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, _helpers.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                res = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email,
                        password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, _fetch._sessionResponse)
                });
            } else if ('phone' in credentials) {
                const { phone, password, options } = credentials;
                res = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone,
                        password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : 'sms',
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, _fetch._sessionResponse)
                });
            } else throw new (0, _errors.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data, error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user,
                    session
                },
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            let res;
            if ('email' in credentials) {
                const { email, password, options } = credentials;
                res = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email,
                        password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, _fetch._sessionResponsePassword)
                });
            } else if ('phone' in credentials) {
                const { phone, password, options } = credentials;
                res = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone,
                        password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, _fetch._sessionResponsePassword)
                });
            } else throw new (0, _errors.AuthInvalidCredentialsError)('You must provide either an email or phone number and a password');
            const { data, error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, _errors.AuthInvalidTokenResponseError)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, _helpers.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : '').split('/');
        try {
            const { data, error } = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/token?grant_type=pkce`, {
                headers: this.headers,
                body: {
                    auth_code: authCode,
                    code_verifier: codeVerifier
                },
                xform: (0, _fetch._sessionResponse)
            });
            await (0, _helpers.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            if (error) throw error;
            if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error: new (0, _errors.AuthInvalidTokenResponseError)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data: Object.assign(Object.assign({}, data), {
                    redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
                }),
                error
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null,
                    redirectType: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        try {
            const { options, provider, token, access_token, nonce } = credentials;
            const res = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider,
                    id_token: token,
                    access_token,
                    nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, _fetch._sessionResponse)
            });
            const { data, error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, _errors.AuthInvalidTokenResponseError)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers('SIGNED_IN', data.session);
            }
            return {
                data,
                error
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            if ('email' in credentials) {
                const { email, options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, _helpers.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { error } = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error
                };
            }
            if ('phone' in credentials) {
                const { phone, options } = credentials;
                const { data, error } = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : 'sms'
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error
                };
            }
            throw new (0, _errors.AuthInvalidCredentialsError)('You must provide either an email or phone number.');
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ('options' in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data, error } = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo,
                xform: (0, _fetch._sessionResponse)
            });
            if (error) throw error;
            if (!data) throw new Error('An error occurred on token verification.');
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == 'recovery' ? 'PASSWORD_RECOVERY' : 'SIGNED_IN', session);
            }
            return {
                data: {
                    user,
                    session
                },
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, _helpers.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            return await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, 'providerId' in params ? {
                    provider_id: params.providerId
                } : null), 'domain' in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, _fetch._ssoResponse)
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, _errors.AuthSessionMissingError)();
                const { error } = await (0, _fetch._request)(this.fetch, 'GET', `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error
                };
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            const endpoint = `${this.url}/resend`;
            if ('email' in credentials) {
                const { email, type, options } = credentials;
                const { error } = await (0, _fetch._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        email,
                        type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error
                };
            } else if ('phone' in credentials) {
                const { phone, type, options } = credentials;
                const { data, error } = await (0, _fetch._request)(this.fetch, 'POST', endpoint, {
                    headers: this.headers,
                    body: {
                        phone,
                        type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error
                };
            }
            throw new (0, _errors.AuthInvalidCredentialsError)('You must provide either an email or phone number and a type');
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     *
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     *
     * **IMPORTANT:** This method loads values directly from the storage attached
     * to the client. If that storage is based on request cookies for example,
     * the values in it may not be authentic and therefore it's strongly advised
     * against using this method and its results in such circumstances. A warning
     * will be emitted if this is detected. Use {@link #getUser()} instead.
     */ async getSession() {
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
        return result;
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug('#_acquireLock', 'begin', acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug('#_acquireLock', 'lock acquired for storage key', this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug('#_acquireLock', 'lock released for storage key', this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug('#_acquireLock', 'end');
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug('#_useSession', 'begin');
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug('#_useSession', 'end');
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug('#__loadSession()', 'begin');
        if (!this.lockAcquired) this._debug('#__loadSession()', 'used outside of an acquired lock!', new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, _helpers.getItemAsync)(this.storage, this.storageKey);
            this._debug('#getSession()', 'session from storage', maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug('#getSession()', 'session from storage is not valid');
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            const hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
            this._debug('#__loadSession()', `session has${hasExpired ? '' : ' not'} expired`, 'expires_at', currentSession.expires_at);
            if (!hasExpired) {
                if (this.storage.isServer) {
                    let suppressWarning = this.suppressGetSessionWarning;
                    const proxySession = new Proxy(currentSession, {
                        get: (target, prop, receiver)=>{
                            if (!suppressWarning && prop === 'user') {
                                // only show warning when the user object is being accessed from the server
                                console.warn('Using the user object as returned from supabase.auth.getSession() or from some supabase.auth.onAuthStateChange() events could be insecure! This value comes directly from the storage medium (usually cookies on the server) and may not be authentic. Use supabase.auth.getUser() instead which authenticates the data by contacting the Supabase Auth server.');
                                suppressWarning = true; // keeps this proxy instance from logging additional warnings
                                this.suppressGetSessionWarning = true; // keeps this client's future proxy instances from warning
                            }
                            return Reflect.get(target, prop, receiver);
                        }
                    });
                    currentSession = proxySession;
                }
                return {
                    data: {
                        session: currentSession
                    },
                    error: null
                };
            }
            const { session, error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error
            };
            return {
                data: {
                    session
                },
                error: null
            };
        } finally{
            this._debug('#__loadSession()', 'end');
        }
    }
    /**
     * Gets the current user details if there is an existing session. This method
     * performs a network request to the Supabase Auth server, so the returned
     * value is authentic and can be used to base authorization rules on.
     *
     * @param jwt Takes in an optional access token JWT. If no JWT is provided, the JWT from the current session is used.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        const result = await this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
        return result;
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, _fetch._request)(this.fetch, 'GET', `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, _fetch._userResponse)
            });
            return await this._useSession(async (result)=>{
                var _a, _b, _c;
                const { data, error } = result;
                if (error) throw error;
                // returns an error if there is no access_token or custom authorization header
                if (!((_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) && !this.hasCustomAuthorizationHeader) return {
                    data: {
                        user: null
                    },
                    error: new (0, _errors.AuthSessionMissingError)()
                };
                return await (0, _fetch._request)(this.fetch, 'GET', `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_c = (_b = data.session) === null || _b === void 0 ? void 0 : _b.access_token) !== null && _c !== void 0 ? _c : undefined,
                    xform: (0, _fetch._userResponse)
                });
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) {
                if ((0, _errors.isAuthSessionMissingError)(error)) {
                    // JWT contains a `session_id` which does not correspond to an active
                    // session in the database, indicating the user is signed out.
                    await this._removeSession();
                    await (0, _helpers.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
                }
                return {
                    data: {
                        user: null
                    },
                    error
                };
            }
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, _errors.AuthSessionMissingError)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === 'pkce' && attributes.email != null) [codeChallenge, codeChallengeMethod] = await (0, _helpers.getCodeChallengeAndMethod)(this.storage, this.storageKey);
                const { data, error: userError } = await (0, _fetch._request)(this.fetch, 'PUT', `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, _fetch._userResponse)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers('USER_UPDATED', session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Decodes a JWT (without performing any validation).
     */ _decodeJWT(jwt) {
        return (0, _helpers.decodeJWTPayload)(jwt);
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, _errors.AuthSessionMissingError)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const payload = (0, _helpers.decodeJWTPayload)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data, error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: 'bearer',
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers('SIGNED_IN', session);
            }
            return {
                data: {
                    user: session.user,
                    session
                },
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data, error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, _errors.AuthSessionMissingError)();
                const { session, error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(params, callbackUrlType) {
        try {
            if (!(0, _helpers.isBrowser)()) throw new (0, _errors.AuthImplicitGrantRedirectError)('No browser detected.');
            // If there's an error in the URL, it doesn't matter what flow it is, we just return the error.
            if (params.error || params.error_description || params.error_code) // The error class returned implies that the redirect is from an implicit grant flow
            // but it could also be from a redirect error from a PKCE flow.
            throw new (0, _errors.AuthImplicitGrantRedirectError)(params.error_description || 'Error in URL with unspecified error_description', {
                error: params.error || 'unspecified_error',
                code: params.error_code || 'unspecified_code'
            });
            // Checks for mismatches between the flowType initialised in the client and the URL parameters
            switch(callbackUrlType){
                case 'implicit':
                    if (this.flowType === 'pkce') throw new (0, _errors.AuthPKCEGrantCodeExchangeError)('Not a valid PKCE flow url.');
                    break;
                case 'pkce':
                    if (this.flowType === 'implicit') throw new (0, _errors.AuthImplicitGrantRedirectError)('Not a valid implicit grant flow url.');
                    break;
                default:
            }
            // Since this is a redirect for PKCE, we attempt to retrieve the code from the URL for the code exchange
            if (callbackUrlType === 'pkce') {
                this._debug('#_initialize()', 'begin', 'is PKCE flow', true);
                if (!params.code) throw new (0, _errors.AuthPKCEGrantCodeExchangeError)('No code detected.');
                const { data, error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                window.history.replaceState(window.history.state, '', url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            const { provider_token, provider_refresh_token, access_token, refresh_token, expires_in, expires_at, token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, _errors.AuthImplicitGrantRedirectError)('No session defined in URL');
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= AUTO_REFRESH_TICK_DURATION) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale', issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn('@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clock for skew', issuedAt, expiresAt, timeNow);
            const { data, error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token,
                provider_refresh_token,
                access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token,
                token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = '';
            this._debug('#_getSessionFromURL()', 'clearing window.location.hash');
            return {
                data: {
                    session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantCallback(params) {
        return Boolean(params.access_token || params.error_description);
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCECallback(params) {
        const currentStorageContent = await (0, _helpers.getItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: 'global'
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope } = {
        scope: 'global'
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, _errors.isAuthApiError)(error) && (error.status === 404 || error.status === 401 || error.status === 403))) return {
                        error
                    };
                }
            }
            if (scope !== 'others') {
                await this._removeSession();
                await (0, _helpers.removeItemAsync)(this.storage, `${this.storageKey}-code-verifier`);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, _helpers.uuid)();
        const subscription = {
            id,
            callback,
            unsubscribe: ()=>{
                this._debug('#unsubscribe()', 'state change callback with id removed', id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug('#onAuthStateChange()', 'registered callback with id', id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session }, error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback('INITIAL_SESSION', session));
                this._debug('INITIAL_SESSION', 'callback id', id, 'session', session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback('INITIAL_SESSION', null));
                this._debug('INITIAL_SESSION', 'callback id', id, 'error', err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === 'pkce') [codeChallenge, codeChallengeMethod] = await (0, _helpers.getCodeChallengeAndMethod)(this.storage, this.storageKey, true // isPasswordRecovery
        );
        try {
            return await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/recover`, {
                body: {
                    email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data, error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data, error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data, error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, _fetch._request)(this.fetch, 'GET', url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, _helpers.isBrowser)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data, error } = result;
                if (error) throw error;
                return await (0, _fetch._request)(this.fetch, 'DELETE', `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, _helpers.retryable)(async (attempt)=>{
                if (attempt > 0) await (0, _helpers.sleep)(200 * Math.pow(2, attempt - 1)); // 200, 400, 800, ...
                this._debug(debugName, 'refreshing attempt', attempt);
                return await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, _fetch._sessionResponse)
                });
            }, (attempt, error)=>{
                const nextBackOffInterval = 200 * Math.pow(2, attempt);
                return error && (0, _errors.isAuthRetryableFetchError)(error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + nextBackOffInterval - startedAt < AUTO_REFRESH_TICK_DURATION;
            });
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, _errors.isAuthError)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error
            };
            throw error;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === 'object' && maybeSession !== null && 'access_token' in maybeSession && 'refresh_token' in maybeSession && 'expires_at' in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug('#_handleProviderSignIn()', 'provider', provider, 'options', options, 'url', url);
        // try to open on the browser
        if ((0, _helpers.isBrowser)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider,
                url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes the token
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = '#_recoverAndRefresh()';
        this._debug(debugName, 'begin');
        try {
            const currentSession = await (0, _helpers.getItemAsync)(this.storage, this.storageKey);
            this._debug(debugName, 'session from storage', currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, 'session is not valid');
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const timeNow = Math.round(Date.now() / 1000);
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + (0, _constants.EXPIRY_MARGIN);
            this._debug(debugName, `session has${expiresWithMargin ? '' : ' not'} expired with margin of ${(0, _constants.EXPIRY_MARGIN)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, _errors.isAuthRetryableFetchError)(error)) {
                            this._debug(debugName, 'refresh failed with a non-retryable error, removing the session', error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers('SIGNED_IN', currentSession);
        } catch (err) {
            this._debug(debugName, 'error', err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, 'end');
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, _errors.AuthSessionMissingError)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, 'begin');
        try {
            this.refreshingDeferred = new (0, _helpers.Deferred)();
            const { data, error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, _errors.AuthSessionMissingError)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers('TOKEN_REFRESHED', data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, 'error', error);
            if ((0, _errors.isAuthError)(error)) {
                const result = {
                    session: null,
                    error
                };
                if (!(0, _errors.isAuthRetryableFetchError)(error)) await this._removeSession();
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, 'end');
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, 'begin', session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event,
                session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, 'end');
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug('#_saveSession()', session);
        // _saveSession is always called whenever a new session has been acquired
        // so we can safely suppress the warning returned by future getSession calls
        this.suppressGetSessionWarning = true;
        await (0, _helpers.setItemAsync)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug('#_removeSession()');
        await (0, _helpers.removeItemAsync)(this.storage, this.storageKey);
        await this._notifyAllSubscribers('SIGNED_OUT', null);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug('#_removeVisibilityChangedCallback()');
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, _helpers.isBrowser)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener('visibilitychange', callback);
        } catch (e) {
            console.error('removing visibilitychange callback failed', e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug('#_startAutoRefresh()');
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), AUTO_REFRESH_TICK_DURATION);
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === 'object' && typeof ticker.unref === 'function') // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== 'undefined' && typeof Deno.unrefTimer === 'function') // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-expect-error TS has no context of Deno
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug('#_stopAutoRefresh()');
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug('#_autoRefreshTokenTick()', 'begin');
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug('#_autoRefreshTokenTick()', 'no session');
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / AUTO_REFRESH_TICK_DURATION);
                            this._debug('#_autoRefreshTokenTick()', `access token expires in ${expiresInTicks} ticks, a tick lasts ${AUTO_REFRESH_TICK_DURATION}ms, refresh threshold is ${AUTO_REFRESH_TICK_THRESHOLD} ticks`);
                            if (expiresInTicks <= AUTO_REFRESH_TICK_THRESHOLD) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error('Auto refresh tick failed with error. This is likely a transient error.', e);
                    }
                } finally{
                    this._debug('#_autoRefreshTokenTick()', 'end');
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, _locks.LockAcquireTimeoutError)) this._debug('auto refresh token tick lock not available');
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug('#_handleVisibilityChange()');
        if (!(0, _helpers.isBrowser)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener('visibilitychange', this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error('_handleVisibilityChange', error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, 'visibilityState', document.visibilityState);
        if (document.visibilityState === 'visible') {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== 'visible') {
                        this._debug(methodName, 'acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting');
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === 'hidden') {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === 'pkce') {
            const [codeChallenge, codeChallengeMethod] = await (0, _helpers.getCodeChallengeAndMethod)(this.storage, this.storageKey);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join('&')}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, _fetch._request)(this.fetch, 'DELETE', `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const body = Object.assign({
                    friendly_name: params.friendlyName,
                    factor_type: params.factorType
                }, params.factorType === 'phone' ? {
                    phone: params.phone
                } : {
                    issuer: params.issuer
                });
                const { data, error } = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/factors`, {
                    body,
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error
                };
                if (params.factorType === 'totp' && ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code)) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, _errors.isAuthError)(error)) return {
                data: null,
                error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data, error } = await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers('MFA_CHALLENGE_VERIFIED', data);
                    return {
                        data,
                        error
                    };
                });
            } catch (error) {
                if ((0, _errors.isAuthError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, _fetch._request)(this.fetch, 'POST', `${this.url}/factors/${params.factorId}/challenge`, {
                        body: {
                            channel: params.channel
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, _errors.isAuthError)(error)) return {
                    data: null,
                    error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === 'totp' && factor.status === 'verified');
        const phone = factors.filter((factor)=>factor.factor_type === 'phone' && factor.status === 'verified');
        return {
            data: {
                all: factors,
                totp,
                phone
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const payload = this._decodeJWT(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === 'verified')) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = 'aal2';
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel,
                        nextLevel,
                        currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
}
exports.default = GoTrueClient;
GoTrueClient.nextInstanceID = 0;

},{"./GoTrueAdminApi":"5bmQV","./lib/constants":"5kgHI","./lib/errors":"8RHqO","./lib/fetch":"dOWmM","./lib/helpers":"lQJ1C","./lib/local-storage":"ej9PT","./lib/polyfills":"9gKt7","./lib/version":"gfN29","./lib/locks":"4RjEn","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"ej9PT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localStorageAdapter", ()=>localStorageAdapter);
/**
 * Returns a localStorage-like object that stores the key-value pairs in
 * memory.
 */ parcelHelpers.export(exports, "memoryLocalStorageAdapter", ()=>memoryLocalStorageAdapter);
var _helpers = require("./helpers");
const localStorageAdapter = {
    getItem: (key)=>{
        if (!(0, _helpers.supportsLocalStorage)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, _helpers.supportsLocalStorage)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, _helpers.supportsLocalStorage)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function memoryLocalStorageAdapter(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}

},{"./helpers":"lQJ1C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9gKt7":[function(require,module,exports,__globalThis) {
/**
 * https://mathiasbynens.be/notes/globalthis
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "polyfillGlobalThis", ()=>polyfillGlobalThis);
function polyfillGlobalThis() {
    if (typeof globalThis === 'object') return;
    try {
        Object.defineProperty(Object.prototype, '__magic__', {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== 'undefined') // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"4RjEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "internals", ()=>internals);
/**
 * An error thrown when a lock cannot be acquired after some amount of time.
 *
 * Use the {@link #isAcquireTimeout} property instead of checking with `instanceof`.
 */ parcelHelpers.export(exports, "LockAcquireTimeoutError", ()=>LockAcquireTimeoutError);
parcelHelpers.export(exports, "NavigatorLockAcquireTimeoutError", ()=>NavigatorLockAcquireTimeoutError);
parcelHelpers.export(exports, "ProcessLockAcquireTimeoutError", ()=>ProcessLockAcquireTimeoutError);
/**
 * Implements a global exclusive lock using the Navigator LockManager API. It
 * is available on all browsers released after 2022-03-15 with Safari being the
 * last one to release support. If the API is not available, this function will
 * throw. Make sure you check availablility before configuring {@link
 * GoTrueClient}.
 *
 * You can turn on debugging by setting the `supabase.gotrue-js.locks.debug`
 * local storage item to `true`.
 *
 * Internals:
 *
 * Since the LockManager API does not preserve stack traces for the async
 * function passed in the `request` method, a trick is used where acquiring the
 * lock releases a previously started promise to run the operation in the `fn`
 * function. The lock waits for that promise to finish (with or without error),
 * while the function will finally wait for the result anyway.
 *
 * @param name Name of the lock to be acquired.
 * @param acquireTimeout If negative, no timeout. If 0 an error is thrown if
 *                       the lock can't be acquired without waiting. If positive, the lock acquire
 *                       will time out after so many milliseconds. An error is
 *                       a timeout if it has `isAcquireTimeout` set to true.
 * @param fn The operation to run once the lock is acquired.
 */ parcelHelpers.export(exports, "navigatorLock", ()=>navigatorLock);
/**
 * Implements a global exclusive lock that works only in the current process.
 * Useful for environments like React Native or other non-browser
 * single-process (i.e. no concept of "tabs") environments.
 *
 * Use {@link #navigatorLock} in browser environments.
 *
 * @param name Name of the lock to be acquired.
 * @param acquireTimeout If negative, no timeout. If 0 an error is thrown if
 *                       the lock can't be acquired without waiting. If positive, the lock acquire
 *                       will time out after so many milliseconds. An error is
 *                       a timeout if it has `isAcquireTimeout` set to true.
 * @param fn The operation to run once the lock is acquired.
 */ parcelHelpers.export(exports, "processLock", ()=>processLock);
var _helpers = require("./helpers");
const internals = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, _helpers.supportsLocalStorage)() && globalThis.localStorage && globalThis.localStorage.getItem('supabase.gotrue-js.locks.debug') === 'true')
};
class LockAcquireTimeoutError extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class NavigatorLockAcquireTimeoutError extends LockAcquireTimeoutError {
}
class ProcessLockAcquireTimeoutError extends LockAcquireTimeoutError {
}
async function navigatorLock(name, acquireTimeout, fn) {
    if (internals.debug) console.log('@supabase/gotrue-js: navigatorLock: acquire lock', name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if (internals.debug) console.log('@supabase/gotrue-js: navigatorLock acquire timed out', name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    // Wrapping navigator.locks.request() with a plain Promise is done as some
    // libraries like zone.js patch the Promise object to track the execution
    // context. However, it appears that most browsers use an internal promise
    // implementation when using the navigator.locks.request() API causing them
    // to lose context and emit confusing log messages or break certain features.
    // This wrapping is believed to help zone.js track the execution context
    // better.
    return await Promise.resolve().then(()=>globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
            mode: 'exclusive',
            ifAvailable: true
        } : {
            mode: 'exclusive',
            signal: abortController.signal
        }, async (lock)=>{
            if (lock) {
                if (internals.debug) console.log('@supabase/gotrue-js: navigatorLock: acquired', name, lock.name);
                try {
                    return await fn();
                } finally{
                    if (internals.debug) console.log('@supabase/gotrue-js: navigatorLock: released', name, lock.name);
                }
            } else if (acquireTimeout === 0) {
                if (internals.debug) console.log('@supabase/gotrue-js: navigatorLock: not immediately available', name);
                throw new NavigatorLockAcquireTimeoutError(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
            } else {
                if (internals.debug) try {
                    const result = await globalThis.navigator.locks.query();
                    console.log('@supabase/gotrue-js: Navigator LockManager state', JSON.stringify(result, null, '  '));
                } catch (e) {
                    console.warn('@supabase/gotrue-js: Error when querying Navigator LockManager state', e);
                }
                // Browser is not following the Navigator LockManager spec, it
                // returned a null lock when we didn't use ifAvailable. So we can
                // pretend the lock is acquired in the name of backward compatibility
                // and user experience and just run the function.
                console.warn('@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request');
                return await fn();
            }
        }));
}
const PROCESS_LOCKS = {};
async function processLock(name, acquireTimeout, fn) {
    var _a;
    const previousOperation = (_a = PROCESS_LOCKS[name]) !== null && _a !== void 0 ? _a : Promise.resolve();
    const currentOperation = Promise.race([
        previousOperation.catch(()=>{
            // ignore error of previous operation that we're waiting to finish
            return null;
        }),
        acquireTimeout >= 0 ? new Promise((_, reject)=>{
            setTimeout(()=>{
                reject(new ProcessLockAcquireTimeoutError(`Acquring process lock with name "${name}" timed out`));
            }, acquireTimeout);
        }) : null
    ].filter((x)=>x)).catch((e)=>{
        if (e && e.isAcquireTimeout) throw e;
        return null;
    }).then(async ()=>{
        // previous operations finished and we didn't get a race on the acquire
        // timeout, so the current operation can finally start
        return await fn();
    });
    PROCESS_LOCKS[name] = currentOperation.catch(async (e)=>{
        if (e && e.isAcquireTimeout) {
            // if the current operation timed out, it doesn't mean that the previous
            // operation finished, so we need contnue waiting for it to finish
            await previousOperation;
            return null;
        }
        throw e;
    });
    // finally wait for the current operation to finish successfully, with an
    // error or with an acquire timeout error
    return await currentOperation;
}

},{"./helpers":"lQJ1C","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dTWKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _goTrueAdminApi = require("./GoTrueAdminApi");
var _goTrueAdminApiDefault = parcelHelpers.interopDefault(_goTrueAdminApi);
const AuthAdminApi = (0, _goTrueAdminApiDefault.default);
exports.default = AuthAdminApi;

},{"./GoTrueAdminApi":"5bmQV","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"itpDP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _goTrueClient = require("./GoTrueClient");
var _goTrueClientDefault = parcelHelpers.interopDefault(_goTrueClient);
const AuthClient = (0, _goTrueClientDefault.default);
exports.default = AuthClient;

},{"./GoTrueClient":"8QbFP","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"aKMd1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"kAY9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserStateManager", ()=>UserStateManager);
parcelHelpers.export(exports, "userStateManager", ()=>userStateManager);
class UserStateManager {
    constructor(){
        this.bodyElement = document.body;
        this.initStyles();
    }
    initStyles() {
        const style = document.createElement('style');
        style.textContent = `
      [ss-user-state='is-logged-in'] {
        display: none;
      }

      [ss-user-state='!is-logged-in'] {
        display: none;
      }

      [is-logged-in] [ss-user-state='is-logged-in'] {
        display: block;
      }

      body:not([is-logged-in]) [ss-user-state='!is-logged-in'] {
        display: block;
      }
    `;
        document.head.appendChild(style);
    }
    static getInstance() {
        if (!UserStateManager.instance) UserStateManager.instance = new UserStateManager();
        return UserStateManager.instance;
    }
    updateLoginState(isLoggedIn) {
        if (isLoggedIn) this.bodyElement.setAttribute('is-logged-in', '');
        else this.bodyElement.removeAttribute('is-logged-in');
    }
}
const userStateManager = UserStateManager.getInstance();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2pVOg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identifyUser", ()=>identifyUser);
var _posthogJs = require("posthog-js");
var _posthogJsDefault = parcelHelpers.interopDefault(_posthogJs);
const identifyUser = (userId, userMetadata)=>{
    (0, _posthogJsDefault.default).identify(userId, {
        email: userMetadata.email,
        name: userMetadata.name
    });
};

},{"posthog-js":"2NARa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"2NARa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COPY_AUTOCAPTURE_EVENT", ()=>v);
parcelHelpers.export(exports, "Compression", ()=>e);
parcelHelpers.export(exports, "PostHog", ()=>ho);
parcelHelpers.export(exports, "SurveyQuestionBranchingType", ()=>Rr);
parcelHelpers.export(exports, "SurveyQuestionType", ()=>Fr);
parcelHelpers.export(exports, "SurveyType", ()=>Pr);
parcelHelpers.export(exports, "default", ()=>po);
parcelHelpers.export(exports, "knownUnsafeEditableEvent", ()=>g);
parcelHelpers.export(exports, "posthog", ()=>po);
parcelHelpers.export(exports, "severityLevels", ()=>f);
var e, t = "undefined" != typeof window ? window : void 0, i = "undefined" != typeof globalThis ? globalThis : t, n = Array.prototype, r = n.forEach, s = n.indexOf, o = null == i ? void 0 : i.navigator, a = null == i ? void 0 : i.document, l = null == i ? void 0 : i.location, u = null == i ? void 0 : i.fetch, c = null != i && i.XMLHttpRequest && "withCredentials" in new i.XMLHttpRequest ? i.XMLHttpRequest : void 0, d = null == i ? void 0 : i.AbortController, h = null == o ? void 0 : o.userAgent, _ = null != t ? t : {}, p = {
    DEBUG: !1,
    LIB_VERSION: "1.206.1"
}, v = "$copy_autocapture", g = [
    "$snapshot",
    "$pageview",
    "$pageleave",
    "$set",
    "survey dismissed",
    "survey sent",
    "survey shown",
    "$identify",
    "$groupidentify",
    "$create_alias",
    "$$client_ingestion_warning",
    "$web_experiment_applied",
    "$feature_enrollment_update",
    "$feature_flag_called"
];
!function(e) {
    e.GZipJS = "gzip-js", e.Base64 = "base64";
}(e || (e = {}));
var f = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function m(e, t) {
    return -1 !== e.indexOf(t);
}
var b = function(e) {
    return e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}, y = function(e) {
    return e.replace(/^\$/, "");
};
var w = Array.isArray, S = Object.prototype, E = S.hasOwnProperty, k = S.toString, x = w || function(e) {
    return "[object Array]" === k.call(e);
}, I = (e)=>"function" == typeof e, C = (e)=>e === Object(e) && !x(e), P = (e)=>{
    if (C(e)) {
        for(var t in e)if (E.call(e, t)) return !1;
        return !0;
    }
    return !1;
}, F = (e)=>void 0 === e, R = (e)=>"[object String]" == k.call(e), T = (e)=>R(e) && 0 === e.trim().length, $ = (e)=>null === e, O = (e)=>F(e) || $(e), M = (e)=>"[object Number]" == k.call(e), L = (e)=>"[object Boolean]" === k.call(e), A = (e)=>e instanceof FormData, D = (e)=>m(g, e), N = (e)=>{
    var i = {
        _log: function(i) {
            if (t && (p.DEBUG || _.POSTHOG_DEBUG) && !F(t.console) && t.console) {
                for(var n = ("__rrweb_original__" in t.console[i]) ? t.console[i].__rrweb_original__ : t.console[i], r = arguments.length, s = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)s[o - 1] = arguments[o];
                n(e, ...s);
            }
        },
        info: function() {
            for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            i._log("log", ...t);
        },
        warn: function() {
            for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            i._log("warn", ...t);
        },
        error: function() {
            for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            i._log("error", ...t);
        },
        critical: function() {
            for(var t = arguments.length, i = new Array(t), n = 0; n < t; n++)i[n] = arguments[n];
            console.error(e, ...i);
        },
        uninitializedWarning: (e)=>{
            i.error("You must initialize PostHog before calling ".concat(e));
        },
        createLogger: (t)=>N("".concat(e, " ").concat(t))
    };
    return i;
}, q = N("[PostHog.js]"), B = q.createLogger, H = B("[ExternalScriptsLoader]"), U = (e, t, i)=>{
    if (e.config.disable_external_dependency_loading) return H.warn("".concat(t, " was requested but loading of external scripts is disabled.")), i("Loading of external scripts is disabled");
    var n = ()=>{
        if (!a) return i("document not found");
        var n = a.createElement("script");
        if (n.type = "text/javascript", n.crossOrigin = "anonymous", n.src = t, n.onload = (e)=>i(void 0, e), n.onerror = (e)=>i(e), e.config.prepare_external_dependency_script && (n = e.config.prepare_external_dependency_script(n)), !n) return i("prepare_external_dependency_script returned null");
        var r, s = a.querySelectorAll("body > script");
        s.length > 0 ? null === (r = s[0].parentNode) || void 0 === r || r.insertBefore(n, s[0]) : a.body.appendChild(n);
    };
    null != a && a.body ? n() : null == a || a.addEventListener("DOMContentLoaded", n);
};
function z(e, t) {
    var i = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), i.push.apply(i, n);
    }
    return i;
}
function j(e) {
    for(var t = 1; t < arguments.length; t++){
        var i = null != arguments[t] ? arguments[t] : {};
        t % 2 ? z(Object(i), !0).forEach(function(t) {
            W(e, t, i[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : z(Object(i)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
        });
    }
    return e;
}
function W(e, t, i) {
    return t in e ? Object.defineProperty(e, t, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = i, e;
}
function V(e, t) {
    if (null == e) return {};
    var i, n, r = function(e, t) {
        if (null == e) return {};
        var i, n, r = {}, s = Object.keys(e);
        for(n = 0; n < s.length; n++)i = s[n], t.indexOf(i) >= 0 || (r[i] = e[i]);
        return r;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(n = 0; n < s.length; n++)i = s[n], t.indexOf(i) >= 0 || Object.prototype.propertyIsEnumerable.call(e, i) && (r[i] = e[i]);
    }
    return r;
}
_.__PosthogExtensions__ = _.__PosthogExtensions__ || {}, _.__PosthogExtensions__.loadExternalDependency = (e, t, i)=>{
    var n = "/static/".concat(t, ".js") + "?v=".concat(e.version);
    if ("remote-config" === t && (n = "/array/".concat(e.config.token, "/config.js")), "toolbar" === t) {
        var r = 3e5, s = Math.floor(Date.now() / r) * r;
        n = "".concat(n, "&t=").concat(s);
    }
    var o = e.requestRouter.endpointFor("assets", n);
    U(e, o, i);
}, _.__PosthogExtensions__.loadSiteApp = (e, t, i)=>{
    var n = e.requestRouter.endpointFor("api", t);
    U(e, n, i);
};
var G = {};
function J(e, t, i) {
    if (x(e)) {
        if (r && e.forEach === r) e.forEach(t, i);
        else if ("length" in e && e.length === +e.length) {
            for(var n = 0, s = e.length; n < s; n++)if (n in e && t.call(i, e[n], n) === G) return;
        }
    }
}
function Y(e, t, i) {
    if (!O(e)) {
        if (x(e)) return J(e, t, i);
        if (A(e)) {
            for (var n of e.entries())if (t.call(i, n[1], n[0]) === G) return;
        } else for(var r in e)if (E.call(e, r) && t.call(i, e[r], r) === G) return;
    }
}
var K = function(e) {
    for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)i[n - 1] = arguments[n];
    return J(i, function(t) {
        for(var i in t)void 0 !== t[i] && (e[i] = t[i]);
    }), e;
};
function X(e) {
    for(var t = Object.keys(e), i = t.length, n = new Array(i); i--;)n[i] = [
        t[i],
        e[t[i]]
    ];
    return n;
}
var Q = function(e) {
    try {
        return e();
    } catch (e) {
        return;
    }
}, Z = function(e) {
    return function() {
        try {
            for(var t = arguments.length, i = new Array(t), n = 0; n < t; n++)i[n] = arguments[n];
            return e.apply(this, i);
        } catch (e) {
            q.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), q.critical(e);
        }
    };
}, ee = function(e) {
    var t = {};
    return Y(e, function(e, i) {
        R(e) && e.length > 0 && (t[i] = e);
    }), t;
};
function te(e, t) {
    var i, n, r;
    return i = e, n = (e)=>R(e) && !$(t) ? e.slice(0, t) : e, r = new Set, function e(t, i) {
        var s;
        return t !== Object(t) ? n ? n(t, i) : t : r.has(t) ? void 0 : (r.add(t), x(t) ? (s = [], J(t, (t)=>{
            s.push(e(t));
        })) : (s = {}, Y(t, (t, i)=>{
            r.has(t) || (s[i] = e(t, i));
        })), s);
    }(i);
}
var ie = function() {
    function e(t) {
        return t && (t.preventDefault = e.preventDefault, t.stopPropagation = e.stopPropagation), t;
    }
    return e.preventDefault = function() {
        this.returnValue = !1;
    }, e.stopPropagation = function() {
        this.cancelBubble = !0;
    }, function(i, n, r, s, o) {
        if (i) {
            if (i.addEventListener && !s) i.addEventListener(n, r, !!o);
            else {
                var a = "on" + n, l = i[a];
                i[a] = function(i, n, r) {
                    return function(s) {
                        if (s = s || e(null == t ? void 0 : t.event)) {
                            var o, a = !0;
                            I(r) && (o = r(s));
                            var l = n.call(i, s);
                            return !1 !== o && !1 !== l || (a = !1), a;
                        }
                    };
                }(i, r, l);
            }
        } else q.error("No valid element provided to register_event");
    };
}();
function ne(e, t) {
    for(var i = 0; i < e.length; i++)if (t(e[i])) return e[i];
}
var re = "$people_distinct_id", se = "__alias", oe = "__timers", ae = "$autocapture_disabled_server_side", le = "$heatmaps_enabled_server_side", ue = "$exception_capture_enabled_server_side", ce = "$web_vitals_enabled_server_side", de = "$dead_clicks_enabled_server_side", he = "$web_vitals_allowed_metrics", _e = "$session_recording_enabled_server_side", pe = "$console_log_recording_enabled_server_side", ve = "$session_recording_network_payload_capture", ge = "$session_recording_canvas_recording", fe = "$replay_sample_rate", me = "$replay_minimum_duration", be = "$replay_script_config", ye = "$sesid", we = "$session_is_sampled", Se = "$session_recording_url_trigger_activated_session", Ee = "$session_recording_event_trigger_activated_session", ke = "$enabled_feature_flags", xe = "$early_access_features", Ie = "$stored_person_properties", Ce = "$stored_group_properties", Pe = "$surveys", Fe = "$surveys_activated", Re = "$flag_call_reported", Te = "$user_state", $e = "$client_session_props", Oe = "$capture_rate_limit", Me = "$initial_campaign_params", Le = "$initial_referrer_info", Ae = "$initial_person_info", De = "$epp", Ne = "__POSTHOG_TOOLBAR__", qe = "$posthog_cookieless", Be = [
    re,
    se,
    "__cmpns",
    oe,
    _e,
    le,
    ye,
    ke,
    Te,
    xe,
    Ce,
    Ie,
    Pe,
    Re,
    $e,
    Oe,
    Me,
    Le,
    De
], He = B("[FeatureFlags]"), Ue = "$active_feature_flags", ze = "$override_feature_flags", je = "$feature_flag_payloads", We = (e)=>{
    var t = {};
    for (var [i, n] of X(e || {}))n && (t[i] = n);
    return t;
};
class Ve {
    constructor(e){
        W(this, "_override_warning", !1), W(this, "_hasLoadedFlags", !1), W(this, "_requestInFlight", !1), W(this, "_reloadingDisabled", !1), W(this, "_additionalReloadRequested", !1), W(this, "_decideCalled", !1), W(this, "_flagsLoadedFromRemote", !1), this.instance = e, this.featureFlagEventHandlers = [];
    }
    decide() {
        if (this.instance.config.__preview_remote_config) this._decideCalled = !0;
        else {
            var e = !this._reloadDebouncer && (this.instance.config.advanced_disable_feature_flags || this.instance.config.advanced_disable_feature_flags_on_first_load);
            this._callDecideEndpoint({
                disableFlags: e
            });
        }
    }
    get hasLoadedFlags() {
        return this._hasLoadedFlags;
    }
    getFlags() {
        return Object.keys(this.getFlagVariants());
    }
    getFlagVariants() {
        var e = this.instance.get_property(ke), t = this.instance.get_property(ze);
        if (!t) return e || {};
        for(var i = K({}, e), n = Object.keys(t), r = 0; r < n.length; r++)i[n[r]] = t[n[r]];
        return this._override_warning || (He.warn(" Overriding feature flags!", {
            enabledFlags: e,
            overriddenFlags: t,
            finalFlags: i
        }), this._override_warning = !0), i;
    }
    getFlagPayloads() {
        return this.instance.get_property(je) || {};
    }
    reloadFeatureFlags() {
        this._reloadingDisabled || this.instance.config.advanced_disable_feature_flags || this._reloadDebouncer || (this._reloadDebouncer = setTimeout(()=>{
            this._callDecideEndpoint();
        }, 5));
    }
    clearDebouncer() {
        clearTimeout(this._reloadDebouncer), this._reloadDebouncer = void 0;
    }
    ensureFlagsLoaded() {
        this._hasLoadedFlags || this._requestInFlight || this._reloadDebouncer || this.reloadFeatureFlags();
    }
    setAnonymousDistinctId(e) {
        this.$anon_distinct_id = e;
    }
    setReloadingPaused(e) {
        this._reloadingDisabled = e;
    }
    _callDecideEndpoint(t) {
        if (this.clearDebouncer(), !this.instance.config.advanced_disable_decide) {
            if (this._requestInFlight) this._additionalReloadRequested = !0;
            else {
                var i = {
                    token: this.instance.config.token,
                    distinct_id: this.instance.get_distinct_id(),
                    groups: this.instance.getGroups(),
                    $anon_distinct_id: this.$anon_distinct_id,
                    person_properties: this.instance.get_property(Ie),
                    group_properties: this.instance.get_property(Ce)
                };
                (null != t && t.disableFlags || this.instance.config.advanced_disable_feature_flags) && (i.disable_flags = !0), this._requestInFlight = !0, this.instance._send_request({
                    method: "POST",
                    url: this.instance.requestRouter.endpointFor("api", "/decide/?v=3"),
                    data: i,
                    compression: this.instance.config.disable_compression ? void 0 : e.Base64,
                    timeout: this.instance.config.feature_flag_request_timeout_ms,
                    callback: (e)=>{
                        var t, n, r = !0;
                        (200 === e.statusCode && (this.$anon_distinct_id = void 0, r = !1), this._requestInFlight = !1, this._decideCalled) || (this._decideCalled = !0, this.instance._onRemoteConfig(null !== (n = e.json) && void 0 !== n ? n : {}));
                        i.disable_flags || (this._flagsLoadedFromRemote = !r, this.receivedFeatureFlags(null !== (t = e.json) && void 0 !== t ? t : {}, r), this._additionalReloadRequested && (this._additionalReloadRequested = !1, this._callDecideEndpoint()));
                    }
                });
            }
        }
    }
    getFeatureFlag(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (this._hasLoadedFlags || this.getFlags() && this.getFlags().length > 0) {
            var i, n, r, s, o, a = this.getFlagVariants()[e], l = "".concat(a), u = this.instance.get_property(Re) || {};
            if (t.send_event || !("send_event" in t)) {
                if (!(e in u) || !u[e].includes(l)) x(u[e]) ? u[e].push(l) : u[e] = [
                    l
                ], null === (i = this.instance.persistence) || void 0 === i || i.register({
                    [Re]: u
                }), this.instance.capture("$feature_flag_called", {
                    $feature_flag: e,
                    $feature_flag_response: a,
                    $feature_flag_payload: this.getFeatureFlagPayload(e) || null,
                    $feature_flag_bootstrapped_response: (null === (n = this.instance.config.bootstrap) || void 0 === n || null === (r = n.featureFlags) || void 0 === r ? void 0 : r[e]) || null,
                    $feature_flag_bootstrapped_payload: (null === (s = this.instance.config.bootstrap) || void 0 === s || null === (o = s.featureFlagPayloads) || void 0 === o ? void 0 : o[e]) || null,
                    $used_bootstrap_value: !this._flagsLoadedFromRemote
                });
            }
            return a;
        }
        He.warn('getFeatureFlag for key "' + e + "\" failed. Feature flags didn't load in time.");
    }
    getFeatureFlagPayload(e) {
        return this.getFlagPayloads()[e];
    }
    isFeatureEnabled(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (this._hasLoadedFlags || this.getFlags() && this.getFlags().length > 0) return !!this.getFeatureFlag(e, t);
        He.warn('isFeatureEnabled for key "' + e + "\" failed. Feature flags didn't load in time.");
    }
    addFeatureFlagsHandler(e) {
        this.featureFlagEventHandlers.push(e);
    }
    removeFeatureFlagsHandler(e) {
        this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((t)=>t !== e);
    }
    receivedFeatureFlags(e, t) {
        if (this.instance.persistence) {
            this._hasLoadedFlags = !0;
            var i = this.getFlagVariants(), n = this.getFlagPayloads();
            !function(e, t) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, r = e.featureFlags, s = e.featureFlagPayloads;
                if (r) {
                    if (x(r)) {
                        var o = {};
                        if (r) for(var a = 0; a < r.length; a++)o[r[a]] = !0;
                        t && t.register({
                            [Ue]: r,
                            [ke]: o
                        });
                    } else {
                        var l = r, u = s;
                        e.errorsWhileComputingFlags && (l = j(j({}, i), l), u = j(j({}, n), u)), t && t.register({
                            [Ue]: Object.keys(We(l)),
                            [ke]: l || {},
                            [je]: u || {}
                        });
                    }
                }
            }(e, this.instance.persistence, i, n), this._fireFeatureFlagsCallbacks(t);
        }
    }
    override(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (!this.instance.__loaded || !this.instance.persistence) return He.uninitializedWarning("posthog.feature_flags.override");
        if (this._override_warning = t, !1 === e) this.instance.persistence.unregister(ze);
        else if (x(e)) {
            for(var i = {}, n = 0; n < e.length; n++)i[e[n]] = !0;
            this.instance.persistence.register({
                [ze]: i
            });
        } else this.instance.persistence.register({
            [ze]: e
        });
    }
    onFeatureFlags(e) {
        if (this.addFeatureFlagsHandler(e), this._hasLoadedFlags) {
            var { flags: t, flagVariants: i } = this._prepareFeatureFlagsForCallbacks();
            e(t, i);
        }
        return ()=>this.removeFeatureFlagsHandler(e);
    }
    updateEarlyAccessFeatureEnrollment(e, t) {
        var i, n = (this.instance.get_property(xe) || []).find((t)=>t.flagKey === e), r = {
            ["$feature_enrollment/".concat(e)]: t
        }, s = {
            $feature_flag: e,
            $feature_enrollment: t,
            $set: r
        };
        n && (s.$early_access_feature_name = n.name), this.instance.capture("$feature_enrollment_update", s), this.setPersonPropertiesForFlags(r, !1);
        var o = j(j({}, this.getFlagVariants()), {}, {
            [e]: t
        });
        null === (i = this.instance.persistence) || void 0 === i || i.register({
            [Ue]: Object.keys(We(o)),
            [ke]: o
        }), this._fireFeatureFlagsCallbacks();
    }
    getEarlyAccessFeatures(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], i = this.instance.get_property(xe);
        if (i && !t) return e(i);
        this.instance._send_request({
            url: this.instance.requestRouter.endpointFor("api", "/api/early_access_features/?token=".concat(this.instance.config.token)),
            method: "GET",
            callback: (t)=>{
                var i;
                if (t.json) {
                    var n = t.json.earlyAccessFeatures;
                    return null === (i = this.instance.persistence) || void 0 === i || i.register({
                        [xe]: n
                    }), e(n);
                }
            }
        });
    }
    _prepareFeatureFlagsForCallbacks() {
        var e = this.getFlags(), t = this.getFlagVariants();
        return {
            flags: e.filter((e)=>t[e]),
            flagVariants: Object.keys(t).filter((e)=>t[e]).reduce((e, i)=>(e[i] = t[i], e), {})
        };
    }
    _fireFeatureFlagsCallbacks(e) {
        var { flags: t, flagVariants: i } = this._prepareFeatureFlagsForCallbacks();
        this.featureFlagEventHandlers.forEach((n)=>n(t, i, {
                errorsLoading: e
            }));
    }
    setPersonPropertiesForFlags(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.instance.get_property(Ie) || {};
        this.instance.register({
            [Ie]: j(j({}, i), e)
        }), t && this.instance.reloadFeatureFlags();
    }
    resetPersonPropertiesForFlags() {
        this.instance.unregister(Ie);
    }
    setGroupPropertiesForFlags(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this.instance.get_property(Ce) || {};
        0 !== Object.keys(i).length && Object.keys(i).forEach((t)=>{
            i[t] = j(j({}, i[t]), e[t]), delete e[t];
        }), this.instance.register({
            [Ce]: j(j({}, i), e)
        }), t && this.instance.reloadFeatureFlags();
    }
    resetGroupPropertiesForFlags(e) {
        if (e) {
            var t = this.instance.get_property(Ce) || {};
            this.instance.register({
                [Ce]: j(j({}, t), {}, {
                    [e]: {}
                })
            });
        } else this.instance.unregister(Ce);
    }
}
Math.trunc || (Math.trunc = function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
}), Number.isInteger || (Number.isInteger = function(e) {
    return M(e) && isFinite(e) && Math.floor(e) === e;
});
var Ge = "0123456789abcdef";
class Je {
    constructor(e){
        if (this.bytes = e, 16 !== e.length) throw new TypeError("not 128-bit length");
    }
    static fromFieldsV7(e, t, i, n) {
        if (!Number.isInteger(e) || !Number.isInteger(t) || !Number.isInteger(i) || !Number.isInteger(n) || e < 0 || t < 0 || i < 0 || n < 0 || e > 0xffffffffffff || t > 4095 || i > 1073741823 || n > 4294967295) throw new RangeError("invalid field value");
        var r = new Uint8Array(16);
        return r[0] = e / Math.pow(2, 40), r[1] = e / Math.pow(2, 32), r[2] = e / Math.pow(2, 24), r[3] = e / Math.pow(2, 16), r[4] = e / Math.pow(2, 8), r[5] = e, r[6] = 112 | t >>> 8, r[7] = t, r[8] = 128 | i >>> 24, r[9] = i >>> 16, r[10] = i >>> 8, r[11] = i, r[12] = n >>> 24, r[13] = n >>> 16, r[14] = n >>> 8, r[15] = n, new Je(r);
    }
    toString() {
        for(var e = "", t = 0; t < this.bytes.length; t++)e = e + Ge.charAt(this.bytes[t] >>> 4) + Ge.charAt(15 & this.bytes[t]), 3 !== t && 5 !== t && 7 !== t && 9 !== t || (e += "-");
        if (36 !== e.length) throw new Error("Invalid UUIDv7 was generated");
        return e;
    }
    clone() {
        return new Je(this.bytes.slice(0));
    }
    equals(e) {
        return 0 === this.compareTo(e);
    }
    compareTo(e) {
        for(var t = 0; t < 16; t++){
            var i = this.bytes[t] - e.bytes[t];
            if (0 !== i) return Math.sign(i);
        }
        return 0;
    }
}
class Ye {
    constructor(){
        W(this, "timestamp", 0), W(this, "counter", 0), W(this, "random", new Qe);
    }
    generate() {
        var e = this.generateOrAbort();
        if (F(e)) {
            this.timestamp = 0;
            var t = this.generateOrAbort();
            if (F(t)) throw new Error("Could not generate UUID after timestamp reset");
            return t;
        }
        return e;
    }
    generateOrAbort() {
        var e = Date.now();
        if (e > this.timestamp) this.timestamp = e, this.resetCounter();
        else {
            if (!(e + 1e4 > this.timestamp)) return;
            this.counter++, this.counter > 4398046511103 && (this.timestamp++, this.resetCounter());
        }
        return Je.fromFieldsV7(this.timestamp, Math.trunc(this.counter / Math.pow(2, 30)), this.counter & Math.pow(2, 30) - 1, this.random.nextUint32());
    }
    resetCounter() {
        this.counter = 1024 * this.random.nextUint32() + (1023 & this.random.nextUint32());
    }
}
var Ke, Xe = (e)=>{
    if ("undefined" != typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
    for(var t = 0; t < e.length; t++)e[t] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
    return e;
};
t && !F(t.crypto) && crypto.getRandomValues && (Xe = (e)=>crypto.getRandomValues(e));
class Qe {
    constructor(){
        W(this, "buffer", new Uint32Array(8)), W(this, "cursor", 1 / 0);
    }
    nextUint32() {
        return this.cursor >= this.buffer.length && (Xe(this.buffer), this.cursor = 0), this.buffer[this.cursor++];
    }
}
var Ze = ()=>et().toString(), et = ()=>(Ke || (Ke = new Ye)).generate(), tt = "Thu, 01 Jan 1970 00:00:00 GMT", it = "";
var nt = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
function rt(e, t) {
    if (t) {
        var i = function(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a;
            if (it) return it;
            if (!t) return "";
            if ([
                "localhost",
                "127.0.0.1"
            ].includes(e)) return "";
            for(var i = e.split("."), n = Math.min(i.length, 8), r = "dmn_chk_" + Ze(), s = new RegExp("(^|;)\\s*" + r + "=1"); !it && n--;){
                var o = i.slice(n).join("."), l = r + "=1;domain=." + o;
                t.cookie = l, s.test(t.cookie) && (t.cookie = l + ";expires=" + tt, it = o);
            }
            return it;
        }(e);
        if (!i) {
            var n = ((e)=>{
                var t = e.match(nt);
                return t ? t[0] : "";
            })(e);
            n !== i && q.info("Warning: cookie subdomain discovery mismatch", n, i), i = n;
        }
        return i ? "; domain=." + i : "";
    }
    return "";
}
var st = {
    is_supported: ()=>!!a,
    error: function(e) {
        q.error("cookieStore error: " + e);
    },
    get: function(e) {
        if (a) {
            try {
                for(var t = e + "=", i = a.cookie.split(";").filter((e)=>e.length), n = 0; n < i.length; n++){
                    for(var r = i[n]; " " == r.charAt(0);)r = r.substring(1, r.length);
                    if (0 === r.indexOf(t)) return decodeURIComponent(r.substring(t.length, r.length));
                }
            } catch (e) {}
            return null;
        }
    },
    parse: function(e) {
        var t;
        try {
            t = JSON.parse(st.get(e)) || {};
        } catch (e) {}
        return t;
    },
    set: function(e, t, i, n, r) {
        if (a) try {
            var s = "", o = "", l = rt(a.location.hostname, n);
            if (i) {
                var u = new Date;
                u.setTime(u.getTime() + 24 * i * 3600000), s = "; expires=" + u.toUTCString();
            }
            r && (o = "; secure");
            var c = e + "=" + encodeURIComponent(JSON.stringify(t)) + s + "; SameSite=Lax; path=/" + l + o;
            return c.length > 3686.4 && q.warn("cookieStore warning: large cookie, len=" + c.length), a.cookie = c, c;
        } catch (e) {
            return;
        }
    },
    remove: function(e, t) {
        try {
            st.set(e, "", -1, t);
        } catch (e) {
            return;
        }
    }
}, ot = null, at = {
    is_supported: function() {
        if (!$(ot)) return ot;
        var e = !0;
        if (F(t)) e = !1;
        else try {
            var i = "__mplssupport__";
            at.set(i, "xyz"), '"xyz"' !== at.get(i) && (e = !1), at.remove(i);
        } catch (t) {
            e = !1;
        }
        return e || q.error("localStorage unsupported; falling back to cookie store"), ot = e, e;
    },
    error: function(e) {
        q.error("localStorage error: " + e);
    },
    get: function(e) {
        try {
            return null == t ? void 0 : t.localStorage.getItem(e);
        } catch (e) {
            at.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse(at.get(e)) || {};
        } catch (e) {}
        return null;
    },
    set: function(e, i) {
        try {
            null == t || t.localStorage.setItem(e, JSON.stringify(i));
        } catch (e) {
            at.error(e);
        }
    },
    remove: function(e) {
        try {
            null == t || t.localStorage.removeItem(e);
        } catch (e) {
            at.error(e);
        }
    }
}, lt = [
    "distinct_id",
    ye,
    we,
    De,
    Ae
], ut = j(j({}, at), {}, {
    parse: function(e) {
        try {
            var t = {};
            try {
                t = st.parse(e) || {};
            } catch (e) {}
            var i = K(t, JSON.parse(at.get(e) || "{}"));
            return at.set(e, i), i;
        } catch (e) {}
        return null;
    },
    set: function(e, t, i, n, r, s) {
        try {
            at.set(e, t, void 0, void 0, s);
            var o = {};
            lt.forEach((e)=>{
                t[e] && (o[e] = t[e]);
            }), Object.keys(o).length && st.set(e, o, i, n, r, s);
        } catch (e) {
            at.error(e);
        }
    },
    remove: function(e, i) {
        try {
            null == t || t.localStorage.removeItem(e), st.remove(e, i);
        } catch (e) {
            at.error(e);
        }
    }
}), ct = {}, dt = {
    is_supported: function() {
        return !0;
    },
    error: function(e) {
        q.error("memoryStorage error: " + e);
    },
    get: function(e) {
        return ct[e] || null;
    },
    parse: function(e) {
        return ct[e] || null;
    },
    set: function(e, t) {
        ct[e] = t;
    },
    remove: function(e) {
        delete ct[e];
    }
}, ht = null, _t = {
    is_supported: function() {
        if (!$(ht)) return ht;
        if (ht = !0, F(t)) ht = !1;
        else try {
            var e = "__support__";
            _t.set(e, "xyz"), '"xyz"' !== _t.get(e) && (ht = !1), _t.remove(e);
        } catch (e) {
            ht = !1;
        }
        return ht;
    },
    error: function(e) {
        q.error("sessionStorage error: ", e);
    },
    get: function(e) {
        try {
            return null == t ? void 0 : t.sessionStorage.getItem(e);
        } catch (e) {
            _t.error(e);
        }
        return null;
    },
    parse: function(e) {
        try {
            return JSON.parse(_t.get(e)) || null;
        } catch (e) {}
        return null;
    },
    set: function(e, i) {
        try {
            null == t || t.sessionStorage.setItem(e, JSON.stringify(i));
        } catch (e) {
            _t.error(e);
        }
    },
    remove: function(e) {
        try {
            null == t || t.sessionStorage.removeItem(e);
        } catch (e) {
            _t.error(e);
        }
    }
}, pt = [
    "localhost",
    "127.0.0.1"
], vt = (e)=>{
    var t = null == a ? void 0 : a.createElement("a");
    return F(t) ? null : (t.href = e, t);
}, gt = function(e, t) {
    return !!function(e) {
        try {
            new RegExp(e);
        } catch (e) {
            return !1;
        }
        return !0;
    }(t) && new RegExp(t).test(e);
}, ft = function(e) {
    var t, i, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "&", r = [];
    return Y(e, function(e, n) {
        F(e) || F(n) || "undefined" === n || (t = encodeURIComponent(((e)=>e instanceof File)(e) ? e.name : e.toString()), i = encodeURIComponent(n), r[r.length] = i + "=" + t);
    }), r.join(n);
}, mt = function(e, t) {
    for(var i, n = ((e.split("#")[0] || "").split("?")[1] || "").split("&"), r = 0; r < n.length; r++){
        var s = n[r].split("=");
        if (s[0] === t) {
            i = s;
            break;
        }
    }
    if (!x(i) || i.length < 2) return "";
    var o = i[1];
    try {
        o = decodeURIComponent(o);
    } catch (e) {
        q.error("Skipping decoding for malformed query param: " + o);
    }
    return o.replace(/\+/g, " ");
}, bt = function(e, t) {
    var i = e.match(new RegExp(t + "=([^&]*)"));
    return i ? i[1] : null;
}, yt = "Mobile", wt = "iOS", St = "Android", Et = "Tablet", kt = St + " " + Et, xt = "iPad", It = "Apple", Ct = It + " Watch", Pt = "Safari", Ft = "BlackBerry", Rt = "Samsung", Tt = Rt + "Browser", $t = Rt + " Internet", Ot = "Chrome", Mt = Ot + " OS", Lt = Ot + " " + wt, At = "Internet Explorer", Dt = At + " " + yt, Nt = "Opera", qt = Nt + " Mini", Bt = "Edge", Ht = "Microsoft " + Bt, Ut = "Firefox", zt = Ut + " " + wt, jt = "Nintendo", Wt = "PlayStation", Vt = "Xbox", Gt = St + " " + yt, Jt = yt + " " + Pt, Yt = "Windows", Kt = Yt + " Phone", Xt = "Nokia", Qt = "Ouya", Zt = "Generic", ei = Zt + " " + yt.toLowerCase(), ti = Zt + " " + Et.toLowerCase(), ii = "Konqueror", ni = "(\\d+(\\.\\d+)?)", ri = new RegExp("Version/" + ni), si = new RegExp(Vt, "i"), oi = new RegExp(Wt + " \\w+", "i"), ai = new RegExp(jt + " \\w+", "i"), li = new RegExp(Ft + "|PlayBook|BB10", "i"), ui = {
    "NT3.51": "NT 3.11",
    "NT4.0": "NT 4.0",
    "5.0": "2000",
    5.1: "XP",
    5.2: "XP",
    "6.0": "Vista",
    6.1: "7",
    6.2: "8",
    6.3: "8.1",
    6.4: "10",
    "10.0": "10"
};
var ci = (e, t)=>t && m(t, It) || function(e) {
        return m(e, Pt) && !m(e, Ot) && !m(e, St);
    }(e), di = function(e, t) {
    return t = t || "", m(e, " OPR/") && m(e, "Mini") ? qt : m(e, " OPR/") ? Nt : li.test(e) ? Ft : m(e, "IE" + yt) || m(e, "WPDesktop") ? Dt : m(e, Tt) ? $t : m(e, Bt) || m(e, "Edg/") ? Ht : m(e, "FBIOS") ? "Facebook " + yt : m(e, "UCWEB") || m(e, "UCBrowser") ? "UC Browser" : m(e, "CriOS") ? Lt : m(e, "CrMo") || m(e, Ot) ? Ot : m(e, St) && m(e, Pt) ? Gt : m(e, "FxiOS") ? zt : m(e.toLowerCase(), ii.toLowerCase()) ? ii : ci(e, t) ? m(e, yt) ? Jt : Pt : m(e, Ut) ? Ut : m(e, "MSIE") || m(e, "Trident/") ? At : m(e, "Gecko") ? Ut : "";
}, hi = {
    [Dt]: [
        new RegExp("rv:" + ni)
    ],
    [Ht]: [
        new RegExp(Bt + "?\\/" + ni)
    ],
    [Ot]: [
        new RegExp("(" + Ot + "|CrMo)\\/" + ni)
    ],
    [Lt]: [
        new RegExp("CriOS\\/" + ni)
    ],
    "UC Browser": [
        new RegExp("(UCBrowser|UCWEB)\\/" + ni)
    ],
    [Pt]: [
        ri
    ],
    [Jt]: [
        ri
    ],
    [Nt]: [
        new RegExp("(Opera|OPR)\\/" + ni)
    ],
    [Ut]: [
        new RegExp(Ut + "\\/" + ni)
    ],
    [zt]: [
        new RegExp("FxiOS\\/" + ni)
    ],
    [ii]: [
        new RegExp("Konqueror[:/]?" + ni, "i")
    ],
    [Ft]: [
        new RegExp(Ft + " " + ni),
        ri
    ],
    [Gt]: [
        new RegExp("android\\s" + ni, "i")
    ],
    [$t]: [
        new RegExp(Tt + "\\/" + ni)
    ],
    [At]: [
        new RegExp("(rv:|MSIE )" + ni)
    ],
    Mozilla: [
        new RegExp("rv:" + ni)
    ]
}, _i = [
    [
        new RegExp(Vt + "; " + Vt + " (.*?)[);]", "i"),
        (e)=>[
                Vt,
                e && e[1] || ""
            ]
    ],
    [
        new RegExp(jt, "i"),
        [
            jt,
            ""
        ]
    ],
    [
        new RegExp(Wt, "i"),
        [
            Wt,
            ""
        ]
    ],
    [
        li,
        [
            Ft,
            ""
        ]
    ],
    [
        new RegExp(Yt, "i"),
        (e, t)=>{
            if (/Phone/.test(t) || /WPDesktop/.test(t)) return [
                Kt,
                ""
            ];
            if (new RegExp(yt).test(t) && !/IEMobile\b/.test(t)) return [
                Yt + " " + yt,
                ""
            ];
            var i = /Windows NT ([0-9.]+)/i.exec(t);
            if (i && i[1]) {
                var n = i[1], r = ui[n] || "";
                return /arm/i.test(t) && (r = "RT"), [
                    Yt,
                    r
                ];
            }
            return [
                Yt,
                ""
            ];
        }
    ],
    [
        /((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/,
        (e)=>{
            if (e && e[3]) {
                var t = [
                    e[3],
                    e[4],
                    e[5] || "0"
                ];
                return [
                    wt,
                    t.join(".")
                ];
            }
            return [
                wt,
                ""
            ];
        }
    ],
    [
        /(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i,
        (e)=>{
            var t = "";
            return e && e.length >= 3 && (t = F(e[2]) ? e[3] : e[2]), [
                "watchOS",
                t
            ];
        }
    ],
    [
        new RegExp("(" + St + " (\\d+)\\.(\\d+)\\.?(\\d+)?|" + St + ")", "i"),
        (e)=>{
            if (e && e[2]) {
                var t = [
                    e[2],
                    e[3],
                    e[4] || "0"
                ];
                return [
                    St,
                    t.join(".")
                ];
            }
            return [
                St,
                ""
            ];
        }
    ],
    [
        /Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i,
        (e)=>{
            var t = [
                "Mac OS X",
                ""
            ];
            if (e && e[1]) {
                var i = [
                    e[1],
                    e[2],
                    e[3] || "0"
                ];
                t[1] = i.join(".");
            }
            return t;
        }
    ],
    [
        /Mac/i,
        [
            "Mac OS X",
            ""
        ]
    ],
    [
        /CrOS/,
        [
            Mt,
            ""
        ]
    ],
    [
        /Linux|debian/i,
        [
            "Linux",
            ""
        ]
    ]
], pi = function(e) {
    return ai.test(e) ? jt : oi.test(e) ? Wt : si.test(e) ? Vt : new RegExp(Qt, "i").test(e) ? Qt : new RegExp("(" + Kt + "|WPDesktop)", "i").test(e) ? Kt : /iPad/.test(e) ? xt : /iPod/.test(e) ? "iPod Touch" : /iPhone/.test(e) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(e) ? Ct : li.test(e) ? Ft : /(kobo)\s(ereader|touch)/i.test(e) ? "Kobo" : new RegExp(Xt, "i").test(e) ? Xt : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(e) || /(kf[a-z]+)( bui|\)).+silk\//i.test(e) ? "Kindle Fire" : /(Android|ZTE)/i.test(e) ? !new RegExp(yt).test(e) || /(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(e) ? /pixel[\daxl ]{1,6}/i.test(e) && !/pixel c/i.test(e) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(e) || /lmy47v/i.test(e) && !/QTAQZ3/i.test(e) ? St : kt : St : new RegExp("(pda|" + yt + ")", "i").test(e) ? ei : new RegExp(Et, "i").test(e) && !new RegExp(Et + " pc", "i").test(e) ? ti : "";
}, vi = "https?://(.*)", gi = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gad_source",
    "gclsrc",
    "dclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "msclkid",
    "twclid",
    "li_fat_id",
    "mc_cid",
    "igshid",
    "ttclid",
    "rdt_cid",
    "irclid",
    "_kx"
], fi = {
    campaignParams: function(e) {
        return a ? this._campaignParamsFromUrl(a.URL, e) : {};
    },
    _campaignParamsFromUrl: function(e, t) {
        var i = gi.concat(t || []), n = {};
        return Y(i, function(t) {
            var i = mt(e, t);
            n[t] = i || null;
        }), n;
    },
    _searchEngine: function(e) {
        return e ? 0 === e.search(vi + "google.([^/?]*)") ? "google" : 0 === e.search(vi + "bing.com") ? "bing" : 0 === e.search(vi + "yahoo.com") ? "yahoo" : 0 === e.search(vi + "duckduckgo.com") ? "duckduckgo" : null : null;
    },
    _searchInfoFromReferrer: function(e) {
        var t = fi._searchEngine(e), i = "yahoo" != t ? "q" : "p", n = {};
        if (!$(t)) {
            n.$search_engine = t;
            var r = a ? mt(a.referrer, i) : "";
            r.length && (n.ph_keyword = r);
        }
        return n;
    },
    searchInfo: function() {
        var e = null == a ? void 0 : a.referrer;
        return e ? this._searchInfoFromReferrer(e) : {};
    },
    browser: di,
    browserVersion: function(e, t) {
        var i = di(e, t), n = hi[i];
        if (F(n)) return null;
        for(var r = 0; r < n.length; r++){
            var s = n[r], o = e.match(s);
            if (o) return parseFloat(o[o.length - 2]);
        }
        return null;
    },
    browserLanguage: function() {
        return navigator.language || navigator.userLanguage;
    },
    browserLanguagePrefix: function() {
        var e = this.browserLanguage();
        return "string" == typeof e ? e.split("-")[0] : void 0;
    },
    os: function(e) {
        for(var t = 0; t < _i.length; t++){
            var [i, n] = _i[t], r = i.exec(e), s = r && (I(n) ? n(r, e) : n);
            if (s) return s;
        }
        return [
            "",
            ""
        ];
    },
    device: pi,
    deviceType: function(e) {
        var t = pi(e);
        return t === xt || t === kt || "Kobo" === t || "Kindle Fire" === t || t === ti ? Et : t === jt || t === Vt || t === Wt || t === Qt ? "Console" : t === Ct ? "Wearable" : t ? yt : "Desktop";
    },
    referrer: function() {
        return (null == a ? void 0 : a.referrer) || "$direct";
    },
    referringDomain: function() {
        var e;
        return null != a && a.referrer && (null === (e = vt(a.referrer)) || void 0 === e ? void 0 : e.host) || "$direct";
    },
    referrerInfo: function() {
        return {
            $referrer: this.referrer(),
            $referring_domain: this.referringDomain()
        };
    },
    initialPersonInfo: function() {
        return {
            r: this.referrer().substring(0, 1e3),
            u: null == l ? void 0 : l.href.substring(0, 1e3)
        };
    },
    initialPersonPropsFromInfo: function(e) {
        var t, { r: i, u: n } = e, r = {
            $initial_referrer: i,
            $initial_referring_domain: null == i ? void 0 : "$direct" == i ? "$direct" : null === (t = vt(i)) || void 0 === t ? void 0 : t.host
        };
        if (n) {
            r.$initial_current_url = n;
            var s = vt(n);
            r.$initial_host = null == s ? void 0 : s.host, r.$initial_pathname = null == s ? void 0 : s.pathname, Y(this._campaignParamsFromUrl(n), function(e, t) {
                r["$initial_" + y(t)] = e;
            });
        }
        i && Y(this._searchInfoFromReferrer(i), function(e, t) {
            r["$initial_" + y(t)] = e;
        });
        return r;
    },
    timezone: function() {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        } catch (e) {
            return;
        }
    },
    timezoneOffset: function() {
        try {
            return (new Date).getTimezoneOffset();
        } catch (e) {
            return;
        }
    },
    properties: function() {
        if (!h) return {};
        var [e, i] = fi.os(h);
        return K(ee({
            $os: e,
            $os_version: i,
            $browser: fi.browser(h, navigator.vendor),
            $device: fi.device(h),
            $device_type: fi.deviceType(h),
            $timezone: fi.timezone(),
            $timezone_offset: fi.timezoneOffset()
        }), {
            $current_url: null == l ? void 0 : l.href,
            $host: null == l ? void 0 : l.host,
            $pathname: null == l ? void 0 : l.pathname,
            $raw_user_agent: h.length > 1e3 ? h.substring(0, 997) + "..." : h,
            $browser_version: fi.browserVersion(h, navigator.vendor),
            $browser_language: fi.browserLanguage(),
            $browser_language_prefix: fi.browserLanguagePrefix(),
            $screen_height: null == t ? void 0 : t.screen.height,
            $screen_width: null == t ? void 0 : t.screen.width,
            $viewport_height: null == t ? void 0 : t.innerHeight,
            $viewport_width: null == t ? void 0 : t.innerWidth,
            $lib: "web",
            $lib_version: p.LIB_VERSION,
            $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10),
            $time: Date.now() / 1e3
        });
    },
    people_properties: function() {
        if (!h) return {};
        var [e, t] = fi.os(h);
        return K(ee({
            $os: e,
            $os_version: t,
            $browser: fi.browser(h, navigator.vendor)
        }), {
            $browser_version: fi.browserVersion(h, navigator.vendor)
        });
    }
}, mi = [
    "cookie",
    "localstorage",
    "localstorage+cookie",
    "sessionstorage",
    "memory"
];
class bi {
    constructor(e){
        this.config = e, this.props = {}, this.campaign_params_saved = !1, this.name = ((e)=>{
            var t = "";
            return e.token && (t = e.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), e.persistence_name ? "ph_" + e.persistence_name : "ph_" + t + "_posthog";
        })(e), this.storage = this.buildStorage(e), this.load(), e.debug && q.info("Persistence loaded", e.persistence, j({}, this.props)), this.update_config(e, e), this.save();
    }
    buildStorage(e) {
        -1 === mi.indexOf(e.persistence.toLowerCase()) && (q.critical("Unknown persistence type " + e.persistence + "; falling back to localStorage+cookie"), e.persistence = "localStorage+cookie");
        var t = e.persistence.toLowerCase();
        return "localstorage" === t && at.is_supported() ? at : "localstorage+cookie" === t && ut.is_supported() ? ut : "sessionstorage" === t && _t.is_supported() ? _t : "memory" === t ? dt : "cookie" === t ? st : ut.is_supported() ? ut : st;
    }
    properties() {
        var e = {};
        return Y(this.props, function(t, i) {
            if (i === ke && C(t)) for(var n = Object.keys(t), r = 0; r < n.length; r++)e["$feature/".concat(n[r])] = t[n[r]];
            else a = i, l = !1, ($(o = Be) ? l : s && o.indexOf === s ? -1 != o.indexOf(a) : (Y(o, function(e) {
                if (l || (l = e === a)) return G;
            }), l)) || (e[i] = t);
            var o, a, l;
        }), e;
    }
    load() {
        if (!this.disabled) {
            var e = this.storage.parse(this.name);
            e && (this.props = K({}, e));
        }
    }
    save() {
        this.disabled || this.storage.set(this.name, this.props, this.expire_days, this.cross_subdomain, this.secure, this.config.debug);
    }
    remove() {
        this.storage.remove(this.name, !1), this.storage.remove(this.name, !0);
    }
    clear() {
        this.remove(), this.props = {};
    }
    register_once(e, t, i) {
        if (C(e)) {
            F(t) && (t = "None"), this.expire_days = F(i) ? this.default_expiry : i;
            var n = !1;
            if (Y(e, (e, i)=>{
                this.props.hasOwnProperty(i) && this.props[i] !== t || (this.props[i] = e, n = !0);
            }), n) return this.save(), !0;
        }
        return !1;
    }
    register(e, t) {
        if (C(e)) {
            this.expire_days = F(t) ? this.default_expiry : t;
            var i = !1;
            if (Y(e, (t, n)=>{
                e.hasOwnProperty(n) && this.props[n] !== t && (this.props[n] = t, i = !0);
            }), i) return this.save(), !0;
        }
        return !1;
    }
    unregister(e) {
        e in this.props && (delete this.props[e], this.save());
    }
    update_campaign_params() {
        if (!this.campaign_params_saved) {
            var e = fi.campaignParams(this.config.custom_campaign_params);
            P(ee(e)) || this.register(e), this.campaign_params_saved = !0;
        }
    }
    update_search_keyword() {
        this.register(fi.searchInfo());
    }
    update_referrer_info() {
        this.register_once(fi.referrerInfo(), void 0);
    }
    set_initial_person_info() {
        this.props[Me] || this.props[Le] || this.register_once({
            [Ae]: fi.initialPersonInfo()
        }, void 0);
    }
    get_referrer_info() {
        return ee({
            $referrer: this.props.$referrer,
            $referring_domain: this.props.$referring_domain
        });
    }
    get_initial_props() {
        var e = {};
        Y([
            Le,
            Me
        ], (t)=>{
            var i = this.props[t];
            i && Y(i, function(t, i) {
                e["$initial_" + y(i)] = t;
            });
        });
        var t = this.props[Ae];
        if (t) {
            var i = fi.initialPersonPropsFromInfo(t);
            K(e, i);
        }
        return e;
    }
    safe_merge(e) {
        return Y(this.props, function(t, i) {
            i in e || (e[i] = t);
        }), e;
    }
    update_config(e, t) {
        if (this.default_expiry = this.expire_days = e.cookie_expiration, this.set_disabled(e.disable_persistence), this.set_cross_subdomain(e.cross_subdomain_cookie), this.set_secure(e.secure_cookie), e.persistence !== t.persistence) {
            var i = this.buildStorage(e), n = this.props;
            this.clear(), this.storage = i, this.props = n, this.save();
        }
    }
    set_disabled(e) {
        this.disabled = e, this.disabled ? this.remove() : this.save();
    }
    set_cross_subdomain(e) {
        e !== this.cross_subdomain && (this.cross_subdomain = e, this.remove(), this.save());
    }
    get_cross_subdomain() {
        return !!this.cross_subdomain;
    }
    set_secure(e) {
        e !== this.secure && (this.secure = e, this.remove(), this.save());
    }
    set_event_timer(e, t) {
        var i = this.props[oe] || {};
        i[e] = t, this.props[oe] = i, this.save();
    }
    remove_event_timer(e) {
        var t = (this.props[oe] || {})[e];
        return F(t) || (delete this.props[oe][e], this.save()), t;
    }
    get_property(e) {
        return this.props[e];
    }
    set_property(e, t) {
        this.props[e] = t, this.save();
    }
}
function yi(e) {
    var t, i;
    return (null === (t = JSON.stringify(e, (i = [], function(e, t) {
        if (C(t)) {
            for(; i.length > 0 && i[i.length - 1] !== this;)i.pop();
            return i.includes(t) ? "[Circular]" : (i.push(t), t);
        }
        return t;
    }))) || void 0 === t ? void 0 : t.length) || 0;
}
function wi(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6606028.8;
    if (e.size >= t && e.data.length > 1) {
        var i = Math.floor(e.data.length / 2), n = e.data.slice(0, i), r = e.data.slice(i);
        return [
            wi({
                size: yi(n),
                data: n,
                sessionId: e.sessionId,
                windowId: e.windowId
            }),
            wi({
                size: yi(r),
                data: r,
                sessionId: e.sessionId,
                windowId: e.windowId
            })
        ].flatMap((e)=>e);
    }
    return [
        e
    ];
}
var Si = ((e)=>(e[e.DomContentLoaded = 0] = "DomContentLoaded", e[e.Load = 1] = "Load", e[e.FullSnapshot = 2] = "FullSnapshot", e[e.IncrementalSnapshot = 3] = "IncrementalSnapshot", e[e.Meta = 4] = "Meta", e[e.Custom = 5] = "Custom", e[e.Plugin = 6] = "Plugin", e))(Si || {}), Ei = ((e)=>(e[e.Mutation = 0] = "Mutation", e[e.MouseMove = 1] = "MouseMove", e[e.MouseInteraction = 2] = "MouseInteraction", e[e.Scroll = 3] = "Scroll", e[e.ViewportResize = 4] = "ViewportResize", e[e.Input = 5] = "Input", e[e.TouchMove = 6] = "TouchMove", e[e.MediaInteraction = 7] = "MediaInteraction", e[e.StyleSheetRule = 8] = "StyleSheetRule", e[e.CanvasMutation = 9] = "CanvasMutation", e[e.Font = 10] = "Font", e[e.Log = 11] = "Log", e[e.Drag = 12] = "Drag", e[e.StyleDeclaration = 13] = "StyleDeclaration", e[e.Selection = 14] = "Selection", e[e.AdoptedStyleSheet = 15] = "AdoptedStyleSheet", e[e.CustomElement = 16] = "CustomElement", e))(Ei || {});
function ki(e) {
    var t;
    return e instanceof Element && (e.id === Ne || !(null === (t = e.closest) || void 0 === t || !t.call(e, ".toolbar-global-fade-container")));
}
function xi(e) {
    return !!e && 1 === e.nodeType;
}
function Ii(e, t) {
    return !!e && !!e.tagName && e.tagName.toLowerCase() === t.toLowerCase();
}
function Ci(e) {
    return !!e && 3 === e.nodeType;
}
function Pi(e) {
    return !!e && 11 === e.nodeType;
}
function Fi(e) {
    return e ? b(e).split(/\s+/) : [];
}
function Ri(e) {
    var i = null == t ? void 0 : t.location.href;
    return !!(i && e && e.some((e)=>i.match(e)));
}
function Ti(e) {
    var t = "";
    switch(typeof e.className){
        case "string":
            t = e.className;
            break;
        case "object":
            t = (e.className && "baseVal" in e.className ? e.className.baseVal : null) || e.getAttribute("class") || "";
            break;
        default:
            t = "";
    }
    return Fi(t);
}
function $i(e) {
    return O(e) ? null : b(e).split(/(\s+)/).filter((e)=>Vi(e)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function Oi(e) {
    var t = "";
    return Ni(e) && !qi(e) && e.childNodes && e.childNodes.length && Y(e.childNodes, function(e) {
        var i;
        Ci(e) && e.textContent && (t += null !== (i = $i(e.textContent)) && void 0 !== i ? i : "");
    }), b(t);
}
function Mi(e) {
    var t;
    return F(e.target) ? e.srcElement || null : null !== (t = e.target) && void 0 !== t && t.shadowRoot ? e.composedPath()[0] || null : e.target || null;
}
var Li = [
    "a",
    "button",
    "form",
    "input",
    "select",
    "textarea",
    "label"
];
function Ai(e) {
    var t = e.parentNode;
    return !(!t || !xi(t)) && t;
}
function Di(e, i) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, r = arguments.length > 3 ? arguments[3] : void 0, s = arguments.length > 4 ? arguments[4] : void 0;
    if (!t || !e || Ii(e, "html") || !xi(e)) return !1;
    if (null != n && n.url_allowlist && !Ri(n.url_allowlist)) return !1;
    if (null != n && n.url_ignorelist && Ri(n.url_ignorelist)) return !1;
    if (null != n && n.dom_event_allowlist) {
        var o = n.dom_event_allowlist;
        if (o && !o.some((e)=>i.type === e)) return !1;
    }
    for(var a = !1, l = [
        e
    ], u = !0, c = e; c.parentNode && !Ii(c, "body");)if (Pi(c.parentNode)) l.push(c.parentNode.host), c = c.parentNode.host;
    else {
        if (!(u = Ai(c))) break;
        if (r || Li.indexOf(u.tagName.toLowerCase()) > -1) a = !0;
        else {
            var d = t.getComputedStyle(u);
            d && "pointer" === d.getPropertyValue("cursor") && (a = !0);
        }
        l.push(u), c = u;
    }
    if (!function(e, t) {
        var i = null == t ? void 0 : t.element_allowlist;
        if (F(i)) return !0;
        var n = function(e) {
            if (i.some((t)=>e.tagName.toLowerCase() === t)) return {
                v: !0
            };
        };
        for (var r of e){
            var s = n(r);
            if ("object" == typeof s) return s.v;
        }
        return !1;
    }(l, n)) return !1;
    if (!function(e, t) {
        var i = null == t ? void 0 : t.css_selector_allowlist;
        if (F(i)) return !0;
        var n = function(e) {
            if (i.some((t)=>e.matches(t))) return {
                v: !0
            };
        };
        for (var r of e){
            var s = n(r);
            if ("object" == typeof s) return s.v;
        }
        return !1;
    }(l, n)) return !1;
    var h = t.getComputedStyle(e);
    if (h && "pointer" === h.getPropertyValue("cursor") && "click" === i.type) return !0;
    var _ = e.tagName.toLowerCase();
    switch(_){
        case "html":
            return !1;
        case "form":
            return (s || [
                "submit"
            ]).indexOf(i.type) >= 0;
        case "input":
        case "select":
        case "textarea":
            return (s || [
                "change",
                "click"
            ]).indexOf(i.type) >= 0;
        default:
            return a ? (s || [
                "click"
            ]).indexOf(i.type) >= 0 : (s || [
                "click"
            ]).indexOf(i.type) >= 0 && (Li.indexOf(_) > -1 || "true" === e.getAttribute("contenteditable"));
    }
}
function Ni(e) {
    for(var t = e; t.parentNode && !Ii(t, "body"); t = t.parentNode){
        var i = Ti(t);
        if (m(i, "ph-sensitive") || m(i, "ph-no-capture")) return !1;
    }
    if (m(Ti(e), "ph-include")) return !0;
    var n = e.type || "";
    if (R(n)) switch(n.toLowerCase()){
        case "hidden":
        case "password":
            return !1;
    }
    var r = e.name || e.id || "";
    if (R(r)) {
        if (/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(r.replace(/[^a-zA-Z0-9]/g, ""))) return !1;
    }
    return !0;
}
function qi(e) {
    return !!(Ii(e, "input") && ![
        "button",
        "checkbox",
        "submit",
        "reset"
    ].includes(e.type) || Ii(e, "select") || Ii(e, "textarea") || "true" === e.getAttribute("contenteditable"));
}
var Bi = "(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11})", Hi = new RegExp("^(?:".concat(Bi, ")$")), Ui = new RegExp(Bi), zi = "\\d{3}-?\\d{2}-?\\d{4}", ji = new RegExp("^(".concat(zi, ")$")), Wi = new RegExp("(".concat(zi, ")"));
function Vi(e) {
    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
    if (O(e)) return !1;
    if (R(e)) {
        if (e = b(e), (t ? Hi : Ui).test((e || "").replace(/[- ]/g, ""))) return !1;
        if ((t ? ji : Wi).test(e)) return !1;
    }
    return !0;
}
function Gi(e) {
    var t = Oi(e);
    return Vi(t = "".concat(t, " ").concat(Ji(e)).trim()) ? t : "";
}
function Ji(e) {
    var t = "";
    return e && e.childNodes && e.childNodes.length && Y(e.childNodes, function(e) {
        var i;
        if (e && "span" === (null === (i = e.tagName) || void 0 === i ? void 0 : i.toLowerCase())) try {
            var n = Oi(e);
            t = "".concat(t, " ").concat(n).trim(), e.childNodes && e.childNodes.length && (t = "".concat(t, " ").concat(Ji(e)).trim());
        } catch (e) {
            q.error("[AutoCapture]", e);
        }
    }), t;
}
function Yi(e) {
    return function(e) {
        var t = e.map((e)=>{
            var t, i, n = "";
            if (e.tag_name && (n += e.tag_name), e.attr_class) for (var r of (e.attr_class.sort(), e.attr_class))n += ".".concat(r.replace(/"/g, ""));
            var s = j(j(j(j({}, e.text ? {
                text: e.text
            } : {}), {}, {
                "nth-child": null !== (t = e.nth_child) && void 0 !== t ? t : 0,
                "nth-of-type": null !== (i = e.nth_of_type) && void 0 !== i ? i : 0
            }, e.href ? {
                href: e.href
            } : {}), e.attr_id ? {
                attr_id: e.attr_id
            } : {}), e.attributes), o = {};
            return X(s).sort((e, t)=>{
                var [i] = e, [n] = t;
                return i.localeCompare(n);
            }).forEach((e)=>{
                var [t, i] = e;
                return o[Ki(t.toString())] = Ki(i.toString());
            }), n += ":", n += X(s).map((e)=>{
                var [t, i] = e;
                return "".concat(t, '="').concat(i, '"');
            }).join("");
        });
        return t.join(";");
    }(function(e) {
        return e.map((e)=>{
            var t, i, n = {
                text: null === (t = e.$el_text) || void 0 === t ? void 0 : t.slice(0, 400),
                tag_name: e.tag_name,
                href: null === (i = e.attr__href) || void 0 === i ? void 0 : i.slice(0, 2048),
                attr_class: Xi(e),
                attr_id: e.attr__id,
                nth_child: e.nth_child,
                nth_of_type: e.nth_of_type,
                attributes: {}
            };
            return X(e).filter((e)=>{
                var [t] = e;
                return 0 === t.indexOf("attr__");
            }).forEach((e)=>{
                var [t, i] = e;
                return n.attributes[t] = i;
            }), n;
        });
    }(e));
}
function Ki(e) {
    return e.replace(/"|\\"/g, '\\"');
}
function Xi(e) {
    var t = e.attr__class;
    return t ? x(t) ? t : Fi(t) : void 0;
}
var Qi = "[SessionRecording]", Zi = "redacted", en = {
    initiatorTypes: [
        "audio",
        "beacon",
        "body",
        "css",
        "early-hint",
        "embed",
        "fetch",
        "frame",
        "iframe",
        "icon",
        "image",
        "img",
        "input",
        "link",
        "navigation",
        "object",
        "ping",
        "script",
        "track",
        "video",
        "xmlhttprequest"
    ],
    maskRequestFn: (e)=>e,
    recordHeaders: !1,
    recordBody: !1,
    recordInitialRequests: !1,
    recordPerformance: !1,
    performanceEntryTypeToObserve: [
        "first-input",
        "navigation",
        "paint",
        "resource"
    ],
    payloadSizeLimitBytes: 1e6,
    payloadHostDenyList: [
        ".lr-ingest.io",
        ".ingest.sentry.io",
        ".clarity.ms",
        "analytics.google.com"
    ]
}, tn = [
    "authorization",
    "x-forwarded-for",
    "authorization",
    "cookie",
    "set-cookie",
    "x-api-key",
    "x-real-ip",
    "remote-addr",
    "forwarded",
    "proxy-authorization",
    "x-csrf-token",
    "x-csrftoken",
    "x-xsrf-token"
], nn = [
    "password",
    "secret",
    "passwd",
    "api_key",
    "apikey",
    "auth",
    "credentials",
    "mysql_pwd",
    "privatekey",
    "private_key",
    "token"
], rn = [
    "/s/",
    "/e/",
    "/i/"
];
function sn(e, t, i, n) {
    if (O(e)) return e;
    var r = (null == t ? void 0 : t["content-length"]) || function(e) {
        return new Blob([
            e
        ]).size;
    }(e);
    return R(r) && (r = parseInt(r)), r > i ? Qi + " ".concat(n, " body too large to record (").concat(r, " bytes)") : e;
}
function on(e, t) {
    if (O(e)) return e;
    var i = e;
    return Vi(i, !1) || (i = Qi + " " + t + " body " + Zi), Y(nn, (e)=>{
        var n, r;
        null !== (n = i) && void 0 !== n && n.length && -1 !== (null === (r = i) || void 0 === r ? void 0 : r.indexOf(e)) && (i = Qi + " " + t + " body " + Zi + " as might contain: " + e);
    }), i;
}
var an = (e, t)=>{
    var i, n, r, s = {
        payloadSizeLimitBytes: en.payloadSizeLimitBytes,
        performanceEntryTypeToObserve: [
            ...en.performanceEntryTypeToObserve
        ],
        payloadHostDenyList: [
            ...t.payloadHostDenyList || [],
            ...en.payloadHostDenyList
        ]
    }, o = !1 !== e.session_recording.recordHeaders && t.recordHeaders, a = !1 !== e.session_recording.recordBody && t.recordBody, l = !1 !== e.capture_performance && t.recordPerformance, u = (i = s, r = Math.min(1e6, null !== (n = i.payloadSizeLimitBytes) && void 0 !== n ? n : 1e6), (e)=>(null != e && e.requestBody && (e.requestBody = sn(e.requestBody, e.requestHeaders, r, "Request")), null != e && e.responseBody && (e.responseBody = sn(e.responseBody, e.responseHeaders, r, "Response")), e)), c = (t)=>{
        var i, n;
        return u(((e, t)=>{
            var i, n = vt(e.name), r = 0 === t.indexOf("http") ? null === (i = vt(t)) || void 0 === i ? void 0 : i.pathname : t;
            "/" === r && (r = "");
            var s = null == n ? void 0 : n.pathname.replace(r || "", "");
            if (!(n && s && rn.some((e)=>0 === s.indexOf(e)))) return e;
        })((n = (i = t).requestHeaders, O(n) || Y(Object.keys(null != n ? n : {}), (e)=>{
            tn.includes(e.toLowerCase()) && (n[e] = Zi);
        }), i), e.api_host));
    }, d = I(e.session_recording.maskNetworkRequestFn);
    return d && I(e.session_recording.maskCapturedNetworkRequestFn) && q.warn("Both `maskNetworkRequestFn` and `maskCapturedNetworkRequestFn` are defined. `maskNetworkRequestFn` will be ignored."), d && (e.session_recording.maskCapturedNetworkRequestFn = (t)=>{
        var i = e.session_recording.maskNetworkRequestFn({
            url: t.name
        });
        return j(j({}, t), {}, {
            name: null == i ? void 0 : i.url
        });
    }), s.maskRequestFn = I(e.session_recording.maskCapturedNetworkRequestFn) ? (t)=>{
        var i, n, r, s = c(t);
        return s && null !== (i = null === (n = (r = e.session_recording).maskCapturedNetworkRequestFn) || void 0 === n ? void 0 : n.call(r, s)) && void 0 !== i ? i : void 0;
    } : (e)=>(function(e) {
            if (!F(e)) return e.requestBody = on(e.requestBody, "Request"), e.responseBody = on(e.responseBody, "Response"), e;
        })(c(e)), j(j(j({}, en), s), {}, {
        recordHeaders: o,
        recordBody: a,
        recordPerformance: l,
        recordInitialRequests: l
    });
};
function ln(e, t, i, n, r) {
    return t > i && (q.warn("min cannot be greater than max."), t = i), M(e) ? e > i ? (n && q.warn(n + " cannot be  greater than max: " + i + ". Using max value instead."), i) : e < t ? (n && q.warn(n + " cannot be less than min: " + t + ". Using min value instead."), t) : e : (n && q.warn(n + " must be a number. using max or fallback. max: " + i + ", fallback: " + r), ln(r || i, t, i, n));
}
class un {
    constructor(e){
        var t, i, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        W(this, "bucketSize", 100), W(this, "refillRate", 10), W(this, "mutationBuckets", {}), W(this, "loggedTracker", {}), W(this, "refillBuckets", ()=>{
            Object.keys(this.mutationBuckets).forEach((e)=>{
                this.mutationBuckets[e] = this.mutationBuckets[e] + this.refillRate, this.mutationBuckets[e] >= this.bucketSize && delete this.mutationBuckets[e];
            });
        }), W(this, "getNodeOrRelevantParent", (e)=>{
            var t = this.rrweb.mirror.getNode(e);
            if ("svg" !== (null == t ? void 0 : t.nodeName) && t instanceof Element) {
                var i = t.closest("svg");
                if (i) return [
                    this.rrweb.mirror.getId(i),
                    i
                ];
            }
            return [
                e,
                t
            ];
        }), W(this, "numberOfChanges", (e)=>{
            var t, i, n, r, s, o, a, l;
            return (null !== (t = null === (i = e.removes) || void 0 === i ? void 0 : i.length) && void 0 !== t ? t : 0) + (null !== (n = null === (r = e.attributes) || void 0 === r ? void 0 : r.length) && void 0 !== n ? n : 0) + (null !== (s = null === (o = e.texts) || void 0 === o ? void 0 : o.length) && void 0 !== s ? s : 0) + (null !== (a = null === (l = e.adds) || void 0 === l ? void 0 : l.length) && void 0 !== a ? a : 0);
        }), W(this, "throttleMutations", (e)=>{
            if (3 !== e.type || 0 !== e.data.source) return e;
            var t = e.data, i = this.numberOfChanges(t);
            t.attributes && (t.attributes = t.attributes.filter((e)=>{
                var t, i, n, [r, s] = this.getNodeOrRelevantParent(e.id);
                if (0 === this.mutationBuckets[r]) return !1;
                (this.mutationBuckets[r] = null !== (t = this.mutationBuckets[r]) && void 0 !== t ? t : this.bucketSize, this.mutationBuckets[r] = Math.max(this.mutationBuckets[r] - 1, 0), 0 === this.mutationBuckets[r]) && (this.loggedTracker[r] || (this.loggedTracker[r] = !0, null === (i = (n = this.options).onBlockedNode) || void 0 === i || i.call(n, r, s)));
                return e;
            }));
            var n = this.numberOfChanges(t);
            return 0 !== n || i === n ? e : void 0;
        }), this.rrweb = e, this.options = n, this.refillRate = ln(null !== (t = this.options.refillRate) && void 0 !== t ? t : this.refillRate, 0, 100, "mutation throttling refill rate"), this.bucketSize = ln(null !== (i = this.options.bucketSize) && void 0 !== i ? i : this.bucketSize, 0, 100, "mutation throttling bucket size"), setInterval(()=>{
            this.refillBuckets();
        }, 1e3);
    }
}
var cn = Uint8Array, dn = Uint16Array, hn = Uint32Array, _n = new cn([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    0,
    0,
    0
]), pn = new cn([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    0,
    0
]), vn = new cn([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]), gn = function(e, t) {
    for(var i = new dn(31), n = 0; n < 31; ++n)i[n] = t += 1 << e[n - 1];
    var r = new hn(i[30]);
    for(n = 1; n < 30; ++n)for(var s = i[n]; s < i[n + 1]; ++s)r[s] = s - i[n] << 5 | n;
    return [
        i,
        r
    ];
}, fn = gn(_n, 2), mn = fn[0], bn = fn[1];
mn[28] = 258, bn[258] = 28;
for(var yn = gn(pn, 0)[1], wn = new dn(32768), Sn = 0; Sn < 32768; ++Sn){
    var En = (43690 & Sn) >>> 1 | (21845 & Sn) << 1;
    En = (61680 & (En = (52428 & En) >>> 2 | (13107 & En) << 2)) >>> 4 | (3855 & En) << 4, wn[Sn] = ((65280 & En) >>> 8 | (255 & En) << 8) >>> 1;
}
var kn = function(e, t, i) {
    for(var n = e.length, r = 0, s = new dn(t); r < n; ++r)++s[e[r] - 1];
    var o, a = new dn(t);
    for(r = 0; r < t; ++r)a[r] = a[r - 1] + s[r - 1] << 1;
    if (i) {
        o = new dn(1 << t);
        var l = 15 - t;
        for(r = 0; r < n; ++r)if (e[r]) for(var u = r << 4 | e[r], c = t - e[r], d = a[e[r] - 1]++ << c, h = d | (1 << c) - 1; d <= h; ++d)o[wn[d] >>> l] = u;
    } else for(o = new dn(n), r = 0; r < n; ++r)o[r] = wn[a[e[r] - 1]++] >>> 15 - e[r];
    return o;
}, xn = new cn(288);
for(Sn = 0; Sn < 144; ++Sn)xn[Sn] = 8;
for(Sn = 144; Sn < 256; ++Sn)xn[Sn] = 9;
for(Sn = 256; Sn < 280; ++Sn)xn[Sn] = 7;
for(Sn = 280; Sn < 288; ++Sn)xn[Sn] = 8;
var In = new cn(32);
for(Sn = 0; Sn < 32; ++Sn)In[Sn] = 5;
var Cn = kn(xn, 9, 0), Pn = kn(In, 5, 0), Fn = function(e) {
    return (e / 8 >> 0) + (7 & e && 1);
}, Rn = function(e, t, i) {
    (null == i || i > e.length) && (i = e.length);
    var n = new (e instanceof dn ? dn : e instanceof hn ? hn : cn)(i - t);
    return n.set(e.subarray(t, i)), n;
}, Tn = function(e, t, i) {
    i <<= 7 & t;
    var n = t / 8 >> 0;
    e[n] |= i, e[n + 1] |= i >>> 8;
}, $n = function(e, t, i) {
    i <<= 7 & t;
    var n = t / 8 >> 0;
    e[n] |= i, e[n + 1] |= i >>> 8, e[n + 2] |= i >>> 16;
}, On = function(e, t) {
    for(var i = [], n = 0; n < e.length; ++n)e[n] && i.push({
        s: n,
        f: e[n]
    });
    var r = i.length, s = i.slice();
    if (!r) return [
        new cn(0),
        0
    ];
    if (1 == r) {
        var o = new cn(i[0].s + 1);
        return o[i[0].s] = 1, [
            o,
            1
        ];
    }
    i.sort(function(e, t) {
        return e.f - t.f;
    }), i.push({
        s: -1,
        f: 25001
    });
    var a = i[0], l = i[1], u = 0, c = 1, d = 2;
    for(i[0] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    }; c != r - 1;)a = i[i[u].f < i[d].f ? u++ : d++], l = i[u != c && i[u].f < i[d].f ? u++ : d++], i[c++] = {
        s: -1,
        f: a.f + l.f,
        l: a,
        r: l
    };
    var h = s[0].s;
    for(n = 1; n < r; ++n)s[n].s > h && (h = s[n].s);
    var _ = new dn(h + 1), p = Mn(i[c - 1], _, 0);
    if (p > t) {
        n = 0;
        var v = 0, g = p - t, f = 1 << g;
        for(s.sort(function(e, t) {
            return _[t.s] - _[e.s] || e.f - t.f;
        }); n < r; ++n){
            var m = s[n].s;
            if (!(_[m] > t)) break;
            v += f - (1 << p - _[m]), _[m] = t;
        }
        for(v >>>= g; v > 0;){
            var b = s[n].s;
            _[b] < t ? v -= 1 << t - _[b]++ - 1 : ++n;
        }
        for(; n >= 0 && v; --n){
            var y = s[n].s;
            _[y] == t && (--_[y], ++v);
        }
        p = t;
    }
    return [
        new cn(_),
        p
    ];
}, Mn = function(e, t, i) {
    return -1 == e.s ? Math.max(Mn(e.l, t, i + 1), Mn(e.r, t, i + 1)) : t[e.s] = i;
}, Ln = function(e) {
    for(var t = e.length; t && !e[--t];);
    for(var i = new dn(++t), n = 0, r = e[0], s = 1, o = function(e) {
        i[n++] = e;
    }, a = 1; a <= t; ++a)if (e[a] == r && a != t) ++s;
    else {
        if (!r && s > 2) {
            for(; s > 138; s -= 138)o(32754);
            s > 2 && (o(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
        } else if (s > 3) {
            for(o(r), --s; s > 6; s -= 6)o(8304);
            s > 2 && (o(s - 3 << 5 | 8208), s = 0);
        }
        for(; s--;)o(r);
        s = 1, r = e[a];
    }
    return [
        i.subarray(0, n),
        t
    ];
}, An = function(e, t) {
    for(var i = 0, n = 0; n < t.length; ++n)i += e[n] * t[n];
    return i;
}, Dn = function(e, t, i) {
    var n = i.length, r = Fn(t + 2);
    e[r] = 255 & n, e[r + 1] = n >>> 8, e[r + 2] = 255 ^ e[r], e[r + 3] = 255 ^ e[r + 1];
    for(var s = 0; s < n; ++s)e[r + s + 4] = i[s];
    return 8 * (r + 4 + n);
}, Nn = function(e, t, i, n, r, s, o, a, l, u, c) {
    Tn(t, c++, i), ++r[256];
    for(var d = On(r, 15), h = d[0], _ = d[1], p = On(s, 15), v = p[0], g = p[1], f = Ln(h), m = f[0], b = f[1], y = Ln(v), w = y[0], S = y[1], E = new dn(19), k = 0; k < m.length; ++k)E[31 & m[k]]++;
    for(k = 0; k < w.length; ++k)E[31 & w[k]]++;
    for(var x = On(E, 7), I = x[0], C = x[1], P = 19; P > 4 && !I[vn[P - 1]]; --P);
    var F, R, T, $, O = u + 5 << 3, M = An(r, xn) + An(s, In) + o, L = An(r, h) + An(s, v) + o + 14 + 3 * P + An(E, I) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
    if (O <= M && O <= L) return Dn(t, c, e.subarray(l, l + u));
    if (Tn(t, c, 1 + (L < M)), c += 2, L < M) {
        F = kn(h, _, 0), R = h, T = kn(v, g, 0), $ = v;
        var A = kn(I, C, 0);
        Tn(t, c, b - 257), Tn(t, c + 5, S - 1), Tn(t, c + 10, P - 4), c += 14;
        for(k = 0; k < P; ++k)Tn(t, c + 3 * k, I[vn[k]]);
        c += 3 * P;
        for(var D = [
            m,
            w
        ], N = 0; N < 2; ++N){
            var q = D[N];
            for(k = 0; k < q.length; ++k){
                var B = 31 & q[k];
                Tn(t, c, A[B]), c += I[B], B > 15 && (Tn(t, c, q[k] >>> 5 & 127), c += q[k] >>> 12);
            }
        }
    } else F = Cn, R = xn, T = Pn, $ = In;
    for(k = 0; k < a; ++k)if (n[k] > 255) {
        B = n[k] >>> 18 & 31;
        $n(t, c, F[B + 257]), c += R[B + 257], B > 7 && (Tn(t, c, n[k] >>> 23 & 31), c += _n[B]);
        var H = 31 & n[k];
        $n(t, c, T[H]), c += $[H], H > 3 && ($n(t, c, n[k] >>> 5 & 8191), c += pn[H]);
    } else $n(t, c, F[n[k]]), c += R[n[k]];
    return $n(t, c, F[256]), c + R[256];
}, qn = new hn([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]), Bn = function() {
    for(var e = new hn(256), t = 0; t < 256; ++t){
        for(var i = t, n = 9; --n;)i = (1 & i && 3988292384) ^ i >>> 1;
        e[t] = i;
    }
    return e;
}(), Hn = function() {
    var e = 4294967295;
    return {
        p: function(t) {
            for(var i = e, n = 0; n < t.length; ++n)i = Bn[255 & i ^ t[n]] ^ i >>> 8;
            e = i;
        },
        d: function() {
            return 4294967295 ^ e;
        }
    };
}, Un = function(e, t, i, n, r) {
    return function(e, t, i, n, r, s) {
        var o = e.length, a = new cn(n + o + 5 * (1 + Math.floor(o / 7e3)) + r), l = a.subarray(n, a.length - r), u = 0;
        if (!t || o < 8) for(var c = 0; c <= o; c += 65535){
            var d = c + 65535;
            d < o ? u = Dn(l, u, e.subarray(c, d)) : (l[c] = s, u = Dn(l, u, e.subarray(c, o)));
        }
        else {
            for(var h = qn[t - 1], _ = h >>> 13, p = 8191 & h, v = (1 << i) - 1, g = new dn(32768), f = new dn(v + 1), m = Math.ceil(i / 3), b = 2 * m, y = function(t) {
                return (e[t] ^ e[t + 1] << m ^ e[t + 2] << b) & v;
            }, w = new hn(25e3), S = new dn(288), E = new dn(32), k = 0, x = 0, I = (c = 0, 0), C = 0, P = 0; c < o; ++c){
                var F = y(c), R = 32767 & c, T = f[F];
                if (g[R] = T, f[F] = R, C <= c) {
                    var $ = o - c;
                    if ((k > 7e3 || I > 24576) && $ > 423) {
                        u = Nn(e, l, 0, w, S, E, x, I, P, c - P, u), I = k = x = 0, P = c;
                        for(var O = 0; O < 286; ++O)S[O] = 0;
                        for(O = 0; O < 30; ++O)E[O] = 0;
                    }
                    var M = 2, L = 0, A = p, D = R - T & 32767;
                    if ($ > 2 && F == y(c - D)) for(var N = Math.min(_, $) - 1, q = Math.min(32767, c), B = Math.min(258, $); D <= q && --A && R != T;){
                        if (e[c + M] == e[c + M - D]) {
                            for(var H = 0; H < B && e[c + H] == e[c + H - D]; ++H);
                            if (H > M) {
                                if (M = H, L = D, H > N) break;
                                var U = Math.min(D, H - 2), z = 0;
                                for(O = 0; O < U; ++O){
                                    var j = c - D + O + 32768 & 32767, W = j - g[j] + 32768 & 32767;
                                    W > z && (z = W, T = j);
                                }
                            }
                        }
                        D += (R = T) - (T = g[R]) + 32768 & 32767;
                    }
                    if (L) {
                        w[I++] = 268435456 | bn[M] << 18 | yn[L];
                        var V = 31 & bn[M], G = 31 & yn[L];
                        x += _n[V] + pn[G], ++S[257 + V], ++E[G], C = c + M, ++k;
                    } else w[I++] = e[c], ++S[e[c]];
                }
            }
            u = Nn(e, l, s, w, S, E, x, I, P, c - P, u);
        }
        return Rn(a, 0, n + Fn(u) + r);
    }(e, null == t.level ? 6 : t.level, null == t.mem ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(e.length)))) : 12 + t.mem, i, n, !r);
}, zn = function(e, t, i) {
    for(; i; ++t)e[t] = i, i >>>= 8;
}, jn = function(e, t) {
    var i = t.filename;
    if (e[0] = 31, e[1] = 139, e[2] = 8, e[8] = t.level < 2 ? 4 : 9 == t.level ? 2 : 0, e[9] = 3, 0 != t.mtime && zn(e, 4, Math.floor(new Date(t.mtime || Date.now()) / 1e3)), i) {
        e[3] = 8;
        for(var n = 0; n <= i.length; ++n)e[n + 10] = i.charCodeAt(n);
    }
}, Wn = function(e) {
    return 10 + (e.filename && e.filename.length + 1 || 0);
};
function Vn(e, t) {
    void 0 === t && (t = {});
    var i = Hn(), n = e.length;
    i.p(e);
    var r = Un(e, t, Wn(t), 8), s = r.length;
    return jn(r, t), zn(r, s - 8, i.d()), zn(r, s - 4, n), r;
}
function Gn(e, t) {
    var i = e.length;
    if ("undefined" != typeof TextEncoder) return (new TextEncoder).encode(e);
    for(var n = new cn(e.length + (e.length >>> 1)), r = 0, s = function(e) {
        n[r++] = e;
    }, o = 0; o < i; ++o){
        if (r + 5 > n.length) {
            var a = new cn(r + 8 + (i - o << 1));
            a.set(n), n = a;
        }
        var l = e.charCodeAt(o);
        l < 128 || t ? s(l) : l < 2048 ? (s(192 | l >>> 6), s(128 | 63 & l)) : l > 55295 && l < 57344 ? (s(240 | (l = 65536 + (1047552 & l) | 1023 & e.charCodeAt(++o)) >>> 18), s(128 | l >>> 12 & 63), s(128 | l >>> 6 & 63), s(128 | 63 & l)) : (s(224 | l >>> 12), s(128 | l >>> 6 & 63), s(128 | 63 & l));
    }
    return Rn(n, 0, r);
}
var Jn = "[SessionRecording]", Yn = B(Jn), Kn = 3e5, Xn = [
    Ei.MouseMove,
    Ei.MouseInteraction,
    Ei.Scroll,
    Ei.ViewportResize,
    Ei.Input,
    Ei.TouchMove,
    Ei.MediaInteraction,
    Ei.Drag
], Qn = (e)=>({
        rrwebMethod: e,
        enqueuedAt: Date.now(),
        attempt: 1
    });
function Zn(e) {
    return function(e, t) {
        for(var i = "", n = 0; n < e.length;){
            var r = e[n++];
            r < 128 || t ? i += String.fromCharCode(r) : r < 224 ? i += String.fromCharCode((31 & r) << 6 | 63 & e[n++]) : r < 240 ? i += String.fromCharCode((15 & r) << 12 | (63 & e[n++]) << 6 | 63 & e[n++]) : (r = ((15 & r) << 18 | (63 & e[n++]) << 12 | (63 & e[n++]) << 6 | 63 & e[n++]) - 65536, i += String.fromCharCode(55296 | r >> 10, 56320 | 1023 & r));
        }
        return i;
    }(Vn(Gn(JSON.stringify(e))), !0);
}
function er(e) {
    return e.type === Si.Custom && "sessionIdle" === e.data.tag;
}
function tr(e, t) {
    return t.some((t)=>"regex" === t.matching && new RegExp(t.url).test(e));
}
class ir {
    get sessionIdleThresholdMilliseconds() {
        return this.instance.config.session_recording.session_idle_threshold_ms || 3e5;
    }
    get rrwebRecord() {
        var e, t;
        return null == _ || null === (e = _.__PosthogExtensions__) || void 0 === e || null === (t = e.rrweb) || void 0 === t ? void 0 : t.record;
    }
    get started() {
        return this._captureStarted;
    }
    get sessionManager() {
        if (!this.instance.sessionManager) throw new Error(Jn + " must be started with a valid sessionManager.");
        return this.instance.sessionManager;
    }
    get fullSnapshotIntervalMillis() {
        var e, t;
        return "trigger_pending" === this.triggerStatus ? 6e4 : null !== (e = null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.full_snapshot_interval_millis) && void 0 !== e ? e : Kn;
    }
    get isSampled() {
        var e = this.instance.get_property(we);
        return L(e) ? e : null;
    }
    get sessionDuration() {
        var e, t, i = null === (e = this.buffer) || void 0 === e ? void 0 : e.data[(null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) - 1], { sessionStartTimestamp: n } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
        return i ? i.timestamp - n : null;
    }
    get isRecordingEnabled() {
        var e = !!this.instance.get_property(_e), i = !this.instance.config.disable_session_recording;
        return t && e && i;
    }
    get isConsoleLogCaptureEnabled() {
        var e = !!this.instance.get_property(pe), t = this.instance.config.enable_recording_console_log;
        return null != t ? t : e;
    }
    get canvasRecording() {
        var e, t, i, n, r, s, o = this.instance.config.session_recording.captureCanvas, a = this.instance.get_property(ge), l = null !== (e = null !== (t = null == o ? void 0 : o.recordCanvas) && void 0 !== t ? t : null == a ? void 0 : a.enabled) && void 0 !== e && e, u = null !== (i = null !== (n = null == o ? void 0 : o.canvasFps) && void 0 !== n ? n : null == a ? void 0 : a.fps) && void 0 !== i ? i : 0, c = null !== (r = null !== (s = null == o ? void 0 : o.canvasQuality) && void 0 !== s ? s : null == a ? void 0 : a.quality) && void 0 !== r ? r : 0;
        return {
            enabled: l,
            fps: ln(u, 0, 12, "canvas recording fps"),
            quality: ln(c, 0, 1, "canvas recording quality")
        };
    }
    get networkPayloadCapture() {
        var e, t, i = this.instance.get_property(ve), n = {
            recordHeaders: null === (e = this.instance.config.session_recording) || void 0 === e ? void 0 : e.recordHeaders,
            recordBody: null === (t = this.instance.config.session_recording) || void 0 === t ? void 0 : t.recordBody
        }, r = (null == n ? void 0 : n.recordHeaders) || (null == i ? void 0 : i.recordHeaders), s = (null == n ? void 0 : n.recordBody) || (null == i ? void 0 : i.recordBody), o = C(this.instance.config.capture_performance) ? this.instance.config.capture_performance.network_timing : this.instance.config.capture_performance, a = !!(L(o) ? o : null == i ? void 0 : i.capturePerformance);
        return r || s || a ? {
            recordHeaders: r,
            recordBody: s,
            recordPerformance: a
        } : void 0;
    }
    get sampleRate() {
        var e = this.instance.get_property(fe);
        return M(e) ? e : null;
    }
    get minimumDuration() {
        var e = this.instance.get_property(me);
        return M(e) ? e : null;
    }
    get status() {
        return this.receivedDecide ? this.isRecordingEnabled ? this._urlBlocked ? "paused" : O(this._linkedFlag) || this._linkedFlagSeen ? "trigger_pending" === this.triggerStatus ? "buffering" : L(this.isSampled) ? this.isSampled ? "sampled" : "disabled" : "active" : "buffering" : "disabled" : "buffering";
    }
    get urlTriggerStatus() {
        var e;
        return 0 === this._urlTriggers.length ? "trigger_disabled" : (null === (e = this.instance) || void 0 === e ? void 0 : e.get_property(Se)) === this.sessionId ? "trigger_activated" : "trigger_pending";
    }
    get eventTriggerStatus() {
        var e;
        return 0 === this._eventTriggers.length ? "trigger_disabled" : (null === (e = this.instance) || void 0 === e ? void 0 : e.get_property(Ee)) === this.sessionId ? "trigger_activated" : "trigger_pending";
    }
    get triggerStatus() {
        var e = "trigger_activated" === this.eventTriggerStatus || "trigger_activated" === this.urlTriggerStatus, t = "trigger_pending" === this.eventTriggerStatus || "trigger_pending" === this.urlTriggerStatus;
        return e ? "trigger_activated" : t ? "trigger_pending" : "trigger_disabled";
    }
    constructor(e){
        if (W(this, "queuedRRWebEvents", []), W(this, "isIdle", !1), W(this, "_linkedFlagSeen", !1), W(this, "_lastActivityTimestamp", Date.now()), W(this, "_linkedFlag", null), W(this, "_removePageViewCaptureHook", void 0), W(this, "_onSessionIdListener", void 0), W(this, "_persistDecideOnSessionListener", void 0), W(this, "_samplingSessionListener", void 0), W(this, "_urlTriggers", []), W(this, "_urlBlocklist", []), W(this, "_urlBlocked", !1), W(this, "_eventTriggers", []), W(this, "_removeEventTriggerCaptureHook", void 0), W(this, "_forceAllowLocalhostNetworkCapture", !1), W(this, "_onBeforeUnload", ()=>{
            this._flushBuffer();
        }), W(this, "_onOffline", ()=>{
            this._tryAddCustomEvent("browser offline", {});
        }), W(this, "_onOnline", ()=>{
            this._tryAddCustomEvent("browser online", {});
        }), W(this, "_onVisibilityChange", ()=>{
            if (null != a && a.visibilityState) {
                var e = "window " + a.visibilityState;
                this._tryAddCustomEvent(e, {});
            }
        }), this.instance = e, this._captureStarted = !1, this._endpoint = "/s/", this.stopRrweb = void 0, this.receivedDecide = !1, !this.instance.sessionManager) throw Yn.error("started without valid sessionManager"), new Error(Jn + " started without valid sessionManager. This is a bug.");
        if (this.instance.config.__preview_experimental_cookieless_mode) throw new Error(Jn + " cannot be used with __preview_experimental_cookieless_mode.");
        var { sessionId: t, windowId: i } = this.sessionManager.checkAndGetSessionAndWindowId();
        this.sessionId = t, this.windowId = i, this.buffer = this.clearBuffer(), this.sessionIdleThresholdMilliseconds >= this.sessionManager.sessionTimeoutMs && Yn.warn("session_idle_threshold_ms (".concat(this.sessionIdleThresholdMilliseconds, ") is greater than the session timeout (").concat(this.sessionManager.sessionTimeoutMs, "). Session will never be detected as idle"));
    }
    startIfEnabledOrStop(e) {
        this.isRecordingEnabled ? (this._startCapture(e), null == t || t.addEventListener("beforeunload", this._onBeforeUnload), null == t || t.addEventListener("offline", this._onOffline), null == t || t.addEventListener("online", this._onOnline), null == t || t.addEventListener("visibilitychange", this._onVisibilityChange), this._setupSampling(), this._addEventTriggerListener(), O(this._removePageViewCaptureHook) && (this._removePageViewCaptureHook = this.instance.on("eventCaptured", (e)=>{
            try {
                if ("$pageview" === e.event) {
                    var t = null != e && e.properties.$current_url ? this._maskUrl(null == e ? void 0 : e.properties.$current_url) : "";
                    if (!t) return;
                    this._tryAddCustomEvent("$pageview", {
                        href: t
                    });
                }
            } catch (e) {
                Yn.error("Could not add $pageview to rrweb session", e);
            }
        })), this._onSessionIdListener || (this._onSessionIdListener = this.sessionManager.onSessionId((e, t, i)=>{
            var n, r, s, o;
            i && (this._tryAddCustomEvent("$session_id_change", {
                sessionId: e,
                windowId: t,
                changeReason: i
            }), null === (n = this.instance) || void 0 === n || null === (r = n.persistence) || void 0 === r || r.unregister(Ee), null === (s = this.instance) || void 0 === s || null === (o = s.persistence) || void 0 === o || o.unregister(Se));
        }))) : this.stopRecording();
    }
    stopRecording() {
        var e, i, n, r;
        this._captureStarted && this.stopRrweb && (this.stopRrweb(), this.stopRrweb = void 0, this._captureStarted = !1, null == t || t.removeEventListener("beforeunload", this._onBeforeUnload), null == t || t.removeEventListener("offline", this._onOffline), null == t || t.removeEventListener("online", this._onOnline), null == t || t.removeEventListener("visibilitychange", this._onVisibilityChange), this.clearBuffer(), clearInterval(this._fullSnapshotTimer), null === (e = this._removePageViewCaptureHook) || void 0 === e || e.call(this), this._removePageViewCaptureHook = void 0, null === (i = this._removeEventTriggerCaptureHook) || void 0 === i || i.call(this), this._removeEventTriggerCaptureHook = void 0, null === (n = this._onSessionIdListener) || void 0 === n || n.call(this), this._onSessionIdListener = void 0, null === (r = this._samplingSessionListener) || void 0 === r || r.call(this), this._samplingSessionListener = void 0, Yn.info("stopped"));
    }
    makeSamplingDecision(e) {
        var t, i = this.sessionId !== e, n = this.sampleRate;
        if (M(n)) {
            var r, s = this.isSampled, o = i || !L(s);
            if (o) r = Math.random() < n;
            else r = s;
            o && (r ? this._reportStarted("sampled") : Yn.warn("Sample rate (".concat(n, ") has determined that this sessionId (").concat(e, ") will not be sent to the server.")), this._tryAddCustomEvent("samplingDecisionMade", {
                sampleRate: n,
                isSampled: r
            })), null === (t = this.instance.persistence) || void 0 === t || t.register({
                [we]: r
            });
        } else {
            var a;
            null === (a = this.instance.persistence) || void 0 === a || a.register({
                [we]: null
            });
        }
    }
    onRemoteConfig(e) {
        var t, i, n, r, s, o;
        (this._tryAddCustomEvent("$remote_config_received", e), this._persistRemoteConfig(e), this._linkedFlag = (null === (t = e.sessionRecording) || void 0 === t ? void 0 : t.linkedFlag) || null, null !== (i = e.sessionRecording) && void 0 !== i && i.endpoint) && (this._endpoint = null === (o = e.sessionRecording) || void 0 === o ? void 0 : o.endpoint);
        if (this._setupSampling(), !O(this._linkedFlag) && !this._linkedFlagSeen) {
            var a = R(this._linkedFlag) ? this._linkedFlag : this._linkedFlag.flag, l = R(this._linkedFlag) ? null : this._linkedFlag.variant;
            this.instance.onFeatureFlags((e, t)=>{
                var i = C(t) && a in t, n = l ? t[a] === l : i;
                n && this._reportStarted("linked_flag_matched", {
                    linkedFlag: a,
                    linkedVariant: l
                }), this._linkedFlagSeen = n;
            });
        }
        null !== (n = e.sessionRecording) && void 0 !== n && n.urlTriggers && (this._urlTriggers = e.sessionRecording.urlTriggers), null !== (r = e.sessionRecording) && void 0 !== r && r.urlBlocklist && (this._urlBlocklist = e.sessionRecording.urlBlocklist), null !== (s = e.sessionRecording) && void 0 !== s && s.eventTriggers && (this._eventTriggers = e.sessionRecording.eventTriggers), this.receivedDecide = !0, this.startIfEnabledOrStop();
    }
    _setupSampling() {
        M(this.sampleRate) && O(this._samplingSessionListener) && (this._samplingSessionListener = this.sessionManager.onSessionId((e)=>{
            this.makeSamplingDecision(e);
        }));
    }
    _persistRemoteConfig(e) {
        if (this.instance.persistence) {
            var t, i = this.instance.persistence, n = ()=>{
                var t, n, r, s, o, a, l, u, c = null === (t = e.sessionRecording) || void 0 === t ? void 0 : t.sampleRate, d = O(c) ? null : parseFloat(c), h = null === (n = e.sessionRecording) || void 0 === n ? void 0 : n.minimumDurationMilliseconds;
                i.register({
                    [_e]: !!e.sessionRecording,
                    [pe]: null === (r = e.sessionRecording) || void 0 === r ? void 0 : r.consoleLogRecordingEnabled,
                    [ve]: j({
                        capturePerformance: e.capturePerformance
                    }, null === (s = e.sessionRecording) || void 0 === s ? void 0 : s.networkPayloadCapture),
                    [ge]: {
                        enabled: null === (o = e.sessionRecording) || void 0 === o ? void 0 : o.recordCanvas,
                        fps: null === (a = e.sessionRecording) || void 0 === a ? void 0 : a.canvasFps,
                        quality: null === (l = e.sessionRecording) || void 0 === l ? void 0 : l.canvasQuality
                    },
                    [fe]: d,
                    [me]: F(h) ? null : h,
                    [be]: null === (u = e.sessionRecording) || void 0 === u ? void 0 : u.scriptConfig
                });
            };
            n(), null === (t = this._persistDecideOnSessionListener) || void 0 === t || t.call(this), this._persistDecideOnSessionListener = this.sessionManager.onSessionId(n);
        }
    }
    log(e) {
        var t, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "log";
        null === (t = this.instance.sessionRecording) || void 0 === t || t.onRRwebEmit({
            type: 6,
            data: {
                plugin: "rrweb/console@1",
                payload: {
                    level: i,
                    trace: [],
                    payload: [
                        JSON.stringify(e)
                    ]
                }
            },
            timestamp: Date.now()
        });
    }
    _startCapture(e) {
        if (!F(Object.assign) && !F(Array.from) && !(this._captureStarted || this.instance.config.disable_session_recording || this.instance.consent.isOptedOut())) {
            var t, i;
            if (this._captureStarted = !0, this.sessionManager.checkAndGetSessionAndWindowId(), this.rrwebRecord) this._onScriptLoaded();
            else null === (t = _.__PosthogExtensions__) || void 0 === t || null === (i = t.loadExternalDependency) || void 0 === i || i.call(t, this.instance, this.scriptName, (e)=>{
                if (e) return Yn.error("could not load recorder", e);
                this._onScriptLoaded();
            });
            Yn.info("starting"), "active" === this.status && this._reportStarted(e || "recording_initialized");
        }
    }
    get scriptName() {
        var e, t, i;
        return (null === (e = this.instance) || void 0 === e || null === (t = e.persistence) || void 0 === t || null === (i = t.get_property(be)) || void 0 === i ? void 0 : i.script) || "recorder";
    }
    isInteractiveEvent(e) {
        var t;
        return 3 === e.type && -1 !== Xn.indexOf(null === (t = e.data) || void 0 === t ? void 0 : t.source);
    }
    _updateWindowAndSessionIds(e) {
        var t = this.isInteractiveEvent(e);
        t || this.isIdle || e.timestamp - this._lastActivityTimestamp > this.sessionIdleThresholdMilliseconds && (this.isIdle = !0, clearInterval(this._fullSnapshotTimer), this._tryAddCustomEvent("sessionIdle", {
            eventTimestamp: e.timestamp,
            lastActivityTimestamp: this._lastActivityTimestamp,
            threshold: this.sessionIdleThresholdMilliseconds,
            bufferLength: this.buffer.data.length,
            bufferSize: this.buffer.size
        }), this._flushBuffer());
        var i = !1;
        if (t && (this._lastActivityTimestamp = e.timestamp, this.isIdle && (this.isIdle = !1, this._tryAddCustomEvent("sessionNoLongerIdle", {
            reason: "user activity",
            type: e.type
        }), i = !0)), !this.isIdle) {
            var { windowId: n, sessionId: r } = this.sessionManager.checkAndGetSessionAndWindowId(!t, e.timestamp), s = this.sessionId !== r, o = this.windowId !== n;
            this.windowId = n, this.sessionId = r, s || o ? (this.stopRecording(), this.startIfEnabledOrStop("session_id_changed")) : i && this._scheduleFullSnapshot();
        }
    }
    _tryRRWebMethod(e) {
        try {
            return e.rrwebMethod(), !0;
        } catch (t) {
            return this.queuedRRWebEvents.length < 10 ? this.queuedRRWebEvents.push({
                enqueuedAt: e.enqueuedAt || Date.now(),
                attempt: e.attempt++,
                rrwebMethod: e.rrwebMethod
            }) : Yn.warn("could not emit queued rrweb event.", t, e), !1;
        }
    }
    _tryAddCustomEvent(e, t) {
        return this._tryRRWebMethod(Qn(()=>this.rrwebRecord.addCustomEvent(e, t)));
    }
    _tryTakeFullSnapshot() {
        return this._tryRRWebMethod(Qn(()=>this.rrwebRecord.takeFullSnapshot()));
    }
    _onScriptLoaded() {
        var e, t = {
            blockClass: "ph-no-capture",
            blockSelector: void 0,
            ignoreClass: "ph-ignore-input",
            maskTextClass: "ph-mask",
            maskTextSelector: void 0,
            maskTextFn: void 0,
            maskAllInputs: !0,
            maskInputOptions: {
                password: !0
            },
            maskInputFn: void 0,
            slimDOMOptions: {},
            collectFonts: !1,
            inlineStylesheet: !0,
            recordCrossOriginIframes: !1
        }, i = this.instance.config.session_recording;
        for (var [n, r] of Object.entries(i || {}))n in t && ("maskInputOptions" === n ? t.maskInputOptions = j({
            password: !0
        }, r) : t[n] = r);
        if (this.canvasRecording && this.canvasRecording.enabled && (t.recordCanvas = !0, t.sampling = {
            canvas: this.canvasRecording.fps
        }, t.dataURLOptions = {
            type: "image/webp",
            quality: this.canvasRecording.quality
        }), this.rrwebRecord) {
            this.mutationRateLimiter = null !== (e = this.mutationRateLimiter) && void 0 !== e ? e : new un(this.rrwebRecord, {
                refillRate: this.instance.config.session_recording.__mutationRateLimiterRefillRate,
                bucketSize: this.instance.config.session_recording.__mutationRateLimiterBucketSize,
                onBlockedNode: (e, t)=>{
                    var i = "Too many mutations on node '".concat(e, "'. Rate limiting. This could be due to SVG animations or something similar");
                    Yn.info(i, {
                        node: t
                    }), this.log(Jn + " " + i, "warn");
                }
            });
            var s = this._gatherRRWebPlugins();
            this.stopRrweb = this.rrwebRecord(j({
                emit: (e)=>{
                    this.onRRwebEmit(e);
                },
                plugins: s
            }, t)), this._lastActivityTimestamp = Date.now(), this.isIdle = !1, this._tryAddCustomEvent("$session_options", {
                sessionRecordingOptions: t,
                activePlugins: s.map((e)=>null == e ? void 0 : e.name)
            }), this._tryAddCustomEvent("$posthog_config", {
                config: this.instance.config
            });
        } else Yn.error("onScriptLoaded was called but rrwebRecord is not available. This indicates something has gone wrong.");
    }
    _scheduleFullSnapshot() {
        if (this._fullSnapshotTimer && clearInterval(this._fullSnapshotTimer), !this.isIdle) {
            var e = this.fullSnapshotIntervalMillis;
            e && (this._fullSnapshotTimer = setInterval(()=>{
                this._tryTakeFullSnapshot();
            }, e));
        }
    }
    _gatherRRWebPlugins() {
        var e, t, i, n, r = [], s = null === (e = _.__PosthogExtensions__) || void 0 === e || null === (t = e.rrwebPlugins) || void 0 === t ? void 0 : t.getRecordConsolePlugin;
        s && this.isConsoleLogCaptureEnabled && r.push(s());
        var o = null === (i = _.__PosthogExtensions__) || void 0 === i || null === (n = i.rrwebPlugins) || void 0 === n ? void 0 : n.getRecordNetworkPlugin;
        this.networkPayloadCapture && I(o) && (!pt.includes(location.hostname) || this._forceAllowLocalhostNetworkCapture ? r.push(o(an(this.instance.config, this.networkPayloadCapture))) : Yn.info("NetworkCapture not started because we are on localhost."));
        return r;
    }
    onRRwebEmit(e) {
        var t;
        if (this._processQueuedEvents(), e && C(e)) {
            if (e.type === Si.Meta) {
                var i = this._maskUrl(e.data.href);
                if (this._lastHref = i, !i) return;
                e.data.href = i;
            } else this._pageViewFallBack();
            if (this._checkUrlTriggerConditions(), "paused" !== this.status || function(e) {
                return e.type === Si.Custom && "recording paused" === e.data.tag;
            }(e)) {
                e.type === Si.FullSnapshot && this._scheduleFullSnapshot(), e.type === Si.FullSnapshot && "trigger_pending" === this.triggerStatus && this.clearBuffer();
                var n = this.mutationRateLimiter ? this.mutationRateLimiter.throttleMutations(e) : e;
                if (n) {
                    var r = function(e) {
                        var t = e;
                        if (t && C(t) && 6 === t.type && C(t.data) && "rrweb/console@1" === t.data.plugin) {
                            t.data.payload.payload.length > 10 && (t.data.payload.payload = t.data.payload.payload.slice(0, 10), t.data.payload.payload.push("...[truncated]"));
                            for(var i = [], n = 0; n < t.data.payload.payload.length; n++)t.data.payload.payload[n] && t.data.payload.payload[n].length > 2e3 ? i.push(t.data.payload.payload[n].slice(0, 2e3) + "...[truncated]") : i.push(t.data.payload.payload[n]);
                            return t.data.payload.payload = i, e;
                        }
                        return e;
                    }(n);
                    if (this._updateWindowAndSessionIds(r), !this.isIdle || er(r)) {
                        if (er(r)) {
                            var s = r.data.payload;
                            if (s) {
                                var o = s.lastActivityTimestamp, a = s.threshold;
                                r.timestamp = o + a;
                            }
                        }
                        var l = null === (t = this.instance.config.session_recording.compress_events) || void 0 === t || t ? function(e) {
                            if (yi(e) < 1024) return e;
                            try {
                                if (e.type === Si.FullSnapshot) return j(j({}, e), {}, {
                                    data: Zn(e.data),
                                    cv: "2024-10"
                                });
                                if (e.type === Si.IncrementalSnapshot && e.data.source === Ei.Mutation) return j(j({}, e), {}, {
                                    cv: "2024-10",
                                    data: j(j({}, e.data), {}, {
                                        texts: Zn(e.data.texts),
                                        attributes: Zn(e.data.attributes),
                                        removes: Zn(e.data.removes),
                                        adds: Zn(e.data.adds)
                                    })
                                });
                                if (e.type === Si.IncrementalSnapshot && e.data.source === Ei.StyleSheetRule) return j(j({}, e), {}, {
                                    cv: "2024-10",
                                    data: j(j({}, e.data), {}, {
                                        adds: Zn(e.data.adds),
                                        removes: Zn(e.data.removes)
                                    })
                                });
                            } catch (e) {
                                Yn.error("could not compress event - will use uncompressed event", e);
                            }
                            return e;
                        }(r) : r, u = {
                            $snapshot_bytes: yi(l),
                            $snapshot_data: l,
                            $session_id: this.sessionId,
                            $window_id: this.windowId
                        };
                        "disabled" !== this.status ? this._captureSnapshotBuffered(u) : this.clearBuffer();
                    }
                }
            }
        }
    }
    _pageViewFallBack() {
        if (!this.instance.config.capture_pageview && t) {
            var e = this._maskUrl(t.location.href);
            this._lastHref !== e && (this._tryAddCustomEvent("$url_changed", {
                href: e
            }), this._lastHref = e);
        }
    }
    _processQueuedEvents() {
        if (this.queuedRRWebEvents.length) {
            var e = [
                ...this.queuedRRWebEvents
            ];
            this.queuedRRWebEvents = [], e.forEach((e)=>{
                Date.now() - e.enqueuedAt <= 2e3 && this._tryRRWebMethod(e);
            });
        }
    }
    _maskUrl(e) {
        var t = this.instance.config.session_recording;
        if (t.maskNetworkRequestFn) {
            var i, n = {
                url: e
            };
            return null === (i = n = t.maskNetworkRequestFn(n)) || void 0 === i ? void 0 : i.url;
        }
        return e;
    }
    clearBuffer() {
        return this.buffer = {
            size: 0,
            data: [],
            sessionId: this.sessionId,
            windowId: this.windowId
        }, this.buffer;
    }
    _flushBuffer() {
        this.flushBufferTimer && (clearTimeout(this.flushBufferTimer), this.flushBufferTimer = void 0);
        var e = this.minimumDuration, t = this.sessionDuration, i = M(t) && t >= 0, n = M(e) && i && t < e;
        if ("buffering" === this.status || "paused" === this.status || n) return this.flushBufferTimer = setTimeout(()=>{
            this._flushBuffer();
        }, 2e3), this.buffer;
        this.buffer.data.length > 0 && wi(this.buffer).forEach((e)=>{
            this._captureSnapshot({
                $snapshot_bytes: e.size,
                $snapshot_data: e.data,
                $session_id: e.sessionId,
                $window_id: e.windowId,
                $lib: "web",
                $lib_version: p.LIB_VERSION
            });
        });
        return this.clearBuffer();
    }
    _captureSnapshotBuffered(e) {
        var t, i = 2 + ((null === (t = this.buffer) || void 0 === t ? void 0 : t.data.length) || 0);
        !this.isIdle && (this.buffer.size + e.$snapshot_bytes + i > 943718.4 || this.buffer.sessionId !== this.sessionId) && (this.buffer = this._flushBuffer()), this.buffer.size += e.$snapshot_bytes, this.buffer.data.push(e.$snapshot_data), this.flushBufferTimer || this.isIdle || (this.flushBufferTimer = setTimeout(()=>{
            this._flushBuffer();
        }, 2e3));
    }
    _captureSnapshot(e) {
        this.instance.capture("$snapshot", e, {
            _url: this.instance.requestRouter.endpointFor("api", this._endpoint),
            _noTruncate: !0,
            _batchKey: "recordings",
            skip_client_rate_limiting: !0
        });
    }
    _checkUrlTriggerConditions() {
        if (void 0 !== t && t.location.href) {
            var e = t.location.href, i = "paused" === this.status, n = tr(e, this._urlBlocklist);
            n && !i ? this._pauseRecording() : !n && i && this._resumeRecording(), tr(e, this._urlTriggers) && this._activateTrigger("url");
        }
    }
    _activateTrigger(e) {
        var t, i;
        "trigger_pending" === this.triggerStatus && (null === (t = this.instance) || void 0 === t || null === (i = t.persistence) || void 0 === i || i.register({
            ["url" === e ? Se : Ee]: this.sessionId
        }), this._flushBuffer(), this._reportStarted(e + "_trigger_matched"));
    }
    _pauseRecording() {
        "paused" !== this.status && (this._urlBlocked = !0, clearInterval(this._fullSnapshotTimer), Yn.info("recording paused due to URL blocker"), this._tryAddCustomEvent("recording paused", {
            reason: "url blocker"
        }));
    }
    _resumeRecording() {
        "paused" === this.status && (this._urlBlocked = !1, this._tryTakeFullSnapshot(), this._scheduleFullSnapshot(), this._tryAddCustomEvent("recording resumed", {
            reason: "left blocked url"
        }), Yn.info("recording resumed"));
    }
    _addEventTriggerListener() {
        0 !== this._eventTriggers.length && O(this._removeEventTriggerCaptureHook) && (this._removeEventTriggerCaptureHook = this.instance.on("eventCaptured", (e)=>{
            try {
                this._eventTriggers.includes(e.event) && this._activateTrigger("event");
            } catch (e) {
                Yn.error("Could not activate event trigger", e);
            }
        }));
    }
    overrideLinkedFlag() {
        this._linkedFlagSeen = !0, this._tryTakeFullSnapshot(), this._reportStarted("linked_flag_overridden");
    }
    overrideSampling() {
        var e;
        null === (e = this.instance.persistence) || void 0 === e || e.register({
            [we]: !0
        }), this._tryTakeFullSnapshot(), this._reportStarted("sampling_overridden");
    }
    overrideTrigger(e) {
        this._activateTrigger(e);
    }
    _reportStarted(e, t) {
        this.instance.register_for_session({
            $session_recording_start_reason: e
        }), Yn.info(e.replace("_", " "), t), m([
            "recording_initialized",
            "session_id_changed"
        ], e) || this._tryAddCustomEvent(e, t);
    }
}
var nr = B("[RemoteConfig]");
class rr {
    constructor(e){
        this.instance = e;
    }
    get remoteConfig() {
        var e, t;
        return null === (e = _._POSTHOG_REMOTE_CONFIG) || void 0 === e || null === (t = e[this.instance.config.token]) || void 0 === t ? void 0 : t.config;
    }
    _loadRemoteConfigJs(e) {
        var t, i, n;
        null !== (t = _.__PosthogExtensions__) && void 0 !== t && t.loadExternalDependency ? null === (i = _.__PosthogExtensions__) || void 0 === i || null === (n = i.loadExternalDependency) || void 0 === n || n.call(i, this.instance, "remote-config", ()=>e(this.remoteConfig)) : (nr.error("PostHog Extensions not found. Cannot load remote config."), e());
    }
    _loadRemoteConfigJSON(e) {
        this.instance._send_request({
            method: "GET",
            url: this.instance.requestRouter.endpointFor("assets", "/array/".concat(this.instance.config.token, "/config")),
            callback: (t)=>{
                e(t.json);
            }
        });
    }
    load() {
        try {
            if (this.remoteConfig) return nr.info("Using preloaded remote config", this.remoteConfig), void this.onRemoteConfig(this.remoteConfig);
            if (this.instance.config.advanced_disable_decide) return void nr.warn("Remote config is disabled. Falling back to local config.");
            this._loadRemoteConfigJs((e)=>{
                if (!e) return nr.info("No config found after loading remote JS config. Falling back to JSON."), void this._loadRemoteConfigJSON((e)=>{
                    this.onRemoteConfig(e);
                });
                this.onRemoteConfig(e);
            });
        } catch (e) {
            nr.error("Error loading remote config", e);
        }
    }
    onRemoteConfig(e) {
        e ? this.instance.config.__preview_remote_config ? (this.instance._onRemoteConfig(e), !1 !== e.hasFeatureFlags && this.instance.featureFlags.ensureFlagsLoaded()) : nr.info("__preview_remote_config is disabled. Logging config instead", e) : nr.error("Failed to fetch remote config from PostHog.");
    }
}
var sr, or = null != t && t.location ? bt(t.location.hash, "__posthog") || bt(location.hash, "state") : null, ar = "_postHogToolbarParams", lr = B("[Toolbar]");
!function(e) {
    e[e.UNINITIALIZED = 0] = "UNINITIALIZED", e[e.LOADING = 1] = "LOADING", e[e.LOADED = 2] = "LOADED";
}(sr || (sr = {}));
class ur {
    constructor(e){
        this.instance = e;
    }
    setToolbarState(e) {
        _.ph_toolbar_state = e;
    }
    getToolbarState() {
        var e;
        return null !== (e = _.ph_toolbar_state) && void 0 !== e ? e : sr.UNINITIALIZED;
    }
    maybeLoadToolbar() {
        var e, i, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
        if (!t || !a) return !1;
        n = null !== (e = n) && void 0 !== e ? e : t.location, s = null !== (i = s) && void 0 !== i ? i : t.history;
        try {
            if (!r) {
                try {
                    t.localStorage.setItem("test", "test"), t.localStorage.removeItem("test");
                } catch (e) {
                    return !1;
                }
                r = null == t ? void 0 : t.localStorage;
            }
            var o, l = or || bt(n.hash, "__posthog") || bt(n.hash, "state"), u = l ? Q(()=>JSON.parse(atob(decodeURIComponent(l)))) || Q(()=>JSON.parse(decodeURIComponent(l))) : null;
            return u && "ph_authorize" === u.action ? ((o = u).source = "url", o && Object.keys(o).length > 0 && (u.desiredHash ? n.hash = u.desiredHash : s ? s.replaceState(s.state, "", n.pathname + n.search) : n.hash = "")) : ((o = JSON.parse(r.getItem(ar) || "{}")).source = "localstorage", delete o.userIntent), !(!o.token || this.instance.config.token !== o.token) && (this.loadToolbar(o), !0);
        } catch (e) {
            return !1;
        }
    }
    _callLoadToolbar(e) {
        var t = _.ph_load_toolbar || _.ph_load_editor;
        !O(t) && I(t) ? t(e, this.instance) : lr.warn("No toolbar load function found");
    }
    loadToolbar(e) {
        var i = !(null == a || !a.getElementById(Ne));
        if (!t || i) return !1;
        var n = "custom" === this.instance.requestRouter.region && this.instance.config.advanced_disable_toolbar_metrics, r = j(j({
            token: this.instance.config.token
        }, e), {}, {
            apiURL: this.instance.requestRouter.endpointFor("ui")
        }, n ? {
            instrument: !1
        } : {});
        if (t.localStorage.setItem(ar, JSON.stringify(j(j({}, r), {}, {
            source: void 0
        }))), this.getToolbarState() === sr.LOADED) this._callLoadToolbar(r);
        else if (this.getToolbarState() === sr.UNINITIALIZED) {
            var s, o;
            this.setToolbarState(sr.LOADING), null === (s = _.__PosthogExtensions__) || void 0 === s || null === (o = s.loadExternalDependency) || void 0 === o || o.call(s, this.instance, "toolbar", (e)=>{
                if (e) return lr.error("[Toolbar] Failed to load", e), void this.setToolbarState(sr.UNINITIALIZED);
                this.setToolbarState(sr.LOADED), this._callLoadToolbar(r);
            }), ie(t, "turbolinks:load", ()=>{
                this.setToolbarState(sr.UNINITIALIZED), this.loadToolbar(r);
            });
        }
        return !0;
    }
    _loadEditor(e) {
        return this.loadToolbar(e);
    }
    maybeLoadEditor() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
        return this.maybeLoadToolbar(e, t, i);
    }
}
class cr {
    constructor(e){
        W(this, "isPaused", !0), W(this, "queue", []), W(this, "flushTimeoutMs", 3e3), this.sendRequest = e;
    }
    enqueue(e) {
        this.queue.push(e), this.flushTimeout || this.setFlushTimeout();
    }
    unload() {
        this.clearFlushTimeout();
        var e = this.queue.length > 0 ? this.formatQueue() : {}, t = Object.values(e), i = [
            ...t.filter((e)=>0 === e.url.indexOf("/e")),
            ...t.filter((e)=>0 !== e.url.indexOf("/e"))
        ];
        i.map((e)=>{
            this.sendRequest(j(j({}, e), {}, {
                transport: "sendBeacon"
            }));
        });
    }
    enable() {
        this.isPaused = !1, this.setFlushTimeout();
    }
    setFlushTimeout() {
        var e = this;
        this.isPaused || (this.flushTimeout = setTimeout(()=>{
            if (this.clearFlushTimeout(), this.queue.length > 0) {
                var t = this.formatQueue(), i = function(i) {
                    var n = t[i], r = (new Date).getTime();
                    n.data && x(n.data) && Y(n.data, (e)=>{
                        e.offset = Math.abs(e.timestamp - r), delete e.timestamp;
                    }), e.sendRequest(n);
                };
                for(var n in t)i(n);
            }
        }, this.flushTimeoutMs));
    }
    clearFlushTimeout() {
        clearTimeout(this.flushTimeout), this.flushTimeout = void 0;
    }
    formatQueue() {
        var e = {};
        return Y(this.queue, (t)=>{
            var i, n = t, r = (n ? n.batchKey : null) || n.url;
            F(e[r]) && (e[r] = j(j({}, n), {}, {
                data: []
            })), null === (i = e[r].data) || void 0 === i || i.push(n.data);
        }), this.queue = [], e;
    }
}
var dr = function(e) {
    var t, i, n, r, s = "";
    for(t = i = 0, n = (e = (e + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length, r = 0; r < n; r++){
        var o = e.charCodeAt(r), a = null;
        o < 128 ? i++ : a = o > 127 && o < 2048 ? String.fromCharCode(o >> 6 | 192, 63 & o | 128) : String.fromCharCode(o >> 12 | 224, o >> 6 & 63 | 128, 63 & o | 128), $(a) || (i > t && (s += e.substring(t, i)), s += a, t = i = r + 1);
    }
    return i > t && (s += e.substring(t, e.length)), s;
}, hr = !!c || !!u, _r = "text/plain", pr = (e, t)=>{
    var [i, n] = e.split("?"), r = j({}, t);
    null == n || n.split("&").forEach((e)=>{
        var [t] = e.split("=");
        delete r[t];
    });
    var s = ft(r);
    return s = s ? (n ? n + "&" : "") + s : n, "".concat(i, "?").concat(s);
}, vr = (e, t)=>JSON.stringify(e, (e, t)=>"bigint" == typeof t ? t.toString() : t, t), gr = (t)=>{
    var { data: i, compression: n } = t;
    if (i) {
        if (n === e.GZipJS) {
            var r = Vn(Gn(vr(i)), {
                mtime: 0
            }), s = new Blob([
                r
            ], {
                type: _r
            });
            return {
                contentType: _r,
                body: s,
                estimatedSize: s.size
            };
        }
        if (n === e.Base64) {
            var o = function(e) {
                var t, i, n, r, s, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", a = 0, l = 0, u = "", c = [];
                if (!e) return e;
                e = dr(e);
                do t = (s = e.charCodeAt(a++) << 16 | e.charCodeAt(a++) << 8 | e.charCodeAt(a++)) >> 18 & 63, i = s >> 12 & 63, n = s >> 6 & 63, r = 63 & s, c[l++] = o.charAt(t) + o.charAt(i) + o.charAt(n) + o.charAt(r);
                while (a < e.length);
                switch(u = c.join(""), e.length % 3){
                    case 1:
                        u = u.slice(0, -2) + "==";
                        break;
                    case 2:
                        u = u.slice(0, -1) + "=";
                }
                return u;
            }(vr(i)), a = ((e)=>"data=" + encodeURIComponent("string" == typeof e ? e : vr(e)))(o);
            return {
                contentType: "application/x-www-form-urlencoded",
                body: a,
                estimatedSize: new Blob([
                    a
                ]).size
            };
        }
        var l = vr(i);
        return {
            contentType: "application/json",
            body: l,
            estimatedSize: new Blob([
                l
            ]).size
        };
    }
}, fr = [];
u && fr.push({
    transport: "fetch",
    method: (e)=>{
        var t, i, { contentType: n, body: r, estimatedSize: s } = null !== (t = gr(e)) && void 0 !== t ? t : {}, o = new Headers;
        Y(e.headers, function(e, t) {
            o.append(t, e);
        }), n && o.append("Content-Type", n);
        var a = e.url, l = null;
        if (d) {
            var c = new d;
            l = {
                signal: c.signal,
                timeout: setTimeout(()=>c.abort(), e.timeout)
            };
        }
        u(a, j({
            method: (null == e ? void 0 : e.method) || "GET",
            headers: o,
            keepalive: "POST" === e.method && (s || 0) < 52428.8,
            body: r,
            signal: null === (i = l) || void 0 === i ? void 0 : i.signal
        }, e.fetchOptions)).then((t)=>t.text().then((i)=>{
                var n, r = {
                    statusCode: t.status,
                    text: i
                };
                if (200 === t.status) try {
                    r.json = JSON.parse(i);
                } catch (e) {
                    q.error(e);
                }
                null === (n = e.callback) || void 0 === n || n.call(e, r);
            })).catch((t)=>{
            var i;
            q.error(t), null === (i = e.callback) || void 0 === i || i.call(e, {
                statusCode: 0,
                text: t
            });
        }).finally(()=>l ? clearTimeout(l.timeout) : null);
    }
}), c && fr.push({
    transport: "XHR",
    method: (e)=>{
        var t, i = new c;
        i.open(e.method || "GET", e.url, !0);
        var { contentType: n, body: r } = null !== (t = gr(e)) && void 0 !== t ? t : {};
        Y(e.headers, function(e, t) {
            i.setRequestHeader(t, e);
        }), n && i.setRequestHeader("Content-Type", n), e.timeout && (i.timeout = e.timeout), i.withCredentials = !0, i.onreadystatechange = ()=>{
            if (4 === i.readyState) {
                var t, n = {
                    statusCode: i.status,
                    text: i.responseText
                };
                if (200 === i.status) try {
                    n.json = JSON.parse(i.responseText);
                } catch (e) {}
                null === (t = e.callback) || void 0 === t || t.call(e, n);
            }
        }, i.send(r);
    }
}), null != o && o.sendBeacon && fr.push({
    transport: "sendBeacon",
    method: (e)=>{
        var t = pr(e.url, {
            beacon: "1"
        });
        try {
            var i, { contentType: n, body: r } = null !== (i = gr(e)) && void 0 !== i ? i : {}, s = "string" == typeof r ? new Blob([
                r
            ], {
                type: n
            }) : r;
            o.sendBeacon(t, s);
        } catch (e) {}
    }
});
var mr = [
    "retriesPerformedSoFar"
];
class br {
    constructor(e){
        W(this, "isPolling", !1), W(this, "pollIntervalMs", 3e3), W(this, "queue", []), this.instance = e, this.queue = [], this.areWeOnline = !0, !F(t) && "onLine" in t.navigator && (this.areWeOnline = t.navigator.onLine, t.addEventListener("online", ()=>{
            this.areWeOnline = !0, this.flush();
        }), t.addEventListener("offline", ()=>{
            this.areWeOnline = !1;
        }));
    }
    retriableRequest(e) {
        var { retriesPerformedSoFar: t } = e, i = V(e, mr);
        M(t) && t > 0 && (i.url = pr(i.url, {
            retry_count: t
        })), this.instance._send_request(j(j({}, i), {}, {
            callback: (e)=>{
                var n;
                200 !== e.statusCode && (e.statusCode < 400 || e.statusCode >= 500) && (null != t ? t : 0) < 10 ? this.enqueue(j({
                    retriesPerformedSoFar: t
                }, i)) : null === (n = i.callback) || void 0 === n || n.call(i, e);
            }
        }));
    }
    enqueue(e) {
        var t = e.retriesPerformedSoFar || 0;
        e.retriesPerformedSoFar = t + 1;
        var i = function(e) {
            var t = 3e3 * Math.pow(2, e), i = t / 2, n = Math.min(18e5, t), r = (Math.random() - .5) * (n - i);
            return Math.ceil(n + r);
        }(t), n = Date.now() + i;
        this.queue.push({
            retryAt: n,
            requestOptions: e
        });
        var r = "Enqueued failed request for retry in ".concat(i);
        navigator.onLine || (r += " (Browser is offline)"), q.warn(r), this.isPolling || (this.isPolling = !0, this.poll());
    }
    poll() {
        this.poller && clearTimeout(this.poller), this.poller = setTimeout(()=>{
            this.areWeOnline && this.queue.length > 0 && this.flush(), this.poll();
        }, this.pollIntervalMs);
    }
    flush() {
        var e = Date.now(), t = [], i = this.queue.filter((i)=>i.retryAt < e || (t.push(i), !1));
        if (this.queue = t, i.length > 0) for (var { requestOptions: n } of i)this.retriableRequest(n);
    }
    unload() {
        for (var { requestOptions: e } of (this.poller && (clearTimeout(this.poller), this.poller = void 0), this.queue))try {
            this.instance._send_request(j(j({}, e), {}, {
                transport: "sendBeacon"
            }));
        } catch (e) {
            q.error(e);
        }
        this.queue = [];
    }
}
var yr, wr = B("[SessionId]");
class Sr {
    constructor(e, t, i){
        var n;
        if (W(this, "_sessionIdChangedHandlers", []), !e.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
        if (e.config.__preview_experimental_cookieless_mode) throw new Error("SessionIdManager cannot be used with __preview_experimental_cookieless_mode");
        this.config = e.config, this.persistence = e.persistence, this._windowId = void 0, this._sessionId = void 0, this._sessionStartTimestamp = null, this._sessionActivityTimestamp = null, this._sessionIdGenerator = t || Ze, this._windowIdGenerator = i || Ze;
        var r = this.config.persistence_name || this.config.token, s = this.config.session_idle_timeout_seconds || 1800;
        if (this._sessionTimeoutMs = 1e3 * ln(s, 60, 36e3, "session_idle_timeout_seconds", 1800), e.register({
            $configured_session_timeout_ms: this._sessionTimeoutMs
        }), this.resetIdleTimer(), this._window_id_storage_key = "ph_" + r + "_window_id", this._primary_window_exists_storage_key = "ph_" + r + "_primary_window_exists", this._canUseSessionStorage()) {
            var o = _t.parse(this._window_id_storage_key), a = _t.parse(this._primary_window_exists_storage_key);
            o && !a ? this._windowId = o : _t.remove(this._window_id_storage_key), _t.set(this._primary_window_exists_storage_key, !0);
        }
        if (null !== (n = this.config.bootstrap) && void 0 !== n && n.sessionID) try {
            var l = ((e)=>{
                var t = e.replace(/-/g, "");
                if (32 !== t.length) throw new Error("Not a valid UUID");
                if ("7" !== t[12]) throw new Error("Not a UUIDv7");
                return parseInt(t.substring(0, 12), 16);
            })(this.config.bootstrap.sessionID);
            this._setSessionId(this.config.bootstrap.sessionID, (new Date).getTime(), l);
        } catch (e) {
            wr.error("Invalid sessionID in bootstrap", e);
        }
        this._listenToReloadWindow();
    }
    get sessionTimeoutMs() {
        return this._sessionTimeoutMs;
    }
    onSessionId(e) {
        return F(this._sessionIdChangedHandlers) && (this._sessionIdChangedHandlers = []), this._sessionIdChangedHandlers.push(e), this._sessionId && e(this._sessionId, this._windowId), ()=>{
            this._sessionIdChangedHandlers = this._sessionIdChangedHandlers.filter((t)=>t !== e);
        };
    }
    _canUseSessionStorage() {
        return "memory" !== this.config.persistence && !this.persistence.disabled && _t.is_supported();
    }
    _setWindowId(e) {
        e !== this._windowId && (this._windowId = e, this._canUseSessionStorage() && _t.set(this._window_id_storage_key, e));
    }
    _getWindowId() {
        return this._windowId ? this._windowId : this._canUseSessionStorage() ? _t.parse(this._window_id_storage_key) : null;
    }
    _setSessionId(e, t, i) {
        e === this._sessionId && t === this._sessionActivityTimestamp && i === this._sessionStartTimestamp || (this._sessionStartTimestamp = i, this._sessionActivityTimestamp = t, this._sessionId = e, this.persistence.register({
            [ye]: [
                t,
                e,
                i
            ]
        }));
    }
    _getSessionId() {
        if (this._sessionId && this._sessionActivityTimestamp && this._sessionStartTimestamp) return [
            this._sessionActivityTimestamp,
            this._sessionId,
            this._sessionStartTimestamp
        ];
        var e = this.persistence.props[ye];
        return x(e) && 2 === e.length && e.push(e[0]), e || [
            0,
            null,
            0
        ];
    }
    resetSessionId() {
        this._setSessionId(null, null, null);
    }
    _listenToReloadWindow() {
        null == t || t.addEventListener("beforeunload", ()=>{
            this._canUseSessionStorage() && _t.remove(this._primary_window_exists_storage_key);
        });
    }
    checkAndGetSessionAndWindowId() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
        if (this.config.__preview_experimental_cookieless_mode) throw new Error("checkAndGetSessionAndWindowId should not be called in __preview_experimental_cookieless_mode");
        var i = t || (new Date).getTime(), [n, r, s] = this._getSessionId(), o = this._getWindowId(), a = M(s) && s > 0 && Math.abs(i - s) > 864e5, l = !1, u = !r, c = !e && Math.abs(i - n) > this.sessionTimeoutMs;
        u || c || a ? (r = this._sessionIdGenerator(), o = this._windowIdGenerator(), wr.info("new session ID generated", {
            sessionId: r,
            windowId: o,
            changeReason: {
                noSessionId: u,
                activityTimeout: c,
                sessionPastMaximumLength: a
            }
        }), s = i, l = !0) : o || (o = this._windowIdGenerator(), l = !0);
        var d = 0 === n || !e || a ? i : n, h = 0 === s ? (new Date).getTime() : s;
        return this._setWindowId(o), this._setSessionId(r, d, h), e || this.resetIdleTimer(), l && this._sessionIdChangedHandlers.forEach((e)=>e(r, o, l ? {
                noSessionId: u,
                activityTimeout: c,
                sessionPastMaximumLength: a
            } : void 0)), {
            sessionId: r,
            windowId: o,
            sessionStartTimestamp: h,
            changeReason: l ? {
                noSessionId: u,
                activityTimeout: c,
                sessionPastMaximumLength: a
            } : void 0,
            lastActivityTimestamp: n
        };
    }
    resetIdleTimer() {
        clearTimeout(this._enforceIdleTimeout), this._enforceIdleTimeout = setTimeout(()=>{
            this.resetSessionId();
        }, 1.1 * this.sessionTimeoutMs);
    }
}
!function(e) {
    e.US = "us", e.EU = "eu", e.CUSTOM = "custom";
}(yr || (yr = {}));
var Er = "i.posthog.com";
class kr {
    constructor(e){
        W(this, "_regionCache", {}), this.instance = e;
    }
    get apiHost() {
        var e = this.instance.config.api_host.trim().replace(/\/$/, "");
        return "https://app.posthog.com" === e ? "https://us.i.posthog.com" : e;
    }
    get uiHost() {
        var e, t = null === (e = this.instance.config.ui_host) || void 0 === e ? void 0 : e.replace(/\/$/, "");
        return t || (t = this.apiHost.replace(".".concat(Er), ".posthog.com")), "https://app.posthog.com" === t ? "https://us.posthog.com" : t;
    }
    get region() {
        return this._regionCache[this.apiHost] || (/https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = yr.US : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? this._regionCache[this.apiHost] = yr.EU : this._regionCache[this.apiHost] = yr.CUSTOM), this._regionCache[this.apiHost];
    }
    endpointFor(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
        if (t && (t = "/" === t[0] ? t : "/".concat(t)), "ui" === e) return this.uiHost + t;
        if (this.region === yr.CUSTOM) return this.apiHost + t;
        var i = Er + t;
        switch(e){
            case "assets":
                return "https://".concat(this.region, "-assets.").concat(i);
            case "api":
                return "https://".concat(this.region, ".").concat(i);
        }
    }
}
var xr = "posthog-js";
function Ir(e) {
    var { organization: t, projectId: i, prefix: n, severityAllowList: r = [
        "error"
    ] } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
    return (s)=>{
        var o, a, l, u, c;
        if (!("*" === r || r.includes(s.level)) || !e.__loaded) return s;
        s.tags || (s.tags = {});
        var d = e.requestRouter.endpointFor("ui", "/project/".concat(e.config.token, "/person/").concat(e.get_distinct_id()));
        s.tags["PostHog Person URL"] = d, e.sessionRecordingStarted() && (s.tags["PostHog Recording URL"] = e.get_session_replay_url({
            withTimestamp: !0
        }));
        var h = (null === (o = s.exception) || void 0 === o ? void 0 : o.values) || [];
        h.map((e)=>{
            e.stacktrace && (e.stacktrace.type = "raw");
        });
        var _ = {
            $exception_message: (null === (a = h[0]) || void 0 === a ? void 0 : a.value) || s.message,
            $exception_type: null === (l = h[0]) || void 0 === l ? void 0 : l.type,
            $exception_personURL: d,
            $exception_level: s.level,
            $exception_list: h,
            $sentry_event_id: s.event_id,
            $sentry_exception: s.exception,
            $sentry_exception_message: (null === (u = h[0]) || void 0 === u ? void 0 : u.value) || s.message,
            $sentry_exception_type: null === (c = h[0]) || void 0 === c ? void 0 : c.type,
            $sentry_tags: s.tags
        };
        return t && i && (_.$sentry_url = (n || "https://sentry.io/organizations/") + t + "/issues/?project=" + i + "&query=" + s.event_id), e.exceptions.sendExceptionEvent(_), s;
    };
}
class Cr {
    constructor(e, t, i, n, r){
        this.name = xr, this.setupOnce = function(s) {
            s(Ir(e, {
                organization: t,
                projectId: i,
                prefix: n,
                severityAllowList: r
            }));
        };
    }
}
var Pr, Fr, Rr, Tr = B("[SegmentIntegration]");
function $r(e, t) {
    var i = e.config.segment;
    if (!i) return t();
    !function(e, t) {
        var i = e.config.segment;
        if (!i) return t();
        var n = (i)=>{
            var n = ()=>i.anonymousId() || Ze();
            e.config.get_device_id = n, i.id() && (e.register({
                distinct_id: i.id(),
                $device_id: n()
            }), e.persistence.set_property(Te, "identified")), t();
        }, r = i.user();
        "then" in r && I(r.then) ? r.then((e)=>n(e)) : n(r);
    }(e, ()=>{
        i.register(((e)=>{
            Promise && Promise.resolve || Tr.warn("This browser does not have Promise support, and can not use the segment integration");
            var t = (t, i)=>{
                var n;
                if (!i) return t;
                t.event.userId || t.event.anonymousId === e.get_distinct_id() || (Tr.info("No userId set, resetting PostHog"), e.reset()), t.event.userId && t.event.userId !== e.get_distinct_id() && (Tr.info("UserId set, identifying with PostHog"), e.identify(t.event.userId));
                var r = e._calculate_event_properties(i, null !== (n = t.event.properties) && void 0 !== n ? n : {}, new Date);
                return t.event.properties = Object.assign({}, r, t.event.properties), t;
            };
            return {
                name: "PostHog JS",
                type: "enrichment",
                version: "1.0.0",
                isLoaded: ()=>!0,
                load: ()=>Promise.resolve(),
                track: (e)=>t(e, e.event.event),
                page: (e)=>t(e, "$pageview"),
                identify: (e)=>t(e, "$identify"),
                screen: (e)=>t(e, "$screen")
            };
        })(e)).then(()=>{
            t();
        });
    });
}
class Or {
    constructor(e){
        this._instance = e;
    }
    doPageView(e, i) {
        var n, r = this._previousPageViewProperties(e, i);
        return this._currentPageview = {
            pathname: null !== (n = null == t ? void 0 : t.location.pathname) && void 0 !== n ? n : "",
            pageViewId: i,
            timestamp: e
        }, this._instance.scrollManager.resetContext(), r;
    }
    doPageLeave(e) {
        var t;
        return this._previousPageViewProperties(e, null === (t = this._currentPageview) || void 0 === t ? void 0 : t.pageViewId);
    }
    doEvent() {
        var e;
        return {
            $pageview_id: null === (e = this._currentPageview) || void 0 === e ? void 0 : e.pageViewId
        };
    }
    _previousPageViewProperties(e, t) {
        var i = this._currentPageview;
        if (!i) return {
            $pageview_id: t
        };
        var n = {
            $pageview_id: t,
            $prev_pageview_id: i.pageViewId
        }, r = this._instance.scrollManager.getContext();
        if (r && !this._instance.config.disable_scroll_properties) {
            var { maxScrollHeight: s, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: u, maxContentY: c } = r;
            if (!(F(s) || F(o) || F(a) || F(l) || F(u) || F(c))) {
                s = Math.ceil(s), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), u = Math.ceil(u), c = Math.ceil(c);
                var d = s <= 1 ? 1 : ln(o / s, 0, 1), h = s <= 1 ? 1 : ln(a / s, 0, 1), _ = l <= 1 ? 1 : ln(u / l, 0, 1), p = l <= 1 ? 1 : ln(c / l, 0, 1);
                n = K(n, {
                    $prev_pageview_last_scroll: o,
                    $prev_pageview_last_scroll_percentage: d,
                    $prev_pageview_max_scroll: a,
                    $prev_pageview_max_scroll_percentage: h,
                    $prev_pageview_last_content: u,
                    $prev_pageview_last_content_percentage: _,
                    $prev_pageview_max_content: c,
                    $prev_pageview_max_content_percentage: p
                });
            }
        }
        return i.pathname && (n.$prev_pageview_pathname = i.pathname), i.timestamp && (n.$prev_pageview_duration = (e.getTime() - i.timestamp.getTime()) / 1e3), n;
    }
}
!function(e) {
    e.Popover = "popover", e.API = "api", e.Widget = "widget";
}(Pr || (Pr = {})), function(e) {
    e.Open = "open", e.MultipleChoice = "multiple_choice", e.SingleChoice = "single_choice", e.Rating = "rating", e.Link = "link";
}(Fr || (Fr = {})), function(e) {
    e.NextQuestion = "next_question", e.End = "end", e.ResponseBased = "response_based", e.SpecificQuestion = "specific_question";
}(Rr || (Rr = {}));
class Mr {
    constructor(){
        W(this, "events", {}), this.events = {};
    }
    on(e, t) {
        return this.events[e] || (this.events[e] = []), this.events[e].push(t), ()=>{
            this.events[e] = this.events[e].filter((e)=>e !== t);
        };
    }
    emit(e, t) {
        for (var i of this.events[e] || [])i(t);
        for (var n of this.events["*"] || [])n(e, t);
    }
}
class Lr {
    constructor(e){
        W(this, "_debugEventEmitter", new Mr), W(this, "checkStep", (e, t)=>this.checkStepEvent(e, t) && this.checkStepUrl(e, t) && this.checkStepElement(e, t)), W(this, "checkStepEvent", (e, t)=>null == t || !t.event || (null == e ? void 0 : e.event) === (null == t ? void 0 : t.event)), this.instance = e, this.actionEvents = new Set, this.actionRegistry = new Set;
    }
    init() {
        var e;
        if (!F(null === (e = this.instance) || void 0 === e ? void 0 : e._addCaptureHook)) {
            var t;
            null === (t = this.instance) || void 0 === t || t._addCaptureHook((e, t)=>{
                this.on(e, t);
            });
        }
    }
    register(e) {
        var t, i;
        if (!F(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) && (e.forEach((e)=>{
            var t, i;
            null === (t = this.actionRegistry) || void 0 === t || t.add(e), null === (i = e.steps) || void 0 === i || i.forEach((e)=>{
                var t;
                null === (t = this.actionEvents) || void 0 === t || t.add((null == e ? void 0 : e.event) || "");
            });
        }), null !== (i = this.instance) && void 0 !== i && i.autocapture)) {
            var n, r = new Set;
            e.forEach((e)=>{
                var t;
                null === (t = e.steps) || void 0 === t || t.forEach((e)=>{
                    null != e && e.selector && r.add(null == e ? void 0 : e.selector);
                });
            }), null === (n = this.instance) || void 0 === n || n.autocapture.setElementSelectors(r);
        }
    }
    on(e, t) {
        var i;
        null != t && 0 != e.length && (this.actionEvents.has(e) || this.actionEvents.has(null == t ? void 0 : t.event)) && this.actionRegistry && (null === (i = this.actionRegistry) || void 0 === i ? void 0 : i.size) > 0 && this.actionRegistry.forEach((e)=>{
            this.checkAction(t, e) && this._debugEventEmitter.emit("actionCaptured", e.name);
        });
    }
    _addActionHook(e) {
        this.onAction("actionCaptured", (t)=>e(t));
    }
    checkAction(e, t) {
        if (null == (null == t ? void 0 : t.steps)) return !1;
        for (var i of t.steps)if (this.checkStep(e, i)) return !0;
        return !1;
    }
    onAction(e, t) {
        return this._debugEventEmitter.on(e, t);
    }
    checkStepUrl(e, t) {
        if (null != t && t.url) {
            var i, n = null == e || null === (i = e.properties) || void 0 === i ? void 0 : i.$current_url;
            if (!n || "string" != typeof n) return !1;
            if (!Lr.matchString(n, null == t ? void 0 : t.url, (null == t ? void 0 : t.url_matching) || "contains")) return !1;
        }
        return !0;
    }
    static matchString(e, i, n) {
        switch(n){
            case "regex":
                return !!t && gt(e, i);
            case "exact":
                return i === e;
            case "contains":
                var r = Lr.escapeStringRegexp(i).replace(/_/g, ".").replace(/%/g, ".*");
                return gt(e, r);
            default:
                return !1;
        }
    }
    static escapeStringRegexp(e) {
        return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
    }
    checkStepElement(e, t) {
        if ((null != t && t.href || null != t && t.tag_name || null != t && t.text) && !this.getElementsList(e).some((e)=>!(null != t && t.href && !Lr.matchString(e.href || "", null == t ? void 0 : t.href, (null == t ? void 0 : t.href_matching) || "exact")) && (null == t || !t.tag_name || e.tag_name === (null == t ? void 0 : t.tag_name)) && !(null != t && t.text && !Lr.matchString(e.text || "", null == t ? void 0 : t.text, (null == t ? void 0 : t.text_matching) || "exact") && !Lr.matchString(e.$el_text || "", null == t ? void 0 : t.text, (null == t ? void 0 : t.text_matching) || "exact")))) return !1;
        if (null != t && t.selector) {
            var i, n = null == e || null === (i = e.properties) || void 0 === i ? void 0 : i.$element_selectors;
            if (!n) return !1;
            if (!n.includes(null == t ? void 0 : t.selector)) return !1;
        }
        return !0;
    }
    getElementsList(e) {
        return null == (null == e ? void 0 : e.properties.$elements) ? [] : null == e ? void 0 : e.properties.$elements;
    }
}
class Ar {
    constructor(e){
        this.instance = e, this.eventToSurveys = new Map, this.actionToSurveys = new Map;
    }
    register(e) {
        var t;
        F(null === (t = this.instance) || void 0 === t ? void 0 : t._addCaptureHook) || (this.setupEventBasedSurveys(e), this.setupActionBasedSurveys(e));
    }
    setupActionBasedSurveys(e) {
        var t = e.filter((e)=>{
            var t, i, n, r;
            return (null === (t = e.conditions) || void 0 === t ? void 0 : t.actions) && (null === (i = e.conditions) || void 0 === i || null === (n = i.actions) || void 0 === n || null === (r = n.values) || void 0 === r ? void 0 : r.length) > 0;
        });
        if (0 !== t.length) {
            if (null == this.actionMatcher) {
                this.actionMatcher = new Lr(this.instance), this.actionMatcher.init();
                this.actionMatcher._addActionHook((e)=>{
                    this.onAction(e);
                });
            }
            t.forEach((e)=>{
                var t, i, n, r, s, o, a, l, u, c;
                e.conditions && null !== (t = e.conditions) && void 0 !== t && t.actions && null !== (i = e.conditions) && void 0 !== i && null !== (n = i.actions) && void 0 !== n && n.values && (null === (r = e.conditions) || void 0 === r || null === (s = r.actions) || void 0 === s || null === (o = s.values) || void 0 === o ? void 0 : o.length) > 0 && (null === (a = this.actionMatcher) || void 0 === a || a.register(e.conditions.actions.values), null === (l = e.conditions) || void 0 === l || null === (u = l.actions) || void 0 === u || null === (c = u.values) || void 0 === c || c.forEach((t)=>{
                    if (t && t.name) {
                        var i = this.actionToSurveys.get(t.name);
                        i && i.push(e.id), this.actionToSurveys.set(t.name, i || [
                            e.id
                        ]);
                    }
                }));
            });
        }
    }
    setupEventBasedSurveys(e) {
        var t;
        if (0 !== e.filter((e)=>{
            var t, i, n, r;
            return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (i = e.conditions) || void 0 === i || null === (n = i.events) || void 0 === n || null === (r = n.values) || void 0 === r ? void 0 : r.length) > 0;
        }).length) null === (t = this.instance) || void 0 === t || t._addCaptureHook((e, t)=>{
            this.onEvent(e, t);
        }), e.forEach((e)=>{
            var t, i, n;
            null === (t = e.conditions) || void 0 === t || null === (i = t.events) || void 0 === i || null === (n = i.values) || void 0 === n || n.forEach((t)=>{
                if (t && t.name) {
                    var i = this.eventToSurveys.get(t.name);
                    i && i.push(e.id), this.eventToSurveys.set(t.name, i || [
                        e.id
                    ]);
                }
            });
        });
    }
    onEvent(e, t) {
        var i, n, r = (null === (i = this.instance) || void 0 === i || null === (n = i.persistence) || void 0 === n ? void 0 : n.props[Fe]) || [];
        if (Ar.SURVEY_SHOWN_EVENT_NAME == e && t && r.length > 0) {
            var s, o = null == t || null === (s = t.properties) || void 0 === s ? void 0 : s.$survey_id;
            if (o) {
                var a = r.indexOf(o);
                a >= 0 && (r.splice(a, 1), this._updateActivatedSurveys(r));
            }
        } else this.eventToSurveys.has(e) && this._updateActivatedSurveys(r.concat(this.eventToSurveys.get(e) || []));
    }
    onAction(e) {
        var t, i, n = (null === (t = this.instance) || void 0 === t || null === (i = t.persistence) || void 0 === i ? void 0 : i.props[Fe]) || [];
        this.actionToSurveys.has(e) && this._updateActivatedSurveys(n.concat(this.actionToSurveys.get(e) || []));
    }
    _updateActivatedSurveys(e) {
        var t, i;
        null === (t = this.instance) || void 0 === t || null === (i = t.persistence) || void 0 === i || i.register({
            [Fe]: [
                ...new Set(e)
            ]
        });
    }
    getSurveys() {
        var e, t, i = null === (e = this.instance) || void 0 === e || null === (t = e.persistence) || void 0 === t ? void 0 : t.props[Fe];
        return i || [];
    }
    getEventToSurveys() {
        return this.eventToSurveys;
    }
    _getActionMatcher() {
        return this.actionMatcher;
    }
}
W(Ar, "SURVEY_SHOWN_EVENT_NAME", "survey shown");
var Dr, Nr, qr, Br, Hr, Ur, zr, jr, Wr = {}, Vr = [], Gr = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, Jr = Array.isArray;
function Yr(e, t) {
    for(var i in t)e[i] = t[i];
    return e;
}
function Kr(e) {
    var t = e.parentNode;
    t && t.removeChild(e);
}
function Xr(e, t, i, n, r) {
    var s = {
        type: e,
        props: t,
        key: i,
        ref: n,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++qr : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != Nr.vnode && Nr.vnode(s), s;
}
function Qr(e) {
    return e.children;
}
function Zr(e, t) {
    this.props = e, this.context = t;
}
function es(e, t) {
    if (null == t) return e.__ ? es(e.__, e.__i + 1) : null;
    for(var i; t < e.__k.length; t++)if (null != (i = e.__k[t]) && null != i.__e) return i.__e;
    return "function" == typeof e.type ? es(e) : null;
}
function ts(e) {
    var t, i;
    if (null != (e = e.__) && null != e.__c) {
        for(e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++)if (null != (i = e.__k[t]) && null != i.__e) {
            e.__e = e.__c.base = i.__e;
            break;
        }
        return ts(e);
    }
}
function is(e) {
    (!e.__d && (e.__d = !0) && Br.push(e) && !ns.__r++ || Hr !== Nr.debounceRendering) && ((Hr = Nr.debounceRendering) || Ur)(ns);
}
function ns() {
    var e, t, i, n, r, s, o, a, l;
    for(Br.sort(zr); e = Br.shift();)e.__d && (t = Br.length, n = void 0, s = (r = (i = e).__v).__e, a = [], l = [], (o = i.__P) && ((n = Yr({}, r)).__v = r.__v + 1, Nr.vnode && Nr.vnode(n), hs(o, n, r, i.__n, void 0 !== o.ownerSVGElement, 32 & r.__u ? [
        s
    ] : null, a, null == s ? es(r) : s, !!(32 & r.__u), l), n.__.__k[n.__i] = n, _s(a, n, l), n.__e != s && ts(n)), Br.length > t && Br.sort(zr));
    ns.__r = 0;
}
function rs(e, t, i, n, r, s, o, a, l, u, c) {
    var d, h, _, p, v, g = n && n.__k || Vr, f = t.length;
    for(i.__d = l, ss(i, t, g), l = i.__d, d = 0; d < f; d++)null != (_ = i.__k[d]) && "boolean" != typeof _ && "function" != typeof _ && (h = -1 === _.__i ? Wr : g[_.__i] || Wr, _.__i = d, hs(e, _, h, r, s, o, a, l, u, c), p = _.__e, _.ref && h.ref != _.ref && (h.ref && vs(h.ref, null, _), c.push(_.ref, _.__c || p, _)), null == v && null != p && (v = p), 65536 & _.__u || h.__k === _.__k ? l = os(_, l, e) : "function" == typeof _.type && void 0 !== _.__d ? l = _.__d : p && (l = p.nextSibling), _.__d = void 0, _.__u &= -196609);
    i.__d = l, i.__e = v;
}
function ss(e, t, i) {
    var n, r, s, o, a, l = t.length, u = i.length, c = u, d = 0;
    for(e.__k = [], n = 0; n < l; n++)null != (r = e.__k[n] = null == (r = t[n]) || "boolean" == typeof r || "function" == typeof r ? null : "string" == typeof r || "number" == typeof r || "bigint" == typeof r || r.constructor == String ? Xr(null, r, null, null, r) : Jr(r) ? Xr(Qr, {
        children: r
    }, null, null, null) : void 0 === r.constructor && r.__b > 0 ? Xr(r.type, r.props, r.key, r.ref ? r.ref : null, r.__v) : r) ? (r.__ = e, r.__b = e.__b + 1, a = as(r, i, o = n + d, c), r.__i = a, s = null, -1 !== a && (c--, (s = i[a]) && (s.__u |= 131072)), null == s || null === s.__v ? (-1 == a && d--, "function" != typeof r.type && (r.__u |= 65536)) : a !== o && (a === o + 1 ? d++ : a > o ? c > l - o ? d += a - o : d-- : d = a < o && a == o - 1 ? a - o : 0, a !== n + d && (r.__u |= 65536))) : (s = i[n]) && null == s.key && s.__e && (s.__e == e.__d && (e.__d = es(s)), gs(s, s, !1), i[n] = null, c--);
    if (c) for(n = 0; n < u; n++)null != (s = i[n]) && 0 == (131072 & s.__u) && (s.__e == e.__d && (e.__d = es(s)), gs(s, s));
}
function os(e, t, i) {
    var n, r;
    if ("function" == typeof e.type) {
        for(n = e.__k, r = 0; n && r < n.length; r++)n[r] && (n[r].__ = e, t = os(n[r], t, i));
        return t;
    }
    return e.__e != t && (i.insertBefore(e.__e, t || null), t = e.__e), t && t.nextSibling;
}
function as(e, t, i, n) {
    var r = e.key, s = e.type, o = i - 1, a = i + 1, l = t[i];
    if (null === l || l && r == l.key && s === l.type) return i;
    if (n > (null != l && 0 == (131072 & l.__u) ? 1 : 0)) for(; o >= 0 || a < t.length;){
        if (o >= 0) {
            if ((l = t[o]) && 0 == (131072 & l.__u) && r == l.key && s === l.type) return o;
            o--;
        }
        if (a < t.length) {
            if ((l = t[a]) && 0 == (131072 & l.__u) && r == l.key && s === l.type) return a;
            a++;
        }
    }
    return -1;
}
function ls(e, t, i) {
    "-" === t[0] ? e.setProperty(t, null == i ? "" : i) : e[t] = null == i ? "" : "number" != typeof i || Gr.test(t) ? i : i + "px";
}
function us(e, t, i, n, r) {
    var s;
    e: if ("style" === t) {
        if ("string" == typeof i) e.style.cssText = i;
        else {
            if ("string" == typeof n && (e.style.cssText = n = ""), n) for(t in n)i && t in i || ls(e.style, t, "");
            if (i) for(t in i)n && i[t] === n[t] || ls(e.style, t, i[t]);
        }
    } else if ("o" === t[0] && "n" === t[1]) s = t !== (t = t.replace(/(PointerCapture)$|Capture$/, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + s] = i, i ? n ? i.u = n.u : (i.u = Date.now(), e.addEventListener(t, s ? ds : cs, s)) : e.removeEventListener(t, s ? ds : cs, s);
    else {
        if (r) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && "role" !== t && t in e) try {
            e[t] = null == i ? "" : i;
            break e;
        } catch (e) {}
        "function" == typeof i || (null == i || !1 === i && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, i));
    }
}
function cs(e) {
    var t = this.l[e.type + !1];
    if (e.t) {
        if (e.t <= t.u) return;
    } else e.t = Date.now();
    return t(Nr.event ? Nr.event(e) : e);
}
function ds(e) {
    return this.l[e.type + !0](Nr.event ? Nr.event(e) : e);
}
function hs(e, t, i, n, r, s, o, a, l, u) {
    var c, d, h, _, p, v, g, f, m, b, y, w, S, E, k, x = t.type;
    if (void 0 !== t.constructor) return null;
    128 & i.__u && (l = !!(32 & i.__u), s = [
        a = t.__e = i.__e
    ]), (c = Nr.__b) && c(t);
    e: if ("function" == typeof x) try {
        if (f = t.props, m = (c = x.contextType) && n[c.__c], b = c ? m ? m.props.value : c.__ : n, i.__c ? g = (d = t.__c = i.__c).__ = d.__E : ("prototype" in x && x.prototype.render ? t.__c = d = new x(f, b) : (t.__c = d = new Zr(f, b), d.constructor = x, d.render = fs), m && m.sub(d), d.props = f, d.state || (d.state = {}), d.context = b, d.__n = n, h = d.__d = !0, d.__h = [], d._sb = []), null == d.__s && (d.__s = d.state), null != x.getDerivedStateFromProps && (d.__s == d.state && (d.__s = Yr({}, d.__s)), Yr(d.__s, x.getDerivedStateFromProps(f, d.__s))), _ = d.props, p = d.state, d.__v = t, h) null == x.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);
        else {
            if (null == x.getDerivedStateFromProps && f !== _ && null != d.componentWillReceiveProps && d.componentWillReceiveProps(f, b), !d.__e && (null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(f, d.__s, b) || t.__v === i.__v)) {
                for(t.__v !== i.__v && (d.props = f, d.state = d.__s, d.__d = !1), t.__e = i.__e, t.__k = i.__k, t.__k.forEach(function(e) {
                    e && (e.__ = t);
                }), y = 0; y < d._sb.length; y++)d.__h.push(d._sb[y]);
                d._sb = [], d.__h.length && o.push(d);
                break e;
            }
            null != d.componentWillUpdate && d.componentWillUpdate(f, d.__s, b), null != d.componentDidUpdate && d.__h.push(function() {
                d.componentDidUpdate(_, p, v);
            });
        }
        if (d.context = b, d.props = f, d.__P = e, d.__e = !1, w = Nr.__r, S = 0, "prototype" in x && x.prototype.render) {
            for(d.state = d.__s, d.__d = !1, w && w(t), c = d.render(d.props, d.state, d.context), E = 0; E < d._sb.length; E++)d.__h.push(d._sb[E]);
            d._sb = [];
        } else do d.__d = !1, w && w(t), c = d.render(d.props, d.state, d.context), d.state = d.__s;
        while (d.__d && ++S < 25);
        d.state = d.__s, null != d.getChildContext && (n = Yr(Yr({}, n), d.getChildContext())), h || null == d.getSnapshotBeforeUpdate || (v = d.getSnapshotBeforeUpdate(_, p)), rs(e, Jr(k = null != c && c.type === Qr && null == c.key ? c.props.children : c) ? k : [
            k
        ], t, i, n, r, s, o, a, l, u), d.base = t.__e, t.__u &= -161, d.__h.length && o.push(d), g && (d.__E = d.__ = null);
    } catch (e) {
        t.__v = null, l || null != s ? (t.__e = a, t.__u |= l ? 160 : 32, s[s.indexOf(a)] = null) : (t.__e = i.__e, t.__k = i.__k), Nr.__e(e, t, i);
    }
    else null == s && t.__v === i.__v ? (t.__k = i.__k, t.__e = i.__e) : t.__e = ps(i.__e, t, i, n, r, s, o, l, u);
    (c = Nr.diffed) && c(t);
}
function _s(e, t, i) {
    t.__d = void 0;
    for(var n = 0; n < i.length; n++)vs(i[n], i[++n], i[++n]);
    Nr.__c && Nr.__c(t, e), e.some(function(t) {
        try {
            e = t.__h, t.__h = [], e.some(function(e) {
                e.call(t);
            });
        } catch (e) {
            Nr.__e(e, t.__v);
        }
    });
}
function ps(e, t, i, n, r, s, o, a, l) {
    var u, c, d, h, _, p, v, g = i.props, f = t.props, m = t.type;
    if ("svg" === m && (r = !0), null != s) {
        for(u = 0; u < s.length; u++)if ((_ = s[u]) && "setAttribute" in _ == !!m && (m ? _.localName === m : 3 === _.nodeType)) {
            e = _, s[u] = null;
            break;
        }
    }
    if (null == e) {
        if (null === m) return document.createTextNode(f);
        e = r ? document.createElementNS("http://www.w3.org/2000/svg", m) : document.createElement(m, f.is && f), s = null, a = !1;
    }
    if (null === m) g === f || a && e.data === f || (e.data = f);
    else {
        if (s = s && Dr.call(e.childNodes), g = i.props || Wr, !a && null != s) for(g = {}, u = 0; u < e.attributes.length; u++)g[(_ = e.attributes[u]).name] = _.value;
        for(u in g)_ = g[u], "children" == u || ("dangerouslySetInnerHTML" == u ? d = _ : "key" === u || u in f || us(e, u, null, _, r));
        for(u in f)_ = f[u], "children" == u ? h = _ : "dangerouslySetInnerHTML" == u ? c = _ : "value" == u ? p = _ : "checked" == u ? v = _ : "key" === u || a && "function" != typeof _ || g[u] === _ || us(e, u, _, g[u], r);
        if (c) a || d && (c.__html === d.__html || c.__html === e.innerHTML) || (e.innerHTML = c.__html), t.__k = [];
        else if (d && (e.innerHTML = ""), rs(e, Jr(h) ? h : [
            h
        ], t, i, n, r && "foreignObject" !== m, s, o, s ? s[0] : i.__k && es(i, 0), a, l), null != s) for(u = s.length; u--;)null != s[u] && Kr(s[u]);
        a || (u = "value", void 0 !== p && (p !== e[u] || "progress" === m && !p || "option" === m && p !== g[u]) && us(e, u, p, g[u], !1), u = "checked", void 0 !== v && v !== e[u] && us(e, u, v, g[u], !1));
    }
    return e;
}
function vs(e, t, i) {
    try {
        "function" == typeof e ? e(t) : e.current = t;
    } catch (e) {
        Nr.__e(e, i);
    }
}
function gs(e, t, i) {
    var n, r;
    if (Nr.unmount && Nr.unmount(e), (n = e.ref) && (n.current && n.current !== e.__e || vs(n, null, t)), null != (n = e.__c)) {
        if (n.componentWillUnmount) try {
            n.componentWillUnmount();
        } catch (e) {
            Nr.__e(e, t);
        }
        n.base = n.__P = null, e.__c = void 0;
    }
    if (n = e.__k) for(r = 0; r < n.length; r++)n[r] && gs(n[r], t, i || "function" != typeof e.type);
    i || null == e.__e || Kr(e.__e), e.__ = e.__e = e.__d = void 0;
}
function fs(e, t, i) {
    return this.constructor(e, i);
}
Dr = Vr.slice, Nr = {
    __e: function(e, t, i, n) {
        for(var r, s, o; t = t.__;)if ((r = t.__c) && !r.__) try {
            if ((s = r.constructor) && null != s.getDerivedStateFromError && (r.setState(s.getDerivedStateFromError(e)), o = r.__d), null != r.componentDidCatch && (r.componentDidCatch(e, n || {}), o = r.__d), o) return r.__E = r;
        } catch (t) {
            e = t;
        }
        throw e;
    }
}, qr = 0, Zr.prototype.setState = function(e, t) {
    var i;
    i = null != this.__s && this.__s !== this.state ? this.__s : this.__s = Yr({}, this.state), "function" == typeof e && (e = e(Yr({}, i), this.props)), e && Yr(i, e), null != e && this.__v && (t && this._sb.push(t), is(this));
}, Zr.prototype.forceUpdate = function(e) {
    this.__v && (this.__e = !0, e && this.__h.push(e), is(this));
}, Zr.prototype.render = Qr, Br = [], Ur = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, zr = function(e, t) {
    return e.__v.__b - t.__v.__b;
}, ns.__r = 0, jr = 0;
!function(e, t) {
    var i = {
        __c: t = "__cC" + jr++,
        __: e,
        Consumer: function(e, t) {
            return e.children(t);
        },
        Provider: function(e) {
            var i, n;
            return this.getChildContext || (i = [], (n = {})[t] = this, this.getChildContext = function() {
                return n;
            }, this.shouldComponentUpdate = function(e) {
                this.props.value !== e.value && i.some(function(e) {
                    e.__e = !0, is(e);
                });
            }, this.sub = function(e) {
                i.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function() {
                    i.splice(i.indexOf(e), 1), t && t.call(e);
                };
            }), e.children;
        }
    };
    i.Provider.__ = i.Consumer.contextType = i;
}({
    isPreviewMode: !1,
    previewPageIndex: 0,
    handleCloseSurveyPopup: ()=>{},
    isPopup: !0,
    onPreviewSubmit: ()=>{}
});
var ms = B("[Surveys]"), bs = {
    icontains: (e)=>!!t && t.location.href.toLowerCase().indexOf(e.toLowerCase()) > -1,
    not_icontains: (e)=>!!t && -1 === t.location.href.toLowerCase().indexOf(e.toLowerCase()),
    regex: (e)=>!!t && gt(t.location.href, e),
    not_regex: (e)=>!!t && !gt(t.location.href, e),
    exact: (e)=>(null == t ? void 0 : t.location.href) === e,
    is_not: (e)=>(null == t ? void 0 : t.location.href) !== e
};
class ys {
    constructor(e){
        this.instance = e, this._surveyEventReceiver = null;
    }
    onRemoteConfig(e) {
        this._decideServerResponse = !!e.surveys, this.loadIfEnabled();
    }
    reset() {
        localStorage.removeItem("lastSeenSurveyDate");
        var e = (()=>{
            for(var e = [], t = 0; t < localStorage.length; t++){
                var i = localStorage.key(t);
                null != i && i.startsWith("seenSurvey_") && e.push(i);
            }
            return e;
        })();
        e.forEach((e)=>localStorage.removeItem(e));
    }
    loadIfEnabled() {
        var e, t, i, n = null == _ || null === (e = _.__PosthogExtensions__) || void 0 === e ? void 0 : e.generateSurveys;
        this.instance.config.disable_surveys || !this._decideServerResponse || n || (null == this._surveyEventReceiver && (this._surveyEventReceiver = new Ar(this.instance)), null === (t = _.__PosthogExtensions__) || void 0 === t || null === (i = t.loadExternalDependency) || void 0 === i || i.call(t, this.instance, "surveys", (e)=>{
            var t, i;
            if (e) return ms.error("Could not load surveys script", e);
            this._surveyManager = null === (t = _.__PosthogExtensions__) || void 0 === t || null === (i = t.generateSurveys) || void 0 === i ? void 0 : i.call(t, this.instance);
        }));
    }
    getSurveys(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        if (this.instance.config.disable_surveys) return e([]);
        null == this._surveyEventReceiver && (this._surveyEventReceiver = new Ar(this.instance));
        var i = this.instance.get_property(Pe);
        if (i && !t) return e(i);
        this.instance._send_request({
            url: this.instance.requestRouter.endpointFor("api", "/api/surveys/?token=".concat(this.instance.config.token)),
            method: "GET",
            callback: (t)=>{
                var i;
                if (200 !== t.statusCode || !t.json) return e([]);
                var n, r = t.json.surveys || [], s = r.filter((e)=>{
                    var t, i, n, r, s, o, a, l, u, c, d, h;
                    return (null === (t = e.conditions) || void 0 === t ? void 0 : t.events) && (null === (i = e.conditions) || void 0 === i || null === (n = i.events) || void 0 === n ? void 0 : n.values) && (null === (r = e.conditions) || void 0 === r || null === (s = r.events) || void 0 === s || null === (o = s.values) || void 0 === o ? void 0 : o.length) > 0 || (null === (a = e.conditions) || void 0 === a ? void 0 : a.actions) && (null === (l = e.conditions) || void 0 === l || null === (u = l.actions) || void 0 === u ? void 0 : u.values) && (null === (c = e.conditions) || void 0 === c || null === (d = c.actions) || void 0 === d || null === (h = d.values) || void 0 === h ? void 0 : h.length) > 0;
                });
                s.length > 0 && (null === (n = this._surveyEventReceiver) || void 0 === n || n.register(s));
                return null === (i = this.instance.persistence) || void 0 === i || i.register({
                    [Pe]: r
                }), e(r);
            }
        });
    }
    getActiveMatchingSurveys(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        this.getSurveys((t)=>{
            var i, n = t.filter((e)=>!(!e.start_date || e.end_date)).filter((e)=>{
                var t, i, n, r;
                if (!e.conditions) return !0;
                var s = null === (t = e.conditions) || void 0 === t || !t.url || bs[null !== (i = null === (n = e.conditions) || void 0 === n ? void 0 : n.urlMatchType) && void 0 !== i ? i : "icontains"](e.conditions.url), o = null === (r = e.conditions) || void 0 === r || !r.selector || (null == a ? void 0 : a.querySelector(e.conditions.selector));
                return s && o;
            }), r = null === (i = this._surveyEventReceiver) || void 0 === i ? void 0 : i.getSurveys(), s = n.filter((e)=>{
                var t, i, n, s, o, a, l, u, c, d, h;
                if (!(e.linked_flag_key || e.targeting_flag_key || e.internal_targeting_flag_key || null !== (t = e.feature_flag_keys) && void 0 !== t && t.length)) return !0;
                var _ = !e.linked_flag_key || this.instance.featureFlags.isFeatureEnabled(e.linked_flag_key), p = !e.targeting_flag_key || this.instance.featureFlags.isFeatureEnabled(e.targeting_flag_key), v = (null === (i = e.conditions) || void 0 === i ? void 0 : i.events) && (null === (n = e.conditions) || void 0 === n || null === (s = n.events) || void 0 === s ? void 0 : s.values) && (null === (o = e.conditions) || void 0 === o || null === (a = o.events) || void 0 === a ? void 0 : a.values.length) > 0, g = (null === (l = e.conditions) || void 0 === l ? void 0 : l.actions) && (null === (u = e.conditions) || void 0 === u || null === (c = u.actions) || void 0 === c ? void 0 : c.values) && (null === (d = e.conditions) || void 0 === d || null === (h = d.actions) || void 0 === h ? void 0 : h.values.length) > 0, f = !v && !g || (null == r ? void 0 : r.includes(e.id)), m = this._canActivateRepeatedly(e), b = !(e.internal_targeting_flag_key && !m) || this.instance.featureFlags.isFeatureEnabled(e.internal_targeting_flag_key), y = this.checkFlags(e);
                return _ && p && b && f && y;
            });
            return e(s);
        }, t);
    }
    checkFlags(e) {
        var t;
        return null === (t = e.feature_flag_keys) || void 0 === t || !t.length || e.feature_flag_keys.every((e)=>{
            var { key: t, value: i } = e;
            return !t || !i || this.instance.featureFlags.isFeatureEnabled(i);
        });
    }
    getNextSurveyStep(e, t, i) {
        var n, r = e.questions[t], s = t + 1;
        if (null === (n = r.branching) || void 0 === n || !n.type) return t === e.questions.length - 1 ? Rr.End : s;
        if (r.branching.type === Rr.End) return Rr.End;
        if (r.branching.type === Rr.SpecificQuestion) {
            if (Number.isInteger(r.branching.index)) return r.branching.index;
        } else if (r.branching.type === Rr.ResponseBased) {
            if (r.type === Fr.SingleChoice) {
                var o, a, l = r.choices.indexOf("".concat(i));
                if (null !== (o = r.branching) && void 0 !== o && null !== (a = o.responseValues) && void 0 !== a && a.hasOwnProperty(l)) {
                    var u = r.branching.responseValues[l];
                    return Number.isInteger(u) ? u : u === Rr.End ? Rr.End : s;
                }
            } else if (r.type === Fr.Rating) {
                var c, d;
                if ("number" != typeof i || !Number.isInteger(i)) throw new Error("The response type must be an integer");
                var h = function(e, t) {
                    if (3 === t) {
                        if (e < 1 || e > 3) throw new Error("The response must be in range 1-3");
                        return 1 === e ? "negative" : 2 === e ? "neutral" : "positive";
                    }
                    if (5 === t) {
                        if (e < 1 || e > 5) throw new Error("The response must be in range 1-5");
                        return e <= 2 ? "negative" : 3 === e ? "neutral" : "positive";
                    }
                    if (7 === t) {
                        if (e < 1 || e > 7) throw new Error("The response must be in range 1-7");
                        return e <= 3 ? "negative" : 4 === e ? "neutral" : "positive";
                    }
                    if (10 === t) {
                        if (e < 0 || e > 10) throw new Error("The response must be in range 0-10");
                        return e <= 6 ? "detractors" : e <= 8 ? "passives" : "promoters";
                    }
                    throw new Error("The scale must be one of: 3, 5, 7, 10");
                }(i, r.scale);
                if (null !== (c = r.branching) && void 0 !== c && null !== (d = c.responseValues) && void 0 !== d && d.hasOwnProperty(h)) {
                    var _ = r.branching.responseValues[h];
                    return Number.isInteger(_) ? _ : _ === Rr.End ? Rr.End : s;
                }
            }
            return s;
        }
        return ms.warn("Falling back to next question index due to unexpected branching type"), s;
    }
    _canActivateRepeatedly(e) {
        var t;
        return O(null === (t = _.__PosthogExtensions__) || void 0 === t ? void 0 : t.canActivateRepeatedly) ? (ms.warn("init was not called"), !1) : _.__PosthogExtensions__.canActivateRepeatedly(e);
    }
    canRenderSurvey(e) {
        O(this._surveyManager) ? ms.warn("init was not called") : this.getSurveys((t)=>{
            var i = t.filter((t)=>t.id === e)[0];
            this._surveyManager.canRenderSurvey(i);
        });
    }
    renderSurvey(e, t) {
        O(this._surveyManager) ? ms.warn("init was not called") : this.getSurveys((i)=>{
            var n = i.filter((t)=>t.id === e)[0];
            this._surveyManager.renderSurvey(n, null == a ? void 0 : a.querySelector(t));
        });
    }
}
var ws = B("[RateLimiter]");
class Ss {
    constructor(e){
        var t, i;
        W(this, "serverLimits", {}), W(this, "lastEventRateLimited", !1), W(this, "checkForLimiting", (e)=>{
            var t = e.text;
            if (t && t.length) try {
                (JSON.parse(t).quota_limited || []).forEach((e)=>{
                    ws.info("".concat(e || "events", " is quota limited.")), this.serverLimits[e] = (new Date).getTime() + 6e4;
                });
            } catch (e) {
                return void ws.warn('could not rate limit - continuing. Error: "'.concat(null == e ? void 0 : e.message, '"'), {
                    text: t
                });
            }
        }), this.instance = e, this.captureEventsPerSecond = (null === (t = e.config.rate_limiting) || void 0 === t ? void 0 : t.events_per_second) || 10, this.captureEventsBurstLimit = Math.max((null === (i = e.config.rate_limiting) || void 0 === i ? void 0 : i.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond), this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
    }
    clientRateLimitContext() {
        var e, t, i, n = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], r = (new Date).getTime(), s = null !== (e = null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.get_property(Oe)) && void 0 !== e ? e : {
            tokens: this.captureEventsBurstLimit,
            last: r
        };
        s.tokens += (r - s.last) / 1e3 * this.captureEventsPerSecond, s.last = r, s.tokens > this.captureEventsBurstLimit && (s.tokens = this.captureEventsBurstLimit);
        var o = s.tokens < 1;
        return o || n || (s.tokens = Math.max(0, s.tokens - 1)), !o || this.lastEventRateLimited || n || this.instance.capture("$$client_ingestion_warning", {
            $$client_ingestion_warning_message: "posthog-js client rate limited. Config is set to ".concat(this.captureEventsPerSecond, " events per second and ").concat(this.captureEventsBurstLimit, " events burst limit.")
        }, {
            skip_client_rate_limiting: !0
        }), this.lastEventRateLimited = o, null === (i = this.instance.persistence) || void 0 === i || i.set_property(Oe, s), {
            isRateLimited: o,
            remainingTokens: s.tokens
        };
    }
    isServerRateLimited(e) {
        var t = this.serverLimits[e || "events"] || !1;
        return !1 !== t && (new Date).getTime() < t;
    }
}
var Es = ()=>j({
        initialPathName: (null == l ? void 0 : l.pathname) || "",
        referringDomain: fi.referringDomain()
    }, fi.campaignParams());
class ks {
    constructor(e, t, i){
        W(this, "_onSessionIdCallback", (e)=>{
            var t = this._getStoredProps();
            if (!t || t.sessionId !== e) {
                var i = {
                    sessionId: e,
                    props: this._sessionSourceParamGenerator()
                };
                this._persistence.register({
                    [$e]: i
                });
            }
        }), this._sessionIdManager = e, this._persistence = t, this._sessionSourceParamGenerator = i || Es, this._sessionIdManager.onSessionId(this._onSessionIdCallback);
    }
    _getStoredProps() {
        return this._persistence.props[$e];
    }
    getSessionProps() {
        var e, t = null === (e = this._getStoredProps()) || void 0 === e ? void 0 : e.props;
        return t ? {
            $client_session_initial_referring_host: t.referringDomain,
            $client_session_initial_pathname: t.initialPathName,
            $client_session_initial_utm_source: t.utm_source,
            $client_session_initial_utm_campaign: t.utm_campaign,
            $client_session_initial_utm_medium: t.utm_medium,
            $client_session_initial_utm_content: t.utm_content,
            $client_session_initial_utm_term: t.utm_term
        } : {};
    }
}
var xs = [
    "ahrefsbot",
    "ahrefssiteaudit",
    "applebot",
    "baiduspider",
    "better uptime bot",
    "bingbot",
    "bingpreview",
    "bot.htm",
    "bot.php",
    "crawler",
    "deepscan",
    "duckduckbot",
    "facebookexternal",
    "facebookcatalog",
    "gptbot",
    "http://yandex.com/bots",
    "hubspot",
    "ia_archiver",
    "linkedinbot",
    "mj12bot",
    "msnbot",
    "nessus",
    "petalbot",
    "pinterest",
    "prerender",
    "rogerbot",
    "screaming frog",
    "semrushbot",
    "sitebulb",
    "slurp",
    "turnitin",
    "twitterbot",
    "vercelbot",
    "yahoo! slurp",
    "yandexbot",
    "headlesschrome",
    "cypress",
    "Google-HotelAdsVerifier",
    "adsbot-google",
    "apis-google",
    "duplexweb-google",
    "feedfetcher-google",
    "google favicon",
    "google web preview",
    "google-read-aloud",
    "googlebot",
    "googleweblight",
    "mediapartners-google",
    "storebot-google",
    "Bytespider;"
], Is = function(e, t) {
    if (!e) return !1;
    var i = e.toLowerCase();
    return xs.concat(t || []).some((e)=>{
        var t = e.toLowerCase();
        return -1 !== i.indexOf(t);
    });
}, Cs = function(e, t) {
    if (!e) return !1;
    var i = e.userAgent;
    if (i && Is(i, t)) return !0;
    try {
        var n = null == e ? void 0 : e.userAgentData;
        if (null != n && n.brands && n.brands.some((e)=>Is(null == e ? void 0 : e.brand, t))) return !0;
    } catch (e) {}
    return !!e.webdriver;
};
class Ps {
    constructor(){
        this.clicks = [];
    }
    isRageClick(e, t, i) {
        var n = this.clicks[this.clicks.length - 1];
        if (n && Math.abs(e - n.x) + Math.abs(t - n.y) < 30 && i - n.timestamp < 1e3) {
            if (this.clicks.push({
                x: e,
                y: t,
                timestamp: i
            }), 3 === this.clicks.length) return !0;
        } else this.clicks = [
            {
                x: e,
                y: t,
                timestamp: i
            }
        ];
        return !1;
    }
}
var Fs = B("[Dead Clicks]"), Rs = ()=>!0, Ts = (e)=>{
    var t, i = !(null === (t = e.instance.persistence) || void 0 === t || !t.get_property(de)), n = e.instance.config.capture_dead_clicks;
    return L(n) ? n : i;
};
class $s {
    get lazyLoadedDeadClicksAutocapture() {
        return this._lazyLoadedDeadClicksAutocapture;
    }
    constructor(e, t, i){
        this.instance = e, this.isEnabled = t, this.onCapture = i, this.startIfEnabled();
    }
    onRemoteConfig(e) {
        this.instance.persistence && this.instance.persistence.register({
            [de]: null == e ? void 0 : e.captureDeadClicks
        }), this.startIfEnabled();
    }
    startIfEnabled() {
        this.isEnabled(this) && this.loadScript(()=>{
            this.start();
        });
    }
    loadScript(e) {
        var t, i, n;
        null !== (t = _.__PosthogExtensions__) && void 0 !== t && t.initDeadClicksAutocapture && e(), null === (i = _.__PosthogExtensions__) || void 0 === i || null === (n = i.loadExternalDependency) || void 0 === n || n.call(i, this.instance, "dead-clicks-autocapture", (t)=>{
            t ? Fs.error("failed to load script", t) : e();
        });
    }
    start() {
        var e;
        if (a) {
            if (!this._lazyLoadedDeadClicksAutocapture && null !== (e = _.__PosthogExtensions__) && void 0 !== e && e.initDeadClicksAutocapture) {
                var t = C(this.instance.config.capture_dead_clicks) ? this.instance.config.capture_dead_clicks : {};
                t.__onCapture = this.onCapture, this._lazyLoadedDeadClicksAutocapture = _.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, t), this._lazyLoadedDeadClicksAutocapture.start(a), Fs.info("starting...");
            }
        } else Fs.error("`document` not found. Cannot start.");
    }
    stop() {
        this._lazyLoadedDeadClicksAutocapture && (this._lazyLoadedDeadClicksAutocapture.stop(), this._lazyLoadedDeadClicksAutocapture = void 0, Fs.info("stopping..."));
    }
}
var Os = B("[Heatmaps]");
function Ms(e) {
    return C(e) && "clientX" in e && "clientY" in e && M(e.clientX) && M(e.clientY);
}
class Ls {
    constructor(e){
        var i;
        W(this, "rageclicks", new Ps), W(this, "_enabledServerSide", !1), W(this, "_initialized", !1), W(this, "_flushInterval", null), this.instance = e, this._enabledServerSide = !(null === (i = this.instance.persistence) || void 0 === i || !i.props[le]), null == t || t.addEventListener("beforeunload", ()=>{
            this.flush();
        });
    }
    get flushIntervalMilliseconds() {
        var e = 5e3;
        return C(this.instance.config.capture_heatmaps) && this.instance.config.capture_heatmaps.flush_interval_milliseconds && (e = this.instance.config.capture_heatmaps.flush_interval_milliseconds), e;
    }
    get isEnabled() {
        return F(this.instance.config.capture_heatmaps) ? F(this.instance.config.enable_heatmaps) ? this._enabledServerSide : this.instance.config.enable_heatmaps : !1 !== this.instance.config.capture_heatmaps;
    }
    startIfEnabled() {
        if (this.isEnabled) {
            if (this._initialized) return;
            Os.info("starting..."), this._setupListeners(), this._flushInterval = setInterval(this.flush.bind(this), this.flushIntervalMilliseconds);
        } else {
            var e, t;
            clearInterval(null !== (e = this._flushInterval) && void 0 !== e ? e : void 0), null === (t = this.deadClicksCapture) || void 0 === t || t.stop(), this.getAndClearBuffer();
        }
    }
    onRemoteConfig(e) {
        var t = !!e.heatmaps;
        this.instance.persistence && this.instance.persistence.register({
            [le]: t
        }), this._enabledServerSide = t, this.startIfEnabled();
    }
    getAndClearBuffer() {
        var e = this.buffer;
        return this.buffer = void 0, e;
    }
    _onDeadClick(e) {
        this._onClick(e.originalEvent, "deadclick");
    }
    _setupListeners() {
        t && a && (ie(a, "click", (e)=>this._onClick(e || (null == t ? void 0 : t.event)), !1, !0), ie(a, "mousemove", (e)=>this._onMouseMove(e || (null == t ? void 0 : t.event)), !1, !0), this.deadClicksCapture = new $s(this.instance, Rs, this._onDeadClick.bind(this)), this.deadClicksCapture.startIfEnabled(), this._initialized = !0);
    }
    _getProperties(e, i) {
        var n = this.instance.scrollManager.scrollY(), r = this.instance.scrollManager.scrollX(), s = this.instance.scrollManager.scrollElement(), o = function(e, i, n) {
            for(var r = e; r && xi(r) && !Ii(r, "body");){
                if (r === n) return !1;
                if (m(i, null == t ? void 0 : t.getComputedStyle(r).position)) return !0;
                r = Ai(r);
            }
            return !1;
        }(Mi(e), [
            "fixed",
            "sticky"
        ], s);
        return {
            x: e.clientX + (o ? 0 : r),
            y: e.clientY + (o ? 0 : n),
            target_fixed: o,
            type: i
        };
    }
    _onClick(e) {
        var t, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "click";
        if (!ki(e.target) && Ms(e)) {
            var n = this._getProperties(e, i);
            null !== (t = this.rageclicks) && void 0 !== t && t.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._capture(j(j({}, n), {}, {
                type: "rageclick"
            })), this._capture(n);
        }
    }
    _onMouseMove(e) {
        !ki(e.target) && Ms(e) && (clearTimeout(this._mouseMoveTimeout), this._mouseMoveTimeout = setTimeout(()=>{
            this._capture(this._getProperties(e, "mousemove"));
        }, 500));
    }
    _capture(e) {
        if (t) {
            var i = t.location.href;
            this.buffer = this.buffer || {}, this.buffer[i] || (this.buffer[i] = []), this.buffer[i].push(e);
        }
    }
    flush() {
        this.buffer && !P(this.buffer) && this.instance.capture("$$heatmap", {
            $heatmap_data: this.getAndClearBuffer()
        });
    }
}
class As {
    constructor(e){
        W(this, "_updateScrollData", ()=>{
            var e, t, i, n;
            this.context || (this.context = {});
            var r = this.scrollElement(), s = this.scrollY(), o = r ? Math.max(0, r.scrollHeight - r.clientHeight) : 0, a = s + ((null == r ? void 0 : r.clientHeight) || 0), l = (null == r ? void 0 : r.scrollHeight) || 0;
            this.context.lastScrollY = Math.ceil(s), this.context.maxScrollY = Math.max(s, null !== (e = this.context.maxScrollY) && void 0 !== e ? e : 0), this.context.maxScrollHeight = Math.max(o, null !== (t = this.context.maxScrollHeight) && void 0 !== t ? t : 0), this.context.lastContentY = a, this.context.maxContentY = Math.max(a, null !== (i = this.context.maxContentY) && void 0 !== i ? i : 0), this.context.maxContentHeight = Math.max(l, null !== (n = this.context.maxContentHeight) && void 0 !== n ? n : 0);
        }), this.instance = e;
    }
    getContext() {
        return this.context;
    }
    resetContext() {
        var e = this.context;
        return setTimeout(this._updateScrollData, 0), e;
    }
    startMeasuringScrollPosition() {
        null == t || t.addEventListener("scroll", this._updateScrollData, !0), null == t || t.addEventListener("scrollend", this._updateScrollData, !0), null == t || t.addEventListener("resize", this._updateScrollData);
    }
    scrollElement() {
        if (!this.instance.config.scroll_root_selector) return null == t ? void 0 : t.document.documentElement;
        var e = x(this.instance.config.scroll_root_selector) ? this.instance.config.scroll_root_selector : [
            this.instance.config.scroll_root_selector
        ];
        for (var i of e){
            var n = null == t ? void 0 : t.document.querySelector(i);
            if (n) return n;
        }
    }
    scrollY() {
        if (this.instance.config.scroll_root_selector) {
            var e = this.scrollElement();
            return e && e.scrollTop || 0;
        }
        return t && (t.scrollY || t.pageYOffset || t.document.documentElement.scrollTop) || 0;
    }
    scrollX() {
        if (this.instance.config.scroll_root_selector) {
            var e = this.scrollElement();
            return e && e.scrollLeft || 0;
        }
        return t && (t.scrollX || t.pageXOffset || t.document.documentElement.scrollLeft) || 0;
    }
}
var Ds = B("[AutoCapture]");
function Ns(e, t) {
    return t.length > e ? t.slice(0, e) + "..." : t;
}
function qs(e) {
    if (e.previousElementSibling) return e.previousElementSibling;
    var t = e;
    do t = t.previousSibling;
    while (t && !xi(t));
    return t;
}
function Bs(e, t, i, n) {
    var r = e.tagName.toLowerCase(), s = {
        tag_name: r
    };
    Li.indexOf(r) > -1 && !i && ("a" === r.toLowerCase() || "button" === r.toLowerCase() ? s.$el_text = Ns(1024, Gi(e)) : s.$el_text = Ns(1024, Oi(e)));
    var o = Ti(e);
    o.length > 0 && (s.classes = o.filter(function(e) {
        return "" !== e;
    })), Y(e.attributes, function(i) {
        var r;
        if ((!qi(e) || -1 !== [
            "name",
            "id",
            "class",
            "aria-label"
        ].indexOf(i.name)) && (null == n || !n.includes(i.name)) && !t && Vi(i.value) && (r = i.name, !R(r) || "_ngcontent" !== r.substring(0, 10) && "_nghost" !== r.substring(0, 7))) {
            var o = i.value;
            "class" === i.name && (o = Fi(o).join(" ")), s["attr__" + i.name] = Ns(1024, o);
        }
    });
    for(var a = 1, l = 1, u = e; u = qs(u);)a++, u.tagName === e.tagName && l++;
    return s.nth_child = a, s.nth_of_type = l, s;
}
function Hs(e, i) {
    for(var n, r, { e: s, maskAllElementAttributes: o, maskAllText: a, elementAttributeIgnoreList: l, elementsChainAsString: u } = i, c = [
        e
    ], d = e; d.parentNode && !Ii(d, "body");)Pi(d.parentNode) ? (c.push(d.parentNode.host), d = d.parentNode.host) : (c.push(d.parentNode), d = d.parentNode);
    var h, _ = [], p = {}, v = !1, g = !1;
    if (Y(c, (e)=>{
        var t = Ni(e);
        "a" === e.tagName.toLowerCase() && (v = e.getAttribute("href"), v = t && v && Vi(v) && v), m(Ti(e), "ph-no-capture") && (g = !0), _.push(Bs(e, o, a, l));
        var i = function(e) {
            if (!Ni(e)) return {};
            var t = {};
            return Y(e.attributes, function(e) {
                if (e.name && 0 === e.name.indexOf("data-ph-capture-attribute")) {
                    var i = e.name.replace("data-ph-capture-attribute-", ""), n = e.value;
                    i && n && Vi(n) && (t[i] = n);
                }
            }), t;
        }(e);
        K(p, i);
    }), g) return {
        props: {},
        explicitNoCapture: g
    };
    if (a || ("a" === e.tagName.toLowerCase() || "button" === e.tagName.toLowerCase() ? _[0].$el_text = Gi(e) : _[0].$el_text = Oi(e)), v) {
        var f, b;
        _[0].attr__href = v;
        var y = null === (f = vt(v)) || void 0 === f ? void 0 : f.host, w = null == t || null === (b = t.location) || void 0 === b ? void 0 : b.host;
        y && w && y !== w && (h = v);
    }
    return {
        props: K({
            $event_type: s.type,
            $ce_version: 1
        }, u ? {} : {
            $elements: _
        }, {
            $elements_chain: Yi(_)
        }, null !== (n = _[0]) && void 0 !== n && n.$el_text ? {
            $el_text: null === (r = _[0]) || void 0 === r ? void 0 : r.$el_text
        } : {}, h && "click" === s.type ? {
            $external_click_url: h
        } : {}, p)
    };
}
class Us {
    constructor(e){
        W(this, "_initialized", !1), W(this, "_isDisabledServerSide", null), W(this, "rageclicks", new Ps), W(this, "_elementsChainAsString", !1), this.instance = e, this._elementSelectors = null;
    }
    get config() {
        var e, t, i = C(this.instance.config.autocapture) ? this.instance.config.autocapture : {};
        return i.url_allowlist = null === (e = i.url_allowlist) || void 0 === e ? void 0 : e.map((e)=>new RegExp(e)), i.url_ignorelist = null === (t = i.url_ignorelist) || void 0 === t ? void 0 : t.map((e)=>new RegExp(e)), i;
    }
    _addDomEventHandlers() {
        if (this.isBrowserSupported()) {
            if (t && a) {
                var e = (e)=>{
                    e = e || (null == t ? void 0 : t.event);
                    try {
                        this._captureEvent(e);
                    } catch (e) {
                        Ds.error("Failed to capture event", e);
                    }
                }, i = (e)=>{
                    e = e || (null == t ? void 0 : t.event), this._captureEvent(e, v);
                };
                ie(a, "submit", e, !1, !0), ie(a, "change", e, !1, !0), ie(a, "click", e, !1, !0), this.config.capture_copied_text && (ie(a, "copy", i, !1, !0), ie(a, "cut", i, !1, !0));
            }
        } else Ds.info("Disabling Automatic Event Collection because this browser is not supported");
    }
    startIfEnabled() {
        this.isEnabled && !this._initialized && (this._addDomEventHandlers(), this._initialized = !0);
    }
    onRemoteConfig(e) {
        e.elementsChainAsString && (this._elementsChainAsString = e.elementsChainAsString), this.instance.persistence && this.instance.persistence.register({
            [ae]: !!e.autocapture_opt_out
        }), this._isDisabledServerSide = !!e.autocapture_opt_out, this.startIfEnabled();
    }
    setElementSelectors(e) {
        this._elementSelectors = e;
    }
    getElementSelectors(e) {
        var t, i = [];
        return null === (t = this._elementSelectors) || void 0 === t || t.forEach((t)=>{
            var n = null == a ? void 0 : a.querySelectorAll(t);
            null == n || n.forEach((n)=>{
                e === n && i.push(t);
            });
        }), i;
    }
    get isEnabled() {
        var e, t, i = null === (e = this.instance.persistence) || void 0 === e ? void 0 : e.props[ae], n = this._isDisabledServerSide;
        if ($(n) && !L(i) && !this.instance.config.advanced_disable_decide) return !1;
        var r = null !== (t = this._isDisabledServerSide) && void 0 !== t ? t : !!i;
        return !!this.instance.config.autocapture && !r;
    }
    _captureEvent(e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "$autocapture";
        if (this.isEnabled) {
            var n, r = Mi(e);
            if (Ci(r) && (r = r.parentNode || null), "$autocapture" === i && "click" === e.type && e instanceof MouseEvent) this.instance.config.rageclick && null !== (n = this.rageclicks) && void 0 !== n && n.isRageClick(e.clientX, e.clientY, (new Date).getTime()) && this._captureEvent(e, "$rageclick");
            var s = i === v;
            if (r && Di(r, e, this.config, s, s ? [
                "copy",
                "cut"
            ] : void 0)) {
                var { props: o, explicitNoCapture: a } = Hs(r, {
                    e: e,
                    maskAllElementAttributes: this.instance.config.mask_all_element_attributes,
                    maskAllText: this.instance.config.mask_all_text,
                    elementAttributeIgnoreList: this.config.element_attribute_ignorelist,
                    elementsChainAsString: this._elementsChainAsString
                });
                if (a) return !1;
                var l = this.getElementSelectors(r);
                if (l && l.length > 0 && (o.$element_selectors = l), i === v) {
                    var u, c = $i(null == t || null === (u = t.getSelection()) || void 0 === u ? void 0 : u.toString()), d = e.type || "clipboard";
                    if (!c) return !1;
                    o.$selected_content = c, o.$copy_type = d;
                }
                return this.instance.capture(i, o), !0;
            }
        }
    }
    isBrowserSupported() {
        return I(null == a ? void 0 : a.querySelectorAll);
    }
}
var zs = B("[TracingHeaders]");
class js {
    constructor(e){
        W(this, "_restoreXHRPatch", void 0), W(this, "_restoreFetchPatch", void 0), W(this, "_startCapturing", ()=>{
            var e, t, i, n;
            F(this._restoreXHRPatch) && (null === (e = _.__PosthogExtensions__) || void 0 === e || null === (t = e.tracingHeadersPatchFns) || void 0 === t || t._patchXHR(this.instance.sessionManager));
            F(this._restoreFetchPatch) && (null === (i = _.__PosthogExtensions__) || void 0 === i || null === (n = i.tracingHeadersPatchFns) || void 0 === n || n._patchFetch(this.instance.sessionManager));
        }), this.instance = e;
    }
    _loadScript(e) {
        var t, i, n;
        null !== (t = _.__PosthogExtensions__) && void 0 !== t && t.tracingHeadersPatchFns && e(), null === (i = _.__PosthogExtensions__) || void 0 === i || null === (n = i.loadExternalDependency) || void 0 === n || n.call(i, this.instance, "tracing-headers", (t)=>{
            if (t) return zs.error("failed to load script", t);
            e();
        });
    }
    startIfEnabledOrStop() {
        var e, t;
        this.instance.config.__add_tracing_headers ? this._loadScript(this._startCapturing) : (null === (e = this._restoreXHRPatch) || void 0 === e || e.call(this), null === (t = this._restoreFetchPatch) || void 0 === t || t.call(this), this._restoreXHRPatch = void 0, this._restoreFetchPatch = void 0);
    }
}
var Ws;
!function(e) {
    e[e.PENDING = -1] = "PENDING", e[e.DENIED = 0] = "DENIED", e[e.GRANTED = 1] = "GRANTED";
}(Ws || (Ws = {}));
class Vs {
    constructor(e){
        this.instance = e;
    }
    get config() {
        return this.instance.config;
    }
    get consent() {
        return this.getDnt() ? Ws.DENIED : this.storedConsent;
    }
    isOptedOut() {
        return this.consent === Ws.DENIED || this.consent === Ws.PENDING && this.config.opt_out_capturing_by_default;
    }
    isOptedIn() {
        return !this.isOptedOut();
    }
    optInOut(e) {
        this.storage.set(this.storageKey, e ? 1 : 0, this.config.cookie_expiration, this.config.cross_subdomain_cookie, this.config.secure_cookie);
    }
    reset() {
        this.storage.remove(this.storageKey, this.config.cross_subdomain_cookie);
    }
    get storageKey() {
        var { token: e, opt_out_capturing_cookie_prefix: t } = this.instance.config;
        return (t || "__ph_opt_in_out_") + e;
    }
    get storedConsent() {
        var e = this.storage.get(this.storageKey);
        return "1" === e ? Ws.GRANTED : "0" === e ? Ws.DENIED : Ws.PENDING;
    }
    get storage() {
        if (!this._storage) {
            var e = this.config.opt_out_capturing_persistence_type;
            this._storage = "localStorage" === e ? at : st;
            var t = "localStorage" === e ? st : at;
            t.get(this.storageKey) && (this._storage.get(this.storageKey) || this.optInOut("1" === t.get(this.storageKey)), t.remove(this.storageKey, this.config.cross_subdomain_cookie));
        }
        return this._storage;
    }
    getDnt() {
        return !!this.config.respect_dnt && !!ne([
            null == o ? void 0 : o.doNotTrack,
            null == o ? void 0 : o.msDoNotTrack,
            _.doNotTrack
        ], (e)=>m([
                !0,
                1,
                "1",
                "yes"
            ], e));
    }
}
var Gs = B("[ExceptionAutocapture]");
class Js {
    constructor(e){
        var i;
        W(this, "originalOnUnhandledRejectionHandler", void 0), W(this, "startCapturing", ()=>{
            var e, i, n, r;
            if (t && this.isEnabled && !this.hasHandlers && !this.isCapturing) {
                var s = null === (e = _.__PosthogExtensions__) || void 0 === e || null === (i = e.errorWrappingFunctions) || void 0 === i ? void 0 : i.wrapOnError, o = null === (n = _.__PosthogExtensions__) || void 0 === n || null === (r = n.errorWrappingFunctions) || void 0 === r ? void 0 : r.wrapUnhandledRejection;
                if (s && o) try {
                    this.unwrapOnError = s(this.captureException.bind(this)), this.unwrapUnhandledRejection = o(this.captureException.bind(this));
                } catch (e) {
                    Gs.error("failed to start", e), this.stopCapturing();
                }
                else Gs.error("failed to load error wrapping functions - cannot start");
            }
        }), this.instance = e, this.remoteEnabled = !(null === (i = this.instance.persistence) || void 0 === i || !i.props[ue]), this.startIfEnabled();
    }
    get isEnabled() {
        var e;
        return null !== (e = this.remoteEnabled) && void 0 !== e && e;
    }
    get isCapturing() {
        var e;
        return !(null == t || null === (e = t.onerror) || void 0 === e || !e.__POSTHOG_INSTRUMENTED__);
    }
    get hasHandlers() {
        return this.originalOnUnhandledRejectionHandler || this.unwrapOnError;
    }
    startIfEnabled() {
        this.isEnabled && !this.isCapturing && (Gs.info("enabled, starting..."), this.loadScript(this.startCapturing));
    }
    loadScript(e) {
        var t, i;
        this.hasHandlers && e(), null === (t = _.__PosthogExtensions__) || void 0 === t || null === (i = t.loadExternalDependency) || void 0 === i || i.call(t, this.instance, "exception-autocapture", (t)=>{
            if (t) return Gs.error("failed to load script", t);
            e();
        });
    }
    stopCapturing() {
        var e, t;
        null === (e = this.unwrapOnError) || void 0 === e || e.call(this), null === (t = this.unwrapUnhandledRejection) || void 0 === t || t.call(this);
    }
    onRemoteConfig(e) {
        var t = e.autocaptureExceptions;
        this.remoteEnabled = !!t || !1, this.instance.persistence && this.instance.persistence.register({
            [ue]: this.remoteEnabled
        }), this.startIfEnabled();
    }
    captureException(e) {
        var t = this.instance.requestRouter.endpointFor("ui");
        e.$exception_personURL = "".concat(t, "/project/").concat(this.instance.config.token, "/person/").concat(this.instance.get_distinct_id()), this.instance.exceptions.sendExceptionEvent(e);
    }
}
var Ys = B("[Web Vitals]"), Ks = 9e5;
class Xs {
    constructor(e){
        var t;
        W(this, "_enabledServerSide", !1), W(this, "_initialized", !1), W(this, "buffer", {
            url: void 0,
            metrics: [],
            firstMetricTimestamp: void 0
        }), W(this, "_flushToCapture", ()=>{
            clearTimeout(this._delayedFlushTimer), 0 !== this.buffer.metrics.length && (this.instance.capture("$web_vitals", this.buffer.metrics.reduce((e, t)=>j(j({}, e), {}, {
                    ["$web_vitals_".concat(t.name, "_event")]: j({}, t),
                    ["$web_vitals_".concat(t.name, "_value")]: t.value
                }), {})), this.buffer = {
                url: void 0,
                metrics: [],
                firstMetricTimestamp: void 0
            });
        }), W(this, "_addToBuffer", (e)=>{
            var t, i = null === (t = this.instance.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0);
            if (F(i)) Ys.error("Could not read session ID. Dropping metrics!");
            else {
                this.buffer = this.buffer || {
                    url: void 0,
                    metrics: [],
                    firstMetricTimestamp: void 0
                };
                var n = this._currentURL();
                if (!F(n)) {
                    if (O(null == e ? void 0 : e.name) || O(null == e ? void 0 : e.value)) Ys.error("Invalid metric received", e);
                    else if (this._maxAllowedValue && e.value >= this._maxAllowedValue) Ys.error("Ignoring metric with value >= " + this._maxAllowedValue, e);
                    else this.buffer.url !== n && (this._flushToCapture(), this._delayedFlushTimer = setTimeout(this._flushToCapture, this.flushToCaptureTimeoutMs)), F(this.buffer.url) && (this.buffer.url = n), this.buffer.firstMetricTimestamp = F(this.buffer.firstMetricTimestamp) ? Date.now() : this.buffer.firstMetricTimestamp, e.attribution && e.attribution.interactionTargetElement && (e.attribution.interactionTargetElement = void 0), this.buffer.metrics.push(j(j({}, e), {}, {
                        $current_url: n,
                        $session_id: i.sessionId,
                        $window_id: i.windowId,
                        timestamp: Date.now()
                    })), this.buffer.metrics.length === this.allowedMetrics.length && this._flushToCapture();
                }
            }
        }), W(this, "_startCapturing", ()=>{
            var e, t, i, n, r = _.__PosthogExtensions__;
            F(r) || F(r.postHogWebVitalsCallbacks) || ({ onLCP: e, onCLS: t, onFCP: i, onINP: n } = r.postHogWebVitalsCallbacks), e && t && i && n ? (this.allowedMetrics.indexOf("LCP") > -1 && e(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("CLS") > -1 && t(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("FCP") > -1 && i(this._addToBuffer.bind(this)), this.allowedMetrics.indexOf("INP") > -1 && n(this._addToBuffer.bind(this)), this._initialized = !0) : Ys.error("web vitals callbacks not loaded - not starting");
        }), this.instance = e, this._enabledServerSide = !(null === (t = this.instance.persistence) || void 0 === t || !t.props[ce]), this.startIfEnabled();
    }
    get allowedMetrics() {
        var e, t, i = C(this.instance.config.capture_performance) ? null === (e = this.instance.config.capture_performance) || void 0 === e ? void 0 : e.web_vitals_allowed_metrics : void 0;
        return F(i) ? (null === (t = this.instance.persistence) || void 0 === t ? void 0 : t.props[he]) || [
            "CLS",
            "FCP",
            "INP",
            "LCP"
        ] : i;
    }
    get flushToCaptureTimeoutMs() {
        return (C(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals_delayed_flush_ms : void 0) || 5e3;
    }
    get _maxAllowedValue() {
        var e = C(this.instance.config.capture_performance) && M(this.instance.config.capture_performance.__web_vitals_max_value) ? this.instance.config.capture_performance.__web_vitals_max_value : Ks;
        return 0 < e && e <= 6e4 ? Ks : e;
    }
    get isEnabled() {
        var e = C(this.instance.config.capture_performance) ? this.instance.config.capture_performance.web_vitals : void 0;
        return L(e) ? e : this._enabledServerSide;
    }
    startIfEnabled() {
        this.isEnabled && !this._initialized && (Ys.info("enabled, starting..."), this.loadScript(this._startCapturing));
    }
    onRemoteConfig(e) {
        var t = C(e.capturePerformance) && !!e.capturePerformance.web_vitals, i = C(e.capturePerformance) ? e.capturePerformance.web_vitals_allowed_metrics : void 0;
        this.instance.persistence && (this.instance.persistence.register({
            [ce]: t
        }), this.instance.persistence.register({
            [he]: i
        })), this._enabledServerSide = t, this.startIfEnabled();
    }
    loadScript(e) {
        var t, i, n;
        null !== (t = _.__PosthogExtensions__) && void 0 !== t && t.postHogWebVitalsCallbacks && e(), null === (i = _.__PosthogExtensions__) || void 0 === i || null === (n = i.loadExternalDependency) || void 0 === n || n.call(i, this.instance, "web-vitals", (t)=>{
            t ? Ys.error("failed to load script", t) : e();
        });
    }
    _currentURL() {
        var e = t ? t.location.href : void 0;
        return e || Ys.error("Could not determine current URL"), e;
    }
}
var Qs = {
    icontains: (e, i)=>!!t && i.href.toLowerCase().indexOf(e.toLowerCase()) > -1,
    not_icontains: (e, i)=>!!t && -1 === i.href.toLowerCase().indexOf(e.toLowerCase()),
    regex: (e, i)=>!!t && gt(i.href, e),
    not_regex: (e, i)=>!!t && !gt(i.href, e),
    exact: (e, t)=>t.href === e,
    is_not: (e, t)=>t.href !== e
};
class Zs {
    constructor(e){
        var t = this;
        W(this, "getWebExperimentsAndEvaluateDisplayLogic", function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            t.getWebExperiments((e)=>{
                Zs.logInfo("retrieved web experiments from the server"), t._flagToExperiments = new Map, e.forEach((e)=>{
                    if (e.feature_flag_key) {
                        var i;
                        if (t._flagToExperiments) Zs.logInfo("setting flag key ", e.feature_flag_key, " to web experiment ", e), null === (i = t._flagToExperiments) || void 0 === i || i.set(e.feature_flag_key, e);
                        var n = t.instance.getFeatureFlag(e.feature_flag_key);
                        R(n) && e.variants[n] && t.applyTransforms(e.name, n, e.variants[n].transforms);
                    } else if (e.variants) for(var r in e.variants){
                        var s = e.variants[r];
                        Zs.matchesTestVariant(s) && t.applyTransforms(e.name, r, s.transforms);
                    }
                });
            }, e);
        }), this.instance = e, this.instance.onFeatureFlags((e)=>{
            this.onFeatureFlags(e);
        });
    }
    onFeatureFlags(e) {
        if (this._is_bot()) Zs.logInfo("Refusing to render web experiment since the viewer is a likely bot");
        else if (!this.instance.config.disable_web_experiments) {
            if (O(this._flagToExperiments)) return this._flagToExperiments = new Map, this.loadIfEnabled(), void this.previewWebExperiment();
            Zs.logInfo("applying feature flags", e), e.forEach((e)=>{
                var t;
                if (this._flagToExperiments && null !== (t = this._flagToExperiments) && void 0 !== t && t.has(e)) {
                    var i, n = this.instance.getFeatureFlag(e), r = null === (i = this._flagToExperiments) || void 0 === i ? void 0 : i.get(e);
                    n && null != r && r.variants[n] && this.applyTransforms(r.name, n, r.variants[n].transforms);
                }
            });
        }
    }
    previewWebExperiment() {
        var e = Zs.getWindowLocation();
        if (null != e && e.search) {
            var t = mt(null == e ? void 0 : e.search, "__experiment_id"), i = mt(null == e ? void 0 : e.search, "__experiment_variant");
            t && i && (Zs.logInfo("previewing web experiments ".concat(t, " && ").concat(i)), this.getWebExperiments((e)=>{
                this.showPreviewWebExperiment(parseInt(t), i, e);
            }, !1, !0));
        }
    }
    loadIfEnabled() {
        this.instance.config.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
    }
    getWebExperiments(e, t, i) {
        if (this.instance.config.disable_web_experiments && !i) return e([]);
        var n = this.instance.get_property("$web_experiments");
        if (n && !t) return e(n);
        this.instance._send_request({
            url: this.instance.requestRouter.endpointFor("api", "/api/web_experiments/?token=".concat(this.instance.config.token)),
            method: "GET",
            callback: (t)=>{
                if (200 !== t.statusCode || !t.json) return e([]);
                var i = t.json.experiments || [];
                return e(i);
            }
        });
    }
    showPreviewWebExperiment(e, t, i) {
        var n = i.filter((t)=>t.id === e);
        n && n.length > 0 && (Zs.logInfo("Previewing web experiment [".concat(n[0].name, "] with variant [").concat(t, "]")), this.applyTransforms(n[0].name, t, n[0].variants[t].transforms, !0));
    }
    static matchesTestVariant(e) {
        return !O(e.conditions) && Zs.matchUrlConditions(e) && Zs.matchUTMConditions(e);
    }
    static matchUrlConditions(e) {
        var t;
        if (O(e.conditions) || O(null === (t = e.conditions) || void 0 === t ? void 0 : t.url)) return !0;
        var i, n, r, s = Zs.getWindowLocation();
        return !!s && (null === (i = e.conditions) || void 0 === i || !i.url || Qs[null !== (n = null === (r = e.conditions) || void 0 === r ? void 0 : r.urlMatchType) && void 0 !== n ? n : "icontains"](e.conditions.url, s));
    }
    static getWindowLocation() {
        return null == t ? void 0 : t.location;
    }
    static matchUTMConditions(e) {
        var t;
        if (O(e.conditions) || O(null === (t = e.conditions) || void 0 === t ? void 0 : t.utm)) return !0;
        var i = fi.campaignParams();
        if (i.utm_source) {
            var n, r, s, o, a, l, u, c, d, h, _, p, v, g, f, m, b = null === (n = e.conditions) || void 0 === n || null === (r = n.utm) || void 0 === r || !r.utm_campaign || (null === (s = e.conditions) || void 0 === s || null === (o = s.utm) || void 0 === o ? void 0 : o.utm_campaign) == i.utm_campaign, y = null === (a = e.conditions) || void 0 === a || null === (l = a.utm) || void 0 === l || !l.utm_source || (null === (u = e.conditions) || void 0 === u || null === (c = u.utm) || void 0 === c ? void 0 : c.utm_source) == i.utm_source, w = null === (d = e.conditions) || void 0 === d || null === (h = d.utm) || void 0 === h || !h.utm_medium || (null === (_ = e.conditions) || void 0 === _ || null === (p = _.utm) || void 0 === p ? void 0 : p.utm_medium) == i.utm_medium, S = null === (v = e.conditions) || void 0 === v || null === (g = v.utm) || void 0 === g || !g.utm_term || (null === (f = e.conditions) || void 0 === f || null === (m = f.utm) || void 0 === m ? void 0 : m.utm_term) == i.utm_term;
            return b && w && S && y;
        }
        return !1;
    }
    static logInfo(e) {
        for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)i[n - 1] = arguments[n];
        q.info("[WebExperiments] ".concat(e), i);
    }
    applyTransforms(e, t, i, n) {
        var r;
        this._is_bot() ? Zs.logInfo("Refusing to render web experiment since the viewer is a likely bot") : "control" !== t ? i.forEach((i)=>{
            if (i.selector) {
                var r;
                Zs.logInfo("applying transform of variant ".concat(t, " for experiment ").concat(e, " "), i);
                var s, o = 0, a = null === (r = document) || void 0 === r ? void 0 : r.querySelectorAll(i.selector);
                if (null == a || a.forEach((e)=>{
                    var t = e;
                    o += 1, i.attributes && i.attributes.forEach((e)=>{
                        switch(e.name){
                            case "text":
                                t.innerText = e.value;
                                break;
                            case "html":
                                t.innerHTML = e.value;
                                break;
                            case "cssClass":
                                t.className = e.value;
                                break;
                            default:
                                t.setAttribute(e.name, e.value);
                        }
                    }), i.text && (t.innerText = i.text), i.html && (t.parentElement ? t.parentElement.innerHTML = i.html : t.innerHTML = i.html), i.css && t.setAttribute("style", i.css);
                }), this.instance && this.instance.capture) this.instance.capture("$web_experiment_applied", {
                    $web_experiment_name: e,
                    $web_experiment_variant: t,
                    $web_experiment_preview: n,
                    $web_experiment_document_url: null === (s = Zs.getWindowLocation()) || void 0 === s ? void 0 : s.href,
                    $web_experiment_elements_modified: o
                });
            }
        }) : (Zs.logInfo("Control variants leave the page unmodified."), this.instance && this.instance.capture && this.instance.capture("$web_experiment_applied", {
            $web_experiment_name: e,
            $web_experiment_preview: n,
            $web_experiment_variant: t,
            $web_experiment_document_url: null === (r = Zs.getWindowLocation()) || void 0 === r ? void 0 : r.href,
            $web_experiment_elements_modified: 0
        }));
    }
    _is_bot() {
        return o && this.instance ? Cs(o, this.instance.config.custom_blocked_useragents) : void 0;
    }
}
class eo {
    constructor(e){
        this.instance = e;
    }
    sendExceptionEvent(e) {
        this.instance.capture("$exception", e, {
            _noTruncate: !0,
            _batchKey: "exceptionEvent"
        });
    }
}
var to = [
    "$set_once",
    "$set"
], io = B("[SiteApps]");
class no {
    constructor(e){
        this.instance = e, this.bufferedInvocations = [], this.apps = {};
    }
    get isEnabled() {
        return !!this.instance.config.opt_in_site_apps;
    }
    eventCollector(e, t) {
        if (t) {
            var i = this.globalsForEvent(t);
            this.bufferedInvocations.push(i), this.bufferedInvocations.length > 1e3 && (this.bufferedInvocations = this.bufferedInvocations.slice(10));
        }
    }
    get siteAppLoaders() {
        var e, t;
        return null === (e = _._POSTHOG_REMOTE_CONFIG) || void 0 === e || null === (t = e[this.instance.config.token]) || void 0 === t ? void 0 : t.siteApps;
    }
    init() {
        if (this.isEnabled) {
            var e = this.instance._addCaptureHook(this.eventCollector.bind(this));
            this.stopBuffering = ()=>{
                e(), this.bufferedInvocations = [], this.stopBuffering = void 0;
            };
        }
    }
    globalsForEvent(e) {
        var t, i, n, r, s, o, a;
        if (!e) throw new Error("Event payload is required");
        var l = {}, u = this.instance.get_property("$groups") || [], c = this.instance.get_property("$stored_group_properties") || {};
        for (var [d, h] of Object.entries(c))l[d] = {
            id: u[d],
            type: d,
            properties: h
        };
        var { $set_once: _, $set: p } = e;
        return {
            event: j(j({}, V(e, to)), {}, {
                properties: j(j(j({}, e.properties), p ? {
                    $set: j(j({}, null !== (t = null === (i = e.properties) || void 0 === i ? void 0 : i.$set) && void 0 !== t ? t : {}), p)
                } : {}), _ ? {
                    $set_once: j(j({}, null !== (n = null === (r = e.properties) || void 0 === r ? void 0 : r.$set_once) && void 0 !== n ? n : {}), _)
                } : {}),
                elements_chain: null !== (s = null === (o = e.properties) || void 0 === o ? void 0 : o.$elements_chain) && void 0 !== s ? s : "",
                distinct_id: null === (a = e.properties) || void 0 === a ? void 0 : a.distinct_id
            }),
            person: {
                properties: this.instance.get_property("$stored_person_properties")
            },
            groups: l
        };
    }
    setupSiteApp(e) {
        var t = {
            id: e.id,
            loaded: !1,
            errored: !1
        };
        this.apps[e.id] = t;
        var i = (i)=>{
            var n;
            for (var r of (this.apps[e.id].errored = !i, this.apps[e.id].loaded = !0, io.info("Site app with id ".concat(e.id, " ").concat(i ? "loaded" : "errored")), i && this.bufferedInvocations.length && (io.info("Processing ".concat(this.bufferedInvocations.length, " events for site app with id ").concat(e.id)), this.bufferedInvocations.forEach((e)=>{
                var i;
                return null === (i = t.processEvent) || void 0 === i ? void 0 : i.call(t, e);
            })), Object.values(this.apps)))if (!r.loaded) return;
            null === (n = this.stopBuffering) || void 0 === n || n.call(this);
        };
        try {
            var { processEvent: n } = e.init({
                posthog: this.instance,
                callback: (e)=>{
                    i(e);
                }
            });
            n && (t.processEvent = n);
        } catch (t) {
            io.error("Error while initializing PostHog app with config id ".concat(e.id), t), i(!1);
        }
    }
    onCapturedEvent(e) {
        if (0 !== Object.keys(this.apps).length) {
            var t = this.globalsForEvent(e);
            for (var i of Object.values(this.apps))try {
                var n;
                null === (n = i.processEvent) || void 0 === n || n.call(i, t);
            } catch (t) {
                io.error("Error while processing event ".concat(e.event, " for site app ").concat(i.id), t);
            }
        }
    }
    onRemoteConfig(e) {
        var t, i, n, r = this;
        if (null !== (t = this.siteAppLoaders) && void 0 !== t && t.length) {
            if (!this.isEnabled) return void io.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
            for (var s of this.siteAppLoaders)this.setupSiteApp(s);
            this.instance.on("eventCaptured", (e)=>this.onCapturedEvent(e));
        } else if (null === (i = this.stopBuffering) || void 0 === i || i.call(this), null !== (n = e.siteApps) && void 0 !== n && n.length) {
            if (this.isEnabled) {
                var o = function(e, t) {
                    var i, n;
                    _["__$$ph_site_app_".concat(e)] = r.instance, null === (i = _.__PosthogExtensions__) || void 0 === i || null === (n = i.loadSiteApp) || void 0 === n || n.call(i, r.instance, t, (t)=>{
                        if (t) return io.error("Error while initializing PostHog app with config id ".concat(e), t);
                    });
                };
                for (var { id: a, url: l } of e.siteApps)o(a, l);
            } else io.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
        }
    }
}
var ro = {}, so = ()=>{}, oo = "posthog", ao = !hr && -1 === (null == h ? void 0 : h.indexOf("MSIE")) && -1 === (null == h ? void 0 : h.indexOf("Mozilla")), lo = ()=>{
    var e, i, n;
    return {
        api_host: "https://us.i.posthog.com",
        ui_host: null,
        token: "",
        autocapture: !0,
        rageclick: !0,
        cross_subdomain_cookie: (i = null == a ? void 0 : a.location, n = null == i ? void 0 : i.hostname, !!R(n) && "herokuapp.com" !== n.split(".").slice(-2).join(".")),
        persistence: "localStorage+cookie",
        persistence_name: "",
        loaded: so,
        store_google: !0,
        custom_campaign_params: [],
        custom_blocked_useragents: [],
        save_referrer: !0,
        capture_pageview: !0,
        capture_pageleave: "if_capture_pageview",
        debug: l && R(null == l ? void 0 : l.search) && -1 !== l.search.indexOf("__posthog_debug=true") || !1,
        verbose: !1,
        cookie_expiration: 365,
        upgrade: !1,
        disable_session_recording: !1,
        disable_persistence: !1,
        disable_web_experiments: !0,
        disable_surveys: !1,
        enable_recording_console_log: void 0,
        secure_cookie: "https:" === (null == t || null === (e = t.location) || void 0 === e ? void 0 : e.protocol),
        ip: !0,
        opt_out_capturing_by_default: !1,
        opt_out_persistence_by_default: !1,
        opt_out_useragent_filter: !1,
        opt_out_capturing_persistence_type: "localStorage",
        opt_out_capturing_cookie_prefix: null,
        opt_in_site_apps: !1,
        property_denylist: [],
        respect_dnt: !1,
        sanitize_properties: null,
        request_headers: {},
        inapp_protocol: "//",
        inapp_link_new_window: !1,
        request_batching: !0,
        properties_string_max_length: 65535,
        session_recording: {},
        mask_all_element_attributes: !1,
        mask_all_text: !1,
        advanced_disable_decide: !1,
        advanced_disable_feature_flags: !1,
        advanced_disable_feature_flags_on_first_load: !1,
        advanced_disable_toolbar_metrics: !1,
        feature_flag_request_timeout_ms: 3e3,
        on_request_error: (e)=>{
            var t = "Bad HTTP status: " + e.statusCode + " " + e.text;
            q.error(t);
        },
        get_device_id: (e)=>e,
        _onCapture: so,
        capture_performance: void 0,
        name: "posthog",
        bootstrap: {},
        disable_compression: !1,
        session_idle_timeout_seconds: 1800,
        person_profiles: "identified_only",
        __add_tracing_headers: !1,
        before_send: void 0
    };
}, uo = (e)=>{
    var t = {};
    F(e.process_person) || (t.person_profiles = e.process_person), F(e.xhr_headers) || (t.request_headers = e.xhr_headers), F(e.cookie_name) || (t.persistence_name = e.cookie_name), F(e.disable_cookie) || (t.disable_persistence = e.disable_cookie);
    var i = K({}, t, e);
    return x(e.property_blacklist) && (F(e.property_denylist) ? i.property_denylist = e.property_blacklist : x(e.property_denylist) ? i.property_denylist = [
        ...e.property_blacklist,
        ...e.property_denylist
    ] : q.error("Invalid value for property_denylist config: " + e.property_denylist)), i;
};
class co {
    constructor(){
        W(this, "__forceAllowLocalhost", !1);
    }
    get _forceAllowLocalhost() {
        return this.__forceAllowLocalhost;
    }
    set _forceAllowLocalhost(e) {
        q.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = e;
    }
}
class ho {
    get decideEndpointWasHit() {
        var e, t;
        return null !== (e = null === (t = this.featureFlags) || void 0 === t ? void 0 : t.hasLoadedFlags) && void 0 !== e && e;
    }
    constructor(){
        W(this, "webPerformance", new co), W(this, "version", p.LIB_VERSION), W(this, "_internalEventEmitter", new Mr), this.config = lo(), this.SentryIntegration = Cr, this.sentryIntegration = (e)=>(function(e, t) {
                var i = Ir(e, t);
                return {
                    name: xr,
                    processEvent: (e)=>i(e)
                };
            })(this, e), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this._initialPageviewCaptured = !1, this._initialPersonProfilesConfig = null, this.featureFlags = new Ve(this), this.toolbar = new ur(this), this.scrollManager = new As(this), this.pageViewManager = new Or(this), this.surveys = new ys(this), this.experiments = new Zs(this), this.exceptions = new eo(this), this.rateLimiter = new Ss(this), this.requestRouter = new kr(this), this.consent = new Vs(this), this.people = {
            set: (e, t, i)=>{
                var n = R(e) ? {
                    [e]: t
                } : e;
                this.setPersonProperties(n), null == i || i({});
            },
            set_once: (e, t, i)=>{
                var n = R(e) ? {
                    [e]: t
                } : e;
                this.setPersonProperties(void 0, n), null == i || i({});
            }
        }, this.on("eventCaptured", (e)=>q.info('send "'.concat(null == e ? void 0 : e.event, '"'), e));
    }
    init(e, t, i) {
        if (i && i !== oo) {
            var n, r = null !== (n = ro[i]) && void 0 !== n ? n : new ho;
            return r._init(e, t, i), ro[i] = r, ro[oo][i] = r, r;
        }
        return this._init(e, t, i);
    }
    _init(i) {
        var n, r, s, o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = arguments.length > 2 ? arguments[2] : void 0;
        if (F(i) || T(i)) return q.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
        if (this.__loaded) return q.warn("You have already initialized PostHog! Re-initializing is a no-op"), this;
        this.__loaded = !0, this.config = {}, this._triggered_notifs = [], o.person_profiles && (this._initialPersonProfilesConfig = o.person_profiles), this.set_config(K({}, lo(), uo(o), {
            name: a,
            token: i
        })), this.config.on_xhr_error && q.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = o.disable_compression ? void 0 : e.GZipJS, this.persistence = new bi(this.config), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new bi(j(j({}, this.config), {}, {
            persistence: "sessionStorage"
        }));
        var l = j({}, this.persistence.props), u = j({}, this.sessionPersistence.props);
        if (this._requestQueue = new cr((e)=>this._send_retriable_request(e)), this._retryQueue = new br(this), this.__request_queue = [], this.config.__preview_experimental_cookieless_mode || (this.sessionManager = new Sr(this), this.sessionPropsManager = new ks(this.sessionManager, this.persistence)), new js(this).startIfEnabledOrStop(), this.siteApps = new no(this), null === (n = this.siteApps) || void 0 === n || n.init(), this.config.__preview_experimental_cookieless_mode || (this.sessionRecording = new ir(this), this.sessionRecording.startIfEnabledOrStop()), this.config.disable_scroll_properties || this.scrollManager.startMeasuringScrollPosition(), this.autocapture = new Us(this), this.autocapture.startIfEnabled(), this.surveys.loadIfEnabled(), this.heatmaps = new Ls(this), this.heatmaps.startIfEnabled(), this.webVitalsAutocapture = new Xs(this), this.exceptionObserver = new Js(this), this.exceptionObserver.startIfEnabled(), this.deadClicksAutocapture = new $s(this, Ts), this.deadClicksAutocapture.startIfEnabled(), p.DEBUG = p.DEBUG || this.config.debug, p.DEBUG && q.info("Starting in debug mode", {
            this: this,
            config: o,
            thisC: j({}, this.config),
            p: l,
            s: u
        }), this._sync_opt_out_with_persistence(), void 0 !== (null === (r = o.bootstrap) || void 0 === r ? void 0 : r.distinctID)) {
            var c, d, h = this.config.get_device_id(Ze()), _ = null !== (c = o.bootstrap) && void 0 !== c && c.isIdentifiedID ? h : o.bootstrap.distinctID;
            this.persistence.set_property(Te, null !== (d = o.bootstrap) && void 0 !== d && d.isIdentifiedID ? "identified" : "anonymous"), this.register({
                distinct_id: o.bootstrap.distinctID,
                $device_id: _
            });
        }
        if (this._hasBootstrappedFeatureFlags()) {
            var v, g, f = Object.keys((null === (v = o.bootstrap) || void 0 === v ? void 0 : v.featureFlags) || {}).filter((e)=>{
                var t, i;
                return !(null === (t = o.bootstrap) || void 0 === t || null === (i = t.featureFlags) || void 0 === i || !i[e]);
            }).reduce((e, t)=>{
                var i, n;
                return e[t] = (null === (i = o.bootstrap) || void 0 === i || null === (n = i.featureFlags) || void 0 === n ? void 0 : n[t]) || !1, e;
            }, {}), m = Object.keys((null === (g = o.bootstrap) || void 0 === g ? void 0 : g.featureFlagPayloads) || {}).filter((e)=>f[e]).reduce((e, t)=>{
                var i, n, r, s;
                null !== (i = o.bootstrap) && void 0 !== i && null !== (n = i.featureFlagPayloads) && void 0 !== n && n[t] && (e[t] = null === (r = o.bootstrap) || void 0 === r || null === (s = r.featureFlagPayloads) || void 0 === s ? void 0 : s[t]);
                return e;
            }, {});
            this.featureFlags.receivedFeatureFlags({
                featureFlags: f,
                featureFlagPayloads: m
            });
        }
        if (this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: qe,
            $device_id: null
        }, "");
        else if (!this.get_distinct_id()) {
            var b = this.config.get_device_id(Ze());
            this.register_once({
                distinct_id: b,
                $device_id: b
            }, ""), this.persistence.set_property(Te, "anonymous");
        }
        return null == t || null === (s = t.addEventListener) || void 0 === s || s.call(t, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this)), this.toolbar.maybeLoadToolbar(), o.segment ? $r(this, ()=>this._loaded()) : this._loaded(), I(this.config._onCapture) && this.config._onCapture !== so && (q.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (e)=>this.config._onCapture(e.event, e))), this;
    }
    _onRemoteConfig(t) {
        var i, n, r, s, o, l, u, c, d;
        if (!a || !a.body) return q.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(()=>{
            this._onRemoteConfig(t);
        }, 500);
        this.compression = void 0, t.supportedCompression && !this.config.disable_compression && (this.compression = m(t.supportedCompression, e.GZipJS) ? e.GZipJS : m(t.supportedCompression, e.Base64) ? e.Base64 : void 0), null !== (i = t.analytics) && void 0 !== i && i.endpoint && (this.analyticsDefaultEndpoint = t.analytics.endpoint), this.set_config({
            person_profiles: this._initialPersonProfilesConfig ? this._initialPersonProfilesConfig : t.defaultIdentifiedOnly ? "identified_only" : "always"
        }), null === (n = this.siteApps) || void 0 === n || n.onRemoteConfig(t), null === (r = this.sessionRecording) || void 0 === r || r.onRemoteConfig(t), null === (s = this.autocapture) || void 0 === s || s.onRemoteConfig(t), null === (o = this.heatmaps) || void 0 === o || o.onRemoteConfig(t), null === (l = this.surveys) || void 0 === l || l.onRemoteConfig(t), null === (u = this.webVitalsAutocapture) || void 0 === u || u.onRemoteConfig(t), null === (c = this.exceptionObserver) || void 0 === c || c.onRemoteConfig(t), null === (d = this.deadClicksAutocapture) || void 0 === d || d.onRemoteConfig(t);
    }
    _loaded() {
        try {
            this.config.loaded(this);
        } catch (e) {
            q.critical("`loaded` function failed", e);
        }
        this._start_queue_if_opted_in(), this.config.capture_pageview && setTimeout(()=>{
            this.consent.isOptedIn() && this._captureInitialPageview();
        }, 1), new rr(this).load(), this.featureFlags.decide();
    }
    _start_queue_if_opted_in() {
        var e;
        this.has_opted_out_capturing() || this.config.request_batching && (null === (e = this._requestQueue) || void 0 === e || e.enable());
    }
    _dom_loaded() {
        this.has_opted_out_capturing() || J(this.__request_queue, (e)=>this._send_retriable_request(e)), this.__request_queue = [], this._start_queue_if_opted_in();
    }
    _handle_unload() {
        var e, t;
        this.config.request_batching ? (this._shouldCapturePageleave() && this.capture("$pageleave"), null === (e = this._requestQueue) || void 0 === e || e.unload(), null === (t = this._retryQueue) || void 0 === t || t.unload()) : this._shouldCapturePageleave() && this.capture("$pageleave", null, {
            transport: "sendBeacon"
        });
    }
    _send_request(e) {
        this.__loaded && (ao ? this.__request_queue.push(e) : this.rateLimiter.isServerRateLimited(e.batchKey) || (e.transport = e.transport || this.config.api_transport, e.url = pr(e.url, {
            ip: this.config.ip ? 1 : 0
        }), e.headers = j({}, this.config.request_headers), e.compression = "best-available" === e.compression ? this.compression : e.compression, e.fetchOptions = e.fetchOptions || this.config.fetch_options, ((e)=>{
            var t, i, n, r = j({}, e);
            r.timeout = r.timeout || 6e4, r.url = pr(r.url, {
                _: (new Date).getTime().toString(),
                ver: p.LIB_VERSION,
                compression: r.compression
            });
            var s = null !== (t = r.transport) && void 0 !== t ? t : "fetch", o = null !== (i = null === (n = ne(fr, (e)=>e.transport === s)) || void 0 === n ? void 0 : n.method) && void 0 !== i ? i : fr[0].method;
            if (!o) throw new Error("No available transport method");
            o(r);
        })(j(j({}, e), {}, {
            callback: (t)=>{
                var i, n, r;
                (this.rateLimiter.checkForLimiting(t), t.statusCode >= 400) && (null === (n = (r = this.config).on_request_error) || void 0 === n || n.call(r, t));
                null === (i = e.callback) || void 0 === i || i.call(e, t);
            }
        }))));
    }
    _send_retriable_request(e) {
        this._retryQueue ? this._retryQueue.retriableRequest(e) : this._send_request(e);
    }
    _execute_array(e) {
        var t, i = [], n = [], r = [];
        J(e, (e)=>{
            e && (t = e[0], x(t) ? r.push(e) : I(e) ? e.call(this) : x(e) && "alias" === t ? i.push(e) : x(e) && -1 !== t.indexOf("capture") && I(this[t]) ? r.push(e) : n.push(e));
        });
        var s = function(e, t) {
            J(e, function(e) {
                if (x(e[0])) {
                    var i = t;
                    Y(e, function(e) {
                        i = i[e[0]].apply(i, e.slice(1));
                    });
                } else this[e[0]].apply(this, e.slice(1));
            }, t);
        };
        s(i, this), s(n, this), s(r, this);
    }
    _hasBootstrappedFeatureFlags() {
        var e, t;
        return (null === (e = this.config.bootstrap) || void 0 === e ? void 0 : e.featureFlags) && Object.keys(null === (t = this.config.bootstrap) || void 0 === t ? void 0 : t.featureFlags).length > 0 || !1;
    }
    push(e) {
        this._execute_array([
            e
        ]);
    }
    capture(e, t, i) {
        var n;
        if (this.__loaded && this.persistence && this.sessionPersistence && this._requestQueue) {
            if (!this.consent.isOptedOut()) {
                if (!F(e) && R(e)) {
                    if (this.config.opt_out_useragent_filter || !this._is_bot()) {
                        var r = null != i && i.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
                        if (null == r || !r.isRateLimited) {
                            this.sessionPersistence.update_search_keyword(), this.config.store_google && this.sessionPersistence.update_campaign_params(), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.store_google || this.config.save_referrer) && this.persistence.set_initial_person_info();
                            var s = new Date, o = (null == i ? void 0 : i.timestamp) || s, a = Ze(), l = {
                                uuid: a,
                                event: e,
                                properties: this._calculate_event_properties(e, t || {}, o, a)
                            };
                            r && (l.properties.$lib_rate_limit_remaining_tokens = r.remainingTokens), (null == i ? void 0 : i.$set) && (l.$set = null == i ? void 0 : i.$set);
                            var u = this._calculate_set_once_properties(null == i ? void 0 : i.$set_once);
                            u && (l.$set_once = u), (l = te(l, null != i && i._noTruncate ? null : this.config.properties_string_max_length)).timestamp = o, F(null == i ? void 0 : i.timestamp) || (l.properties.$event_time_override_provided = !0, l.properties.$event_time_override_system_time = s);
                            var c = j(j({}, l.properties.$set), l.$set);
                            if (P(c) || this.setPersonPropertiesForFlags(c), !O(this.config.before_send)) {
                                var d = this._runBeforeSend(l);
                                if (!d) return;
                                l = d;
                            }
                            this._internalEventEmitter.emit("eventCaptured", l);
                            var h = {
                                method: "POST",
                                url: null !== (n = null == i ? void 0 : i._url) && void 0 !== n ? n : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint),
                                data: l,
                                compression: "best-available",
                                batchKey: null == i ? void 0 : i._batchKey
                            };
                            return !this.config.request_batching || i && (null == i || !i._batchKey) || null != i && i.send_instantly ? this._send_retriable_request(h) : this._requestQueue.enqueue(h), l;
                        }
                        q.critical("This capture call is ignored due to client rate limiting.");
                    }
                } else q.error("No event name provided to posthog.capture");
            }
        } else q.uninitializedWarning("posthog.capture");
    }
    _addCaptureHook(e) {
        return this.on("eventCaptured", (t)=>e(t.event, t));
    }
    _calculate_event_properties(e, t, i, n) {
        if (i = i || new Date, !this.persistence || !this.sessionPersistence) return t;
        var r = this.persistence.remove_event_timer(e), s = j({}, t);
        if (s.token = this.config.token, this.config.__preview_experimental_cookieless_mode && (s.$cookieless_mode = !0), "$snapshot" === e) {
            var o = j(j({}, this.persistence.properties()), this.sessionPersistence.properties());
            return s.distinct_id = o.distinct_id, (!R(s.distinct_id) && !M(s.distinct_id) || T(s.distinct_id)) && q.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), s;
        }
        var l, u = fi.properties();
        if (this.sessionManager) {
            var { sessionId: c, windowId: d } = this.sessionManager.checkAndGetSessionAndWindowId();
            s.$session_id = c, s.$window_id = d;
        }
        if (this.sessionRecording && (s.$recording_status = this.sessionRecording.status), this.requestRouter.region === yr.CUSTOM && (s.$lib_custom_api_host = this.config.api_host), this.sessionPropsManager && this.config.__preview_send_client_session_params && ("$pageview" === e || "$pageleave" === e || "$autocapture" === e)) {
            var _ = this.sessionPropsManager.getSessionProps();
            s = K(s, _);
        }
        if (l = "$pageview" === e ? this.pageViewManager.doPageView(i, n) : "$pageleave" === e ? this.pageViewManager.doPageLeave(i) : this.pageViewManager.doEvent(), s = K(s, l), "$pageview" === e && a && (s.title = a.title), !F(r)) {
            var p = i.getTime() - r;
            s.$duration = parseFloat((p / 1e3).toFixed(3));
        }
        h && this.config.opt_out_useragent_filter && (s.$browser_type = this._is_bot() ? "bot" : "browser"), (s = K({}, u, this.persistence.properties(), this.sessionPersistence.properties(), s)).$is_identified = this._isIdentified(), x(this.config.property_denylist) ? Y(this.config.property_denylist, function(e) {
            delete s[e];
        }) : q.error("Invalid value for property_denylist config: " + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
        var v = this.config.sanitize_properties;
        v && (q.error("sanitize_properties is deprecated. Use before_send instead"), s = v(s, e));
        var g = this._hasPersonProcessing();
        return s.$process_person_profile = g, g && this._requirePersonProcessing("_calculate_event_properties"), s;
    }
    _calculate_set_once_properties(e) {
        if (!this.persistence || !this._hasPersonProcessing()) return e;
        var t = K({}, this.persistence.get_initial_props(), e || {}), i = this.config.sanitize_properties;
        return i && (q.error("sanitize_properties is deprecated. Use before_send instead"), t = i(t, "$set_once")), P(t) ? void 0 : t;
    }
    register(e, t) {
        var i;
        null === (i = this.persistence) || void 0 === i || i.register(e, t);
    }
    register_once(e, t, i) {
        var n;
        null === (n = this.persistence) || void 0 === n || n.register_once(e, t, i);
    }
    register_for_session(e) {
        var t;
        null === (t = this.sessionPersistence) || void 0 === t || t.register(e);
    }
    unregister(e) {
        var t;
        null === (t = this.persistence) || void 0 === t || t.unregister(e);
    }
    unregister_for_session(e) {
        var t;
        null === (t = this.sessionPersistence) || void 0 === t || t.unregister(e);
    }
    _register_single(e, t) {
        this.register({
            [e]: t
        });
    }
    getFeatureFlag(e, t) {
        return this.featureFlags.getFeatureFlag(e, t);
    }
    getFeatureFlagPayload(e) {
        var t = this.featureFlags.getFeatureFlagPayload(e);
        try {
            return JSON.parse(t);
        } catch (e) {
            return t;
        }
    }
    isFeatureEnabled(e, t) {
        return this.featureFlags.isFeatureEnabled(e, t);
    }
    reloadFeatureFlags() {
        this.featureFlags.reloadFeatureFlags();
    }
    updateEarlyAccessFeatureEnrollment(e, t) {
        this.featureFlags.updateEarlyAccessFeatureEnrollment(e, t);
    }
    getEarlyAccessFeatures(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return this.featureFlags.getEarlyAccessFeatures(e, t);
    }
    on(e, t) {
        return this._internalEventEmitter.on(e, t);
    }
    onFeatureFlags(e) {
        return this.featureFlags.onFeatureFlags(e);
    }
    onSessionId(e) {
        var t, i;
        return null !== (t = null === (i = this.sessionManager) || void 0 === i ? void 0 : i.onSessionId(e)) && void 0 !== t ? t : ()=>{};
    }
    getSurveys(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        this.surveys.getSurveys(e, t);
    }
    getActiveMatchingSurveys(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        this.surveys.getActiveMatchingSurveys(e, t);
    }
    renderSurvey(e, t) {
        this.surveys.renderSurvey(e, t);
    }
    canRenderSurvey(e) {
        this.surveys.canRenderSurvey(e);
    }
    getNextSurveyStep(e, t, i) {
        return this.surveys.getNextSurveyStep(e, t, i);
    }
    identify(e, t, i) {
        if (!this.__loaded || !this.persistence) return q.uninitializedWarning("posthog.identify");
        if (M(e) && (e = e.toString(), q.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), e) {
            if ([
                "distinct_id",
                "distinctid"
            ].includes(e.toLowerCase())) q.critical('The string "'.concat(e, '" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.'));
            else if (this._requirePersonProcessing("posthog.identify")) {
                var n = this.get_distinct_id();
                if (this.register({
                    $user_id: e
                }), !this.get_property("$device_id")) {
                    var r = n;
                    this.register_once({
                        $had_persisted_distinct_id: !0,
                        $device_id: r
                    }, "");
                }
                e !== n && e !== this.get_property(se) && (this.unregister(se), this.register({
                    distinct_id: e
                }));
                var s = "anonymous" === (this.persistence.get_property(Te) || "anonymous");
                e !== n && s ? (this.persistence.set_property(Te, "identified"), this.setPersonPropertiesForFlags(t || {}, !1), this.capture("$identify", {
                    distinct_id: e,
                    $anon_distinct_id: n
                }, {
                    $set: t || {},
                    $set_once: i || {}
                }), this.featureFlags.setAnonymousDistinctId(n)) : (t || i) && this.setPersonProperties(t, i), e !== n && (this.reloadFeatureFlags(), this.unregister(Re));
            }
        } else q.error("Unique user id has not been set in posthog.identify");
    }
    setPersonProperties(e, t) {
        (e || t) && this._requirePersonProcessing("posthog.setPersonProperties") && (this.setPersonPropertiesForFlags(e || {}), this.capture("$set", {
            $set: e || {},
            $set_once: t || {}
        }));
    }
    group(e, t, i) {
        if (e && t) {
            if (this._requirePersonProcessing("posthog.group")) {
                var n = this.getGroups();
                n[e] !== t && this.resetGroupPropertiesForFlags(e), this.register({
                    $groups: j(j({}, n), {}, {
                        [e]: t
                    })
                }), i && (this.capture("$groupidentify", {
                    $group_type: e,
                    $group_key: t,
                    $group_set: i
                }), this.setGroupPropertiesForFlags({
                    [e]: i
                })), n[e] === t || i || this.reloadFeatureFlags();
            }
        } else q.error("posthog.group requires a group type and group key");
    }
    resetGroups() {
        this.register({
            $groups: {}
        }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
    }
    setPersonPropertiesForFlags(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        this.featureFlags.setPersonPropertiesForFlags(e, t);
    }
    resetPersonPropertiesForFlags() {
        this.featureFlags.resetPersonPropertiesForFlags();
    }
    setGroupPropertiesForFlags(e) {
        var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
        this._requirePersonProcessing("posthog.setGroupPropertiesForFlags") && this.featureFlags.setGroupPropertiesForFlags(e, t);
    }
    resetGroupPropertiesForFlags(e) {
        this.featureFlags.resetGroupPropertiesForFlags(e);
    }
    reset(e) {
        var t, i, n, r, s;
        if (q.info("reset"), !this.__loaded) return q.uninitializedWarning("posthog.reset");
        var o = this.get_property("$device_id");
        if (this.consent.reset(), null === (t = this.persistence) || void 0 === t || t.clear(), null === (i = this.sessionPersistence) || void 0 === i || i.clear(), null === (n = this.surveys) || void 0 === n || n.reset(), null === (r = this.persistence) || void 0 === r || r.set_property(Te, "anonymous"), null === (s = this.sessionManager) || void 0 === s || s.resetSessionId(), this.config.__preview_experimental_cookieless_mode) this.register_once({
            distinct_id: qe,
            $device_id: null
        }, "");
        else {
            var a = this.config.get_device_id(Ze());
            this.register_once({
                distinct_id: a,
                $device_id: e ? a : o
            }, "");
        }
    }
    get_distinct_id() {
        return this.get_property("distinct_id");
    }
    getGroups() {
        return this.get_property("$groups") || {};
    }
    get_session_id() {
        var e, t;
        return null !== (e = null === (t = this.sessionManager) || void 0 === t ? void 0 : t.checkAndGetSessionAndWindowId(!0).sessionId) && void 0 !== e ? e : "";
    }
    get_session_replay_url(e) {
        if (!this.sessionManager) return "";
        var { sessionId: t, sessionStartTimestamp: i } = this.sessionManager.checkAndGetSessionAndWindowId(!0), n = this.requestRouter.endpointFor("ui", "/project/".concat(this.config.token, "/replay/").concat(t));
        if (null != e && e.withTimestamp && i) {
            var r, s = null !== (r = e.timestampLookBack) && void 0 !== r ? r : 10;
            if (!i) return n;
            var o = Math.max(Math.floor(((new Date).getTime() - i) / 1e3) - s, 0);
            n += "?t=".concat(o);
        }
        return n;
    }
    alias(e, t) {
        return e === this.get_property(re) ? (q.critical("Attempting to create alias for existing People user - aborting."), -2) : this._requirePersonProcessing("posthog.alias") ? (F(t) && (t = this.get_distinct_id()), e !== t ? (this._register_single(se, e), this.capture("$create_alias", {
            alias: e,
            distinct_id: t
        })) : (q.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1)) : void 0;
    }
    set_config(e) {
        var t, i, n, r, s = j({}, this.config);
        C(e) && (K(this.config, uo(e)), null === (t = this.persistence) || void 0 === t || t.update_config(this.config, s), this.sessionPersistence = "sessionStorage" === this.config.persistence || "memory" === this.config.persistence ? this.persistence : new bi(j(j({}, this.config), {}, {
            persistence: "sessionStorage"
        })), at.is_supported() && "true" === at.get("ph_debug") && (this.config.debug = !0), this.config.debug && (p.DEBUG = !0, q.info("set_config", {
            config: e,
            oldConfig: s,
            newConfig: j({}, this.config)
        })), null === (i = this.sessionRecording) || void 0 === i || i.startIfEnabledOrStop(), null === (n = this.autocapture) || void 0 === n || n.startIfEnabled(), null === (r = this.heatmaps) || void 0 === r || r.startIfEnabled(), this.surveys.loadIfEnabled(), this._sync_opt_out_with_persistence());
    }
    startSessionRecording(e) {
        var t = !0 === e, i = {
            sampling: t || !(null == e || !e.sampling),
            linked_flag: t || !(null == e || !e.linked_flag),
            url_trigger: t || !(null == e || !e.url_trigger),
            event_trigger: t || !(null == e || !e.event_trigger)
        };
        if (Object.values(i).some(Boolean)) {
            var n, r, s, o, a;
            if (null === (n = this.sessionManager) || void 0 === n || n.checkAndGetSessionAndWindowId(), i.sampling) null === (r = this.sessionRecording) || void 0 === r || r.overrideSampling();
            if (i.linked_flag) null === (s = this.sessionRecording) || void 0 === s || s.overrideLinkedFlag();
            if (i.url_trigger) null === (o = this.sessionRecording) || void 0 === o || o.overrideTrigger("url");
            if (i.event_trigger) null === (a = this.sessionRecording) || void 0 === a || a.overrideTrigger("event");
        }
        this.set_config({
            disable_session_recording: !1
        });
    }
    stopSessionRecording() {
        this.set_config({
            disable_session_recording: !0
        });
    }
    sessionRecordingStarted() {
        var e;
        return !(null === (e = this.sessionRecording) || void 0 === e || !e.started);
    }
    captureException(e, t) {
        var i, n = new Error("PostHog syntheticException"), r = I(null === (i = _.__PosthogExtensions__) || void 0 === i ? void 0 : i.parseErrorAsProperties) ? _.__PosthogExtensions__.parseErrorAsProperties([
            e.message,
            void 0,
            void 0,
            void 0,
            e
        ], {
            syntheticException: n
        }) : j({
            $exception_level: "error",
            $exception_list: [
                {
                    type: e.name,
                    value: e.message,
                    mechanism: {
                        handled: !0,
                        synthetic: !1
                    }
                }
            ]
        }, t);
        this.exceptions.sendExceptionEvent(r);
    }
    loadToolbar(e) {
        return this.toolbar.loadToolbar(e);
    }
    get_property(e) {
        var t;
        return null === (t = this.persistence) || void 0 === t ? void 0 : t.props[e];
    }
    getSessionProperty(e) {
        var t;
        return null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.props[e];
    }
    toString() {
        var e, t = null !== (e = this.config.name) && void 0 !== e ? e : oo;
        return t !== oo && (t = oo + "." + t), t;
    }
    _isIdentified() {
        var e, t;
        return "identified" === (null === (e = this.persistence) || void 0 === e ? void 0 : e.get_property(Te)) || "identified" === (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.get_property(Te));
    }
    _hasPersonProcessing() {
        var e, t, i, n;
        return !("never" === this.config.person_profiles || "identified_only" === this.config.person_profiles && !this._isIdentified() && P(this.getGroups()) && (null === (e = this.persistence) || void 0 === e || null === (t = e.props) || void 0 === t || !t[se]) && (null === (i = this.persistence) || void 0 === i || null === (n = i.props) || void 0 === n || !n[De]));
    }
    _shouldCapturePageleave() {
        return !0 === this.config.capture_pageleave || "if_capture_pageview" === this.config.capture_pageleave && this.config.capture_pageview;
    }
    createPersonProfile() {
        this._hasPersonProcessing() || this._requirePersonProcessing("posthog.createPersonProfile") && this.setPersonProperties({}, {});
    }
    _requirePersonProcessing(e) {
        return "never" === this.config.person_profiles ? (q.error(e + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this._register_single(De, !0), !0);
    }
    _sync_opt_out_with_persistence() {
        var e, t, i, n, r = this.consent.isOptedOut(), s = this.config.opt_out_persistence_by_default, o = this.config.disable_persistence || r && !!s;
        (null === (e = this.persistence) || void 0 === e ? void 0 : e.disabled) !== o && (null === (i = this.persistence) || void 0 === i || i.set_disabled(o));
        (null === (t = this.sessionPersistence) || void 0 === t ? void 0 : t.disabled) !== o && (null === (n = this.sessionPersistence) || void 0 === n || n.set_disabled(o));
    }
    opt_in_capturing(e) {
        var t;
        (this.consent.optInOut(!0), this._sync_opt_out_with_persistence(), F(null == e ? void 0 : e.captureEventName) || null != e && e.captureEventName) && this.capture(null !== (t = null == e ? void 0 : e.captureEventName) && void 0 !== t ? t : "$opt_in", null == e ? void 0 : e.captureProperties, {
            send_instantly: !0
        });
        this.config.capture_pageview && this._captureInitialPageview();
    }
    opt_out_capturing() {
        this.consent.optInOut(!1), this._sync_opt_out_with_persistence();
    }
    has_opted_in_capturing() {
        return this.consent.isOptedIn();
    }
    has_opted_out_capturing() {
        return this.consent.isOptedOut();
    }
    clear_opt_in_out_capturing() {
        this.consent.reset(), this._sync_opt_out_with_persistence();
    }
    _is_bot() {
        return o ? Cs(o, this.config.custom_blocked_useragents) : void 0;
    }
    _captureInitialPageview() {
        a && !this._initialPageviewCaptured && (this._initialPageviewCaptured = !0, this.capture("$pageview", {
            title: a.title
        }, {
            send_instantly: !0
        }));
    }
    debug(e) {
        !1 === e ? (null == t || t.console.log("You've disabled debug mode."), localStorage && localStorage.removeItem("ph_debug"), this.set_config({
            debug: !1
        })) : (null == t || t.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), localStorage && localStorage.setItem("ph_debug", "true"), this.set_config({
            debug: !0
        }));
    }
    _runBeforeSend(e) {
        if (O(this.config.before_send)) return e;
        var t = x(this.config.before_send) ? this.config.before_send : [
            this.config.before_send
        ], i = e;
        for (var n of t){
            if (i = n(i), O(i)) {
                var r = "Event '".concat(e.event, "' was rejected in beforeSend function");
                return D(e.event) ? q.warn("".concat(r, ". This can cause unexpected behavior.")) : q.info(r), null;
            }
            i.properties && !P(i.properties) || q.warn("Event '".concat(e.event, "' has no properties after beforeSend function, this is likely an error."));
        }
        return i;
    }
    getPageViewId() {
        var e;
        return null === (e = this.pageViewManager._currentPageview) || void 0 === e ? void 0 : e.pageViewId;
    }
}
!function(e, t) {
    for(var i = 0; i < t.length; i++)e.prototype[t[i]] = Z(e.prototype[t[i]]);
}(ho, [
    "identify"
]);
var _o, po = (_o = ro[oo] = new ho, function() {
    function e() {
        e.done || (e.done = !0, ao = !1, Y(ro, function(e) {
            e._dom_loaded();
        }));
    }
    null != a && a.addEventListener && ("complete" === a.readyState ? e() : a.addEventListener("DOMContentLoaded", e, !1)), t && ie(t, "load", e, !0);
}(), _o);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"dwh13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "websiteRoutes", ()=>websiteRoutes);
parcelHelpers.export(exports, "SUPABASE_REDIRECT_URL", ()=>SUPABASE_REDIRECT_URL);
const mainDashboardURL = window.location.hostname === "localhost" ? "/" : "/dashboard";
const websiteRoutes = {
    home: "/",
    login: "/app/login",
    signup: "/app/signup",
    verify: "/app/verify",
    dashboard: "/components/",
    inspiration: "/inspiration/",
    inspirationsHome: "/inspirations",
    componentPageUrl: "/components/",
    preview: "/preview",
    mainDashboard: mainDashboardURL
};
const SUPABASE_REDIRECT_URL = `${location.protocol}//${location.host}${websiteRoutes.verify}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"9Y0pX":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("e3a4c20a8ea8341a")(require("8d3f6d27f0ccea45").resolve("1bg04")),
    require("e3a4c20a8ea8341a")(require("8d3f6d27f0ccea45").resolve("s5Dtw"))
]).then(()=>module.bundle.root('pol41'));

},{"e3a4c20a8ea8341a":"9wKyf","8d3f6d27f0ccea45":"gSiLw"}],"d9yXj":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("de55c97f42e54e04")(require("3848f3167d1538ee").resolve("1bg04")),
    require("de55c97f42e54e04")(require("3848f3167d1538ee").resolve("a2Mxw"))
]).then(()=>module.bundle.root('fNKrn'));

},{"de55c97f42e54e04":"9wKyf","3848f3167d1538ee":"gSiLw"}],"iLyIO":[function(require,module,exports,__globalThis) {
module.exports = require("7242db79e51db70c")(require("d0ff8f76edb8e8f8").resolve("fddn7")).then(()=>module.bundle.root('9Yc6s'));

},{"7242db79e51db70c":"9wKyf","d0ff8f76edb8e8f8":"gSiLw"}],"26IT8":[function(require,module,exports,__globalThis) {
module.exports = require("85db02754529df6e")(require("91f5d6cf276d039f").resolve("8JkDf")).then(()=>module.bundle.root('dzqwq'));

},{"85db02754529df6e":"9wKyf","91f5d6cf276d039f":"gSiLw"}],"hveJJ":[function(require,module,exports,__globalThis) {
module.exports = require("b802cee3dcf8d6cf")(require("c8d08bf9b81ca96c").resolve("4o371")).then(()=>module.bundle.root('dRyYX'));

},{"b802cee3dcf8d6cf":"9wKyf","c8d08bf9b81ca96c":"gSiLw"}],"fcuxK":[function(require,module,exports,__globalThis) {
module.exports = require("c0f4f81f6dd79f75")(require("dfc7be1fe5b63888").resolve("jhr1I")).then(()=>module.bundle.root('28L8n'));

},{"c0f4f81f6dd79f75":"9wKyf","dfc7be1fe5b63888":"gSiLw"}],"lAq9d":[function(require,module,exports,__globalThis) {
module.exports = require("573f7a9ecf2f52a")(require("b87ba60d485a11b3").resolve("lmMa7")).then(()=>module.bundle.root('1HHB2'));

},{"573f7a9ecf2f52a":"9wKyf","b87ba60d485a11b3":"gSiLw"}],"d0q55":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("e40e9b99fb93817")(require("dfba49f7e159ba00").resolve("1bg04")),
    require("e40e9b99fb93817")(require("dfba49f7e159ba00").resolve("1808G"))
]).then(()=>module.bundle.root('cw0yE'));

},{"e40e9b99fb93817":"9wKyf","dfba49f7e159ba00":"gSiLw"}],"kUH5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initNavbar", ()=>initNavbar);
var _core = require("@xatom/core");
var _index = require("./index");
const initNavbar = ()=>{
    const navbar = new (0, _core.WFComponent)("[ss-component='dashboard-navbar']");
    if (!navbar) return; // Exit if navbar doesn't exist
    const logoutBtn = navbar.getChildAsComponent("[ss-func-btn='logout']");
    if (!logoutBtn) return; // Exit if logout button doesn't exist
    // Add click handler for logout
    logoutBtn.on("click", (e)=>{
        e.preventDefault();
        const originalText = logoutBtn.getText() || "Logout";
        logoutBtn.setText("Logging out...");
        logoutBtn.setAttribute("disabled", "true");
        (0, _index.logout)().finally(()=>{
            logoutBtn.setText(originalText);
            logoutBtn.removeAttribute("disabled");
        });
    });
};

},{"@xatom/core":"5eqAK","./index":"apxUl","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}],"gxEu2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initPostHog", ()=>initPostHog);
var _posthogJs = require("posthog-js");
var _posthogJsDefault = parcelHelpers.interopDefault(_posthogJs);
const initPostHog = ()=>{
    (0, _posthogJsDefault.default).init('phc_j6YeoqLCrMN7AWfXn897XVnhIiwDtcsBZSfNiNRsjPr', {
        api_host: 'https://eu.i.posthog.com',
        person_profiles: 'identified_only'
    });
};

},{"posthog-js":"2NARa","@parcel/transformer-js/src/esmodule-helpers.js":"jiucr"}]},["jJLhA","83hJF"], "83hJF", "parcelRequire94c2")

//# sourceMappingURL=app.js.map
